//@ts-nocheck
  // DO NOT MODIFY THIS FILE. This file is automatically generated by Tina
  export function gql(strings: TemplateStringsArray, ...args: string[]): string {
    let str = ''
    strings.forEach((string, i) => {
      str += string + (args[i] || '')
    })
    return str
  }
  export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** References another document, used as a foreign key */
  Reference: { input: any; output: any; }
  JSON: { input: any; output: any; }
};

export type SystemInfo = {
  __typename?: 'SystemInfo';
  filename: Scalars['String']['output'];
  title?: Maybe<Scalars['String']['output']>;
  basename: Scalars['String']['output'];
  breadcrumbs: Array<Scalars['String']['output']>;
  path: Scalars['String']['output'];
  relativePath: Scalars['String']['output'];
  extension: Scalars['String']['output'];
  template: Scalars['String']['output'];
  collection: Collection;
};


export type SystemInfoBreadcrumbsArgs = {
  excludeExtension?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Folder = {
  __typename?: 'Folder';
  name: Scalars['String']['output'];
  path: Scalars['String']['output'];
};

export type PageInfo = {
  __typename?: 'PageInfo';
  hasPreviousPage: Scalars['Boolean']['output'];
  hasNextPage: Scalars['Boolean']['output'];
  startCursor: Scalars['String']['output'];
  endCursor: Scalars['String']['output'];
};

export type Node = {
  id: Scalars['ID']['output'];
};

export type Document = {
  id: Scalars['ID']['output'];
  _sys?: Maybe<SystemInfo>;
  _values: Scalars['JSON']['output'];
};

/** A relay-compliant pagination connection */
export type Connection = {
  totalCount: Scalars['Float']['output'];
  pageInfo: PageInfo;
};

export type Query = {
  __typename?: 'Query';
  getOptimizedQuery?: Maybe<Scalars['String']['output']>;
  collection: Collection;
  collections: Array<Collection>;
  node: Node;
  document: DocumentNode;
  page: Page;
  pageConnection: PageConnection;
  article: Article;
  articleConnection: ArticleConnection;
  post: Post;
  postConnection: PostConnection;
  category: Category;
  categoryConnection: CategoryConnection;
  author: Author;
  authorConnection: AuthorConnection;
  product: Product;
  productConnection: ProductConnection;
  testimonial: Testimonial;
  testimonialConnection: TestimonialConnection;
  partner: Partner;
  partnerConnection: PartnerConnection;
  cobrand: Cobrand;
  cobrandConnection: CobrandConnection;
  bga: Bga;
  bgaConnection: BgaConnection;
  notification: Notification;
  notificationConnection: NotificationConnection;
  settings: Settings;
  settingsConnection: SettingsConnection;
  form: Form;
  formConnection: FormConnection;
  manager: Manager;
  managerConnection: ManagerConnection;
  specialPage: SpecialPage;
  specialPageConnection: SpecialPageConnection;
};


export type QueryGetOptimizedQueryArgs = {
  queryString: Scalars['String']['input'];
};


export type QueryCollectionArgs = {
  collection?: InputMaybe<Scalars['String']['input']>;
};


export type QueryNodeArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
};


export type QueryDocumentArgs = {
  collection?: InputMaybe<Scalars['String']['input']>;
  relativePath?: InputMaybe<Scalars['String']['input']>;
};


export type QueryPageArgs = {
  relativePath?: InputMaybe<Scalars['String']['input']>;
};


export type QueryPageConnectionArgs = {
  before?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Float']['input']>;
  last?: InputMaybe<Scalars['Float']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<PageFilter>;
};


export type QueryArticleArgs = {
  relativePath?: InputMaybe<Scalars['String']['input']>;
};


export type QueryArticleConnectionArgs = {
  before?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Float']['input']>;
  last?: InputMaybe<Scalars['Float']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ArticleFilter>;
};


export type QueryPostArgs = {
  relativePath?: InputMaybe<Scalars['String']['input']>;
};


export type QueryPostConnectionArgs = {
  before?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Float']['input']>;
  last?: InputMaybe<Scalars['Float']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<PostFilter>;
};


export type QueryCategoryArgs = {
  relativePath?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCategoryConnectionArgs = {
  before?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Float']['input']>;
  last?: InputMaybe<Scalars['Float']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<CategoryFilter>;
};


export type QueryAuthorArgs = {
  relativePath?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAuthorConnectionArgs = {
  before?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Float']['input']>;
  last?: InputMaybe<Scalars['Float']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<AuthorFilter>;
};


export type QueryProductArgs = {
  relativePath?: InputMaybe<Scalars['String']['input']>;
};


export type QueryProductConnectionArgs = {
  before?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Float']['input']>;
  last?: InputMaybe<Scalars['Float']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ProductFilter>;
};


export type QueryTestimonialArgs = {
  relativePath?: InputMaybe<Scalars['String']['input']>;
};


export type QueryTestimonialConnectionArgs = {
  before?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Float']['input']>;
  last?: InputMaybe<Scalars['Float']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<TestimonialFilter>;
};


export type QueryPartnerArgs = {
  relativePath?: InputMaybe<Scalars['String']['input']>;
};


export type QueryPartnerConnectionArgs = {
  before?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Float']['input']>;
  last?: InputMaybe<Scalars['Float']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<PartnerFilter>;
};


export type QueryCobrandArgs = {
  relativePath?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCobrandConnectionArgs = {
  before?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Float']['input']>;
  last?: InputMaybe<Scalars['Float']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<CobrandFilter>;
};


export type QueryBgaArgs = {
  relativePath?: InputMaybe<Scalars['String']['input']>;
};


export type QueryBgaConnectionArgs = {
  before?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Float']['input']>;
  last?: InputMaybe<Scalars['Float']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<BgaFilter>;
};


export type QueryNotificationArgs = {
  relativePath?: InputMaybe<Scalars['String']['input']>;
};


export type QueryNotificationConnectionArgs = {
  before?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Float']['input']>;
  last?: InputMaybe<Scalars['Float']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<NotificationFilter>;
};


export type QuerySettingsArgs = {
  relativePath?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySettingsConnectionArgs = {
  before?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Float']['input']>;
  last?: InputMaybe<Scalars['Float']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<SettingsFilter>;
};


export type QueryFormArgs = {
  relativePath?: InputMaybe<Scalars['String']['input']>;
};


export type QueryFormConnectionArgs = {
  before?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Float']['input']>;
  last?: InputMaybe<Scalars['Float']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FormFilter>;
};


export type QueryManagerArgs = {
  relativePath?: InputMaybe<Scalars['String']['input']>;
};


export type QueryManagerConnectionArgs = {
  before?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Float']['input']>;
  last?: InputMaybe<Scalars['Float']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ManagerFilter>;
};


export type QuerySpecialPageArgs = {
  relativePath?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySpecialPageConnectionArgs = {
  before?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Float']['input']>;
  last?: InputMaybe<Scalars['Float']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<SpecialPageFilter>;
};

export type DocumentFilter = {
  page?: InputMaybe<PageFilter>;
  article?: InputMaybe<ArticleFilter>;
  post?: InputMaybe<PostFilter>;
  category?: InputMaybe<CategoryFilter>;
  author?: InputMaybe<AuthorFilter>;
  product?: InputMaybe<ProductFilter>;
  testimonial?: InputMaybe<TestimonialFilter>;
  partner?: InputMaybe<PartnerFilter>;
  cobrand?: InputMaybe<CobrandFilter>;
  bga?: InputMaybe<BgaFilter>;
  notification?: InputMaybe<NotificationFilter>;
  settings?: InputMaybe<SettingsFilter>;
  form?: InputMaybe<FormFilter>;
  manager?: InputMaybe<ManagerFilter>;
  specialPage?: InputMaybe<SpecialPageFilter>;
};

export type DocumentConnectionEdges = {
  __typename?: 'DocumentConnectionEdges';
  cursor: Scalars['String']['output'];
  node?: Maybe<DocumentNode>;
};

export type DocumentConnection = Connection & {
  __typename?: 'DocumentConnection';
  pageInfo: PageInfo;
  totalCount: Scalars['Float']['output'];
  edges?: Maybe<Array<Maybe<DocumentConnectionEdges>>>;
};

export type Collection = {
  __typename?: 'Collection';
  name: Scalars['String']['output'];
  slug: Scalars['String']['output'];
  label?: Maybe<Scalars['String']['output']>;
  path: Scalars['String']['output'];
  format?: Maybe<Scalars['String']['output']>;
  matches?: Maybe<Scalars['String']['output']>;
  templates?: Maybe<Array<Maybe<Scalars['JSON']['output']>>>;
  fields?: Maybe<Array<Maybe<Scalars['JSON']['output']>>>;
  documents: DocumentConnection;
};


export type CollectionDocumentsArgs = {
  before?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Float']['input']>;
  last?: InputMaybe<Scalars['Float']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<DocumentFilter>;
  folder?: InputMaybe<Scalars['String']['input']>;
};

export type DocumentNode = PageGeneric | PageBlog | PageForm | Article | Post | Category | Author | Product | Testimonial | Partner | Cobrand | Bga | Notification | SettingsNavigation | SettingsFooter | SettingsSite | SettingsRedirects | SettingsSecurity | SettingsThreeStarOccList | SettingsStatesListTemplate | SettingsGroupDiCompanyRateTypes | SettingsNotFoundPage | SettingsAiRatesTable | FormLtdiManualForm | FormStdiDigitalForm | FormLtcManualForm | FormCiForm | FormAeiForm | FormGroupDiForm | FormLtdiDropticketForm | FormLtcDropticketForm | FormGroupDiCalculatorForm | FormAgentSignupForm | FormAgentSimpleForm | Manager | SpecialPageProposalSpecialPage | SpecialPageIneligibleSpecialPage | Folder;

export type PageGenericSettingsPublish = {
  __typename?: 'PageGenericSettingsPublish';
  published?: Maybe<Scalars['Boolean']['output']>;
  publishedDate?: Maybe<Scalars['String']['output']>;
};

export type PageBlogSettingsSeoImage = {
  __typename?: 'PageBlogSettingsSeoImage';
  src?: Maybe<Scalars['String']['output']>;
  width?: Maybe<Scalars['Float']['output']>;
  height?: Maybe<Scalars['Float']['output']>;
  aspectRatio?: Maybe<Scalars['Float']['output']>;
  format?: Maybe<Scalars['String']['output']>;
  alt?: Maybe<Scalars['String']['output']>;
};

export type PageBlogSettingsSeoOrg = {
  __typename?: 'PageBlogSettingsSeoOrg';
  disable?: Maybe<Scalars['Boolean']['output']>;
};

export type PageFormSettingsSeoFaqItems = {
  __typename?: 'PageFormSettingsSeoFaqItems';
  q?: Maybe<Scalars['String']['output']>;
  a?: Maybe<Scalars['String']['output']>;
};

export type PageBlogSettingsSeoFaq = {
  __typename?: 'PageBlogSettingsSeoFaq';
  disable?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  items?: Maybe<Array<Maybe<PageFormSettingsSeoFaqItems>>>;
};

export type PageFormSettingsSeoHowToImage = {
  __typename?: 'PageFormSettingsSeoHowToImage';
  src?: Maybe<Scalars['String']['output']>;
  width?: Maybe<Scalars['Float']['output']>;
  height?: Maybe<Scalars['Float']['output']>;
  aspectRatio?: Maybe<Scalars['Float']['output']>;
  format?: Maybe<Scalars['String']['output']>;
  alt?: Maybe<Scalars['String']['output']>;
};

export type PageFormSettingsSeoHowToSteps = {
  __typename?: 'PageFormSettingsSeoHowToSteps';
  name?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
};

export type PageBlogSettingsSeoHowTo = {
  __typename?: 'PageBlogSettingsSeoHowTo';
  disable?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  image?: Maybe<PageFormSettingsSeoHowToImage>;
  steps?: Maybe<Array<Maybe<PageFormSettingsSeoHowToSteps>>>;
};

export type PageGenericSettingsSeo = {
  __typename?: 'PageGenericSettingsSeo';
  title?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  image?: Maybe<PageBlogSettingsSeoImage>;
  org?: Maybe<PageBlogSettingsSeoOrg>;
  faq?: Maybe<PageBlogSettingsSeoFaq>;
  howTo?: Maybe<PageBlogSettingsSeoHowTo>;
};

export type PageGenericSettingsSitemap = {
  __typename?: 'PageGenericSettingsSitemap';
  exclude?: Maybe<Scalars['Boolean']['output']>;
  breadcrumb?: Maybe<Scalars['String']['output']>;
  changefreq?: Maybe<Scalars['String']['output']>;
  priority?: Maybe<Scalars['Float']['output']>;
};

export type PageGenericSettingsNotification = Notification;

export type PageBlogSettingsNavigationRightSideButtonOverride = {
  __typename?: 'PageBlogSettingsNavigationRightSideButtonOverride';
  label?: Maybe<Scalars['String']['output']>;
  link?: Maybe<Scalars['String']['output']>;
  ariaLabel?: Maybe<Scalars['String']['output']>;
};

export type PageGenericSettingsNavigation = {
  __typename?: 'PageGenericSettingsNavigation';
  disableLogo?: Maybe<Scalars['Boolean']['output']>;
  disableLeft?: Maybe<Scalars['Boolean']['output']>;
  disableRight?: Maybe<Scalars['Boolean']['output']>;
  disableButtons?: Maybe<Scalars['Boolean']['output']>;
  rightSideButtonOverride?: Maybe<PageBlogSettingsNavigationRightSideButtonOverride>;
};

export type PageGenericSettingsFooter = {
  __typename?: 'PageGenericSettingsFooter';
  disableLinks?: Maybe<Scalars['Boolean']['output']>;
  disableBottom?: Maybe<Scalars['Boolean']['output']>;
};

export type PageGenericSettingsDisclaimer = {
  __typename?: 'PageGenericSettingsDisclaimer';
  disable?: Maybe<Scalars['Boolean']['output']>;
  content?: Maybe<Scalars['JSON']['output']>;
};

export type PageBlogSettingsPartnerPartnerRef = Partner;

export type PageBlogSettingsPartnerCobrandRef = Cobrand;

export type PageGenericSettingsPartner = {
  __typename?: 'PageGenericSettingsPartner';
  partnerRef?: Maybe<PageBlogSettingsPartnerPartnerRef>;
  cobrandRef?: Maybe<PageBlogSettingsPartnerCobrandRef>;
};

export type PageGenericSettingsClient = {
  __typename?: 'PageGenericSettingsClient';
  enabled?: Maybe<Scalars['Boolean']['output']>;
};

export type PageGenericSettings = {
  __typename?: 'PageGenericSettings';
  publish?: Maybe<PageGenericSettingsPublish>;
  seo?: Maybe<PageGenericSettingsSeo>;
  sitemap?: Maybe<PageGenericSettingsSitemap>;
  notification?: Maybe<PageGenericSettingsNotification>;
  navigation?: Maybe<PageGenericSettingsNavigation>;
  footer?: Maybe<PageGenericSettingsFooter>;
  disclaimer?: Maybe<PageGenericSettingsDisclaimer>;
  partner?: Maybe<PageGenericSettingsPartner>;
  client?: Maybe<PageGenericSettingsClient>;
};

export type PageGenericContentSectionHeroGenericLists = {
  __typename?: 'PageGenericContentSectionHeroGenericLists';
  title?: Maybe<Scalars['String']['output']>;
  items?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type PageGenericContentSectionHeroGenericImage = {
  __typename?: 'PageGenericContentSectionHeroGenericImage';
  src?: Maybe<Scalars['String']['output']>;
  width?: Maybe<Scalars['Float']['output']>;
  height?: Maybe<Scalars['Float']['output']>;
  aspectRatio?: Maybe<Scalars['Float']['output']>;
  format?: Maybe<Scalars['String']['output']>;
  alt?: Maybe<Scalars['String']['output']>;
  scale?: Maybe<Scalars['Float']['output']>;
};

export type PageGenericContentSectionHeroGenericSimpleFormRef = FormLtdiManualForm | FormStdiDigitalForm | FormLtcManualForm | FormCiForm | FormAeiForm | FormGroupDiForm | FormLtdiDropticketForm | FormLtcDropticketForm | FormGroupDiCalculatorForm | FormAgentSignupForm | FormAgentSimpleForm;

export type PageGenericContentSectionHeroGenericButtons = {
  __typename?: 'PageGenericContentSectionHeroGenericButtons';
  label?: Maybe<Scalars['String']['output']>;
  link?: Maybe<Scalars['String']['output']>;
  ariaLabel?: Maybe<Scalars['String']['output']>;
};

export type PageGenericContentSectionHeroGenericFormRef = FormLtdiManualForm | FormStdiDigitalForm | FormLtcManualForm | FormCiForm | FormAeiForm | FormGroupDiForm | FormLtdiDropticketForm | FormLtcDropticketForm | FormGroupDiCalculatorForm | FormAgentSignupForm | FormAgentSimpleForm;

export type PageGenericContentSectionHeroGenericFloatingItemsSingleIconLinkItem = {
  __typename?: 'PageGenericContentSectionHeroGenericFloatingItemsSingleIconLinkItem';
  icon?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  link?: Maybe<Scalars['String']['output']>;
};

export type PageGenericContentSectionHeroGenericFloatingItemsSingleIconTextItem = {
  __typename?: 'PageGenericContentSectionHeroGenericFloatingItemsSingleIconTextItem';
  icon?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
};

export type PageGenericContentSectionHeroGenericFloatingItemsGroupedIconTextItemItems = {
  __typename?: 'PageGenericContentSectionHeroGenericFloatingItemsGroupedIconTextItemItems';
  icon?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
};

export type PageGenericContentSectionHeroGenericFloatingItemsGroupedIconTextItem = {
  __typename?: 'PageGenericContentSectionHeroGenericFloatingItemsGroupedIconTextItem';
  items?: Maybe<Array<Maybe<PageGenericContentSectionHeroGenericFloatingItemsGroupedIconTextItemItems>>>;
};

export type PageGenericContentSectionHeroGenericFloatingItemsSingleImageTextItem = {
  __typename?: 'PageGenericContentSectionHeroGenericFloatingItemsSingleImageTextItem';
  image?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
};

export type PageGenericContentSectionHeroGenericFloatingItemsGroupedImageTextItemItems = {
  __typename?: 'PageGenericContentSectionHeroGenericFloatingItemsGroupedImageTextItemItems';
  image?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
};

export type PageGenericContentSectionHeroGenericFloatingItemsGroupedImageTextItem = {
  __typename?: 'PageGenericContentSectionHeroGenericFloatingItemsGroupedImageTextItem';
  items?: Maybe<Array<Maybe<PageGenericContentSectionHeroGenericFloatingItemsGroupedImageTextItemItems>>>;
};

export type PageGenericContentSectionHeroGenericFloatingItemsSingleImageItem = {
  __typename?: 'PageGenericContentSectionHeroGenericFloatingItemsSingleImageItem';
  image?: Maybe<Scalars['String']['output']>;
};

export type PageGenericContentSectionHeroGenericFloatingItems = PageGenericContentSectionHeroGenericFloatingItemsSingleIconLinkItem | PageGenericContentSectionHeroGenericFloatingItemsSingleIconTextItem | PageGenericContentSectionHeroGenericFloatingItemsGroupedIconTextItem | PageGenericContentSectionHeroGenericFloatingItemsSingleImageTextItem | PageGenericContentSectionHeroGenericFloatingItemsGroupedImageTextItem | PageGenericContentSectionHeroGenericFloatingItemsSingleImageItem;

export type PageGenericContentSectionHeroGeneric = {
  __typename?: 'PageGenericContentSectionHeroGeneric';
  title?: Maybe<Scalars['String']['output']>;
  headingSize?: Maybe<Scalars['String']['output']>;
  headingRich?: Maybe<Scalars['JSON']['output']>;
  subheadingRich?: Maybe<Scalars['JSON']['output']>;
  textRich?: Maybe<Scalars['JSON']['output']>;
  lists?: Maybe<Array<Maybe<PageGenericContentSectionHeroGenericLists>>>;
  image?: Maybe<PageGenericContentSectionHeroGenericImage>;
  simpleFormRef?: Maybe<PageGenericContentSectionHeroGenericSimpleFormRef>;
  buttons?: Maybe<Array<Maybe<PageGenericContentSectionHeroGenericButtons>>>;
  formRef?: Maybe<PageGenericContentSectionHeroGenericFormRef>;
  floatingItems?: Maybe<Array<Maybe<PageGenericContentSectionHeroGenericFloatingItems>>>;
};

export type PageGenericContentSectionHeroAgentImage = {
  __typename?: 'PageGenericContentSectionHeroAgentImage';
  src?: Maybe<Scalars['String']['output']>;
  width?: Maybe<Scalars['Float']['output']>;
  height?: Maybe<Scalars['Float']['output']>;
  aspectRatio?: Maybe<Scalars['Float']['output']>;
  format?: Maybe<Scalars['String']['output']>;
  alt?: Maybe<Scalars['String']['output']>;
};

export type PageGenericContentSectionHeroAgentDefaultProductsProductRef = Product;

export type PageGenericContentSectionHeroAgentDefaultProducts = {
  __typename?: 'PageGenericContentSectionHeroAgentDefaultProducts';
  productRef?: Maybe<PageGenericContentSectionHeroAgentDefaultProductsProductRef>;
};

export type PageGenericContentSectionHeroAgentDisplay = {
  __typename?: 'PageGenericContentSectionHeroAgentDisplay';
  icon?: Maybe<Scalars['Boolean']['output']>;
  graphic?: Maybe<Scalars['Boolean']['output']>;
  actionLabel?: Maybe<Scalars['Boolean']['output']>;
  descriptionText?: Maybe<Scalars['Boolean']['output']>;
  descriptionItems?: Maybe<Scalars['Boolean']['output']>;
  disclaimer?: Maybe<Scalars['Boolean']['output']>;
  buttons?: Maybe<Scalars['Boolean']['output']>;
};

export type PageGenericContentSectionHeroAgent = {
  __typename?: 'PageGenericContentSectionHeroAgent';
  headingRich?: Maybe<Scalars['JSON']['output']>;
  fallbackHeadingRich?: Maybe<Scalars['JSON']['output']>;
  textRich?: Maybe<Scalars['JSON']['output']>;
  image?: Maybe<PageGenericContentSectionHeroAgentImage>;
  defaultProducts?: Maybe<Array<Maybe<PageGenericContentSectionHeroAgentDefaultProducts>>>;
  display?: Maybe<PageGenericContentSectionHeroAgentDisplay>;
};

export type PageGenericContentSectionLogosImages = {
  __typename?: 'PageGenericContentSectionLogosImages';
  image?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type PageGenericContentSectionLogos = {
  __typename?: 'PageGenericContentSectionLogos';
  headingText?: Maybe<Scalars['String']['output']>;
  images?: Maybe<Array<Maybe<PageGenericContentSectionLogosImages>>>;
};

export type PageGenericContentSectionBadgesBadges = {
  __typename?: 'PageGenericContentSectionBadgesBadges';
  image?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
};

export type PageGenericContentSectionBadges = {
  __typename?: 'PageGenericContentSectionBadges';
  title?: Maybe<Scalars['String']['output']>;
  badges?: Maybe<Array<Maybe<PageGenericContentSectionBadgesBadges>>>;
};

export type PageGenericContentSectionTestimonialSliderItemsRef = Testimonial;

export type PageGenericContentSectionTestimonialSliderItems = {
  __typename?: 'PageGenericContentSectionTestimonialSliderItems';
  ref: PageGenericContentSectionTestimonialSliderItemsRef;
};

export type PageGenericContentSectionTestimonialSlider = {
  __typename?: 'PageGenericContentSectionTestimonialSlider';
  title?: Maybe<Scalars['String']['output']>;
  headingRich?: Maybe<Scalars['JSON']['output']>;
  highlight?: Maybe<Scalars['String']['output']>;
  textRich?: Maybe<Scalars['JSON']['output']>;
  items?: Maybe<Array<Maybe<PageGenericContentSectionTestimonialSliderItems>>>;
};

export type PageGenericContentSectionTestimonialGridItemsRef = Testimonial;

export type PageGenericContentSectionTestimonialGridItems = {
  __typename?: 'PageGenericContentSectionTestimonialGridItems';
  ref: PageGenericContentSectionTestimonialGridItemsRef;
};

export type PageGenericContentSectionTestimonialGrid = {
  __typename?: 'PageGenericContentSectionTestimonialGrid';
  headingText?: Maybe<Scalars['String']['output']>;
  items?: Maybe<Array<Maybe<PageGenericContentSectionTestimonialGridItems>>>;
};

export type PageGenericContentSectionFloatingCtaButtons = {
  __typename?: 'PageGenericContentSectionFloatingCtaButtons';
  label?: Maybe<Scalars['String']['output']>;
  link?: Maybe<Scalars['String']['output']>;
  ariaLabel?: Maybe<Scalars['String']['output']>;
};

export type PageGenericContentSectionFloatingCta = {
  __typename?: 'PageGenericContentSectionFloatingCta';
  headingText?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  buttons?: Maybe<Array<Maybe<PageGenericContentSectionFloatingCtaButtons>>>;
};

export type PageGenericContentSectionImageCtaButtons = {
  __typename?: 'PageGenericContentSectionImageCtaButtons';
  label?: Maybe<Scalars['String']['output']>;
  link?: Maybe<Scalars['String']['output']>;
  ariaLabel?: Maybe<Scalars['String']['output']>;
};

export type PageGenericContentSectionImageCta = {
  __typename?: 'PageGenericContentSectionImageCta';
  headingText?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  buttons?: Maybe<Array<Maybe<PageGenericContentSectionImageCtaButtons>>>;
  imageSrc?: Maybe<Scalars['String']['output']>;
};

export type PageGenericContentSectionProductsItemsRef = Product;

export type PageGenericContentSectionProductsItems = {
  __typename?: 'PageGenericContentSectionProductsItems';
  ref: PageGenericContentSectionProductsItemsRef;
};

export type PageGenericContentSectionProductsDisplay = {
  __typename?: 'PageGenericContentSectionProductsDisplay';
  icon?: Maybe<Scalars['Boolean']['output']>;
  graphic?: Maybe<Scalars['Boolean']['output']>;
  actionLabel?: Maybe<Scalars['Boolean']['output']>;
  descriptionText?: Maybe<Scalars['Boolean']['output']>;
  descriptionItems?: Maybe<Scalars['Boolean']['output']>;
  disclaimer?: Maybe<Scalars['Boolean']['output']>;
  buttons?: Maybe<Scalars['Boolean']['output']>;
};

export type PageGenericContentSectionProducts = {
  __typename?: 'PageGenericContentSectionProducts';
  headingRich?: Maybe<Scalars['JSON']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  items?: Maybe<Array<Maybe<PageGenericContentSectionProductsItems>>>;
  display?: Maybe<PageGenericContentSectionProductsDisplay>;
};

export type PageGenericContentSectionProductsSimpleItemsRef = Product;

export type PageGenericContentSectionProductsSimpleItems = {
  __typename?: 'PageGenericContentSectionProductsSimpleItems';
  ref: PageGenericContentSectionProductsSimpleItemsRef;
};

export type PageGenericContentSectionProductsSimpleDisplay = {
  __typename?: 'PageGenericContentSectionProductsSimpleDisplay';
  actionLabel?: Maybe<Scalars['Boolean']['output']>;
  descriptionText?: Maybe<Scalars['Boolean']['output']>;
  descriptionItems?: Maybe<Scalars['Boolean']['output']>;
  disclaimer?: Maybe<Scalars['Boolean']['output']>;
  buttons?: Maybe<Scalars['Boolean']['output']>;
};

export type PageGenericContentSectionProductsSimple = {
  __typename?: 'PageGenericContentSectionProductsSimple';
  items?: Maybe<Array<Maybe<PageGenericContentSectionProductsSimpleItems>>>;
  display?: Maybe<PageGenericContentSectionProductsSimpleDisplay>;
};

export type PageGenericContentSectionHowItWorksItemsButton = {
  __typename?: 'PageGenericContentSectionHowItWorksItemsButton';
  label?: Maybe<Scalars['String']['output']>;
  link?: Maybe<Scalars['String']['output']>;
  ariaLabel?: Maybe<Scalars['String']['output']>;
};

export type PageGenericContentSectionHowItWorksItems = {
  __typename?: 'PageGenericContentSectionHowItWorksItems';
  image?: Maybe<Scalars['String']['output']>;
  headingText?: Maybe<Scalars['String']['output']>;
  subheadingText?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  button?: Maybe<PageGenericContentSectionHowItWorksItemsButton>;
};

export type PageGenericContentSectionHowItWorksDisplay = {
  __typename?: 'PageGenericContentSectionHowItWorksDisplay';
  number?: Maybe<Scalars['Boolean']['output']>;
};

export type PageGenericContentSectionHowItWorks = {
  __typename?: 'PageGenericContentSectionHowItWorks';
  title?: Maybe<Scalars['String']['output']>;
  headingText?: Maybe<Scalars['String']['output']>;
  active?: Maybe<Scalars['Float']['output']>;
  items?: Maybe<Array<Maybe<PageGenericContentSectionHowItWorksItems>>>;
  display?: Maybe<PageGenericContentSectionHowItWorksDisplay>;
};

export type PageGenericContentSectionIconColumnsCols = {
  __typename?: 'PageGenericContentSectionIconColumnsCols';
  imageSrc?: Maybe<Scalars['String']['output']>;
  disableIconBg?: Maybe<Scalars['Boolean']['output']>;
  size?: Maybe<Scalars['Float']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  titleSize?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
};

export type PageGenericContentSectionIconColumns = {
  __typename?: 'PageGenericContentSectionIconColumns';
  title?: Maybe<Scalars['String']['output']>;
  headingText?: Maybe<Scalars['String']['output']>;
  subheadingText?: Maybe<Scalars['String']['output']>;
  colNum?: Maybe<Scalars['Float']['output']>;
  colSpacing?: Maybe<Scalars['Float']['output']>;
  bgColor?: Maybe<Scalars['String']['output']>;
  cols?: Maybe<Array<Maybe<PageGenericContentSectionIconColumnsCols>>>;
};

export type PageGenericContentSectionBlogPostsPostsRef = Post;

export type PageGenericContentSectionBlogPostsPosts = {
  __typename?: 'PageGenericContentSectionBlogPostsPosts';
  ref?: Maybe<PageGenericContentSectionBlogPostsPostsRef>;
};

export type PageGenericContentSectionBlogPosts = {
  __typename?: 'PageGenericContentSectionBlogPosts';
  title?: Maybe<Scalars['String']['output']>;
  headingText?: Maybe<Scalars['String']['output']>;
  posts?: Maybe<Array<Maybe<PageGenericContentSectionBlogPostsPosts>>>;
};

export type PageGenericContentSectionArticlesPostsRef = Article;

export type PageGenericContentSectionArticlesPosts = {
  __typename?: 'PageGenericContentSectionArticlesPosts';
  ref?: Maybe<PageGenericContentSectionArticlesPostsRef>;
};

export type PageGenericContentSectionArticles = {
  __typename?: 'PageGenericContentSectionArticles';
  title?: Maybe<Scalars['String']['output']>;
  headingText?: Maybe<Scalars['String']['output']>;
  posts?: Maybe<Array<Maybe<PageGenericContentSectionArticlesPosts>>>;
};

export type PageGenericContentSectionCtaArticlesPostsCta = {
  __typename?: 'PageGenericContentSectionCtaArticlesPostsCta';
  label?: Maybe<Scalars['String']['output']>;
  link?: Maybe<Scalars['String']['output']>;
};

export type PageGenericContentSectionCtaArticlesPostsRef = Article;

export type PageGenericContentSectionCtaArticlesPosts = {
  __typename?: 'PageGenericContentSectionCtaArticlesPosts';
  tag?: Maybe<Scalars['String']['output']>;
  headingText?: Maybe<Scalars['String']['output']>;
  imageSrc?: Maybe<Scalars['String']['output']>;
  cta?: Maybe<PageGenericContentSectionCtaArticlesPostsCta>;
  ref?: Maybe<PageGenericContentSectionCtaArticlesPostsRef>;
};

export type PageGenericContentSectionCtaArticles = {
  __typename?: 'PageGenericContentSectionCtaArticles';
  posts?: Maybe<Array<Maybe<PageGenericContentSectionCtaArticlesPosts>>>;
};

export type PageGenericContentSectionHelpfulArticlesCtaButton = {
  __typename?: 'PageGenericContentSectionHelpfulArticlesCtaButton';
  label?: Maybe<Scalars['String']['output']>;
  link?: Maybe<Scalars['String']['output']>;
};

export type PageGenericContentSectionHelpfulArticlesCta = {
  __typename?: 'PageGenericContentSectionHelpfulArticlesCta';
  headingText?: Maybe<Scalars['String']['output']>;
  imageSrc?: Maybe<Scalars['String']['output']>;
  button?: Maybe<PageGenericContentSectionHelpfulArticlesCtaButton>;
};

export type PageGenericContentSectionHelpfulArticlesPostsRef = Article;

export type PageGenericContentSectionHelpfulArticlesPosts = {
  __typename?: 'PageGenericContentSectionHelpfulArticlesPosts';
  ref?: Maybe<PageGenericContentSectionHelpfulArticlesPostsRef>;
};

export type PageGenericContentSectionHelpfulArticles = {
  __typename?: 'PageGenericContentSectionHelpfulArticles';
  cta?: Maybe<PageGenericContentSectionHelpfulArticlesCta>;
  title?: Maybe<Scalars['String']['output']>;
  posts?: Maybe<Array<Maybe<PageGenericContentSectionHelpfulArticlesPosts>>>;
};

export type PageGenericContentSectionStatsItems = {
  __typename?: 'PageGenericContentSectionStatsItems';
  number?: Maybe<Scalars['Float']['output']>;
  unit?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
};

export type PageGenericContentSectionStatsButton = {
  __typename?: 'PageGenericContentSectionStatsButton';
  label?: Maybe<Scalars['String']['output']>;
  link?: Maybe<Scalars['String']['output']>;
  ariaLabel?: Maybe<Scalars['String']['output']>;
};

export type PageGenericContentSectionStatsQuote = {
  __typename?: 'PageGenericContentSectionStatsQuote';
  text?: Maybe<Scalars['String']['output']>;
  author?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type PageGenericContentSectionStats = {
  __typename?: 'PageGenericContentSectionStats';
  title?: Maybe<Scalars['String']['output']>;
  headingText?: Maybe<Scalars['String']['output']>;
  items?: Maybe<Array<Maybe<PageGenericContentSectionStatsItems>>>;
  secondaryHeading?: Maybe<Scalars['JSON']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  button?: Maybe<PageGenericContentSectionStatsButton>;
  imageSrc?: Maybe<Scalars['String']['output']>;
  quote?: Maybe<PageGenericContentSectionStatsQuote>;
};

export type PageGenericContentSectionResourcesGroupsItems = {
  __typename?: 'PageGenericContentSectionResourcesGroupsItems';
  label?: Maybe<Scalars['String']['output']>;
  link?: Maybe<Scalars['String']['output']>;
  ariaLabel?: Maybe<Scalars['String']['output']>;
};

export type PageGenericContentSectionResourcesGroups = {
  __typename?: 'PageGenericContentSectionResourcesGroups';
  title?: Maybe<Scalars['String']['output']>;
  items?: Maybe<Array<Maybe<PageGenericContentSectionResourcesGroupsItems>>>;
};

export type PageGenericContentSectionResources = {
  __typename?: 'PageGenericContentSectionResources';
  title?: Maybe<Scalars['String']['output']>;
  headingText?: Maybe<Scalars['String']['output']>;
  imageSrc?: Maybe<Scalars['String']['output']>;
  groups?: Maybe<Array<Maybe<PageGenericContentSectionResourcesGroups>>>;
};

export type PageGenericContentSectionResourceHubGroupsArticlesLink = {
  __typename?: 'PageGenericContentSectionResourceHubGroupsArticlesLink';
  label?: Maybe<Scalars['String']['output']>;
  link?: Maybe<Scalars['String']['output']>;
  ariaLabel?: Maybe<Scalars['String']['output']>;
};

export type PageGenericContentSectionResourceHubGroupsArticles = {
  __typename?: 'PageGenericContentSectionResourceHubGroupsArticles';
  title?: Maybe<Scalars['String']['output']>;
  textRich?: Maybe<Scalars['JSON']['output']>;
  link?: Maybe<PageGenericContentSectionResourceHubGroupsArticlesLink>;
};

export type PageGenericContentSectionResourceHubGroups = {
  __typename?: 'PageGenericContentSectionResourceHubGroups';
  title?: Maybe<Scalars['String']['output']>;
  tocTitle?: Maybe<Scalars['String']['output']>;
  articles?: Maybe<Array<Maybe<PageGenericContentSectionResourceHubGroupsArticles>>>;
};

export type PageGenericContentSectionResourceHub = {
  __typename?: 'PageGenericContentSectionResourceHub';
  title?: Maybe<Scalars['String']['output']>;
  headingText?: Maybe<Scalars['String']['output']>;
  imageSrc?: Maybe<Scalars['String']['output']>;
  groups?: Maybe<Array<Maybe<PageGenericContentSectionResourceHubGroups>>>;
};

export type PageGenericContentSectionFileResourcesFilterSettingsFiltersItems = {
  __typename?: 'PageGenericContentSectionFileResourcesFilterSettingsFiltersItems';
  label?: Maybe<Scalars['String']['output']>;
  tag?: Maybe<Scalars['String']['output']>;
};

export type PageGenericContentSectionFileResourcesFilterSettingsFilters = {
  __typename?: 'PageGenericContentSectionFileResourcesFilterSettingsFilters';
  label?: Maybe<Scalars['String']['output']>;
  items?: Maybe<Array<Maybe<PageGenericContentSectionFileResourcesFilterSettingsFiltersItems>>>;
};

export type PageGenericContentSectionFileResourcesFilterSettings = {
  __typename?: 'PageGenericContentSectionFileResourcesFilterSettings';
  title?: Maybe<Scalars['String']['output']>;
  resetLabel?: Maybe<Scalars['String']['output']>;
  noItemsMessage?: Maybe<Scalars['String']['output']>;
  filters?: Maybe<Array<Maybe<PageGenericContentSectionFileResourcesFilterSettingsFilters>>>;
};

export type PageGenericContentSectionFileResourcesResources = {
  __typename?: 'PageGenericContentSectionFileResourcesResources';
  title?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  tooltip?: Maybe<Scalars['String']['output']>;
  link?: Maybe<Scalars['String']['output']>;
  tags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type PageGenericContentSectionFileResources = {
  __typename?: 'PageGenericContentSectionFileResources';
  filterSettings?: Maybe<PageGenericContentSectionFileResourcesFilterSettings>;
  resources?: Maybe<Array<Maybe<PageGenericContentSectionFileResourcesResources>>>;
};

export type PageGenericContentSectionOurStory = {
  __typename?: 'PageGenericContentSectionOurStory';
  headingText?: Maybe<Scalars['String']['output']>;
  subheadingText?: Maybe<Scalars['String']['output']>;
  textRich?: Maybe<Scalars['JSON']['output']>;
};

export type PageGenericContentSectionTeamItems = {
  __typename?: 'PageGenericContentSectionTeamItems';
  image?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  about?: Maybe<Scalars['String']['output']>;
};

export type PageGenericContentSectionTeam = {
  __typename?: 'PageGenericContentSectionTeam';
  headingText?: Maybe<Scalars['String']['output']>;
  items?: Maybe<Array<Maybe<PageGenericContentSectionTeamItems>>>;
};

export type PageGenericContentSectionValuesItems = {
  __typename?: 'PageGenericContentSectionValuesItems';
  icon?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
};

export type PageGenericContentSectionValues = {
  __typename?: 'PageGenericContentSectionValues';
  headingText?: Maybe<Scalars['String']['output']>;
  items?: Maybe<Array<Maybe<PageGenericContentSectionValuesItems>>>;
};

export type PageGenericContentSectionImageBrzImage = {
  __typename?: 'PageGenericContentSectionImageBrzImage';
  title?: Maybe<Scalars['String']['output']>;
  src?: Maybe<Scalars['String']['output']>;
  width?: Maybe<Scalars['Float']['output']>;
  height?: Maybe<Scalars['Float']['output']>;
  aspectRatio?: Maybe<Scalars['Float']['output']>;
  format?: Maybe<Scalars['String']['output']>;
  alt?: Maybe<Scalars['String']['output']>;
  radius?: Maybe<Scalars['Float']['output']>;
};

export type PageGenericContentSectionImage = {
  __typename?: 'PageGenericContentSectionImage';
  brzImage?: Maybe<PageGenericContentSectionImageBrzImage>;
  scrollable?: Maybe<Scalars['Boolean']['output']>;
  spacing?: Maybe<Scalars['Float']['output']>;
  maxWidth?: Maybe<Scalars['String']['output']>;
  align?: Maybe<Scalars['String']['output']>;
};

export type PageGenericContentSectionButtonsButtons = {
  __typename?: 'PageGenericContentSectionButtonsButtons';
  label?: Maybe<Scalars['String']['output']>;
  link?: Maybe<Scalars['String']['output']>;
  ariaLabel?: Maybe<Scalars['String']['output']>;
  variant?: Maybe<Scalars['String']['output']>;
  color?: Maybe<Scalars['String']['output']>;
  size?: Maybe<Scalars['String']['output']>;
};

export type PageGenericContentSectionButtons = {
  __typename?: 'PageGenericContentSectionButtons';
  align?: Maybe<Scalars['String']['output']>;
  buttons?: Maybe<Array<Maybe<PageGenericContentSectionButtonsButtons>>>;
  spacing?: Maybe<Scalars['Float']['output']>;
};

export type PageGenericContentSectionPressItems = {
  __typename?: 'PageGenericContentSectionPressItems';
  headingText?: Maybe<Scalars['String']['output']>;
  link?: Maybe<Scalars['String']['output']>;
};

export type PageGenericContentSectionPress = {
  __typename?: 'PageGenericContentSectionPress';
  headingText?: Maybe<Scalars['String']['output']>;
  textRich?: Maybe<Scalars['JSON']['output']>;
  items?: Maybe<Array<Maybe<PageGenericContentSectionPressItems>>>;
};

export type PageGenericContentSectionTwoColumnText = {
  __typename?: 'PageGenericContentSectionTwoColumnText';
  title?: Maybe<Scalars['String']['output']>;
  headingText?: Maybe<Scalars['String']['output']>;
  imageSrc?: Maybe<Scalars['String']['output']>;
  textRich?: Maybe<Scalars['JSON']['output']>;
};

export type PageGenericContentSectionThreeColumnTextCols = {
  __typename?: 'PageGenericContentSectionThreeColumnTextCols';
  title?: Maybe<Scalars['String']['output']>;
  textRich?: Maybe<Scalars['JSON']['output']>;
};

export type PageGenericContentSectionThreeColumnText = {
  __typename?: 'PageGenericContentSectionThreeColumnText';
  headingText?: Maybe<Scalars['String']['output']>;
  cols?: Maybe<Array<Maybe<PageGenericContentSectionThreeColumnTextCols>>>;
};

export type PageGenericContentSectionVibeButton = {
  __typename?: 'PageGenericContentSectionVibeButton';
  label?: Maybe<Scalars['String']['output']>;
  link?: Maybe<Scalars['String']['output']>;
  ariaLabel?: Maybe<Scalars['String']['output']>;
};

export type PageGenericContentSectionVibeItems = {
  __typename?: 'PageGenericContentSectionVibeItems';
  icon?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
};

export type PageGenericContentSectionVibe = {
  __typename?: 'PageGenericContentSectionVibe';
  title?: Maybe<Scalars['String']['output']>;
  headingText?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  button?: Maybe<PageGenericContentSectionVibeButton>;
  imageSrc?: Maybe<Scalars['String']['output']>;
  items?: Maybe<Array<Maybe<PageGenericContentSectionVibeItems>>>;
};

export type PageGenericContentSectionSellingPointsItems = {
  __typename?: 'PageGenericContentSectionSellingPointsItems';
  icon?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
};

export type PageGenericContentSectionSellingPoints = {
  __typename?: 'PageGenericContentSectionSellingPoints';
  imageSrc?: Maybe<Scalars['String']['output']>;
  headingText?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  items?: Maybe<Array<Maybe<PageGenericContentSectionSellingPointsItems>>>;
};

export type PageGenericContentSectionOpeningsItems = {
  __typename?: 'PageGenericContentSectionOpeningsItems';
  title?: Maybe<Scalars['String']['output']>;
  location?: Maybe<Scalars['String']['output']>;
  link?: Maybe<Scalars['String']['output']>;
};

export type PageGenericContentSectionOpenings = {
  __typename?: 'PageGenericContentSectionOpenings';
  sectionId?: Maybe<Scalars['String']['output']>;
  headingText?: Maybe<Scalars['String']['output']>;
  textRich?: Maybe<Scalars['JSON']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  items?: Maybe<Array<Maybe<PageGenericContentSectionOpeningsItems>>>;
};

export type PageGenericContentSectionStoryCardsItemsEmployeeStory = {
  __typename?: 'PageGenericContentSectionStoryCardsItemsEmployeeStory';
  textRich?: Maybe<Scalars['JSON']['output']>;
  author?: Maybe<Scalars['String']['output']>;
  authorTitle?: Maybe<Scalars['String']['output']>;
  authorImage?: Maybe<Scalars['String']['output']>;
};

export type PageGenericContentSectionStoryCardsItemsAchievementBrzImage = {
  __typename?: 'PageGenericContentSectionStoryCardsItemsAchievementBrzImage';
  src?: Maybe<Scalars['String']['output']>;
  width?: Maybe<Scalars['Float']['output']>;
  height?: Maybe<Scalars['Float']['output']>;
  aspectRatio?: Maybe<Scalars['Float']['output']>;
  format?: Maybe<Scalars['String']['output']>;
  alt?: Maybe<Scalars['String']['output']>;
};

export type PageGenericContentSectionStoryCardsItemsAchievement = {
  __typename?: 'PageGenericContentSectionStoryCardsItemsAchievement';
  title?: Maybe<Scalars['String']['output']>;
  textRich?: Maybe<Scalars['JSON']['output']>;
  brzImage?: Maybe<PageGenericContentSectionStoryCardsItemsAchievementBrzImage>;
  badgeImage?: Maybe<Scalars['String']['output']>;
};

export type PageGenericContentSectionStoryCardsItemsAnnouncementImages = {
  __typename?: 'PageGenericContentSectionStoryCardsItemsAnnouncementImages';
  imageSrc?: Maybe<Scalars['String']['output']>;
  alt?: Maybe<Scalars['String']['output']>;
};

export type PageGenericContentSectionStoryCardsItemsAnnouncement = {
  __typename?: 'PageGenericContentSectionStoryCardsItemsAnnouncement';
  headingText?: Maybe<Scalars['String']['output']>;
  subheadingText?: Maybe<Scalars['String']['output']>;
  textRich?: Maybe<Scalars['JSON']['output']>;
  images?: Maybe<Array<Maybe<PageGenericContentSectionStoryCardsItemsAnnouncementImages>>>;
};

export type PageGenericContentSectionStoryCardsItems = PageGenericContentSectionStoryCardsItemsEmployeeStory | PageGenericContentSectionStoryCardsItemsAchievement | PageGenericContentSectionStoryCardsItemsAnnouncement;

export type PageGenericContentSectionStoryCards = {
  __typename?: 'PageGenericContentSectionStoryCards';
  title?: Maybe<Scalars['String']['output']>;
  items?: Maybe<Array<Maybe<PageGenericContentSectionStoryCardsItems>>>;
};

export type PageGenericContentSectionOtherOffersItems = {
  __typename?: 'PageGenericContentSectionOtherOffersItems';
  headingText?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  imageSrc?: Maybe<Scalars['String']['output']>;
};

export type PageGenericContentSectionOtherOffers = {
  __typename?: 'PageGenericContentSectionOtherOffers';
  headingText?: Maybe<Scalars['String']['output']>;
  items?: Maybe<Array<Maybe<PageGenericContentSectionOtherOffersItems>>>;
};

export type PageGenericContentSectionAccordionItems = {
  __typename?: 'PageGenericContentSectionAccordionItems';
  title?: Maybe<Scalars['String']['output']>;
  textRich?: Maybe<Scalars['JSON']['output']>;
};

export type PageGenericContentSectionAccordion = {
  __typename?: 'PageGenericContentSectionAccordion';
  title?: Maybe<Scalars['String']['output']>;
  sectionId?: Maybe<Scalars['String']['output']>;
  items?: Maybe<Array<Maybe<PageGenericContentSectionAccordionItems>>>;
};

export type PageGenericContentSectionQuoteProposalHelpTip = {
  __typename?: 'PageGenericContentSectionQuoteProposalHelpTip';
  headingText?: Maybe<Scalars['String']['output']>;
  contentRich?: Maybe<Scalars['JSON']['output']>;
};

export type PageGenericContentSectionQuoteProposalNotFoundError = {
  __typename?: 'PageGenericContentSectionQuoteProposalNotFoundError';
  headingText?: Maybe<Scalars['String']['output']>;
  textRich?: Maybe<Scalars['JSON']['output']>;
};

export type PageGenericContentSectionQuoteProposalGenericError = {
  __typename?: 'PageGenericContentSectionQuoteProposalGenericError';
  headingText?: Maybe<Scalars['String']['output']>;
  textRich?: Maybe<Scalars['JSON']['output']>;
};

export type PageGenericContentSectionQuoteProposal = {
  __typename?: 'PageGenericContentSectionQuoteProposal';
  headingText?: Maybe<Scalars['String']['output']>;
  subheadingRich?: Maybe<Scalars['JSON']['output']>;
  imageSrc?: Maybe<Scalars['String']['output']>;
  helpTip?: Maybe<PageGenericContentSectionQuoteProposalHelpTip>;
  addonsHeadingText?: Maybe<Scalars['String']['output']>;
  notFoundError?: Maybe<PageGenericContentSectionQuoteProposalNotFoundError>;
  genericError?: Maybe<PageGenericContentSectionQuoteProposalGenericError>;
};

export type PageGenericContentSectionTableRows = {
  __typename?: 'PageGenericContentSectionTableRows';
  columns?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type PageGenericContentSectionTable = {
  __typename?: 'PageGenericContentSectionTable';
  title?: Maybe<Scalars['String']['output']>;
  headingText?: Maybe<Scalars['String']['output']>;
  rows?: Maybe<Array<Maybe<PageGenericContentSectionTableRows>>>;
};

export type PageGenericContentSectionHeading = {
  __typename?: 'PageGenericContentSectionHeading';
  align?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  headingLevel?: Maybe<Scalars['String']['output']>;
  headingText?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  marginBottom?: Maybe<Scalars['String']['output']>;
};

export type PageGenericContentSectionContent = {
  __typename?: 'PageGenericContentSectionContent';
  align?: Maybe<Scalars['String']['output']>;
  maxWidth?: Maybe<Scalars['String']['output']>;
  contentRich?: Maybe<Scalars['JSON']['output']>;
};

export type PageGenericContentSectionSidebarContentRowsCols = {
  __typename?: 'PageGenericContentSectionSidebarContentRowsCols';
  contentRich?: Maybe<Scalars['JSON']['output']>;
};

export type PageGenericContentSectionSidebarContentRows = {
  __typename?: 'PageGenericContentSectionSidebarContentRows';
  cols?: Maybe<Array<Maybe<PageGenericContentSectionSidebarContentRowsCols>>>;
};

export type PageGenericContentSectionSidebarContent = {
  __typename?: 'PageGenericContentSectionSidebarContent';
  sidebarRich?: Maybe<Scalars['JSON']['output']>;
  rows?: Maybe<Array<Maybe<PageGenericContentSectionSidebarContentRows>>>;
};

export type PageGenericContentSectionHtml = {
  __typename?: 'PageGenericContentSectionHTML';
  contentText?: Maybe<Scalars['String']['output']>;
};

export type PageGenericContent = PageGenericContentSectionHeroGeneric | PageGenericContentSectionHeroAgent | PageGenericContentSectionLogos | PageGenericContentSectionBadges | PageGenericContentSectionTestimonialSlider | PageGenericContentSectionTestimonialGrid | PageGenericContentSectionFloatingCta | PageGenericContentSectionImageCta | PageGenericContentSectionProducts | PageGenericContentSectionProductsSimple | PageGenericContentSectionHowItWorks | PageGenericContentSectionIconColumns | PageGenericContentSectionBlogPosts | PageGenericContentSectionArticles | PageGenericContentSectionCtaArticles | PageGenericContentSectionHelpfulArticles | PageGenericContentSectionStats | PageGenericContentSectionResources | PageGenericContentSectionResourceHub | PageGenericContentSectionFileResources | PageGenericContentSectionOurStory | PageGenericContentSectionTeam | PageGenericContentSectionValues | PageGenericContentSectionImage | PageGenericContentSectionButtons | PageGenericContentSectionPress | PageGenericContentSectionTwoColumnText | PageGenericContentSectionThreeColumnText | PageGenericContentSectionVibe | PageGenericContentSectionSellingPoints | PageGenericContentSectionOpenings | PageGenericContentSectionStoryCards | PageGenericContentSectionOtherOffers | PageGenericContentSectionAccordion | PageGenericContentSectionQuoteProposal | PageGenericContentSectionTable | PageGenericContentSectionHeading | PageGenericContentSectionContent | PageGenericContentSectionSidebarContent | PageGenericContentSectionHtml;

export type PageGeneric = Node & Document & {
  __typename?: 'PageGeneric';
  component?: Maybe<Scalars['String']['output']>;
  updatedDate?: Maybe<Scalars['String']['output']>;
  publishedDate?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  settings?: Maybe<PageGenericSettings>;
  content?: Maybe<Array<Maybe<PageGenericContent>>>;
  id: Scalars['ID']['output'];
  _sys: SystemInfo;
  _values: Scalars['JSON']['output'];
};

export type PageBlogSettingsPublish = {
  __typename?: 'PageBlogSettingsPublish';
  published?: Maybe<Scalars['Boolean']['output']>;
  publishedDate?: Maybe<Scalars['String']['output']>;
};

export type PageFormSettingsSeoImage = {
  __typename?: 'PageFormSettingsSeoImage';
  src?: Maybe<Scalars['String']['output']>;
  width?: Maybe<Scalars['Float']['output']>;
  height?: Maybe<Scalars['Float']['output']>;
  aspectRatio?: Maybe<Scalars['Float']['output']>;
  format?: Maybe<Scalars['String']['output']>;
  alt?: Maybe<Scalars['String']['output']>;
};

export type PageFormSettingsSeoOrg = {
  __typename?: 'PageFormSettingsSeoOrg';
  disable?: Maybe<Scalars['Boolean']['output']>;
};

export type ArticleSettingsSeoFaqItems = {
  __typename?: 'ArticleSettingsSeoFaqItems';
  q?: Maybe<Scalars['String']['output']>;
  a?: Maybe<Scalars['String']['output']>;
};

export type PageFormSettingsSeoFaq = {
  __typename?: 'PageFormSettingsSeoFaq';
  disable?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  items?: Maybe<Array<Maybe<ArticleSettingsSeoFaqItems>>>;
};

export type ArticleSettingsSeoHowToImage = {
  __typename?: 'ArticleSettingsSeoHowToImage';
  src?: Maybe<Scalars['String']['output']>;
  width?: Maybe<Scalars['Float']['output']>;
  height?: Maybe<Scalars['Float']['output']>;
  aspectRatio?: Maybe<Scalars['Float']['output']>;
  format?: Maybe<Scalars['String']['output']>;
  alt?: Maybe<Scalars['String']['output']>;
};

export type ArticleSettingsSeoHowToSteps = {
  __typename?: 'ArticleSettingsSeoHowToSteps';
  name?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
};

export type PageFormSettingsSeoHowTo = {
  __typename?: 'PageFormSettingsSeoHowTo';
  disable?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  image?: Maybe<ArticleSettingsSeoHowToImage>;
  steps?: Maybe<Array<Maybe<ArticleSettingsSeoHowToSteps>>>;
};

export type PageBlogSettingsSeo = {
  __typename?: 'PageBlogSettingsSeo';
  title?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  image?: Maybe<PageFormSettingsSeoImage>;
  org?: Maybe<PageFormSettingsSeoOrg>;
  faq?: Maybe<PageFormSettingsSeoFaq>;
  howTo?: Maybe<PageFormSettingsSeoHowTo>;
};

export type PageBlogSettingsSitemap = {
  __typename?: 'PageBlogSettingsSitemap';
  exclude?: Maybe<Scalars['Boolean']['output']>;
  breadcrumb?: Maybe<Scalars['String']['output']>;
  changefreq?: Maybe<Scalars['String']['output']>;
  priority?: Maybe<Scalars['Float']['output']>;
};

export type PageBlogSettingsNotification = Notification;

export type PageFormSettingsNavigationRightSideButtonOverride = {
  __typename?: 'PageFormSettingsNavigationRightSideButtonOverride';
  label?: Maybe<Scalars['String']['output']>;
  link?: Maybe<Scalars['String']['output']>;
  ariaLabel?: Maybe<Scalars['String']['output']>;
};

export type PageBlogSettingsNavigation = {
  __typename?: 'PageBlogSettingsNavigation';
  disableLogo?: Maybe<Scalars['Boolean']['output']>;
  disableLeft?: Maybe<Scalars['Boolean']['output']>;
  disableRight?: Maybe<Scalars['Boolean']['output']>;
  disableButtons?: Maybe<Scalars['Boolean']['output']>;
  rightSideButtonOverride?: Maybe<PageFormSettingsNavigationRightSideButtonOverride>;
};

export type PageBlogSettingsFooter = {
  __typename?: 'PageBlogSettingsFooter';
  disableLinks?: Maybe<Scalars['Boolean']['output']>;
  disableBottom?: Maybe<Scalars['Boolean']['output']>;
};

export type PageBlogSettingsDisclaimer = {
  __typename?: 'PageBlogSettingsDisclaimer';
  disable?: Maybe<Scalars['Boolean']['output']>;
  content?: Maybe<Scalars['JSON']['output']>;
};

export type PageFormSettingsPartnerPartnerRef = Partner;

export type PageFormSettingsPartnerCobrandRef = Cobrand;

export type PageBlogSettingsPartner = {
  __typename?: 'PageBlogSettingsPartner';
  partnerRef?: Maybe<PageFormSettingsPartnerPartnerRef>;
  cobrandRef?: Maybe<PageFormSettingsPartnerCobrandRef>;
};

export type PageBlogSettingsClient = {
  __typename?: 'PageBlogSettingsClient';
  enabled?: Maybe<Scalars['Boolean']['output']>;
};

export type PageBlogSettings = {
  __typename?: 'PageBlogSettings';
  publish?: Maybe<PageBlogSettingsPublish>;
  seo?: Maybe<PageBlogSettingsSeo>;
  sitemap?: Maybe<PageBlogSettingsSitemap>;
  notification?: Maybe<PageBlogSettingsNotification>;
  navigation?: Maybe<PageBlogSettingsNavigation>;
  footer?: Maybe<PageBlogSettingsFooter>;
  disclaimer?: Maybe<PageBlogSettingsDisclaimer>;
  partner?: Maybe<PageBlogSettingsPartner>;
  client?: Maybe<PageBlogSettingsClient>;
};

export type PageBlogCategoriesRef = Category;

export type PageBlogCategories = {
  __typename?: 'PageBlogCategories';
  ref?: Maybe<PageBlogCategoriesRef>;
};

export type PageBlogPopularRef = Post;

export type PageBlogPopular = {
  __typename?: 'PageBlogPopular';
  ref?: Maybe<PageBlogPopularRef>;
};

export type PageBlogCtaButtons = {
  __typename?: 'PageBlogCtaButtons';
  label?: Maybe<Scalars['String']['output']>;
  link?: Maybe<Scalars['String']['output']>;
  ariaLabel?: Maybe<Scalars['String']['output']>;
};

export type PageBlogCta = {
  __typename?: 'PageBlogCta';
  headingText?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  buttons?: Maybe<Array<Maybe<PageBlogCtaButtons>>>;
};

export type PageBlog = Node & Document & {
  __typename?: 'PageBlog';
  component?: Maybe<Scalars['String']['output']>;
  updatedDate?: Maybe<Scalars['String']['output']>;
  publishedDate?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  settings?: Maybe<PageBlogSettings>;
  heading?: Maybe<Scalars['String']['output']>;
  categories?: Maybe<Array<Maybe<PageBlogCategories>>>;
  popular?: Maybe<Array<Maybe<PageBlogPopular>>>;
  cta?: Maybe<PageBlogCta>;
  id: Scalars['ID']['output'];
  _sys: SystemInfo;
  _values: Scalars['JSON']['output'];
};

export type PageFormSettingsPublish = {
  __typename?: 'PageFormSettingsPublish';
  published?: Maybe<Scalars['Boolean']['output']>;
  publishedDate?: Maybe<Scalars['String']['output']>;
};

export type ArticleSettingsSeoImage = {
  __typename?: 'ArticleSettingsSeoImage';
  src?: Maybe<Scalars['String']['output']>;
  width?: Maybe<Scalars['Float']['output']>;
  height?: Maybe<Scalars['Float']['output']>;
  aspectRatio?: Maybe<Scalars['Float']['output']>;
  format?: Maybe<Scalars['String']['output']>;
  alt?: Maybe<Scalars['String']['output']>;
};

export type ArticleSettingsSeoOrg = {
  __typename?: 'ArticleSettingsSeoOrg';
  disable?: Maybe<Scalars['Boolean']['output']>;
};

export type PostSettingsSeoFaqItems = {
  __typename?: 'PostSettingsSeoFaqItems';
  q?: Maybe<Scalars['String']['output']>;
  a?: Maybe<Scalars['String']['output']>;
};

export type ArticleSettingsSeoFaq = {
  __typename?: 'ArticleSettingsSeoFaq';
  disable?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  items?: Maybe<Array<Maybe<PostSettingsSeoFaqItems>>>;
};

export type PostSettingsSeoHowToImage = {
  __typename?: 'PostSettingsSeoHowToImage';
  src?: Maybe<Scalars['String']['output']>;
  width?: Maybe<Scalars['Float']['output']>;
  height?: Maybe<Scalars['Float']['output']>;
  aspectRatio?: Maybe<Scalars['Float']['output']>;
  format?: Maybe<Scalars['String']['output']>;
  alt?: Maybe<Scalars['String']['output']>;
};

export type PostSettingsSeoHowToSteps = {
  __typename?: 'PostSettingsSeoHowToSteps';
  name?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
};

export type ArticleSettingsSeoHowTo = {
  __typename?: 'ArticleSettingsSeoHowTo';
  disable?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  image?: Maybe<PostSettingsSeoHowToImage>;
  steps?: Maybe<Array<Maybe<PostSettingsSeoHowToSteps>>>;
};

export type PageFormSettingsSeo = {
  __typename?: 'PageFormSettingsSeo';
  title?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  image?: Maybe<ArticleSettingsSeoImage>;
  org?: Maybe<ArticleSettingsSeoOrg>;
  faq?: Maybe<ArticleSettingsSeoFaq>;
  howTo?: Maybe<ArticleSettingsSeoHowTo>;
};

export type PageFormSettingsSitemap = {
  __typename?: 'PageFormSettingsSitemap';
  exclude?: Maybe<Scalars['Boolean']['output']>;
  breadcrumb?: Maybe<Scalars['String']['output']>;
  changefreq?: Maybe<Scalars['String']['output']>;
  priority?: Maybe<Scalars['Float']['output']>;
};

export type PageFormSettingsNotification = Notification;

export type ArticleSettingsNavigationRightSideButtonOverride = {
  __typename?: 'ArticleSettingsNavigationRightSideButtonOverride';
  label?: Maybe<Scalars['String']['output']>;
  link?: Maybe<Scalars['String']['output']>;
  ariaLabel?: Maybe<Scalars['String']['output']>;
};

export type PageFormSettingsNavigation = {
  __typename?: 'PageFormSettingsNavigation';
  disableLogo?: Maybe<Scalars['Boolean']['output']>;
  disableLeft?: Maybe<Scalars['Boolean']['output']>;
  disableRight?: Maybe<Scalars['Boolean']['output']>;
  disableButtons?: Maybe<Scalars['Boolean']['output']>;
  rightSideButtonOverride?: Maybe<ArticleSettingsNavigationRightSideButtonOverride>;
};

export type PageFormSettingsFooter = {
  __typename?: 'PageFormSettingsFooter';
  disableLinks?: Maybe<Scalars['Boolean']['output']>;
  disableBottom?: Maybe<Scalars['Boolean']['output']>;
};

export type PageFormSettingsDisclaimer = {
  __typename?: 'PageFormSettingsDisclaimer';
  disable?: Maybe<Scalars['Boolean']['output']>;
  content?: Maybe<Scalars['JSON']['output']>;
};

export type ArticleSettingsPartnerPartnerRef = Partner;

export type ArticleSettingsPartnerCobrandRef = Cobrand;

export type PageFormSettingsPartner = {
  __typename?: 'PageFormSettingsPartner';
  partnerRef?: Maybe<ArticleSettingsPartnerPartnerRef>;
  cobrandRef?: Maybe<ArticleSettingsPartnerCobrandRef>;
};

export type PageFormSettingsClient = {
  __typename?: 'PageFormSettingsClient';
  enabled?: Maybe<Scalars['Boolean']['output']>;
};

export type PageFormSettings = {
  __typename?: 'PageFormSettings';
  publish?: Maybe<PageFormSettingsPublish>;
  seo?: Maybe<PageFormSettingsSeo>;
  sitemap?: Maybe<PageFormSettingsSitemap>;
  notification?: Maybe<PageFormSettingsNotification>;
  navigation?: Maybe<PageFormSettingsNavigation>;
  footer?: Maybe<PageFormSettingsFooter>;
  disclaimer?: Maybe<PageFormSettingsDisclaimer>;
  partner?: Maybe<PageFormSettingsPartner>;
  client?: Maybe<PageFormSettingsClient>;
};

export type PageFormCarrierButton = {
  __typename?: 'PageFormCarrierButton';
  label?: Maybe<Scalars['String']['output']>;
  link?: Maybe<Scalars['String']['output']>;
  ariaLabel?: Maybe<Scalars['String']['output']>;
  hint?: Maybe<Scalars['String']['output']>;
};

export type PageFormCarrier = {
  __typename?: 'PageFormCarrier';
  logo?: Maybe<Scalars['String']['output']>;
  headingText?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  button?: Maybe<PageFormCarrierButton>;
};

export type PageFormFormImages = {
  __typename?: 'PageFormFormImages';
  image?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type PageFormFormSettings = FormLtdiManualForm | FormStdiDigitalForm | FormLtcManualForm | FormCiForm | FormAeiForm | FormGroupDiForm | FormLtdiDropticketForm | FormLtcDropticketForm | FormGroupDiCalculatorForm | FormAgentSignupForm | FormAgentSimpleForm;

export type PageFormForm = {
  __typename?: 'PageFormForm';
  title?: Maybe<Scalars['String']['output']>;
  headingText?: Maybe<Scalars['String']['output']>;
  subheadingText?: Maybe<Scalars['String']['output']>;
  images?: Maybe<Array<Maybe<PageFormFormImages>>>;
  settings?: Maybe<PageFormFormSettings>;
};

export type PageFormCalendar = {
  __typename?: 'PageFormCalendar';
  headingText?: Maybe<Scalars['String']['output']>;
  subheadingText?: Maybe<Scalars['String']['output']>;
};

export type PageFormSidebarHelpLinks = {
  __typename?: 'PageFormSidebarHelpLinks';
  label?: Maybe<Scalars['String']['output']>;
  link?: Maybe<Scalars['String']['output']>;
  ariaLabel?: Maybe<Scalars['String']['output']>;
};

export type PageFormSidebarHelp = {
  __typename?: 'PageFormSidebarHelp';
  title?: Maybe<Scalars['String']['output']>;
  links?: Maybe<Array<Maybe<PageFormSidebarHelpLinks>>>;
};

export type PageFormSidebarItems = {
  __typename?: 'PageFormSidebarItems';
  title?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
};

export type PageFormSidebarContactsItems = {
  __typename?: 'PageFormSidebarContactsItems';
  textRich?: Maybe<Scalars['JSON']['output']>;
  sub?: Maybe<Scalars['String']['output']>;
};

export type PageFormSidebarContacts = {
  __typename?: 'PageFormSidebarContacts';
  title?: Maybe<Scalars['String']['output']>;
  items?: Maybe<Array<Maybe<PageFormSidebarContactsItems>>>;
};

export type PageFormSidebarTestimonial = Testimonial;

export type PageFormSidebar = {
  __typename?: 'PageFormSidebar';
  help?: Maybe<PageFormSidebarHelp>;
  headingText?: Maybe<Scalars['String']['output']>;
  subheadingText?: Maybe<Scalars['String']['output']>;
  items?: Maybe<Array<Maybe<PageFormSidebarItems>>>;
  contacts?: Maybe<PageFormSidebarContacts>;
  testimonial?: Maybe<PageFormSidebarTestimonial>;
  image?: Maybe<Scalars['String']['output']>;
};

export type PageForm = Node & Document & {
  __typename?: 'PageForm';
  component?: Maybe<Scalars['String']['output']>;
  updatedDate?: Maybe<Scalars['String']['output']>;
  publishedDate?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  settings?: Maybe<PageFormSettings>;
  carrier?: Maybe<PageFormCarrier>;
  form?: Maybe<PageFormForm>;
  calendar?: Maybe<PageFormCalendar>;
  sidebar?: Maybe<PageFormSidebar>;
  id: Scalars['ID']['output'];
  _sys: SystemInfo;
  _values: Scalars['JSON']['output'];
};

export type Page = PageGeneric | PageBlog | PageForm;

export type StringFilter = {
  startsWith?: InputMaybe<Scalars['String']['input']>;
  eq?: InputMaybe<Scalars['String']['input']>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type DatetimeFilter = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  eq?: InputMaybe<Scalars['String']['input']>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type BooleanFilter = {
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PageGenericSettingsPublishFilter = {
  published?: InputMaybe<BooleanFilter>;
  publishedDate?: InputMaybe<DatetimeFilter>;
};

export type NumberFilter = {
  lt?: InputMaybe<Scalars['Float']['input']>;
  lte?: InputMaybe<Scalars['Float']['input']>;
  gte?: InputMaybe<Scalars['Float']['input']>;
  gt?: InputMaybe<Scalars['Float']['input']>;
  eq?: InputMaybe<Scalars['Float']['input']>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};

export type PageBlogSettingsSeoImageFilter = {
  src?: InputMaybe<StringFilter>;
  width?: InputMaybe<NumberFilter>;
  height?: InputMaybe<NumberFilter>;
  aspectRatio?: InputMaybe<NumberFilter>;
  format?: InputMaybe<StringFilter>;
  alt?: InputMaybe<StringFilter>;
};

export type PageBlogSettingsSeoOrgFilter = {
  disable?: InputMaybe<BooleanFilter>;
};

export type PageFormSettingsSeoFaqItemsFilter = {
  q?: InputMaybe<StringFilter>;
  a?: InputMaybe<StringFilter>;
};

export type PageBlogSettingsSeoFaqFilter = {
  disable?: InputMaybe<BooleanFilter>;
  name?: InputMaybe<StringFilter>;
  items?: InputMaybe<PageFormSettingsSeoFaqItemsFilter>;
};

export type PageFormSettingsSeoHowToImageFilter = {
  src?: InputMaybe<StringFilter>;
  width?: InputMaybe<NumberFilter>;
  height?: InputMaybe<NumberFilter>;
  aspectRatio?: InputMaybe<NumberFilter>;
  format?: InputMaybe<StringFilter>;
  alt?: InputMaybe<StringFilter>;
};

export type PageFormSettingsSeoHowToStepsFilter = {
  name?: InputMaybe<StringFilter>;
  url?: InputMaybe<StringFilter>;
  text?: InputMaybe<StringFilter>;
};

export type PageBlogSettingsSeoHowToFilter = {
  disable?: InputMaybe<BooleanFilter>;
  name?: InputMaybe<StringFilter>;
  description?: InputMaybe<StringFilter>;
  image?: InputMaybe<PageFormSettingsSeoHowToImageFilter>;
  steps?: InputMaybe<PageFormSettingsSeoHowToStepsFilter>;
};

export type PageGenericSettingsSeoFilter = {
  title?: InputMaybe<StringFilter>;
  url?: InputMaybe<StringFilter>;
  description?: InputMaybe<StringFilter>;
  image?: InputMaybe<PageBlogSettingsSeoImageFilter>;
  org?: InputMaybe<PageBlogSettingsSeoOrgFilter>;
  faq?: InputMaybe<PageBlogSettingsSeoFaqFilter>;
  howTo?: InputMaybe<PageBlogSettingsSeoHowToFilter>;
};

export type PageGenericSettingsSitemapFilter = {
  exclude?: InputMaybe<BooleanFilter>;
  breadcrumb?: InputMaybe<StringFilter>;
  changefreq?: InputMaybe<StringFilter>;
  priority?: InputMaybe<NumberFilter>;
};

export type PageGenericSettingsNotificationFilter = {
  notification?: InputMaybe<NotificationFilter>;
};

export type PageBlogSettingsNavigationRightSideButtonOverrideFilter = {
  label?: InputMaybe<StringFilter>;
  link?: InputMaybe<StringFilter>;
  ariaLabel?: InputMaybe<StringFilter>;
};

export type PageGenericSettingsNavigationFilter = {
  disableLogo?: InputMaybe<BooleanFilter>;
  disableLeft?: InputMaybe<BooleanFilter>;
  disableRight?: InputMaybe<BooleanFilter>;
  disableButtons?: InputMaybe<BooleanFilter>;
  rightSideButtonOverride?: InputMaybe<PageBlogSettingsNavigationRightSideButtonOverrideFilter>;
};

export type PageGenericSettingsFooterFilter = {
  disableLinks?: InputMaybe<BooleanFilter>;
  disableBottom?: InputMaybe<BooleanFilter>;
};

export type RichTextFilter = {
  startsWith?: InputMaybe<Scalars['String']['input']>;
  eq?: InputMaybe<Scalars['String']['input']>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PageGenericSettingsDisclaimerFilter = {
  disable?: InputMaybe<BooleanFilter>;
  content?: InputMaybe<RichTextFilter>;
};

export type PageBlogSettingsPartnerPartnerRefFilter = {
  partner?: InputMaybe<PartnerFilter>;
};

export type PageBlogSettingsPartnerCobrandRefFilter = {
  cobrand?: InputMaybe<CobrandFilter>;
};

export type PageGenericSettingsPartnerFilter = {
  partnerRef?: InputMaybe<PageBlogSettingsPartnerPartnerRefFilter>;
  cobrandRef?: InputMaybe<PageBlogSettingsPartnerCobrandRefFilter>;
};

export type PageGenericSettingsClientFilter = {
  enabled?: InputMaybe<BooleanFilter>;
};

export type PageGenericSettingsFilter = {
  publish?: InputMaybe<PageGenericSettingsPublishFilter>;
  seo?: InputMaybe<PageGenericSettingsSeoFilter>;
  sitemap?: InputMaybe<PageGenericSettingsSitemapFilter>;
  notification?: InputMaybe<PageGenericSettingsNotificationFilter>;
  navigation?: InputMaybe<PageGenericSettingsNavigationFilter>;
  footer?: InputMaybe<PageGenericSettingsFooterFilter>;
  disclaimer?: InputMaybe<PageGenericSettingsDisclaimerFilter>;
  partner?: InputMaybe<PageGenericSettingsPartnerFilter>;
  client?: InputMaybe<PageGenericSettingsClientFilter>;
};

export type PageGenericContentSectionHeroGenericHeadingRichTextRotatorFilter = {
  items?: InputMaybe<StringFilter>;
};

export type PageGenericContentSectionHeroGenericHeadingRichBreakFilter = {
  size?: InputMaybe<NumberFilter>;
};

export type PageGenericContentSectionHeroGenericHeadingRichCompanyNameFilter = {
  usePossesive?: InputMaybe<BooleanFilter>;
  fallback?: InputMaybe<StringFilter>;
};

export type PageGenericContentSectionHeroGenericHeadingRichClientNameFilter = {
  useFirstName?: InputMaybe<BooleanFilter>;
  useLastName?: InputMaybe<BooleanFilter>;
  usePossesive?: InputMaybe<BooleanFilter>;
  highlight?: InputMaybe<BooleanFilter>;
  highlightColor?: InputMaybe<StringFilter>;
  fallback?: InputMaybe<StringFilter>;
};

export type PageGenericContentSectionHeroGenericHeadingRichCurrentYearFilter = {
  add?: InputMaybe<StringFilter>;
};

export type PageGenericContentSectionHeroGenericHeadingRichFilter = {
  TextRotator?: InputMaybe<PageGenericContentSectionHeroGenericHeadingRichTextRotatorFilter>;
  Break?: InputMaybe<PageGenericContentSectionHeroGenericHeadingRichBreakFilter>;
  CompanyName?: InputMaybe<PageGenericContentSectionHeroGenericHeadingRichCompanyNameFilter>;
  ClientName?: InputMaybe<PageGenericContentSectionHeroGenericHeadingRichClientNameFilter>;
  CurrentYear?: InputMaybe<PageGenericContentSectionHeroGenericHeadingRichCurrentYearFilter>;
};

export type PageGenericContentSectionHeroGenericSubheadingRichHighlightFilter = {
  color?: InputMaybe<StringFilter>;
  body?: InputMaybe<StringFilter>;
};

export type PageGenericContentSectionHeroGenericSubheadingRichFilter = {
  highlight?: InputMaybe<PageGenericContentSectionHeroGenericSubheadingRichHighlightFilter>;
};

export type PageGenericContentSectionHeroGenericTextRichHighlightFilter = {
  color?: InputMaybe<StringFilter>;
  body?: InputMaybe<StringFilter>;
};

export type PageGenericContentSectionHeroGenericTextRichFilter = {
  highlight?: InputMaybe<PageGenericContentSectionHeroGenericTextRichHighlightFilter>;
};

export type PageGenericContentSectionHeroGenericListsFilter = {
  title?: InputMaybe<StringFilter>;
  items?: InputMaybe<StringFilter>;
};

export type PageGenericContentSectionHeroGenericImageFilter = {
  src?: InputMaybe<StringFilter>;
  width?: InputMaybe<NumberFilter>;
  height?: InputMaybe<NumberFilter>;
  aspectRatio?: InputMaybe<NumberFilter>;
  format?: InputMaybe<StringFilter>;
  alt?: InputMaybe<StringFilter>;
  scale?: InputMaybe<NumberFilter>;
};

export type PageGenericContentSectionHeroGenericSimpleFormRefFilter = {
  form?: InputMaybe<FormFilter>;
};

export type PageGenericContentSectionHeroGenericButtonsFilter = {
  label?: InputMaybe<StringFilter>;
  link?: InputMaybe<StringFilter>;
  ariaLabel?: InputMaybe<StringFilter>;
};

export type PageGenericContentSectionHeroGenericFormRefFilter = {
  form?: InputMaybe<FormFilter>;
};

export type ImageFilter = {
  startsWith?: InputMaybe<Scalars['String']['input']>;
  eq?: InputMaybe<Scalars['String']['input']>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type PageGenericContentSectionHeroGenericFloatingItemsSingleIconLinkItemFilter = {
  icon?: InputMaybe<ImageFilter>;
  title?: InputMaybe<StringFilter>;
  text?: InputMaybe<StringFilter>;
  link?: InputMaybe<StringFilter>;
};

export type PageGenericContentSectionHeroGenericFloatingItemsSingleIconTextItemFilter = {
  icon?: InputMaybe<ImageFilter>;
  text?: InputMaybe<StringFilter>;
};

export type PageGenericContentSectionHeroGenericFloatingItemsGroupedIconTextItemItemsFilter = {
  icon?: InputMaybe<ImageFilter>;
  text?: InputMaybe<StringFilter>;
};

export type PageGenericContentSectionHeroGenericFloatingItemsGroupedIconTextItemFilter = {
  items?: InputMaybe<PageGenericContentSectionHeroGenericFloatingItemsGroupedIconTextItemItemsFilter>;
};

export type PageGenericContentSectionHeroGenericFloatingItemsSingleImageTextItemFilter = {
  image?: InputMaybe<ImageFilter>;
  text?: InputMaybe<StringFilter>;
};

export type PageGenericContentSectionHeroGenericFloatingItemsGroupedImageTextItemItemsFilter = {
  image?: InputMaybe<ImageFilter>;
  text?: InputMaybe<StringFilter>;
};

export type PageGenericContentSectionHeroGenericFloatingItemsGroupedImageTextItemFilter = {
  items?: InputMaybe<PageGenericContentSectionHeroGenericFloatingItemsGroupedImageTextItemItemsFilter>;
};

export type PageGenericContentSectionHeroGenericFloatingItemsSingleImageItemFilter = {
  image?: InputMaybe<ImageFilter>;
};

export type PageGenericContentSectionHeroGenericFloatingItemsFilter = {
  singleIconLinkItem?: InputMaybe<PageGenericContentSectionHeroGenericFloatingItemsSingleIconLinkItemFilter>;
  singleIconTextItem?: InputMaybe<PageGenericContentSectionHeroGenericFloatingItemsSingleIconTextItemFilter>;
  groupedIconTextItem?: InputMaybe<PageGenericContentSectionHeroGenericFloatingItemsGroupedIconTextItemFilter>;
  singleImageTextItem?: InputMaybe<PageGenericContentSectionHeroGenericFloatingItemsSingleImageTextItemFilter>;
  groupedImageTextItem?: InputMaybe<PageGenericContentSectionHeroGenericFloatingItemsGroupedImageTextItemFilter>;
  singleImageItem?: InputMaybe<PageGenericContentSectionHeroGenericFloatingItemsSingleImageItemFilter>;
};

export type PageGenericContentSectionHeroGenericFilter = {
  title?: InputMaybe<StringFilter>;
  headingSize?: InputMaybe<StringFilter>;
  headingRich?: InputMaybe<PageGenericContentSectionHeroGenericHeadingRichFilter>;
  subheadingRich?: InputMaybe<PageGenericContentSectionHeroGenericSubheadingRichFilter>;
  textRich?: InputMaybe<PageGenericContentSectionHeroGenericTextRichFilter>;
  lists?: InputMaybe<PageGenericContentSectionHeroGenericListsFilter>;
  image?: InputMaybe<PageGenericContentSectionHeroGenericImageFilter>;
  simpleFormRef?: InputMaybe<PageGenericContentSectionHeroGenericSimpleFormRefFilter>;
  buttons?: InputMaybe<PageGenericContentSectionHeroGenericButtonsFilter>;
  formRef?: InputMaybe<PageGenericContentSectionHeroGenericFormRefFilter>;
  floatingItems?: InputMaybe<PageGenericContentSectionHeroGenericFloatingItemsFilter>;
};

export type PageGenericContentSectionHeroAgentHeadingRichBreakFilter = {
  size?: InputMaybe<NumberFilter>;
};

export type PageGenericContentSectionHeroAgentHeadingRichAgentNameFilter = {
  default?: InputMaybe<StringFilter>;
};

export type PageGenericContentSectionHeroAgentHeadingRichCurrentYearFilter = {
  add?: InputMaybe<StringFilter>;
};

export type PageGenericContentSectionHeroAgentHeadingRichFilter = {
  Break?: InputMaybe<PageGenericContentSectionHeroAgentHeadingRichBreakFilter>;
  AgentName?: InputMaybe<PageGenericContentSectionHeroAgentHeadingRichAgentNameFilter>;
  CurrentYear?: InputMaybe<PageGenericContentSectionHeroAgentHeadingRichCurrentYearFilter>;
};

export type PageGenericContentSectionHeroAgentFallbackHeadingRichBreakFilter = {
  size?: InputMaybe<NumberFilter>;
};

export type PageGenericContentSectionHeroAgentFallbackHeadingRichFilter = {
  Break?: InputMaybe<PageGenericContentSectionHeroAgentFallbackHeadingRichBreakFilter>;
};

export type PageGenericContentSectionHeroAgentImageFilter = {
  src?: InputMaybe<StringFilter>;
  width?: InputMaybe<NumberFilter>;
  height?: InputMaybe<NumberFilter>;
  aspectRatio?: InputMaybe<NumberFilter>;
  format?: InputMaybe<StringFilter>;
  alt?: InputMaybe<StringFilter>;
};

export type PageGenericContentSectionHeroAgentDefaultProductsProductRefFilter = {
  product?: InputMaybe<ProductFilter>;
};

export type PageGenericContentSectionHeroAgentDefaultProductsFilter = {
  productRef?: InputMaybe<PageGenericContentSectionHeroAgentDefaultProductsProductRefFilter>;
};

export type PageGenericContentSectionHeroAgentDisplayFilter = {
  icon?: InputMaybe<BooleanFilter>;
  graphic?: InputMaybe<BooleanFilter>;
  actionLabel?: InputMaybe<BooleanFilter>;
  descriptionText?: InputMaybe<BooleanFilter>;
  descriptionItems?: InputMaybe<BooleanFilter>;
  disclaimer?: InputMaybe<BooleanFilter>;
  buttons?: InputMaybe<BooleanFilter>;
};

export type PageGenericContentSectionHeroAgentFilter = {
  headingRich?: InputMaybe<PageGenericContentSectionHeroAgentHeadingRichFilter>;
  fallbackHeadingRich?: InputMaybe<PageGenericContentSectionHeroAgentFallbackHeadingRichFilter>;
  textRich?: InputMaybe<RichTextFilter>;
  image?: InputMaybe<PageGenericContentSectionHeroAgentImageFilter>;
  defaultProducts?: InputMaybe<PageGenericContentSectionHeroAgentDefaultProductsFilter>;
  display?: InputMaybe<PageGenericContentSectionHeroAgentDisplayFilter>;
};

export type PageGenericContentSectionLogosImagesFilter = {
  image?: InputMaybe<ImageFilter>;
  title?: InputMaybe<StringFilter>;
};

export type PageGenericContentSectionLogosFilter = {
  headingText?: InputMaybe<StringFilter>;
  images?: InputMaybe<PageGenericContentSectionLogosImagesFilter>;
};

export type PageGenericContentSectionBadgesBadgesFilter = {
  image?: InputMaybe<ImageFilter>;
  text?: InputMaybe<StringFilter>;
};

export type PageGenericContentSectionBadgesFilter = {
  title?: InputMaybe<StringFilter>;
  badges?: InputMaybe<PageGenericContentSectionBadgesBadgesFilter>;
};

export type PageGenericContentSectionTestimonialSliderTextRichBreakFilter = {
  size?: InputMaybe<NumberFilter>;
};

export type PageGenericContentSectionTestimonialSliderTextRichClientNameFilter = {
  useFirstName?: InputMaybe<BooleanFilter>;
  useLastName?: InputMaybe<BooleanFilter>;
  usePossesive?: InputMaybe<BooleanFilter>;
  highlight?: InputMaybe<BooleanFilter>;
  highlightColor?: InputMaybe<StringFilter>;
  fallback?: InputMaybe<StringFilter>;
};

export type PageGenericContentSectionTestimonialSliderTextRichFilter = {
  Break?: InputMaybe<PageGenericContentSectionTestimonialSliderTextRichBreakFilter>;
  ClientName?: InputMaybe<PageGenericContentSectionTestimonialSliderTextRichClientNameFilter>;
};

export type PageGenericContentSectionTestimonialSliderItemsRefFilter = {
  testimonial?: InputMaybe<TestimonialFilter>;
};

export type PageGenericContentSectionTestimonialSliderItemsFilter = {
  ref?: InputMaybe<PageGenericContentSectionTestimonialSliderItemsRefFilter>;
};

export type PageGenericContentSectionTestimonialSliderFilter = {
  title?: InputMaybe<StringFilter>;
  headingRich?: InputMaybe<RichTextFilter>;
  highlight?: InputMaybe<StringFilter>;
  textRich?: InputMaybe<PageGenericContentSectionTestimonialSliderTextRichFilter>;
  items?: InputMaybe<PageGenericContentSectionTestimonialSliderItemsFilter>;
};

export type PageGenericContentSectionTestimonialGridItemsRefFilter = {
  testimonial?: InputMaybe<TestimonialFilter>;
};

export type PageGenericContentSectionTestimonialGridItemsFilter = {
  ref?: InputMaybe<PageGenericContentSectionTestimonialGridItemsRefFilter>;
};

export type PageGenericContentSectionTestimonialGridFilter = {
  headingText?: InputMaybe<StringFilter>;
  items?: InputMaybe<PageGenericContentSectionTestimonialGridItemsFilter>;
};

export type PageGenericContentSectionFloatingCtaButtonsFilter = {
  label?: InputMaybe<StringFilter>;
  link?: InputMaybe<StringFilter>;
  ariaLabel?: InputMaybe<StringFilter>;
};

export type PageGenericContentSectionFloatingCtaFilter = {
  headingText?: InputMaybe<StringFilter>;
  text?: InputMaybe<StringFilter>;
  buttons?: InputMaybe<PageGenericContentSectionFloatingCtaButtonsFilter>;
};

export type PageGenericContentSectionImageCtaButtonsFilter = {
  label?: InputMaybe<StringFilter>;
  link?: InputMaybe<StringFilter>;
  ariaLabel?: InputMaybe<StringFilter>;
};

export type PageGenericContentSectionImageCtaFilter = {
  headingText?: InputMaybe<StringFilter>;
  text?: InputMaybe<StringFilter>;
  buttons?: InputMaybe<PageGenericContentSectionImageCtaButtonsFilter>;
  imageSrc?: InputMaybe<ImageFilter>;
};

export type PageGenericContentSectionProductsHeadingRichTextRotatorFilter = {
  items?: InputMaybe<StringFilter>;
};

export type PageGenericContentSectionProductsHeadingRichBreakFilter = {
  size?: InputMaybe<NumberFilter>;
};

export type PageGenericContentSectionProductsHeadingRichFilter = {
  TextRotator?: InputMaybe<PageGenericContentSectionProductsHeadingRichTextRotatorFilter>;
  Break?: InputMaybe<PageGenericContentSectionProductsHeadingRichBreakFilter>;
};

export type PageGenericContentSectionProductsItemsRefFilter = {
  product?: InputMaybe<ProductFilter>;
};

export type PageGenericContentSectionProductsItemsFilter = {
  ref?: InputMaybe<PageGenericContentSectionProductsItemsRefFilter>;
};

export type PageGenericContentSectionProductsDisplayFilter = {
  icon?: InputMaybe<BooleanFilter>;
  graphic?: InputMaybe<BooleanFilter>;
  actionLabel?: InputMaybe<BooleanFilter>;
  descriptionText?: InputMaybe<BooleanFilter>;
  descriptionItems?: InputMaybe<BooleanFilter>;
  disclaimer?: InputMaybe<BooleanFilter>;
  buttons?: InputMaybe<BooleanFilter>;
};

export type PageGenericContentSectionProductsFilter = {
  headingRich?: InputMaybe<PageGenericContentSectionProductsHeadingRichFilter>;
  text?: InputMaybe<StringFilter>;
  title?: InputMaybe<StringFilter>;
  items?: InputMaybe<PageGenericContentSectionProductsItemsFilter>;
  display?: InputMaybe<PageGenericContentSectionProductsDisplayFilter>;
};

export type PageGenericContentSectionProductsSimpleItemsRefFilter = {
  product?: InputMaybe<ProductFilter>;
};

export type PageGenericContentSectionProductsSimpleItemsFilter = {
  ref?: InputMaybe<PageGenericContentSectionProductsSimpleItemsRefFilter>;
};

export type PageGenericContentSectionProductsSimpleDisplayFilter = {
  actionLabel?: InputMaybe<BooleanFilter>;
  descriptionText?: InputMaybe<BooleanFilter>;
  descriptionItems?: InputMaybe<BooleanFilter>;
  disclaimer?: InputMaybe<BooleanFilter>;
  buttons?: InputMaybe<BooleanFilter>;
};

export type PageGenericContentSectionProductsSimpleFilter = {
  items?: InputMaybe<PageGenericContentSectionProductsSimpleItemsFilter>;
  display?: InputMaybe<PageGenericContentSectionProductsSimpleDisplayFilter>;
};

export type PageGenericContentSectionHowItWorksItemsButtonFilter = {
  label?: InputMaybe<StringFilter>;
  link?: InputMaybe<StringFilter>;
  ariaLabel?: InputMaybe<StringFilter>;
};

export type PageGenericContentSectionHowItWorksItemsFilter = {
  image?: InputMaybe<ImageFilter>;
  headingText?: InputMaybe<StringFilter>;
  subheadingText?: InputMaybe<StringFilter>;
  text?: InputMaybe<StringFilter>;
  button?: InputMaybe<PageGenericContentSectionHowItWorksItemsButtonFilter>;
};

export type PageGenericContentSectionHowItWorksDisplayFilter = {
  number?: InputMaybe<BooleanFilter>;
};

export type PageGenericContentSectionHowItWorksFilter = {
  title?: InputMaybe<StringFilter>;
  headingText?: InputMaybe<StringFilter>;
  active?: InputMaybe<NumberFilter>;
  items?: InputMaybe<PageGenericContentSectionHowItWorksItemsFilter>;
  display?: InputMaybe<PageGenericContentSectionHowItWorksDisplayFilter>;
};

export type PageGenericContentSectionIconColumnsColsFilter = {
  imageSrc?: InputMaybe<ImageFilter>;
  disableIconBg?: InputMaybe<BooleanFilter>;
  size?: InputMaybe<NumberFilter>;
  title?: InputMaybe<StringFilter>;
  titleSize?: InputMaybe<StringFilter>;
  text?: InputMaybe<StringFilter>;
};

export type PageGenericContentSectionIconColumnsFilter = {
  title?: InputMaybe<StringFilter>;
  headingText?: InputMaybe<StringFilter>;
  subheadingText?: InputMaybe<StringFilter>;
  colNum?: InputMaybe<NumberFilter>;
  colSpacing?: InputMaybe<NumberFilter>;
  bgColor?: InputMaybe<StringFilter>;
  cols?: InputMaybe<PageGenericContentSectionIconColumnsColsFilter>;
};

export type PageGenericContentSectionBlogPostsPostsRefFilter = {
  post?: InputMaybe<PostFilter>;
};

export type PageGenericContentSectionBlogPostsPostsFilter = {
  ref?: InputMaybe<PageGenericContentSectionBlogPostsPostsRefFilter>;
};

export type PageGenericContentSectionBlogPostsFilter = {
  title?: InputMaybe<StringFilter>;
  headingText?: InputMaybe<StringFilter>;
  posts?: InputMaybe<PageGenericContentSectionBlogPostsPostsFilter>;
};

export type PageGenericContentSectionArticlesPostsRefFilter = {
  article?: InputMaybe<ArticleFilter>;
};

export type PageGenericContentSectionArticlesPostsFilter = {
  ref?: InputMaybe<PageGenericContentSectionArticlesPostsRefFilter>;
};

export type PageGenericContentSectionArticlesFilter = {
  title?: InputMaybe<StringFilter>;
  headingText?: InputMaybe<StringFilter>;
  posts?: InputMaybe<PageGenericContentSectionArticlesPostsFilter>;
};

export type PageGenericContentSectionCtaArticlesPostsCtaFilter = {
  label?: InputMaybe<StringFilter>;
  link?: InputMaybe<StringFilter>;
};

export type PageGenericContentSectionCtaArticlesPostsRefFilter = {
  article?: InputMaybe<ArticleFilter>;
};

export type PageGenericContentSectionCtaArticlesPostsFilter = {
  tag?: InputMaybe<StringFilter>;
  headingText?: InputMaybe<StringFilter>;
  imageSrc?: InputMaybe<ImageFilter>;
  cta?: InputMaybe<PageGenericContentSectionCtaArticlesPostsCtaFilter>;
  ref?: InputMaybe<PageGenericContentSectionCtaArticlesPostsRefFilter>;
};

export type PageGenericContentSectionCtaArticlesFilter = {
  posts?: InputMaybe<PageGenericContentSectionCtaArticlesPostsFilter>;
};

export type PageGenericContentSectionHelpfulArticlesCtaButtonFilter = {
  label?: InputMaybe<StringFilter>;
  link?: InputMaybe<StringFilter>;
};

export type PageGenericContentSectionHelpfulArticlesCtaFilter = {
  headingText?: InputMaybe<StringFilter>;
  imageSrc?: InputMaybe<ImageFilter>;
  button?: InputMaybe<PageGenericContentSectionHelpfulArticlesCtaButtonFilter>;
};

export type PageGenericContentSectionHelpfulArticlesPostsRefFilter = {
  article?: InputMaybe<ArticleFilter>;
};

export type PageGenericContentSectionHelpfulArticlesPostsFilter = {
  ref?: InputMaybe<PageGenericContentSectionHelpfulArticlesPostsRefFilter>;
};

export type PageGenericContentSectionHelpfulArticlesFilter = {
  cta?: InputMaybe<PageGenericContentSectionHelpfulArticlesCtaFilter>;
  title?: InputMaybe<StringFilter>;
  posts?: InputMaybe<PageGenericContentSectionHelpfulArticlesPostsFilter>;
};

export type PageGenericContentSectionStatsItemsFilter = {
  number?: InputMaybe<NumberFilter>;
  unit?: InputMaybe<StringFilter>;
  text?: InputMaybe<StringFilter>;
};

export type PageGenericContentSectionStatsSecondaryHeadingHighlightFilter = {
  color?: InputMaybe<StringFilter>;
  body?: InputMaybe<StringFilter>;
};

export type PageGenericContentSectionStatsSecondaryHeadingBreakFilter = {
  size?: InputMaybe<NumberFilter>;
};

export type PageGenericContentSectionStatsSecondaryHeadingFilter = {
  highlight?: InputMaybe<PageGenericContentSectionStatsSecondaryHeadingHighlightFilter>;
  Break?: InputMaybe<PageGenericContentSectionStatsSecondaryHeadingBreakFilter>;
};

export type PageGenericContentSectionStatsButtonFilter = {
  label?: InputMaybe<StringFilter>;
  link?: InputMaybe<StringFilter>;
  ariaLabel?: InputMaybe<StringFilter>;
};

export type PageGenericContentSectionStatsQuoteFilter = {
  text?: InputMaybe<StringFilter>;
  author?: InputMaybe<StringFilter>;
  title?: InputMaybe<StringFilter>;
};

export type PageGenericContentSectionStatsFilter = {
  title?: InputMaybe<StringFilter>;
  headingText?: InputMaybe<StringFilter>;
  items?: InputMaybe<PageGenericContentSectionStatsItemsFilter>;
  secondaryHeading?: InputMaybe<PageGenericContentSectionStatsSecondaryHeadingFilter>;
  text?: InputMaybe<StringFilter>;
  button?: InputMaybe<PageGenericContentSectionStatsButtonFilter>;
  imageSrc?: InputMaybe<ImageFilter>;
  quote?: InputMaybe<PageGenericContentSectionStatsQuoteFilter>;
};

export type PageGenericContentSectionResourcesGroupsItemsFilter = {
  label?: InputMaybe<StringFilter>;
  link?: InputMaybe<StringFilter>;
  ariaLabel?: InputMaybe<StringFilter>;
};

export type PageGenericContentSectionResourcesGroupsFilter = {
  title?: InputMaybe<StringFilter>;
  items?: InputMaybe<PageGenericContentSectionResourcesGroupsItemsFilter>;
};

export type PageGenericContentSectionResourcesFilter = {
  title?: InputMaybe<StringFilter>;
  headingText?: InputMaybe<StringFilter>;
  imageSrc?: InputMaybe<ImageFilter>;
  groups?: InputMaybe<PageGenericContentSectionResourcesGroupsFilter>;
};

export type PageGenericContentSectionResourceHubGroupsArticlesLinkFilter = {
  label?: InputMaybe<StringFilter>;
  link?: InputMaybe<StringFilter>;
  ariaLabel?: InputMaybe<StringFilter>;
};

export type PageGenericContentSectionResourceHubGroupsArticlesFilter = {
  title?: InputMaybe<StringFilter>;
  textRich?: InputMaybe<RichTextFilter>;
  link?: InputMaybe<PageGenericContentSectionResourceHubGroupsArticlesLinkFilter>;
};

export type PageGenericContentSectionResourceHubGroupsFilter = {
  title?: InputMaybe<StringFilter>;
  tocTitle?: InputMaybe<StringFilter>;
  articles?: InputMaybe<PageGenericContentSectionResourceHubGroupsArticlesFilter>;
};

export type PageGenericContentSectionResourceHubFilter = {
  title?: InputMaybe<StringFilter>;
  headingText?: InputMaybe<StringFilter>;
  imageSrc?: InputMaybe<ImageFilter>;
  groups?: InputMaybe<PageGenericContentSectionResourceHubGroupsFilter>;
};

export type PageGenericContentSectionFileResourcesFilterSettingsFiltersItemsFilter = {
  label?: InputMaybe<StringFilter>;
  tag?: InputMaybe<StringFilter>;
};

export type PageGenericContentSectionFileResourcesFilterSettingsFiltersFilter = {
  label?: InputMaybe<StringFilter>;
  items?: InputMaybe<PageGenericContentSectionFileResourcesFilterSettingsFiltersItemsFilter>;
};

export type PageGenericContentSectionFileResourcesFilterSettingsFilter = {
  title?: InputMaybe<StringFilter>;
  resetLabel?: InputMaybe<StringFilter>;
  noItemsMessage?: InputMaybe<StringFilter>;
  filters?: InputMaybe<PageGenericContentSectionFileResourcesFilterSettingsFiltersFilter>;
};

export type PageGenericContentSectionFileResourcesResourcesFilter = {
  title?: InputMaybe<StringFilter>;
  type?: InputMaybe<StringFilter>;
  tooltip?: InputMaybe<StringFilter>;
  link?: InputMaybe<StringFilter>;
  tags?: InputMaybe<StringFilter>;
};

export type PageGenericContentSectionFileResourcesFilter = {
  filterSettings?: InputMaybe<PageGenericContentSectionFileResourcesFilterSettingsFilter>;
  resources?: InputMaybe<PageGenericContentSectionFileResourcesResourcesFilter>;
};

export type PageGenericContentSectionOurStoryTextRichBreakFilter = {
  size?: InputMaybe<NumberFilter>;
};

export type PageGenericContentSectionOurStoryTextRichFilter = {
  Break?: InputMaybe<PageGenericContentSectionOurStoryTextRichBreakFilter>;
};

export type PageGenericContentSectionOurStoryFilter = {
  headingText?: InputMaybe<StringFilter>;
  subheadingText?: InputMaybe<StringFilter>;
  textRich?: InputMaybe<PageGenericContentSectionOurStoryTextRichFilter>;
};

export type PageGenericContentSectionTeamItemsFilter = {
  image?: InputMaybe<ImageFilter>;
  name?: InputMaybe<StringFilter>;
  title?: InputMaybe<StringFilter>;
  about?: InputMaybe<StringFilter>;
};

export type PageGenericContentSectionTeamFilter = {
  headingText?: InputMaybe<StringFilter>;
  items?: InputMaybe<PageGenericContentSectionTeamItemsFilter>;
};

export type PageGenericContentSectionValuesItemsFilter = {
  icon?: InputMaybe<ImageFilter>;
  title?: InputMaybe<StringFilter>;
  text?: InputMaybe<StringFilter>;
};

export type PageGenericContentSectionValuesFilter = {
  headingText?: InputMaybe<StringFilter>;
  items?: InputMaybe<PageGenericContentSectionValuesItemsFilter>;
};

export type PageGenericContentSectionImageBrzImageFilter = {
  title?: InputMaybe<StringFilter>;
  src?: InputMaybe<StringFilter>;
  width?: InputMaybe<NumberFilter>;
  height?: InputMaybe<NumberFilter>;
  aspectRatio?: InputMaybe<NumberFilter>;
  format?: InputMaybe<StringFilter>;
  alt?: InputMaybe<StringFilter>;
  radius?: InputMaybe<NumberFilter>;
};

export type PageGenericContentSectionImageFilter = {
  brzImage?: InputMaybe<PageGenericContentSectionImageBrzImageFilter>;
  scrollable?: InputMaybe<BooleanFilter>;
  spacing?: InputMaybe<NumberFilter>;
  maxWidth?: InputMaybe<StringFilter>;
  align?: InputMaybe<StringFilter>;
};

export type PageGenericContentSectionButtonsButtonsFilter = {
  label?: InputMaybe<StringFilter>;
  link?: InputMaybe<StringFilter>;
  ariaLabel?: InputMaybe<StringFilter>;
  variant?: InputMaybe<StringFilter>;
  color?: InputMaybe<StringFilter>;
  size?: InputMaybe<StringFilter>;
};

export type PageGenericContentSectionButtonsFilter = {
  align?: InputMaybe<StringFilter>;
  buttons?: InputMaybe<PageGenericContentSectionButtonsButtonsFilter>;
  spacing?: InputMaybe<NumberFilter>;
};

export type PageGenericContentSectionPressTextRichBreakFilter = {
  size?: InputMaybe<NumberFilter>;
};

export type PageGenericContentSectionPressTextRichFilter = {
  Break?: InputMaybe<PageGenericContentSectionPressTextRichBreakFilter>;
};

export type PageGenericContentSectionPressItemsFilter = {
  headingText?: InputMaybe<StringFilter>;
  link?: InputMaybe<StringFilter>;
};

export type PageGenericContentSectionPressFilter = {
  headingText?: InputMaybe<StringFilter>;
  textRich?: InputMaybe<PageGenericContentSectionPressTextRichFilter>;
  items?: InputMaybe<PageGenericContentSectionPressItemsFilter>;
};

export type PageGenericContentSectionTwoColumnTextTextRichBreakFilter = {
  size?: InputMaybe<NumberFilter>;
};

export type PageGenericContentSectionTwoColumnTextTextRichFilter = {
  Break?: InputMaybe<PageGenericContentSectionTwoColumnTextTextRichBreakFilter>;
};

export type PageGenericContentSectionTwoColumnTextFilter = {
  title?: InputMaybe<StringFilter>;
  headingText?: InputMaybe<StringFilter>;
  imageSrc?: InputMaybe<ImageFilter>;
  textRich?: InputMaybe<PageGenericContentSectionTwoColumnTextTextRichFilter>;
};

export type PageGenericContentSectionThreeColumnTextColsFilter = {
  title?: InputMaybe<StringFilter>;
  textRich?: InputMaybe<RichTextFilter>;
};

export type PageGenericContentSectionThreeColumnTextFilter = {
  headingText?: InputMaybe<StringFilter>;
  cols?: InputMaybe<PageGenericContentSectionThreeColumnTextColsFilter>;
};

export type PageGenericContentSectionVibeButtonFilter = {
  label?: InputMaybe<StringFilter>;
  link?: InputMaybe<StringFilter>;
  ariaLabel?: InputMaybe<StringFilter>;
};

export type PageGenericContentSectionVibeItemsFilter = {
  icon?: InputMaybe<ImageFilter>;
  title?: InputMaybe<StringFilter>;
  text?: InputMaybe<StringFilter>;
};

export type PageGenericContentSectionVibeFilter = {
  title?: InputMaybe<StringFilter>;
  headingText?: InputMaybe<StringFilter>;
  text?: InputMaybe<StringFilter>;
  button?: InputMaybe<PageGenericContentSectionVibeButtonFilter>;
  imageSrc?: InputMaybe<ImageFilter>;
  items?: InputMaybe<PageGenericContentSectionVibeItemsFilter>;
};

export type PageGenericContentSectionSellingPointsItemsFilter = {
  icon?: InputMaybe<ImageFilter>;
  title?: InputMaybe<StringFilter>;
  text?: InputMaybe<StringFilter>;
};

export type PageGenericContentSectionSellingPointsFilter = {
  imageSrc?: InputMaybe<ImageFilter>;
  headingText?: InputMaybe<StringFilter>;
  text?: InputMaybe<StringFilter>;
  items?: InputMaybe<PageGenericContentSectionSellingPointsItemsFilter>;
};

export type PageGenericContentSectionOpeningsTextRichBreakFilter = {
  size?: InputMaybe<NumberFilter>;
};

export type PageGenericContentSectionOpeningsTextRichFilter = {
  Break?: InputMaybe<PageGenericContentSectionOpeningsTextRichBreakFilter>;
};

export type PageGenericContentSectionOpeningsItemsFilter = {
  title?: InputMaybe<StringFilter>;
  location?: InputMaybe<StringFilter>;
  link?: InputMaybe<StringFilter>;
};

export type PageGenericContentSectionOpeningsFilter = {
  sectionId?: InputMaybe<StringFilter>;
  headingText?: InputMaybe<StringFilter>;
  textRich?: InputMaybe<PageGenericContentSectionOpeningsTextRichFilter>;
  title?: InputMaybe<StringFilter>;
  items?: InputMaybe<PageGenericContentSectionOpeningsItemsFilter>;
};

export type PageGenericContentSectionStoryCardsItemsEmployeeStoryTextRichHighlightFilter = {
  color?: InputMaybe<StringFilter>;
  body?: InputMaybe<StringFilter>;
};

export type PageGenericContentSectionStoryCardsItemsEmployeeStoryTextRichBreakFilter = {
  size?: InputMaybe<NumberFilter>;
};

export type PageGenericContentSectionStoryCardsItemsEmployeeStoryTextRichFilter = {
  highlight?: InputMaybe<PageGenericContentSectionStoryCardsItemsEmployeeStoryTextRichHighlightFilter>;
  Break?: InputMaybe<PageGenericContentSectionStoryCardsItemsEmployeeStoryTextRichBreakFilter>;
};

export type PageGenericContentSectionStoryCardsItemsEmployeeStoryFilter = {
  textRich?: InputMaybe<PageGenericContentSectionStoryCardsItemsEmployeeStoryTextRichFilter>;
  author?: InputMaybe<StringFilter>;
  authorTitle?: InputMaybe<StringFilter>;
  authorImage?: InputMaybe<ImageFilter>;
};

export type PageGenericContentSectionStoryCardsItemsAchievementTextRichHighlightFilter = {
  color?: InputMaybe<StringFilter>;
  body?: InputMaybe<StringFilter>;
};

export type PageGenericContentSectionStoryCardsItemsAchievementTextRichBreakFilter = {
  size?: InputMaybe<NumberFilter>;
};

export type PageGenericContentSectionStoryCardsItemsAchievementTextRichFilter = {
  highlight?: InputMaybe<PageGenericContentSectionStoryCardsItemsAchievementTextRichHighlightFilter>;
  Break?: InputMaybe<PageGenericContentSectionStoryCardsItemsAchievementTextRichBreakFilter>;
};

export type PageGenericContentSectionStoryCardsItemsAchievementBrzImageFilter = {
  src?: InputMaybe<StringFilter>;
  width?: InputMaybe<NumberFilter>;
  height?: InputMaybe<NumberFilter>;
  aspectRatio?: InputMaybe<NumberFilter>;
  format?: InputMaybe<StringFilter>;
  alt?: InputMaybe<StringFilter>;
};

export type PageGenericContentSectionStoryCardsItemsAchievementFilter = {
  title?: InputMaybe<StringFilter>;
  textRich?: InputMaybe<PageGenericContentSectionStoryCardsItemsAchievementTextRichFilter>;
  brzImage?: InputMaybe<PageGenericContentSectionStoryCardsItemsAchievementBrzImageFilter>;
  badgeImage?: InputMaybe<ImageFilter>;
};

export type PageGenericContentSectionStoryCardsItemsAnnouncementTextRichHighlightFilter = {
  color?: InputMaybe<StringFilter>;
  body?: InputMaybe<StringFilter>;
};

export type PageGenericContentSectionStoryCardsItemsAnnouncementTextRichBreakFilter = {
  size?: InputMaybe<NumberFilter>;
};

export type PageGenericContentSectionStoryCardsItemsAnnouncementTextRichFilter = {
  highlight?: InputMaybe<PageGenericContentSectionStoryCardsItemsAnnouncementTextRichHighlightFilter>;
  Break?: InputMaybe<PageGenericContentSectionStoryCardsItemsAnnouncementTextRichBreakFilter>;
};

export type PageGenericContentSectionStoryCardsItemsAnnouncementImagesFilter = {
  imageSrc?: InputMaybe<ImageFilter>;
  alt?: InputMaybe<StringFilter>;
};

export type PageGenericContentSectionStoryCardsItemsAnnouncementFilter = {
  headingText?: InputMaybe<StringFilter>;
  subheadingText?: InputMaybe<StringFilter>;
  textRich?: InputMaybe<PageGenericContentSectionStoryCardsItemsAnnouncementTextRichFilter>;
  images?: InputMaybe<PageGenericContentSectionStoryCardsItemsAnnouncementImagesFilter>;
};

export type PageGenericContentSectionStoryCardsItemsFilter = {
  EmployeeStory?: InputMaybe<PageGenericContentSectionStoryCardsItemsEmployeeStoryFilter>;
  Achievement?: InputMaybe<PageGenericContentSectionStoryCardsItemsAchievementFilter>;
  Announcement?: InputMaybe<PageGenericContentSectionStoryCardsItemsAnnouncementFilter>;
};

export type PageGenericContentSectionStoryCardsFilter = {
  title?: InputMaybe<StringFilter>;
  items?: InputMaybe<PageGenericContentSectionStoryCardsItemsFilter>;
};

export type PageGenericContentSectionOtherOffersItemsFilter = {
  headingText?: InputMaybe<StringFilter>;
  text?: InputMaybe<StringFilter>;
  imageSrc?: InputMaybe<ImageFilter>;
};

export type PageGenericContentSectionOtherOffersFilter = {
  headingText?: InputMaybe<StringFilter>;
  items?: InputMaybe<PageGenericContentSectionOtherOffersItemsFilter>;
};

export type PageGenericContentSectionAccordionItemsFilter = {
  title?: InputMaybe<StringFilter>;
  textRich?: InputMaybe<RichTextFilter>;
};

export type PageGenericContentSectionAccordionFilter = {
  title?: InputMaybe<StringFilter>;
  sectionId?: InputMaybe<StringFilter>;
  items?: InputMaybe<PageGenericContentSectionAccordionItemsFilter>;
};

export type PageGenericContentSectionQuoteProposalSubheadingRichClientNameFilter = {
  useFirstName?: InputMaybe<BooleanFilter>;
  useLastName?: InputMaybe<BooleanFilter>;
  usePossesive?: InputMaybe<BooleanFilter>;
  highlight?: InputMaybe<BooleanFilter>;
  highlightColor?: InputMaybe<StringFilter>;
  fallback?: InputMaybe<StringFilter>;
};

export type PageGenericContentSectionQuoteProposalSubheadingRichFilter = {
  ClientName?: InputMaybe<PageGenericContentSectionQuoteProposalSubheadingRichClientNameFilter>;
};

export type PageGenericContentSectionQuoteProposalHelpTipFilter = {
  headingText?: InputMaybe<StringFilter>;
  contentRich?: InputMaybe<RichTextFilter>;
};

export type PageGenericContentSectionQuoteProposalNotFoundErrorFilter = {
  headingText?: InputMaybe<StringFilter>;
  textRich?: InputMaybe<RichTextFilter>;
};

export type PageGenericContentSectionQuoteProposalGenericErrorFilter = {
  headingText?: InputMaybe<StringFilter>;
  textRich?: InputMaybe<RichTextFilter>;
};

export type PageGenericContentSectionQuoteProposalFilter = {
  headingText?: InputMaybe<StringFilter>;
  subheadingRich?: InputMaybe<PageGenericContentSectionQuoteProposalSubheadingRichFilter>;
  imageSrc?: InputMaybe<ImageFilter>;
  helpTip?: InputMaybe<PageGenericContentSectionQuoteProposalHelpTipFilter>;
  addonsHeadingText?: InputMaybe<StringFilter>;
  notFoundError?: InputMaybe<PageGenericContentSectionQuoteProposalNotFoundErrorFilter>;
  genericError?: InputMaybe<PageGenericContentSectionQuoteProposalGenericErrorFilter>;
};

export type PageGenericContentSectionTableRowsFilter = {
  columns?: InputMaybe<StringFilter>;
};

export type PageGenericContentSectionTableFilter = {
  title?: InputMaybe<StringFilter>;
  headingText?: InputMaybe<StringFilter>;
  rows?: InputMaybe<PageGenericContentSectionTableRowsFilter>;
};

export type PageGenericContentSectionHeadingFilter = {
  align?: InputMaybe<StringFilter>;
  title?: InputMaybe<StringFilter>;
  headingLevel?: InputMaybe<StringFilter>;
  headingText?: InputMaybe<StringFilter>;
  text?: InputMaybe<StringFilter>;
  marginBottom?: InputMaybe<StringFilter>;
};

export type PageGenericContentSectionContentContentRichHighlightFilter = {
  color?: InputMaybe<StringFilter>;
  body?: InputMaybe<StringFilter>;
};

export type PageGenericContentSectionContentContentRichBreakFilter = {
  size?: InputMaybe<NumberFilter>;
};

export type PageGenericContentSectionContentContentRichCompanyNameFilter = {
  usePossesive?: InputMaybe<BooleanFilter>;
  fallback?: InputMaybe<StringFilter>;
};

export type PageGenericContentSectionContentContentRichTextRotatorFilter = {
  items?: InputMaybe<StringFilter>;
};

export type PageGenericContentSectionContentContentRichFilter = {
  highlight?: InputMaybe<PageGenericContentSectionContentContentRichHighlightFilter>;
  Break?: InputMaybe<PageGenericContentSectionContentContentRichBreakFilter>;
  CompanyName?: InputMaybe<PageGenericContentSectionContentContentRichCompanyNameFilter>;
  TextRotator?: InputMaybe<PageGenericContentSectionContentContentRichTextRotatorFilter>;
};

export type PageGenericContentSectionContentFilter = {
  align?: InputMaybe<StringFilter>;
  maxWidth?: InputMaybe<StringFilter>;
  contentRich?: InputMaybe<PageGenericContentSectionContentContentRichFilter>;
};

export type PageGenericContentSectionSidebarContentRowsColsContentRichBreakFilter = {
  size?: InputMaybe<NumberFilter>;
};

export type PageGenericContentSectionSidebarContentRowsColsContentRichFilter = {
  Break?: InputMaybe<PageGenericContentSectionSidebarContentRowsColsContentRichBreakFilter>;
};

export type PageGenericContentSectionSidebarContentRowsColsFilter = {
  contentRich?: InputMaybe<PageGenericContentSectionSidebarContentRowsColsContentRichFilter>;
};

export type PageGenericContentSectionSidebarContentRowsFilter = {
  cols?: InputMaybe<PageGenericContentSectionSidebarContentRowsColsFilter>;
};

export type PageGenericContentSectionSidebarContentFilter = {
  sidebarRich?: InputMaybe<RichTextFilter>;
  rows?: InputMaybe<PageGenericContentSectionSidebarContentRowsFilter>;
};

export type PageGenericContentSectionHtmlFilter = {
  contentText?: InputMaybe<StringFilter>;
};

export type PageGenericContentFilter = {
  SectionHeroGeneric?: InputMaybe<PageGenericContentSectionHeroGenericFilter>;
  SectionHeroAgent?: InputMaybe<PageGenericContentSectionHeroAgentFilter>;
  SectionLogos?: InputMaybe<PageGenericContentSectionLogosFilter>;
  SectionBadges?: InputMaybe<PageGenericContentSectionBadgesFilter>;
  SectionTestimonialSlider?: InputMaybe<PageGenericContentSectionTestimonialSliderFilter>;
  SectionTestimonialGrid?: InputMaybe<PageGenericContentSectionTestimonialGridFilter>;
  SectionFloatingCta?: InputMaybe<PageGenericContentSectionFloatingCtaFilter>;
  SectionImageCta?: InputMaybe<PageGenericContentSectionImageCtaFilter>;
  SectionProducts?: InputMaybe<PageGenericContentSectionProductsFilter>;
  SectionProductsSimple?: InputMaybe<PageGenericContentSectionProductsSimpleFilter>;
  SectionHowItWorks?: InputMaybe<PageGenericContentSectionHowItWorksFilter>;
  SectionIconColumns?: InputMaybe<PageGenericContentSectionIconColumnsFilter>;
  SectionBlogPosts?: InputMaybe<PageGenericContentSectionBlogPostsFilter>;
  SectionArticles?: InputMaybe<PageGenericContentSectionArticlesFilter>;
  SectionCtaArticles?: InputMaybe<PageGenericContentSectionCtaArticlesFilter>;
  SectionHelpfulArticles?: InputMaybe<PageGenericContentSectionHelpfulArticlesFilter>;
  SectionStats?: InputMaybe<PageGenericContentSectionStatsFilter>;
  SectionResources?: InputMaybe<PageGenericContentSectionResourcesFilter>;
  SectionResourceHub?: InputMaybe<PageGenericContentSectionResourceHubFilter>;
  SectionFileResources?: InputMaybe<PageGenericContentSectionFileResourcesFilter>;
  SectionOurStory?: InputMaybe<PageGenericContentSectionOurStoryFilter>;
  SectionTeam?: InputMaybe<PageGenericContentSectionTeamFilter>;
  SectionValues?: InputMaybe<PageGenericContentSectionValuesFilter>;
  SectionImage?: InputMaybe<PageGenericContentSectionImageFilter>;
  SectionButtons?: InputMaybe<PageGenericContentSectionButtonsFilter>;
  SectionPress?: InputMaybe<PageGenericContentSectionPressFilter>;
  SectionTwoColumnText?: InputMaybe<PageGenericContentSectionTwoColumnTextFilter>;
  SectionThreeColumnText?: InputMaybe<PageGenericContentSectionThreeColumnTextFilter>;
  SectionVibe?: InputMaybe<PageGenericContentSectionVibeFilter>;
  SectionSellingPoints?: InputMaybe<PageGenericContentSectionSellingPointsFilter>;
  SectionOpenings?: InputMaybe<PageGenericContentSectionOpeningsFilter>;
  SectionStoryCards?: InputMaybe<PageGenericContentSectionStoryCardsFilter>;
  SectionOtherOffers?: InputMaybe<PageGenericContentSectionOtherOffersFilter>;
  SectionAccordion?: InputMaybe<PageGenericContentSectionAccordionFilter>;
  SectionQuoteProposal?: InputMaybe<PageGenericContentSectionQuoteProposalFilter>;
  SectionTable?: InputMaybe<PageGenericContentSectionTableFilter>;
  SectionHeading?: InputMaybe<PageGenericContentSectionHeadingFilter>;
  SectionContent?: InputMaybe<PageGenericContentSectionContentFilter>;
  SectionSidebarContent?: InputMaybe<PageGenericContentSectionSidebarContentFilter>;
  SectionHTML?: InputMaybe<PageGenericContentSectionHtmlFilter>;
};

export type PageGenericFilter = {
  component?: InputMaybe<StringFilter>;
  updatedDate?: InputMaybe<DatetimeFilter>;
  publishedDate?: InputMaybe<DatetimeFilter>;
  title?: InputMaybe<StringFilter>;
  settings?: InputMaybe<PageGenericSettingsFilter>;
  content?: InputMaybe<PageGenericContentFilter>;
};

export type PageBlogSettingsPublishFilter = {
  published?: InputMaybe<BooleanFilter>;
  publishedDate?: InputMaybe<DatetimeFilter>;
};

export type PageFormSettingsSeoImageFilter = {
  src?: InputMaybe<StringFilter>;
  width?: InputMaybe<NumberFilter>;
  height?: InputMaybe<NumberFilter>;
  aspectRatio?: InputMaybe<NumberFilter>;
  format?: InputMaybe<StringFilter>;
  alt?: InputMaybe<StringFilter>;
};

export type PageFormSettingsSeoOrgFilter = {
  disable?: InputMaybe<BooleanFilter>;
};

export type ArticleSettingsSeoFaqItemsFilter = {
  q?: InputMaybe<StringFilter>;
  a?: InputMaybe<StringFilter>;
};

export type PageFormSettingsSeoFaqFilter = {
  disable?: InputMaybe<BooleanFilter>;
  name?: InputMaybe<StringFilter>;
  items?: InputMaybe<ArticleSettingsSeoFaqItemsFilter>;
};

export type ArticleSettingsSeoHowToImageFilter = {
  src?: InputMaybe<StringFilter>;
  width?: InputMaybe<NumberFilter>;
  height?: InputMaybe<NumberFilter>;
  aspectRatio?: InputMaybe<NumberFilter>;
  format?: InputMaybe<StringFilter>;
  alt?: InputMaybe<StringFilter>;
};

export type ArticleSettingsSeoHowToStepsFilter = {
  name?: InputMaybe<StringFilter>;
  url?: InputMaybe<StringFilter>;
  text?: InputMaybe<StringFilter>;
};

export type PageFormSettingsSeoHowToFilter = {
  disable?: InputMaybe<BooleanFilter>;
  name?: InputMaybe<StringFilter>;
  description?: InputMaybe<StringFilter>;
  image?: InputMaybe<ArticleSettingsSeoHowToImageFilter>;
  steps?: InputMaybe<ArticleSettingsSeoHowToStepsFilter>;
};

export type PageBlogSettingsSeoFilter = {
  title?: InputMaybe<StringFilter>;
  url?: InputMaybe<StringFilter>;
  description?: InputMaybe<StringFilter>;
  image?: InputMaybe<PageFormSettingsSeoImageFilter>;
  org?: InputMaybe<PageFormSettingsSeoOrgFilter>;
  faq?: InputMaybe<PageFormSettingsSeoFaqFilter>;
  howTo?: InputMaybe<PageFormSettingsSeoHowToFilter>;
};

export type PageBlogSettingsSitemapFilter = {
  exclude?: InputMaybe<BooleanFilter>;
  breadcrumb?: InputMaybe<StringFilter>;
  changefreq?: InputMaybe<StringFilter>;
  priority?: InputMaybe<NumberFilter>;
};

export type PageBlogSettingsNotificationFilter = {
  notification?: InputMaybe<NotificationFilter>;
};

export type PageFormSettingsNavigationRightSideButtonOverrideFilter = {
  label?: InputMaybe<StringFilter>;
  link?: InputMaybe<StringFilter>;
  ariaLabel?: InputMaybe<StringFilter>;
};

export type PageBlogSettingsNavigationFilter = {
  disableLogo?: InputMaybe<BooleanFilter>;
  disableLeft?: InputMaybe<BooleanFilter>;
  disableRight?: InputMaybe<BooleanFilter>;
  disableButtons?: InputMaybe<BooleanFilter>;
  rightSideButtonOverride?: InputMaybe<PageFormSettingsNavigationRightSideButtonOverrideFilter>;
};

export type PageBlogSettingsFooterFilter = {
  disableLinks?: InputMaybe<BooleanFilter>;
  disableBottom?: InputMaybe<BooleanFilter>;
};

export type PageBlogSettingsDisclaimerFilter = {
  disable?: InputMaybe<BooleanFilter>;
  content?: InputMaybe<RichTextFilter>;
};

export type PageFormSettingsPartnerPartnerRefFilter = {
  partner?: InputMaybe<PartnerFilter>;
};

export type PageFormSettingsPartnerCobrandRefFilter = {
  cobrand?: InputMaybe<CobrandFilter>;
};

export type PageBlogSettingsPartnerFilter = {
  partnerRef?: InputMaybe<PageFormSettingsPartnerPartnerRefFilter>;
  cobrandRef?: InputMaybe<PageFormSettingsPartnerCobrandRefFilter>;
};

export type PageBlogSettingsClientFilter = {
  enabled?: InputMaybe<BooleanFilter>;
};

export type PageBlogSettingsFilter = {
  publish?: InputMaybe<PageBlogSettingsPublishFilter>;
  seo?: InputMaybe<PageBlogSettingsSeoFilter>;
  sitemap?: InputMaybe<PageBlogSettingsSitemapFilter>;
  notification?: InputMaybe<PageBlogSettingsNotificationFilter>;
  navigation?: InputMaybe<PageBlogSettingsNavigationFilter>;
  footer?: InputMaybe<PageBlogSettingsFooterFilter>;
  disclaimer?: InputMaybe<PageBlogSettingsDisclaimerFilter>;
  partner?: InputMaybe<PageBlogSettingsPartnerFilter>;
  client?: InputMaybe<PageBlogSettingsClientFilter>;
};

export type PageBlogCategoriesRefFilter = {
  category?: InputMaybe<CategoryFilter>;
};

export type PageBlogCategoriesFilter = {
  ref?: InputMaybe<PageBlogCategoriesRefFilter>;
};

export type PageBlogPopularRefFilter = {
  post?: InputMaybe<PostFilter>;
};

export type PageBlogPopularFilter = {
  ref?: InputMaybe<PageBlogPopularRefFilter>;
};

export type PageBlogCtaButtonsFilter = {
  label?: InputMaybe<StringFilter>;
  link?: InputMaybe<StringFilter>;
  ariaLabel?: InputMaybe<StringFilter>;
};

export type PageBlogCtaFilter = {
  headingText?: InputMaybe<StringFilter>;
  text?: InputMaybe<StringFilter>;
  buttons?: InputMaybe<PageBlogCtaButtonsFilter>;
};

export type PageBlogFilter = {
  component?: InputMaybe<StringFilter>;
  updatedDate?: InputMaybe<DatetimeFilter>;
  publishedDate?: InputMaybe<DatetimeFilter>;
  title?: InputMaybe<StringFilter>;
  settings?: InputMaybe<PageBlogSettingsFilter>;
  heading?: InputMaybe<StringFilter>;
  categories?: InputMaybe<PageBlogCategoriesFilter>;
  popular?: InputMaybe<PageBlogPopularFilter>;
  cta?: InputMaybe<PageBlogCtaFilter>;
};

export type PageFormSettingsPublishFilter = {
  published?: InputMaybe<BooleanFilter>;
  publishedDate?: InputMaybe<DatetimeFilter>;
};

export type ArticleSettingsSeoImageFilter = {
  src?: InputMaybe<StringFilter>;
  width?: InputMaybe<NumberFilter>;
  height?: InputMaybe<NumberFilter>;
  aspectRatio?: InputMaybe<NumberFilter>;
  format?: InputMaybe<StringFilter>;
  alt?: InputMaybe<StringFilter>;
};

export type ArticleSettingsSeoOrgFilter = {
  disable?: InputMaybe<BooleanFilter>;
};

export type PostSettingsSeoFaqItemsFilter = {
  q?: InputMaybe<StringFilter>;
  a?: InputMaybe<StringFilter>;
};

export type ArticleSettingsSeoFaqFilter = {
  disable?: InputMaybe<BooleanFilter>;
  name?: InputMaybe<StringFilter>;
  items?: InputMaybe<PostSettingsSeoFaqItemsFilter>;
};

export type PostSettingsSeoHowToImageFilter = {
  src?: InputMaybe<StringFilter>;
  width?: InputMaybe<NumberFilter>;
  height?: InputMaybe<NumberFilter>;
  aspectRatio?: InputMaybe<NumberFilter>;
  format?: InputMaybe<StringFilter>;
  alt?: InputMaybe<StringFilter>;
};

export type PostSettingsSeoHowToStepsFilter = {
  name?: InputMaybe<StringFilter>;
  url?: InputMaybe<StringFilter>;
  text?: InputMaybe<StringFilter>;
};

export type ArticleSettingsSeoHowToFilter = {
  disable?: InputMaybe<BooleanFilter>;
  name?: InputMaybe<StringFilter>;
  description?: InputMaybe<StringFilter>;
  image?: InputMaybe<PostSettingsSeoHowToImageFilter>;
  steps?: InputMaybe<PostSettingsSeoHowToStepsFilter>;
};

export type PageFormSettingsSeoFilter = {
  title?: InputMaybe<StringFilter>;
  url?: InputMaybe<StringFilter>;
  description?: InputMaybe<StringFilter>;
  image?: InputMaybe<ArticleSettingsSeoImageFilter>;
  org?: InputMaybe<ArticleSettingsSeoOrgFilter>;
  faq?: InputMaybe<ArticleSettingsSeoFaqFilter>;
  howTo?: InputMaybe<ArticleSettingsSeoHowToFilter>;
};

export type PageFormSettingsSitemapFilter = {
  exclude?: InputMaybe<BooleanFilter>;
  breadcrumb?: InputMaybe<StringFilter>;
  changefreq?: InputMaybe<StringFilter>;
  priority?: InputMaybe<NumberFilter>;
};

export type PageFormSettingsNotificationFilter = {
  notification?: InputMaybe<NotificationFilter>;
};

export type ArticleSettingsNavigationRightSideButtonOverrideFilter = {
  label?: InputMaybe<StringFilter>;
  link?: InputMaybe<StringFilter>;
  ariaLabel?: InputMaybe<StringFilter>;
};

export type PageFormSettingsNavigationFilter = {
  disableLogo?: InputMaybe<BooleanFilter>;
  disableLeft?: InputMaybe<BooleanFilter>;
  disableRight?: InputMaybe<BooleanFilter>;
  disableButtons?: InputMaybe<BooleanFilter>;
  rightSideButtonOverride?: InputMaybe<ArticleSettingsNavigationRightSideButtonOverrideFilter>;
};

export type PageFormSettingsFooterFilter = {
  disableLinks?: InputMaybe<BooleanFilter>;
  disableBottom?: InputMaybe<BooleanFilter>;
};

export type PageFormSettingsDisclaimerFilter = {
  disable?: InputMaybe<BooleanFilter>;
  content?: InputMaybe<RichTextFilter>;
};

export type ArticleSettingsPartnerPartnerRefFilter = {
  partner?: InputMaybe<PartnerFilter>;
};

export type ArticleSettingsPartnerCobrandRefFilter = {
  cobrand?: InputMaybe<CobrandFilter>;
};

export type PageFormSettingsPartnerFilter = {
  partnerRef?: InputMaybe<ArticleSettingsPartnerPartnerRefFilter>;
  cobrandRef?: InputMaybe<ArticleSettingsPartnerCobrandRefFilter>;
};

export type PageFormSettingsClientFilter = {
  enabled?: InputMaybe<BooleanFilter>;
};

export type PageFormSettingsFilter = {
  publish?: InputMaybe<PageFormSettingsPublishFilter>;
  seo?: InputMaybe<PageFormSettingsSeoFilter>;
  sitemap?: InputMaybe<PageFormSettingsSitemapFilter>;
  notification?: InputMaybe<PageFormSettingsNotificationFilter>;
  navigation?: InputMaybe<PageFormSettingsNavigationFilter>;
  footer?: InputMaybe<PageFormSettingsFooterFilter>;
  disclaimer?: InputMaybe<PageFormSettingsDisclaimerFilter>;
  partner?: InputMaybe<PageFormSettingsPartnerFilter>;
  client?: InputMaybe<PageFormSettingsClientFilter>;
};

export type PageFormCarrierButtonFilter = {
  label?: InputMaybe<StringFilter>;
  link?: InputMaybe<StringFilter>;
  ariaLabel?: InputMaybe<StringFilter>;
  hint?: InputMaybe<StringFilter>;
};

export type PageFormCarrierFilter = {
  logo?: InputMaybe<ImageFilter>;
  headingText?: InputMaybe<StringFilter>;
  text?: InputMaybe<StringFilter>;
  button?: InputMaybe<PageFormCarrierButtonFilter>;
};

export type PageFormFormImagesFilter = {
  image?: InputMaybe<ImageFilter>;
  title?: InputMaybe<StringFilter>;
};

export type PageFormFormSettingsFilter = {
  form?: InputMaybe<FormFilter>;
};

export type PageFormFormFilter = {
  title?: InputMaybe<StringFilter>;
  headingText?: InputMaybe<StringFilter>;
  subheadingText?: InputMaybe<StringFilter>;
  images?: InputMaybe<PageFormFormImagesFilter>;
  settings?: InputMaybe<PageFormFormSettingsFilter>;
};

export type PageFormCalendarFilter = {
  headingText?: InputMaybe<StringFilter>;
  subheadingText?: InputMaybe<StringFilter>;
};

export type PageFormSidebarHelpLinksFilter = {
  label?: InputMaybe<StringFilter>;
  link?: InputMaybe<StringFilter>;
  ariaLabel?: InputMaybe<StringFilter>;
};

export type PageFormSidebarHelpFilter = {
  title?: InputMaybe<StringFilter>;
  links?: InputMaybe<PageFormSidebarHelpLinksFilter>;
};

export type PageFormSidebarItemsFilter = {
  title?: InputMaybe<StringFilter>;
  text?: InputMaybe<StringFilter>;
};

export type PageFormSidebarContactsItemsFilter = {
  textRich?: InputMaybe<RichTextFilter>;
  sub?: InputMaybe<StringFilter>;
};

export type PageFormSidebarContactsFilter = {
  title?: InputMaybe<StringFilter>;
  items?: InputMaybe<PageFormSidebarContactsItemsFilter>;
};

export type PageFormSidebarTestimonialFilter = {
  testimonial?: InputMaybe<TestimonialFilter>;
};

export type PageFormSidebarFilter = {
  help?: InputMaybe<PageFormSidebarHelpFilter>;
  headingText?: InputMaybe<StringFilter>;
  subheadingText?: InputMaybe<StringFilter>;
  items?: InputMaybe<PageFormSidebarItemsFilter>;
  contacts?: InputMaybe<PageFormSidebarContactsFilter>;
  testimonial?: InputMaybe<PageFormSidebarTestimonialFilter>;
  image?: InputMaybe<ImageFilter>;
};

export type PageFormFilter = {
  component?: InputMaybe<StringFilter>;
  updatedDate?: InputMaybe<DatetimeFilter>;
  publishedDate?: InputMaybe<DatetimeFilter>;
  title?: InputMaybe<StringFilter>;
  settings?: InputMaybe<PageFormSettingsFilter>;
  carrier?: InputMaybe<PageFormCarrierFilter>;
  form?: InputMaybe<PageFormFormFilter>;
  calendar?: InputMaybe<PageFormCalendarFilter>;
  sidebar?: InputMaybe<PageFormSidebarFilter>;
};

export type PageFilter = {
  Generic?: InputMaybe<PageGenericFilter>;
  Blog?: InputMaybe<PageBlogFilter>;
  Form?: InputMaybe<PageFormFilter>;
};

export type PageConnectionEdges = {
  __typename?: 'PageConnectionEdges';
  cursor: Scalars['String']['output'];
  node?: Maybe<Page>;
};

export type PageConnection = Connection & {
  __typename?: 'PageConnection';
  pageInfo: PageInfo;
  totalCount: Scalars['Float']['output'];
  edges?: Maybe<Array<Maybe<PageConnectionEdges>>>;
};

export type ArticleSettingsPublish = {
  __typename?: 'ArticleSettingsPublish';
  published?: Maybe<Scalars['Boolean']['output']>;
  publishedDate?: Maybe<Scalars['String']['output']>;
};

export type PostSettingsSeoImage = {
  __typename?: 'PostSettingsSeoImage';
  src?: Maybe<Scalars['String']['output']>;
  width?: Maybe<Scalars['Float']['output']>;
  height?: Maybe<Scalars['Float']['output']>;
  aspectRatio?: Maybe<Scalars['Float']['output']>;
  format?: Maybe<Scalars['String']['output']>;
  alt?: Maybe<Scalars['String']['output']>;
};

export type PostSettingsSeoOrg = {
  __typename?: 'PostSettingsSeoOrg';
  disable?: Maybe<Scalars['Boolean']['output']>;
};

export type CategorySettingsSeoFaqItems = {
  __typename?: 'CategorySettingsSeoFaqItems';
  q?: Maybe<Scalars['String']['output']>;
  a?: Maybe<Scalars['String']['output']>;
};

export type PostSettingsSeoFaq = {
  __typename?: 'PostSettingsSeoFaq';
  disable?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  items?: Maybe<Array<Maybe<CategorySettingsSeoFaqItems>>>;
};

export type CategorySettingsSeoHowToImage = {
  __typename?: 'CategorySettingsSeoHowToImage';
  src?: Maybe<Scalars['String']['output']>;
  width?: Maybe<Scalars['Float']['output']>;
  height?: Maybe<Scalars['Float']['output']>;
  aspectRatio?: Maybe<Scalars['Float']['output']>;
  format?: Maybe<Scalars['String']['output']>;
  alt?: Maybe<Scalars['String']['output']>;
};

export type CategorySettingsSeoHowToSteps = {
  __typename?: 'CategorySettingsSeoHowToSteps';
  name?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
};

export type PostSettingsSeoHowTo = {
  __typename?: 'PostSettingsSeoHowTo';
  disable?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  image?: Maybe<CategorySettingsSeoHowToImage>;
  steps?: Maybe<Array<Maybe<CategorySettingsSeoHowToSteps>>>;
};

export type ArticleSettingsSeo = {
  __typename?: 'ArticleSettingsSeo';
  title?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  image?: Maybe<PostSettingsSeoImage>;
  org?: Maybe<PostSettingsSeoOrg>;
  faq?: Maybe<PostSettingsSeoFaq>;
  howTo?: Maybe<PostSettingsSeoHowTo>;
};

export type ArticleSettingsSitemap = {
  __typename?: 'ArticleSettingsSitemap';
  exclude?: Maybe<Scalars['Boolean']['output']>;
  breadcrumb?: Maybe<Scalars['String']['output']>;
  changefreq?: Maybe<Scalars['String']['output']>;
  priority?: Maybe<Scalars['Float']['output']>;
};

export type ArticleSettingsNotification = Notification;

export type PostSettingsNavigationRightSideButtonOverride = {
  __typename?: 'PostSettingsNavigationRightSideButtonOverride';
  label?: Maybe<Scalars['String']['output']>;
  link?: Maybe<Scalars['String']['output']>;
  ariaLabel?: Maybe<Scalars['String']['output']>;
};

export type ArticleSettingsNavigation = {
  __typename?: 'ArticleSettingsNavigation';
  disableLogo?: Maybe<Scalars['Boolean']['output']>;
  disableLeft?: Maybe<Scalars['Boolean']['output']>;
  disableRight?: Maybe<Scalars['Boolean']['output']>;
  disableButtons?: Maybe<Scalars['Boolean']['output']>;
  rightSideButtonOverride?: Maybe<PostSettingsNavigationRightSideButtonOverride>;
};

export type ArticleSettingsFooter = {
  __typename?: 'ArticleSettingsFooter';
  disableLinks?: Maybe<Scalars['Boolean']['output']>;
  disableBottom?: Maybe<Scalars['Boolean']['output']>;
};

export type ArticleSettingsDisclaimer = {
  __typename?: 'ArticleSettingsDisclaimer';
  disable?: Maybe<Scalars['Boolean']['output']>;
  content?: Maybe<Scalars['JSON']['output']>;
};

export type PostSettingsPartnerPartnerRef = Partner;

export type PostSettingsPartnerCobrandRef = Cobrand;

export type ArticleSettingsPartner = {
  __typename?: 'ArticleSettingsPartner';
  partnerRef?: Maybe<PostSettingsPartnerPartnerRef>;
  cobrandRef?: Maybe<PostSettingsPartnerCobrandRef>;
};

export type ArticleSettingsClient = {
  __typename?: 'ArticleSettingsClient';
  enabled?: Maybe<Scalars['Boolean']['output']>;
};

export type ArticleSettings = {
  __typename?: 'ArticleSettings';
  publish?: Maybe<ArticleSettingsPublish>;
  seo?: Maybe<ArticleSettingsSeo>;
  sitemap?: Maybe<ArticleSettingsSitemap>;
  notification?: Maybe<ArticleSettingsNotification>;
  navigation?: Maybe<ArticleSettingsNavigation>;
  footer?: Maybe<ArticleSettingsFooter>;
  disclaimer?: Maybe<ArticleSettingsDisclaimer>;
  partner?: Maybe<ArticleSettingsPartner>;
  client?: Maybe<ArticleSettingsClient>;
};

export type ArticleReadtime = {
  __typename?: 'ArticleReadtime';
  text?: Maybe<Scalars['String']['output']>;
  minutes?: Maybe<Scalars['Float']['output']>;
  time?: Maybe<Scalars['Float']['output']>;
  words?: Maybe<Scalars['Float']['output']>;
};

export type ArticleCategory = Category;

export type ArticleAuthor = Author;

export type ArticleReviewer = Author;

export type ArticleWidgets = {
  __typename?: 'ArticleWidgets';
  image?: Maybe<Scalars['String']['output']>;
  heading?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  link?: Maybe<Scalars['String']['output']>;
};

export type ArticleCtaButtons = {
  __typename?: 'ArticleCtaButtons';
  label?: Maybe<Scalars['String']['output']>;
  link?: Maybe<Scalars['String']['output']>;
  ariaLabel?: Maybe<Scalars['String']['output']>;
};

export type ArticleCta = {
  __typename?: 'ArticleCta';
  headingText?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  buttons?: Maybe<Array<Maybe<ArticleCtaButtons>>>;
};

export type ArticleRelatedRef = Article;

export type ArticleRelated = {
  __typename?: 'ArticleRelated';
  ref?: Maybe<ArticleRelatedRef>;
};

export type Article = Node & Document & {
  __typename?: 'Article';
  component?: Maybe<Scalars['String']['output']>;
  updatedDate?: Maybe<Scalars['String']['output']>;
  publishedDate?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  settings?: Maybe<ArticleSettings>;
  readtime?: Maybe<ArticleReadtime>;
  cover?: Maybe<Scalars['String']['output']>;
  thumbnail?: Maybe<Scalars['String']['output']>;
  headingRich?: Maybe<Scalars['JSON']['output']>;
  subtitleRich?: Maybe<Scalars['String']['output']>;
  excerptText?: Maybe<Scalars['String']['output']>;
  category?: Maybe<ArticleCategory>;
  author?: Maybe<ArticleAuthor>;
  reviewer?: Maybe<ArticleReviewer>;
  widgets?: Maybe<Array<Maybe<ArticleWidgets>>>;
  cta?: Maybe<ArticleCta>;
  related?: Maybe<Array<Maybe<ArticleRelated>>>;
  body?: Maybe<Scalars['JSON']['output']>;
  id: Scalars['ID']['output'];
  _sys: SystemInfo;
  _values: Scalars['JSON']['output'];
};

export type ArticleSettingsPublishFilter = {
  published?: InputMaybe<BooleanFilter>;
  publishedDate?: InputMaybe<DatetimeFilter>;
};

export type PostSettingsSeoImageFilter = {
  src?: InputMaybe<StringFilter>;
  width?: InputMaybe<NumberFilter>;
  height?: InputMaybe<NumberFilter>;
  aspectRatio?: InputMaybe<NumberFilter>;
  format?: InputMaybe<StringFilter>;
  alt?: InputMaybe<StringFilter>;
};

export type PostSettingsSeoOrgFilter = {
  disable?: InputMaybe<BooleanFilter>;
};

export type CategorySettingsSeoFaqItemsFilter = {
  q?: InputMaybe<StringFilter>;
  a?: InputMaybe<StringFilter>;
};

export type PostSettingsSeoFaqFilter = {
  disable?: InputMaybe<BooleanFilter>;
  name?: InputMaybe<StringFilter>;
  items?: InputMaybe<CategorySettingsSeoFaqItemsFilter>;
};

export type CategorySettingsSeoHowToImageFilter = {
  src?: InputMaybe<StringFilter>;
  width?: InputMaybe<NumberFilter>;
  height?: InputMaybe<NumberFilter>;
  aspectRatio?: InputMaybe<NumberFilter>;
  format?: InputMaybe<StringFilter>;
  alt?: InputMaybe<StringFilter>;
};

export type CategorySettingsSeoHowToStepsFilter = {
  name?: InputMaybe<StringFilter>;
  url?: InputMaybe<StringFilter>;
  text?: InputMaybe<StringFilter>;
};

export type PostSettingsSeoHowToFilter = {
  disable?: InputMaybe<BooleanFilter>;
  name?: InputMaybe<StringFilter>;
  description?: InputMaybe<StringFilter>;
  image?: InputMaybe<CategorySettingsSeoHowToImageFilter>;
  steps?: InputMaybe<CategorySettingsSeoHowToStepsFilter>;
};

export type ArticleSettingsSeoFilter = {
  title?: InputMaybe<StringFilter>;
  url?: InputMaybe<StringFilter>;
  description?: InputMaybe<StringFilter>;
  image?: InputMaybe<PostSettingsSeoImageFilter>;
  org?: InputMaybe<PostSettingsSeoOrgFilter>;
  faq?: InputMaybe<PostSettingsSeoFaqFilter>;
  howTo?: InputMaybe<PostSettingsSeoHowToFilter>;
};

export type ArticleSettingsSitemapFilter = {
  exclude?: InputMaybe<BooleanFilter>;
  breadcrumb?: InputMaybe<StringFilter>;
  changefreq?: InputMaybe<StringFilter>;
  priority?: InputMaybe<NumberFilter>;
};

export type ArticleSettingsNotificationFilter = {
  notification?: InputMaybe<NotificationFilter>;
};

export type PostSettingsNavigationRightSideButtonOverrideFilter = {
  label?: InputMaybe<StringFilter>;
  link?: InputMaybe<StringFilter>;
  ariaLabel?: InputMaybe<StringFilter>;
};

export type ArticleSettingsNavigationFilter = {
  disableLogo?: InputMaybe<BooleanFilter>;
  disableLeft?: InputMaybe<BooleanFilter>;
  disableRight?: InputMaybe<BooleanFilter>;
  disableButtons?: InputMaybe<BooleanFilter>;
  rightSideButtonOverride?: InputMaybe<PostSettingsNavigationRightSideButtonOverrideFilter>;
};

export type ArticleSettingsFooterFilter = {
  disableLinks?: InputMaybe<BooleanFilter>;
  disableBottom?: InputMaybe<BooleanFilter>;
};

export type ArticleSettingsDisclaimerFilter = {
  disable?: InputMaybe<BooleanFilter>;
  content?: InputMaybe<RichTextFilter>;
};

export type PostSettingsPartnerPartnerRefFilter = {
  partner?: InputMaybe<PartnerFilter>;
};

export type PostSettingsPartnerCobrandRefFilter = {
  cobrand?: InputMaybe<CobrandFilter>;
};

export type ArticleSettingsPartnerFilter = {
  partnerRef?: InputMaybe<PostSettingsPartnerPartnerRefFilter>;
  cobrandRef?: InputMaybe<PostSettingsPartnerCobrandRefFilter>;
};

export type ArticleSettingsClientFilter = {
  enabled?: InputMaybe<BooleanFilter>;
};

export type ArticleSettingsFilter = {
  publish?: InputMaybe<ArticleSettingsPublishFilter>;
  seo?: InputMaybe<ArticleSettingsSeoFilter>;
  sitemap?: InputMaybe<ArticleSettingsSitemapFilter>;
  notification?: InputMaybe<ArticleSettingsNotificationFilter>;
  navigation?: InputMaybe<ArticleSettingsNavigationFilter>;
  footer?: InputMaybe<ArticleSettingsFooterFilter>;
  disclaimer?: InputMaybe<ArticleSettingsDisclaimerFilter>;
  partner?: InputMaybe<ArticleSettingsPartnerFilter>;
  client?: InputMaybe<ArticleSettingsClientFilter>;
};

export type ArticleReadtimeFilter = {
  text?: InputMaybe<StringFilter>;
  minutes?: InputMaybe<NumberFilter>;
  time?: InputMaybe<NumberFilter>;
  words?: InputMaybe<NumberFilter>;
};

export type ArticleHeadingRichCurrentYearFilter = {
  add?: InputMaybe<StringFilter>;
};

export type ArticleHeadingRichBreakFilter = {
  size?: InputMaybe<NumberFilter>;
};

export type ArticleHeadingRichFilter = {
  CurrentYear?: InputMaybe<ArticleHeadingRichCurrentYearFilter>;
  Break?: InputMaybe<ArticleHeadingRichBreakFilter>;
};

export type ArticleCategoryFilter = {
  category?: InputMaybe<CategoryFilter>;
};

export type ArticleAuthorFilter = {
  author?: InputMaybe<AuthorFilter>;
};

export type ArticleReviewerFilter = {
  author?: InputMaybe<AuthorFilter>;
};

export type ArticleWidgetsFilter = {
  image?: InputMaybe<ImageFilter>;
  heading?: InputMaybe<StringFilter>;
  text?: InputMaybe<StringFilter>;
  label?: InputMaybe<StringFilter>;
  link?: InputMaybe<StringFilter>;
};

export type ArticleCtaButtonsFilter = {
  label?: InputMaybe<StringFilter>;
  link?: InputMaybe<StringFilter>;
  ariaLabel?: InputMaybe<StringFilter>;
};

export type ArticleCtaFilter = {
  headingText?: InputMaybe<StringFilter>;
  text?: InputMaybe<StringFilter>;
  buttons?: InputMaybe<ArticleCtaButtonsFilter>;
};

export type ArticleRelatedRefFilter = {
  article?: InputMaybe<ArticleFilter>;
};

export type ArticleRelatedFilter = {
  ref?: InputMaybe<ArticleRelatedRefFilter>;
};

export type ArticleBodyAnchorFilter = {
  label?: InputMaybe<StringFilter>;
  name?: InputMaybe<StringFilter>;
};

export type ArticleBodyCurrentYearFilter = {
  add?: InputMaybe<StringFilter>;
};

export type ArticleBodyIFrameFilter = {
  src?: InputMaybe<StringFilter>;
  title?: InputMaybe<StringFilter>;
  width?: InputMaybe<StringFilter>;
  height?: InputMaybe<StringFilter>;
  scrolling?: InputMaybe<StringFilter>;
  frameborder?: InputMaybe<StringFilter>;
  style?: InputMaybe<StringFilter>;
  allowfullscreen?: InputMaybe<StringFilter>;
};

export type ArticleBodyDiFormFilter = {
  heading?: InputMaybe<StringFilter>;
};

export type ArticleBodyCiFormFilter = {
  heading?: InputMaybe<StringFilter>;
};

export type ArticleBodyCtaFilter = {
  heading?: InputMaybe<StringFilter>;
  label?: InputMaybe<StringFilter>;
  link?: InputMaybe<StringFilter>;
};

export type ArticleBodyYoutubeFilter = {
  id?: InputMaybe<StringFilter>;
};

export type ArticleBodyYoutubeCarouselFilter = {
  ids?: InputMaybe<StringFilter>;
};

export type ArticleBodyTableFilter = {
  html?: InputMaybe<StringFilter>;
};

export type ArticleBodyFilter = {
  Anchor?: InputMaybe<ArticleBodyAnchorFilter>;
  CurrentYear?: InputMaybe<ArticleBodyCurrentYearFilter>;
  IFrame?: InputMaybe<ArticleBodyIFrameFilter>;
  DiForm?: InputMaybe<ArticleBodyDiFormFilter>;
  CiForm?: InputMaybe<ArticleBodyCiFormFilter>;
  cta?: InputMaybe<ArticleBodyCtaFilter>;
  Youtube?: InputMaybe<ArticleBodyYoutubeFilter>;
  YoutubeCarousel?: InputMaybe<ArticleBodyYoutubeCarouselFilter>;
  Table?: InputMaybe<ArticleBodyTableFilter>;
};

export type ArticleFilter = {
  component?: InputMaybe<StringFilter>;
  updatedDate?: InputMaybe<DatetimeFilter>;
  publishedDate?: InputMaybe<DatetimeFilter>;
  title?: InputMaybe<StringFilter>;
  settings?: InputMaybe<ArticleSettingsFilter>;
  readtime?: InputMaybe<ArticleReadtimeFilter>;
  cover?: InputMaybe<ImageFilter>;
  thumbnail?: InputMaybe<ImageFilter>;
  headingRich?: InputMaybe<ArticleHeadingRichFilter>;
  subtitleRich?: InputMaybe<StringFilter>;
  excerptText?: InputMaybe<StringFilter>;
  category?: InputMaybe<ArticleCategoryFilter>;
  author?: InputMaybe<ArticleAuthorFilter>;
  reviewer?: InputMaybe<ArticleReviewerFilter>;
  widgets?: InputMaybe<ArticleWidgetsFilter>;
  cta?: InputMaybe<ArticleCtaFilter>;
  related?: InputMaybe<ArticleRelatedFilter>;
  body?: InputMaybe<ArticleBodyFilter>;
};

export type ArticleConnectionEdges = {
  __typename?: 'ArticleConnectionEdges';
  cursor: Scalars['String']['output'];
  node?: Maybe<Article>;
};

export type ArticleConnection = Connection & {
  __typename?: 'ArticleConnection';
  pageInfo: PageInfo;
  totalCount: Scalars['Float']['output'];
  edges?: Maybe<Array<Maybe<ArticleConnectionEdges>>>;
};

export type PostSettingsPublish = {
  __typename?: 'PostSettingsPublish';
  published?: Maybe<Scalars['Boolean']['output']>;
  publishedDate?: Maybe<Scalars['String']['output']>;
};

export type CategorySettingsSeoImage = {
  __typename?: 'CategorySettingsSeoImage';
  src?: Maybe<Scalars['String']['output']>;
  width?: Maybe<Scalars['Float']['output']>;
  height?: Maybe<Scalars['Float']['output']>;
  aspectRatio?: Maybe<Scalars['Float']['output']>;
  format?: Maybe<Scalars['String']['output']>;
  alt?: Maybe<Scalars['String']['output']>;
};

export type CategorySettingsSeoOrg = {
  __typename?: 'CategorySettingsSeoOrg';
  disable?: Maybe<Scalars['Boolean']['output']>;
};

export type AuthorSettingsSeoFaqItems = {
  __typename?: 'AuthorSettingsSeoFaqItems';
  q?: Maybe<Scalars['String']['output']>;
  a?: Maybe<Scalars['String']['output']>;
};

export type CategorySettingsSeoFaq = {
  __typename?: 'CategorySettingsSeoFaq';
  disable?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  items?: Maybe<Array<Maybe<AuthorSettingsSeoFaqItems>>>;
};

export type AuthorSettingsSeoHowToImage = {
  __typename?: 'AuthorSettingsSeoHowToImage';
  src?: Maybe<Scalars['String']['output']>;
  width?: Maybe<Scalars['Float']['output']>;
  height?: Maybe<Scalars['Float']['output']>;
  aspectRatio?: Maybe<Scalars['Float']['output']>;
  format?: Maybe<Scalars['String']['output']>;
  alt?: Maybe<Scalars['String']['output']>;
};

export type AuthorSettingsSeoHowToSteps = {
  __typename?: 'AuthorSettingsSeoHowToSteps';
  name?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
};

export type CategorySettingsSeoHowTo = {
  __typename?: 'CategorySettingsSeoHowTo';
  disable?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  image?: Maybe<AuthorSettingsSeoHowToImage>;
  steps?: Maybe<Array<Maybe<AuthorSettingsSeoHowToSteps>>>;
};

export type PostSettingsSeo = {
  __typename?: 'PostSettingsSeo';
  title?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  image?: Maybe<CategorySettingsSeoImage>;
  org?: Maybe<CategorySettingsSeoOrg>;
  faq?: Maybe<CategorySettingsSeoFaq>;
  howTo?: Maybe<CategorySettingsSeoHowTo>;
};

export type PostSettingsSitemap = {
  __typename?: 'PostSettingsSitemap';
  exclude?: Maybe<Scalars['Boolean']['output']>;
  breadcrumb?: Maybe<Scalars['String']['output']>;
  changefreq?: Maybe<Scalars['String']['output']>;
  priority?: Maybe<Scalars['Float']['output']>;
};

export type PostSettingsNotification = Notification;

export type CategorySettingsNavigationRightSideButtonOverride = {
  __typename?: 'CategorySettingsNavigationRightSideButtonOverride';
  label?: Maybe<Scalars['String']['output']>;
  link?: Maybe<Scalars['String']['output']>;
  ariaLabel?: Maybe<Scalars['String']['output']>;
};

export type PostSettingsNavigation = {
  __typename?: 'PostSettingsNavigation';
  disableLogo?: Maybe<Scalars['Boolean']['output']>;
  disableLeft?: Maybe<Scalars['Boolean']['output']>;
  disableRight?: Maybe<Scalars['Boolean']['output']>;
  disableButtons?: Maybe<Scalars['Boolean']['output']>;
  rightSideButtonOverride?: Maybe<CategorySettingsNavigationRightSideButtonOverride>;
};

export type PostSettingsFooter = {
  __typename?: 'PostSettingsFooter';
  disableLinks?: Maybe<Scalars['Boolean']['output']>;
  disableBottom?: Maybe<Scalars['Boolean']['output']>;
};

export type PostSettingsDisclaimer = {
  __typename?: 'PostSettingsDisclaimer';
  disable?: Maybe<Scalars['Boolean']['output']>;
  content?: Maybe<Scalars['JSON']['output']>;
};

export type CategorySettingsPartnerPartnerRef = Partner;

export type CategorySettingsPartnerCobrandRef = Cobrand;

export type PostSettingsPartner = {
  __typename?: 'PostSettingsPartner';
  partnerRef?: Maybe<CategorySettingsPartnerPartnerRef>;
  cobrandRef?: Maybe<CategorySettingsPartnerCobrandRef>;
};

export type PostSettingsClient = {
  __typename?: 'PostSettingsClient';
  enabled?: Maybe<Scalars['Boolean']['output']>;
};

export type PostSettings = {
  __typename?: 'PostSettings';
  publish?: Maybe<PostSettingsPublish>;
  seo?: Maybe<PostSettingsSeo>;
  sitemap?: Maybe<PostSettingsSitemap>;
  notification?: Maybe<PostSettingsNotification>;
  navigation?: Maybe<PostSettingsNavigation>;
  footer?: Maybe<PostSettingsFooter>;
  disclaimer?: Maybe<PostSettingsDisclaimer>;
  partner?: Maybe<PostSettingsPartner>;
  client?: Maybe<PostSettingsClient>;
};

export type PostReadtime = {
  __typename?: 'PostReadtime';
  text?: Maybe<Scalars['String']['output']>;
  minutes?: Maybe<Scalars['Float']['output']>;
  time?: Maybe<Scalars['Float']['output']>;
  words?: Maybe<Scalars['Float']['output']>;
};

export type PostCategory = Category;

export type PostAuthor = Author;

export type PostReviewer = Author;

export type PostWidgets = {
  __typename?: 'PostWidgets';
  image?: Maybe<Scalars['String']['output']>;
  heading?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  link?: Maybe<Scalars['String']['output']>;
};

export type PostCtaButtons = {
  __typename?: 'PostCtaButtons';
  label?: Maybe<Scalars['String']['output']>;
  link?: Maybe<Scalars['String']['output']>;
  ariaLabel?: Maybe<Scalars['String']['output']>;
};

export type PostCta = {
  __typename?: 'PostCta';
  headingText?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  buttons?: Maybe<Array<Maybe<PostCtaButtons>>>;
};

export type PostRelatedRef = Post;

export type PostRelated = {
  __typename?: 'PostRelated';
  ref?: Maybe<PostRelatedRef>;
};

export type Post = Node & Document & {
  __typename?: 'Post';
  component?: Maybe<Scalars['String']['output']>;
  updatedDate?: Maybe<Scalars['String']['output']>;
  publishedDate?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  settings?: Maybe<PostSettings>;
  readtime?: Maybe<PostReadtime>;
  cover?: Maybe<Scalars['String']['output']>;
  thumbnail?: Maybe<Scalars['String']['output']>;
  headingRich?: Maybe<Scalars['JSON']['output']>;
  excerptText?: Maybe<Scalars['String']['output']>;
  category?: Maybe<PostCategory>;
  author?: Maybe<PostAuthor>;
  reviewer?: Maybe<PostReviewer>;
  widgets?: Maybe<Array<Maybe<PostWidgets>>>;
  cta?: Maybe<PostCta>;
  related?: Maybe<Array<Maybe<PostRelated>>>;
  body?: Maybe<Scalars['JSON']['output']>;
  id: Scalars['ID']['output'];
  _sys: SystemInfo;
  _values: Scalars['JSON']['output'];
};

export type PostSettingsPublishFilter = {
  published?: InputMaybe<BooleanFilter>;
  publishedDate?: InputMaybe<DatetimeFilter>;
};

export type CategorySettingsSeoImageFilter = {
  src?: InputMaybe<StringFilter>;
  width?: InputMaybe<NumberFilter>;
  height?: InputMaybe<NumberFilter>;
  aspectRatio?: InputMaybe<NumberFilter>;
  format?: InputMaybe<StringFilter>;
  alt?: InputMaybe<StringFilter>;
};

export type CategorySettingsSeoOrgFilter = {
  disable?: InputMaybe<BooleanFilter>;
};

export type AuthorSettingsSeoFaqItemsFilter = {
  q?: InputMaybe<StringFilter>;
  a?: InputMaybe<StringFilter>;
};

export type CategorySettingsSeoFaqFilter = {
  disable?: InputMaybe<BooleanFilter>;
  name?: InputMaybe<StringFilter>;
  items?: InputMaybe<AuthorSettingsSeoFaqItemsFilter>;
};

export type AuthorSettingsSeoHowToImageFilter = {
  src?: InputMaybe<StringFilter>;
  width?: InputMaybe<NumberFilter>;
  height?: InputMaybe<NumberFilter>;
  aspectRatio?: InputMaybe<NumberFilter>;
  format?: InputMaybe<StringFilter>;
  alt?: InputMaybe<StringFilter>;
};

export type AuthorSettingsSeoHowToStepsFilter = {
  name?: InputMaybe<StringFilter>;
  url?: InputMaybe<StringFilter>;
  text?: InputMaybe<StringFilter>;
};

export type CategorySettingsSeoHowToFilter = {
  disable?: InputMaybe<BooleanFilter>;
  name?: InputMaybe<StringFilter>;
  description?: InputMaybe<StringFilter>;
  image?: InputMaybe<AuthorSettingsSeoHowToImageFilter>;
  steps?: InputMaybe<AuthorSettingsSeoHowToStepsFilter>;
};

export type PostSettingsSeoFilter = {
  title?: InputMaybe<StringFilter>;
  url?: InputMaybe<StringFilter>;
  description?: InputMaybe<StringFilter>;
  image?: InputMaybe<CategorySettingsSeoImageFilter>;
  org?: InputMaybe<CategorySettingsSeoOrgFilter>;
  faq?: InputMaybe<CategorySettingsSeoFaqFilter>;
  howTo?: InputMaybe<CategorySettingsSeoHowToFilter>;
};

export type PostSettingsSitemapFilter = {
  exclude?: InputMaybe<BooleanFilter>;
  breadcrumb?: InputMaybe<StringFilter>;
  changefreq?: InputMaybe<StringFilter>;
  priority?: InputMaybe<NumberFilter>;
};

export type PostSettingsNotificationFilter = {
  notification?: InputMaybe<NotificationFilter>;
};

export type CategorySettingsNavigationRightSideButtonOverrideFilter = {
  label?: InputMaybe<StringFilter>;
  link?: InputMaybe<StringFilter>;
  ariaLabel?: InputMaybe<StringFilter>;
};

export type PostSettingsNavigationFilter = {
  disableLogo?: InputMaybe<BooleanFilter>;
  disableLeft?: InputMaybe<BooleanFilter>;
  disableRight?: InputMaybe<BooleanFilter>;
  disableButtons?: InputMaybe<BooleanFilter>;
  rightSideButtonOverride?: InputMaybe<CategorySettingsNavigationRightSideButtonOverrideFilter>;
};

export type PostSettingsFooterFilter = {
  disableLinks?: InputMaybe<BooleanFilter>;
  disableBottom?: InputMaybe<BooleanFilter>;
};

export type PostSettingsDisclaimerFilter = {
  disable?: InputMaybe<BooleanFilter>;
  content?: InputMaybe<RichTextFilter>;
};

export type CategorySettingsPartnerPartnerRefFilter = {
  partner?: InputMaybe<PartnerFilter>;
};

export type CategorySettingsPartnerCobrandRefFilter = {
  cobrand?: InputMaybe<CobrandFilter>;
};

export type PostSettingsPartnerFilter = {
  partnerRef?: InputMaybe<CategorySettingsPartnerPartnerRefFilter>;
  cobrandRef?: InputMaybe<CategorySettingsPartnerCobrandRefFilter>;
};

export type PostSettingsClientFilter = {
  enabled?: InputMaybe<BooleanFilter>;
};

export type PostSettingsFilter = {
  publish?: InputMaybe<PostSettingsPublishFilter>;
  seo?: InputMaybe<PostSettingsSeoFilter>;
  sitemap?: InputMaybe<PostSettingsSitemapFilter>;
  notification?: InputMaybe<PostSettingsNotificationFilter>;
  navigation?: InputMaybe<PostSettingsNavigationFilter>;
  footer?: InputMaybe<PostSettingsFooterFilter>;
  disclaimer?: InputMaybe<PostSettingsDisclaimerFilter>;
  partner?: InputMaybe<PostSettingsPartnerFilter>;
  client?: InputMaybe<PostSettingsClientFilter>;
};

export type PostReadtimeFilter = {
  text?: InputMaybe<StringFilter>;
  minutes?: InputMaybe<NumberFilter>;
  time?: InputMaybe<NumberFilter>;
  words?: InputMaybe<NumberFilter>;
};

export type PostHeadingRichCurrentYearFilter = {
  add?: InputMaybe<StringFilter>;
};

export type PostHeadingRichFilter = {
  CurrentYear?: InputMaybe<PostHeadingRichCurrentYearFilter>;
};

export type PostCategoryFilter = {
  category?: InputMaybe<CategoryFilter>;
};

export type PostAuthorFilter = {
  author?: InputMaybe<AuthorFilter>;
};

export type PostReviewerFilter = {
  author?: InputMaybe<AuthorFilter>;
};

export type PostWidgetsFilter = {
  image?: InputMaybe<ImageFilter>;
  heading?: InputMaybe<StringFilter>;
  text?: InputMaybe<StringFilter>;
  label?: InputMaybe<StringFilter>;
  link?: InputMaybe<StringFilter>;
};

export type PostCtaButtonsFilter = {
  label?: InputMaybe<StringFilter>;
  link?: InputMaybe<StringFilter>;
  ariaLabel?: InputMaybe<StringFilter>;
};

export type PostCtaFilter = {
  headingText?: InputMaybe<StringFilter>;
  text?: InputMaybe<StringFilter>;
  buttons?: InputMaybe<PostCtaButtonsFilter>;
};

export type PostRelatedRefFilter = {
  post?: InputMaybe<PostFilter>;
};

export type PostRelatedFilter = {
  ref?: InputMaybe<PostRelatedRefFilter>;
};

export type PostBodyAnchorFilter = {
  label?: InputMaybe<StringFilter>;
  name?: InputMaybe<StringFilter>;
};

export type PostBodyCurrentYearFilter = {
  add?: InputMaybe<StringFilter>;
};

export type PostBodyIFrameFilter = {
  src?: InputMaybe<StringFilter>;
  title?: InputMaybe<StringFilter>;
  width?: InputMaybe<StringFilter>;
  height?: InputMaybe<StringFilter>;
  scrolling?: InputMaybe<StringFilter>;
  frameborder?: InputMaybe<StringFilter>;
  style?: InputMaybe<StringFilter>;
  allowfullscreen?: InputMaybe<StringFilter>;
};

export type PostBodyDiFormFilter = {
  heading?: InputMaybe<StringFilter>;
};

export type PostBodyCiFormFilter = {
  heading?: InputMaybe<StringFilter>;
};

export type PostBodyCtaFilter = {
  heading?: InputMaybe<StringFilter>;
  label?: InputMaybe<StringFilter>;
  link?: InputMaybe<StringFilter>;
};

export type PostBodyTableFilter = {
  html?: InputMaybe<StringFilter>;
};

export type PostBodyFilter = {
  Anchor?: InputMaybe<PostBodyAnchorFilter>;
  CurrentYear?: InputMaybe<PostBodyCurrentYearFilter>;
  IFrame?: InputMaybe<PostBodyIFrameFilter>;
  DiForm?: InputMaybe<PostBodyDiFormFilter>;
  CiForm?: InputMaybe<PostBodyCiFormFilter>;
  cta?: InputMaybe<PostBodyCtaFilter>;
  Table?: InputMaybe<PostBodyTableFilter>;
};

export type PostFilter = {
  component?: InputMaybe<StringFilter>;
  updatedDate?: InputMaybe<DatetimeFilter>;
  publishedDate?: InputMaybe<DatetimeFilter>;
  title?: InputMaybe<StringFilter>;
  settings?: InputMaybe<PostSettingsFilter>;
  readtime?: InputMaybe<PostReadtimeFilter>;
  cover?: InputMaybe<ImageFilter>;
  thumbnail?: InputMaybe<ImageFilter>;
  headingRich?: InputMaybe<PostHeadingRichFilter>;
  excerptText?: InputMaybe<StringFilter>;
  category?: InputMaybe<PostCategoryFilter>;
  author?: InputMaybe<PostAuthorFilter>;
  reviewer?: InputMaybe<PostReviewerFilter>;
  widgets?: InputMaybe<PostWidgetsFilter>;
  cta?: InputMaybe<PostCtaFilter>;
  related?: InputMaybe<PostRelatedFilter>;
  body?: InputMaybe<PostBodyFilter>;
};

export type PostConnectionEdges = {
  __typename?: 'PostConnectionEdges';
  cursor: Scalars['String']['output'];
  node?: Maybe<Post>;
};

export type PostConnection = Connection & {
  __typename?: 'PostConnection';
  pageInfo: PageInfo;
  totalCount: Scalars['Float']['output'];
  edges?: Maybe<Array<Maybe<PostConnectionEdges>>>;
};

export type CategorySettingsPublish = {
  __typename?: 'CategorySettingsPublish';
  published?: Maybe<Scalars['Boolean']['output']>;
  publishedDate?: Maybe<Scalars['String']['output']>;
};

export type AuthorSettingsSeoImage = {
  __typename?: 'AuthorSettingsSeoImage';
  src?: Maybe<Scalars['String']['output']>;
  width?: Maybe<Scalars['Float']['output']>;
  height?: Maybe<Scalars['Float']['output']>;
  aspectRatio?: Maybe<Scalars['Float']['output']>;
  format?: Maybe<Scalars['String']['output']>;
  alt?: Maybe<Scalars['String']['output']>;
};

export type AuthorSettingsSeoOrg = {
  __typename?: 'AuthorSettingsSeoOrg';
  disable?: Maybe<Scalars['Boolean']['output']>;
};

export type AuthorSettingsSeoFaq = {
  __typename?: 'AuthorSettingsSeoFaq';
  disable?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  items?: Maybe<Array<Maybe<AuthorSettingsSeoFaqItems>>>;
};

export type AuthorSettingsSeoHowTo = {
  __typename?: 'AuthorSettingsSeoHowTo';
  disable?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  image?: Maybe<AuthorSettingsSeoHowToImage>;
  steps?: Maybe<Array<Maybe<AuthorSettingsSeoHowToSteps>>>;
};

export type CategorySettingsSeo = {
  __typename?: 'CategorySettingsSeo';
  title?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  image?: Maybe<AuthorSettingsSeoImage>;
  org?: Maybe<AuthorSettingsSeoOrg>;
  faq?: Maybe<AuthorSettingsSeoFaq>;
  howTo?: Maybe<AuthorSettingsSeoHowTo>;
};

export type CategorySettingsSitemap = {
  __typename?: 'CategorySettingsSitemap';
  exclude?: Maybe<Scalars['Boolean']['output']>;
  breadcrumb?: Maybe<Scalars['String']['output']>;
  changefreq?: Maybe<Scalars['String']['output']>;
  priority?: Maybe<Scalars['Float']['output']>;
};

export type CategorySettingsNotification = Notification;

export type AuthorSettingsNavigationRightSideButtonOverride = {
  __typename?: 'AuthorSettingsNavigationRightSideButtonOverride';
  label?: Maybe<Scalars['String']['output']>;
  link?: Maybe<Scalars['String']['output']>;
  ariaLabel?: Maybe<Scalars['String']['output']>;
};

export type CategorySettingsNavigation = {
  __typename?: 'CategorySettingsNavigation';
  disableLogo?: Maybe<Scalars['Boolean']['output']>;
  disableLeft?: Maybe<Scalars['Boolean']['output']>;
  disableRight?: Maybe<Scalars['Boolean']['output']>;
  disableButtons?: Maybe<Scalars['Boolean']['output']>;
  rightSideButtonOverride?: Maybe<AuthorSettingsNavigationRightSideButtonOverride>;
};

export type CategorySettingsFooter = {
  __typename?: 'CategorySettingsFooter';
  disableLinks?: Maybe<Scalars['Boolean']['output']>;
  disableBottom?: Maybe<Scalars['Boolean']['output']>;
};

export type CategorySettingsDisclaimer = {
  __typename?: 'CategorySettingsDisclaimer';
  disable?: Maybe<Scalars['Boolean']['output']>;
  content?: Maybe<Scalars['JSON']['output']>;
};

export type AuthorSettingsPartnerPartnerRef = Partner;

export type AuthorSettingsPartnerCobrandRef = Cobrand;

export type CategorySettingsPartner = {
  __typename?: 'CategorySettingsPartner';
  partnerRef?: Maybe<AuthorSettingsPartnerPartnerRef>;
  cobrandRef?: Maybe<AuthorSettingsPartnerCobrandRef>;
};

export type CategorySettingsClient = {
  __typename?: 'CategorySettingsClient';
  enabled?: Maybe<Scalars['Boolean']['output']>;
};

export type CategorySettings = {
  __typename?: 'CategorySettings';
  publish?: Maybe<CategorySettingsPublish>;
  seo?: Maybe<CategorySettingsSeo>;
  sitemap?: Maybe<CategorySettingsSitemap>;
  notification?: Maybe<CategorySettingsNotification>;
  navigation?: Maybe<CategorySettingsNavigation>;
  footer?: Maybe<CategorySettingsFooter>;
  disclaimer?: Maybe<CategorySettingsDisclaimer>;
  partner?: Maybe<CategorySettingsPartner>;
  client?: Maybe<CategorySettingsClient>;
};

export type Category = Node & Document & {
  __typename?: 'Category';
  component?: Maybe<Scalars['String']['output']>;
  updatedDate?: Maybe<Scalars['String']['output']>;
  publishedDate?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  settings?: Maybe<CategorySettings>;
  name?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  _sys: SystemInfo;
  _values: Scalars['JSON']['output'];
};

export type CategorySettingsPublishFilter = {
  published?: InputMaybe<BooleanFilter>;
  publishedDate?: InputMaybe<DatetimeFilter>;
};

export type AuthorSettingsSeoImageFilter = {
  src?: InputMaybe<StringFilter>;
  width?: InputMaybe<NumberFilter>;
  height?: InputMaybe<NumberFilter>;
  aspectRatio?: InputMaybe<NumberFilter>;
  format?: InputMaybe<StringFilter>;
  alt?: InputMaybe<StringFilter>;
};

export type AuthorSettingsSeoOrgFilter = {
  disable?: InputMaybe<BooleanFilter>;
};

export type AuthorSettingsSeoFaqFilter = {
  disable?: InputMaybe<BooleanFilter>;
  name?: InputMaybe<StringFilter>;
  items?: InputMaybe<AuthorSettingsSeoFaqItemsFilter>;
};

export type AuthorSettingsSeoHowToFilter = {
  disable?: InputMaybe<BooleanFilter>;
  name?: InputMaybe<StringFilter>;
  description?: InputMaybe<StringFilter>;
  image?: InputMaybe<AuthorSettingsSeoHowToImageFilter>;
  steps?: InputMaybe<AuthorSettingsSeoHowToStepsFilter>;
};

export type CategorySettingsSeoFilter = {
  title?: InputMaybe<StringFilter>;
  url?: InputMaybe<StringFilter>;
  description?: InputMaybe<StringFilter>;
  image?: InputMaybe<AuthorSettingsSeoImageFilter>;
  org?: InputMaybe<AuthorSettingsSeoOrgFilter>;
  faq?: InputMaybe<AuthorSettingsSeoFaqFilter>;
  howTo?: InputMaybe<AuthorSettingsSeoHowToFilter>;
};

export type CategorySettingsSitemapFilter = {
  exclude?: InputMaybe<BooleanFilter>;
  breadcrumb?: InputMaybe<StringFilter>;
  changefreq?: InputMaybe<StringFilter>;
  priority?: InputMaybe<NumberFilter>;
};

export type CategorySettingsNotificationFilter = {
  notification?: InputMaybe<NotificationFilter>;
};

export type AuthorSettingsNavigationRightSideButtonOverrideFilter = {
  label?: InputMaybe<StringFilter>;
  link?: InputMaybe<StringFilter>;
  ariaLabel?: InputMaybe<StringFilter>;
};

export type CategorySettingsNavigationFilter = {
  disableLogo?: InputMaybe<BooleanFilter>;
  disableLeft?: InputMaybe<BooleanFilter>;
  disableRight?: InputMaybe<BooleanFilter>;
  disableButtons?: InputMaybe<BooleanFilter>;
  rightSideButtonOverride?: InputMaybe<AuthorSettingsNavigationRightSideButtonOverrideFilter>;
};

export type CategorySettingsFooterFilter = {
  disableLinks?: InputMaybe<BooleanFilter>;
  disableBottom?: InputMaybe<BooleanFilter>;
};

export type CategorySettingsDisclaimerFilter = {
  disable?: InputMaybe<BooleanFilter>;
  content?: InputMaybe<RichTextFilter>;
};

export type AuthorSettingsPartnerPartnerRefFilter = {
  partner?: InputMaybe<PartnerFilter>;
};

export type AuthorSettingsPartnerCobrandRefFilter = {
  cobrand?: InputMaybe<CobrandFilter>;
};

export type CategorySettingsPartnerFilter = {
  partnerRef?: InputMaybe<AuthorSettingsPartnerPartnerRefFilter>;
  cobrandRef?: InputMaybe<AuthorSettingsPartnerCobrandRefFilter>;
};

export type CategorySettingsClientFilter = {
  enabled?: InputMaybe<BooleanFilter>;
};

export type CategorySettingsFilter = {
  publish?: InputMaybe<CategorySettingsPublishFilter>;
  seo?: InputMaybe<CategorySettingsSeoFilter>;
  sitemap?: InputMaybe<CategorySettingsSitemapFilter>;
  notification?: InputMaybe<CategorySettingsNotificationFilter>;
  navigation?: InputMaybe<CategorySettingsNavigationFilter>;
  footer?: InputMaybe<CategorySettingsFooterFilter>;
  disclaimer?: InputMaybe<CategorySettingsDisclaimerFilter>;
  partner?: InputMaybe<CategorySettingsPartnerFilter>;
  client?: InputMaybe<CategorySettingsClientFilter>;
};

export type CategoryFilter = {
  component?: InputMaybe<StringFilter>;
  updatedDate?: InputMaybe<DatetimeFilter>;
  publishedDate?: InputMaybe<DatetimeFilter>;
  title?: InputMaybe<StringFilter>;
  settings?: InputMaybe<CategorySettingsFilter>;
  name?: InputMaybe<StringFilter>;
};

export type CategoryConnectionEdges = {
  __typename?: 'CategoryConnectionEdges';
  cursor: Scalars['String']['output'];
  node?: Maybe<Category>;
};

export type CategoryConnection = Connection & {
  __typename?: 'CategoryConnection';
  pageInfo: PageInfo;
  totalCount: Scalars['Float']['output'];
  edges?: Maybe<Array<Maybe<CategoryConnectionEdges>>>;
};

export type AuthorSettingsPublish = {
  __typename?: 'AuthorSettingsPublish';
  published?: Maybe<Scalars['Boolean']['output']>;
  publishedDate?: Maybe<Scalars['String']['output']>;
};

export type AuthorSettingsSeo = {
  __typename?: 'AuthorSettingsSeo';
  title?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  image?: Maybe<AuthorSettingsSeoImage>;
  org?: Maybe<AuthorSettingsSeoOrg>;
  faq?: Maybe<AuthorSettingsSeoFaq>;
  howTo?: Maybe<AuthorSettingsSeoHowTo>;
};

export type AuthorSettingsSitemap = {
  __typename?: 'AuthorSettingsSitemap';
  exclude?: Maybe<Scalars['Boolean']['output']>;
  breadcrumb?: Maybe<Scalars['String']['output']>;
  changefreq?: Maybe<Scalars['String']['output']>;
  priority?: Maybe<Scalars['Float']['output']>;
};

export type AuthorSettingsNotification = Notification;

export type AuthorSettingsNavigation = {
  __typename?: 'AuthorSettingsNavigation';
  disableLogo?: Maybe<Scalars['Boolean']['output']>;
  disableLeft?: Maybe<Scalars['Boolean']['output']>;
  disableRight?: Maybe<Scalars['Boolean']['output']>;
  disableButtons?: Maybe<Scalars['Boolean']['output']>;
  rightSideButtonOverride?: Maybe<AuthorSettingsNavigationRightSideButtonOverride>;
};

export type AuthorSettingsFooter = {
  __typename?: 'AuthorSettingsFooter';
  disableLinks?: Maybe<Scalars['Boolean']['output']>;
  disableBottom?: Maybe<Scalars['Boolean']['output']>;
};

export type AuthorSettingsDisclaimer = {
  __typename?: 'AuthorSettingsDisclaimer';
  disable?: Maybe<Scalars['Boolean']['output']>;
  content?: Maybe<Scalars['JSON']['output']>;
};

export type AuthorSettingsPartner = {
  __typename?: 'AuthorSettingsPartner';
  partnerRef?: Maybe<AuthorSettingsPartnerPartnerRef>;
  cobrandRef?: Maybe<AuthorSettingsPartnerCobrandRef>;
};

export type AuthorSettingsClient = {
  __typename?: 'AuthorSettingsClient';
  enabled?: Maybe<Scalars['Boolean']['output']>;
};

export type AuthorSettings = {
  __typename?: 'AuthorSettings';
  publish?: Maybe<AuthorSettingsPublish>;
  seo?: Maybe<AuthorSettingsSeo>;
  sitemap?: Maybe<AuthorSettingsSitemap>;
  notification?: Maybe<AuthorSettingsNotification>;
  navigation?: Maybe<AuthorSettingsNavigation>;
  footer?: Maybe<AuthorSettingsFooter>;
  disclaimer?: Maybe<AuthorSettingsDisclaimer>;
  partner?: Maybe<AuthorSettingsPartner>;
  client?: Maybe<AuthorSettingsClient>;
};

export type Author = Node & Document & {
  __typename?: 'Author';
  component?: Maybe<Scalars['String']['output']>;
  updatedDate?: Maybe<Scalars['String']['output']>;
  publishedDate?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  settings?: Maybe<AuthorSettings>;
  name?: Maybe<Scalars['String']['output']>;
  jobTitle?: Maybe<Scalars['String']['output']>;
  avatar?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  bio?: Maybe<Scalars['JSON']['output']>;
  id: Scalars['ID']['output'];
  _sys: SystemInfo;
  _values: Scalars['JSON']['output'];
};

export type AuthorSettingsPublishFilter = {
  published?: InputMaybe<BooleanFilter>;
  publishedDate?: InputMaybe<DatetimeFilter>;
};

export type AuthorSettingsSeoFilter = {
  title?: InputMaybe<StringFilter>;
  url?: InputMaybe<StringFilter>;
  description?: InputMaybe<StringFilter>;
  image?: InputMaybe<AuthorSettingsSeoImageFilter>;
  org?: InputMaybe<AuthorSettingsSeoOrgFilter>;
  faq?: InputMaybe<AuthorSettingsSeoFaqFilter>;
  howTo?: InputMaybe<AuthorSettingsSeoHowToFilter>;
};

export type AuthorSettingsSitemapFilter = {
  exclude?: InputMaybe<BooleanFilter>;
  breadcrumb?: InputMaybe<StringFilter>;
  changefreq?: InputMaybe<StringFilter>;
  priority?: InputMaybe<NumberFilter>;
};

export type AuthorSettingsNotificationFilter = {
  notification?: InputMaybe<NotificationFilter>;
};

export type AuthorSettingsNavigationFilter = {
  disableLogo?: InputMaybe<BooleanFilter>;
  disableLeft?: InputMaybe<BooleanFilter>;
  disableRight?: InputMaybe<BooleanFilter>;
  disableButtons?: InputMaybe<BooleanFilter>;
  rightSideButtonOverride?: InputMaybe<AuthorSettingsNavigationRightSideButtonOverrideFilter>;
};

export type AuthorSettingsFooterFilter = {
  disableLinks?: InputMaybe<BooleanFilter>;
  disableBottom?: InputMaybe<BooleanFilter>;
};

export type AuthorSettingsDisclaimerFilter = {
  disable?: InputMaybe<BooleanFilter>;
  content?: InputMaybe<RichTextFilter>;
};

export type AuthorSettingsPartnerFilter = {
  partnerRef?: InputMaybe<AuthorSettingsPartnerPartnerRefFilter>;
  cobrandRef?: InputMaybe<AuthorSettingsPartnerCobrandRefFilter>;
};

export type AuthorSettingsClientFilter = {
  enabled?: InputMaybe<BooleanFilter>;
};

export type AuthorSettingsFilter = {
  publish?: InputMaybe<AuthorSettingsPublishFilter>;
  seo?: InputMaybe<AuthorSettingsSeoFilter>;
  sitemap?: InputMaybe<AuthorSettingsSitemapFilter>;
  notification?: InputMaybe<AuthorSettingsNotificationFilter>;
  navigation?: InputMaybe<AuthorSettingsNavigationFilter>;
  footer?: InputMaybe<AuthorSettingsFooterFilter>;
  disclaimer?: InputMaybe<AuthorSettingsDisclaimerFilter>;
  partner?: InputMaybe<AuthorSettingsPartnerFilter>;
  client?: InputMaybe<AuthorSettingsClientFilter>;
};

export type AuthorFilter = {
  component?: InputMaybe<StringFilter>;
  updatedDate?: InputMaybe<DatetimeFilter>;
  publishedDate?: InputMaybe<DatetimeFilter>;
  title?: InputMaybe<StringFilter>;
  settings?: InputMaybe<AuthorSettingsFilter>;
  name?: InputMaybe<StringFilter>;
  jobTitle?: InputMaybe<StringFilter>;
  avatar?: InputMaybe<ImageFilter>;
  email?: InputMaybe<StringFilter>;
  bio?: InputMaybe<RichTextFilter>;
};

export type AuthorConnectionEdges = {
  __typename?: 'AuthorConnectionEdges';
  cursor: Scalars['String']['output'];
  node?: Maybe<Author>;
};

export type AuthorConnection = Connection & {
  __typename?: 'AuthorConnection';
  pageInfo: PageInfo;
  totalCount: Scalars['Float']['output'];
  edges?: Maybe<Array<Maybe<AuthorConnectionEdges>>>;
};

export type ProductButtons = {
  __typename?: 'ProductButtons';
  label?: Maybe<Scalars['String']['output']>;
  link?: Maybe<Scalars['String']['output']>;
  ariaLabel?: Maybe<Scalars['String']['output']>;
  agentLink?: Maybe<Scalars['String']['output']>;
};

export type Product = Node & Document & {
  __typename?: 'Product';
  dataType?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  productGroup: Scalars['String']['output'];
  shortName?: Maybe<Scalars['String']['output']>;
  icon?: Maybe<Scalars['String']['output']>;
  graphic?: Maybe<Scalars['String']['output']>;
  actionLabel?: Maybe<Scalars['String']['output']>;
  descriptionText?: Maybe<Scalars['String']['output']>;
  descriptionItems?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  disclaimer?: Maybe<Scalars['String']['output']>;
  buttons?: Maybe<Array<Maybe<ProductButtons>>>;
  id: Scalars['ID']['output'];
  _sys: SystemInfo;
  _values: Scalars['JSON']['output'];
};

export type ProductButtonsFilter = {
  label?: InputMaybe<StringFilter>;
  link?: InputMaybe<StringFilter>;
  ariaLabel?: InputMaybe<StringFilter>;
  agentLink?: InputMaybe<StringFilter>;
};

export type ProductFilter = {
  dataType?: InputMaybe<StringFilter>;
  title?: InputMaybe<StringFilter>;
  productGroup?: InputMaybe<StringFilter>;
  shortName?: InputMaybe<StringFilter>;
  icon?: InputMaybe<ImageFilter>;
  graphic?: InputMaybe<ImageFilter>;
  actionLabel?: InputMaybe<StringFilter>;
  descriptionText?: InputMaybe<StringFilter>;
  descriptionItems?: InputMaybe<StringFilter>;
  disclaimer?: InputMaybe<StringFilter>;
  buttons?: InputMaybe<ProductButtonsFilter>;
};

export type ProductConnectionEdges = {
  __typename?: 'ProductConnectionEdges';
  cursor: Scalars['String']['output'];
  node?: Maybe<Product>;
};

export type ProductConnection = Connection & {
  __typename?: 'ProductConnection';
  pageInfo: PageInfo;
  totalCount: Scalars['Float']['output'];
  edges?: Maybe<Array<Maybe<ProductConnectionEdges>>>;
};

export type Testimonial = Node & Document & {
  __typename?: 'Testimonial';
  dataType?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  stars?: Maybe<Scalars['Float']['output']>;
  author?: Maybe<Scalars['String']['output']>;
  authorTitle?: Maybe<Scalars['String']['output']>;
  link?: Maybe<Scalars['String']['output']>;
  body?: Maybe<Scalars['JSON']['output']>;
  id: Scalars['ID']['output'];
  _sys: SystemInfo;
  _values: Scalars['JSON']['output'];
};

export type TestimonialFilter = {
  dataType?: InputMaybe<StringFilter>;
  title?: InputMaybe<StringFilter>;
  stars?: InputMaybe<NumberFilter>;
  author?: InputMaybe<StringFilter>;
  authorTitle?: InputMaybe<StringFilter>;
  link?: InputMaybe<StringFilter>;
  body?: InputMaybe<RichTextFilter>;
};

export type TestimonialConnectionEdges = {
  __typename?: 'TestimonialConnectionEdges';
  cursor: Scalars['String']['output'];
  node?: Maybe<Testimonial>;
};

export type TestimonialConnection = Connection & {
  __typename?: 'TestimonialConnection';
  pageInfo: PageInfo;
  totalCount: Scalars['Float']['output'];
  edges?: Maybe<Array<Maybe<TestimonialConnectionEdges>>>;
};

export type PartnerLogo = {
  __typename?: 'PartnerLogo';
  src?: Maybe<Scalars['String']['output']>;
};

export type Partner = Node & Document & {
  __typename?: 'Partner';
  dataType?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  pid?: Maybe<Scalars['String']['output']>;
  enabled?: Maybe<Scalars['Boolean']['output']>;
  logo?: Maybe<PartnerLogo>;
  displayName?: Maybe<Scalars['String']['output']>;
  ctaLink?: Maybe<Scalars['String']['output']>;
  products?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  disclaimer?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  _sys: SystemInfo;
  _values: Scalars['JSON']['output'];
};

export type PartnerLogoFilter = {
  src?: InputMaybe<ImageFilter>;
};

export type PartnerFilter = {
  dataType?: InputMaybe<StringFilter>;
  title?: InputMaybe<StringFilter>;
  pid?: InputMaybe<StringFilter>;
  enabled?: InputMaybe<BooleanFilter>;
  logo?: InputMaybe<PartnerLogoFilter>;
  displayName?: InputMaybe<StringFilter>;
  ctaLink?: InputMaybe<StringFilter>;
  products?: InputMaybe<StringFilter>;
  disclaimer?: InputMaybe<StringFilter>;
};

export type PartnerConnectionEdges = {
  __typename?: 'PartnerConnectionEdges';
  cursor: Scalars['String']['output'];
  node?: Maybe<Partner>;
};

export type PartnerConnection = Connection & {
  __typename?: 'PartnerConnection';
  pageInfo: PageInfo;
  totalCount: Scalars['Float']['output'];
  edges?: Maybe<Array<Maybe<PartnerConnectionEdges>>>;
};

export type Cobrand = Node & Document & {
  __typename?: 'Cobrand';
  dataType?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  logoSrc?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  _sys: SystemInfo;
  _values: Scalars['JSON']['output'];
};

export type CobrandFilter = {
  dataType?: InputMaybe<StringFilter>;
  title?: InputMaybe<StringFilter>;
  logoSrc?: InputMaybe<ImageFilter>;
  displayName?: InputMaybe<StringFilter>;
};

export type CobrandConnectionEdges = {
  __typename?: 'CobrandConnectionEdges';
  cursor: Scalars['String']['output'];
  node?: Maybe<Cobrand>;
};

export type CobrandConnection = Connection & {
  __typename?: 'CobrandConnection';
  pageInfo: PageInfo;
  totalCount: Scalars['Float']['output'];
  edges?: Maybe<Array<Maybe<CobrandConnectionEdges>>>;
};

export type BgaProductsRefsProductRef = Product;

export type BgaProductsRefs = {
  __typename?: 'BgaProductsRefs';
  productRef?: Maybe<BgaProductsRefsProductRef>;
};

export type Bga = Node & Document & {
  __typename?: 'Bga';
  dataType?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  urlSlug?: Maybe<Scalars['String']['output']>;
  logoSrc?: Maybe<Scalars['String']['output']>;
  mobileLogoSrc?: Maybe<Scalars['String']['output']>;
  websiteDisplayName?: Maybe<Scalars['String']['output']>;
  ctaLink?: Maybe<Scalars['String']['output']>;
  productsRefs?: Maybe<Array<Maybe<BgaProductsRefs>>>;
  id: Scalars['ID']['output'];
  _sys: SystemInfo;
  _values: Scalars['JSON']['output'];
};

export type BgaProductsRefsProductRefFilter = {
  product?: InputMaybe<ProductFilter>;
};

export type BgaProductsRefsFilter = {
  productRef?: InputMaybe<BgaProductsRefsProductRefFilter>;
};

export type BgaFilter = {
  dataType?: InputMaybe<StringFilter>;
  title?: InputMaybe<StringFilter>;
  urlSlug?: InputMaybe<StringFilter>;
  logoSrc?: InputMaybe<ImageFilter>;
  mobileLogoSrc?: InputMaybe<ImageFilter>;
  websiteDisplayName?: InputMaybe<StringFilter>;
  ctaLink?: InputMaybe<StringFilter>;
  productsRefs?: InputMaybe<BgaProductsRefsFilter>;
};

export type BgaConnectionEdges = {
  __typename?: 'BgaConnectionEdges';
  cursor: Scalars['String']['output'];
  node?: Maybe<Bga>;
};

export type BgaConnection = Connection & {
  __typename?: 'BgaConnection';
  pageInfo: PageInfo;
  totalCount: Scalars['Float']['output'];
  edges?: Maybe<Array<Maybe<BgaConnectionEdges>>>;
};

export type Notification = Node & Document & {
  __typename?: 'Notification';
  title: Scalars['String']['output'];
  color?: Maybe<Scalars['String']['output']>;
  body?: Maybe<Scalars['JSON']['output']>;
  id: Scalars['ID']['output'];
  _sys: SystemInfo;
  _values: Scalars['JSON']['output'];
};

export type NotificationFilter = {
  title?: InputMaybe<StringFilter>;
  color?: InputMaybe<StringFilter>;
  body?: InputMaybe<RichTextFilter>;
};

export type NotificationConnectionEdges = {
  __typename?: 'NotificationConnectionEdges';
  cursor: Scalars['String']['output'];
  node?: Maybe<Notification>;
};

export type NotificationConnection = Connection & {
  __typename?: 'NotificationConnection';
  pageInfo: PageInfo;
  totalCount: Scalars['Float']['output'];
  edges?: Maybe<Array<Maybe<NotificationConnectionEdges>>>;
};

export type SettingsNavigationLeftMegaMenuItemsImage = {
  __typename?: 'SettingsNavigationLeftMegaMenuItemsImage';
  src?: Maybe<Scalars['String']['output']>;
  width?: Maybe<Scalars['Float']['output']>;
  height?: Maybe<Scalars['Float']['output']>;
  aspectRatio?: Maybe<Scalars['Float']['output']>;
  format?: Maybe<Scalars['String']['output']>;
  alt?: Maybe<Scalars['String']['output']>;
};

export type SettingsNavigationLeftMegaMenuItemsButtons = {
  __typename?: 'SettingsNavigationLeftMegaMenuItemsButtons';
  label?: Maybe<Scalars['String']['output']>;
  link?: Maybe<Scalars['String']['output']>;
  ariaLabel?: Maybe<Scalars['String']['output']>;
};

export type SettingsNavigationLeftMegaMenuItemsColumnsLinks = {
  __typename?: 'SettingsNavigationLeftMegaMenuItemsColumnsLinks';
  label?: Maybe<Scalars['String']['output']>;
  link?: Maybe<Scalars['String']['output']>;
  ariaLabel?: Maybe<Scalars['String']['output']>;
};

export type SettingsNavigationLeftMegaMenuItemsColumns = {
  __typename?: 'SettingsNavigationLeftMegaMenuItemsColumns';
  title?: Maybe<Scalars['String']['output']>;
  links?: Maybe<Array<Maybe<SettingsNavigationLeftMegaMenuItemsColumnsLinks>>>;
};

export type SettingsNavigationLeftMegaMenuItems = {
  __typename?: 'SettingsNavigationLeftMegaMenuItems';
  title?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  icon?: Maybe<Scalars['String']['output']>;
  image?: Maybe<SettingsNavigationLeftMegaMenuItemsImage>;
  buttons?: Maybe<Array<Maybe<SettingsNavigationLeftMegaMenuItemsButtons>>>;
  columns?: Maybe<Array<Maybe<SettingsNavigationLeftMegaMenuItemsColumns>>>;
};

export type SettingsNavigationLeftMegaMenu = {
  __typename?: 'SettingsNavigationLeftMegaMenu';
  title?: Maybe<Scalars['String']['output']>;
  heading?: Maybe<Scalars['String']['output']>;
  items?: Maybe<Array<Maybe<SettingsNavigationLeftMegaMenuItems>>>;
};

export type SettingsNavigationLeftSimpleMenuItems = {
  __typename?: 'SettingsNavigationLeftSimpleMenuItems';
  icon?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  link?: Maybe<Scalars['String']['output']>;
};

export type SettingsNavigationLeftSimpleMenu = {
  __typename?: 'SettingsNavigationLeftSimpleMenu';
  title?: Maybe<Scalars['String']['output']>;
  items?: Maybe<Array<Maybe<SettingsNavigationLeftSimpleMenuItems>>>;
};

export type SettingsNavigationLeft = SettingsNavigationLeftMegaMenu | SettingsNavigationLeftSimpleMenu;

export type SettingsNavigationRightLinkItem = {
  __typename?: 'SettingsNavigationRightLinkItem';
  label?: Maybe<Scalars['String']['output']>;
  link?: Maybe<Scalars['String']['output']>;
  ariaLabel?: Maybe<Scalars['String']['output']>;
};

export type SettingsNavigationRightDropdownItemItems = {
  __typename?: 'SettingsNavigationRightDropdownItemItems';
  label?: Maybe<Scalars['String']['output']>;
  link?: Maybe<Scalars['String']['output']>;
  ariaLabel?: Maybe<Scalars['String']['output']>;
};

export type SettingsNavigationRightDropdownItem = {
  __typename?: 'SettingsNavigationRightDropdownItem';
  label?: Maybe<Scalars['String']['output']>;
  items?: Maybe<Array<Maybe<SettingsNavigationRightDropdownItemItems>>>;
};

export type SettingsNavigationRightButtonItem = {
  __typename?: 'SettingsNavigationRightButtonItem';
  label?: Maybe<Scalars['String']['output']>;
  link?: Maybe<Scalars['String']['output']>;
  ariaLabel?: Maybe<Scalars['String']['output']>;
};

export type SettingsNavigationRight = SettingsNavigationRightLinkItem | SettingsNavigationRightDropdownItem | SettingsNavigationRightButtonItem;

export type SettingsNavigation = Node & Document & {
  __typename?: 'SettingsNavigation';
  title: Scalars['String']['output'];
  left?: Maybe<Array<Maybe<SettingsNavigationLeft>>>;
  right?: Maybe<Array<Maybe<SettingsNavigationRight>>>;
  id: Scalars['ID']['output'];
  _sys: SystemInfo;
  _values: Scalars['JSON']['output'];
};

export type SettingsFooterColumnsImage = {
  __typename?: 'SettingsFooterColumnsImage';
  src?: Maybe<Scalars['String']['output']>;
  width?: Maybe<Scalars['Float']['output']>;
  height?: Maybe<Scalars['Float']['output']>;
  aspectRatio?: Maybe<Scalars['Float']['output']>;
  format?: Maybe<Scalars['String']['output']>;
  alt?: Maybe<Scalars['String']['output']>;
};

export type SettingsFooterColumnsLinks = {
  __typename?: 'SettingsFooterColumnsLinks';
  label?: Maybe<Scalars['String']['output']>;
  link?: Maybe<Scalars['String']['output']>;
  ariaLabel?: Maybe<Scalars['String']['output']>;
};

export type SettingsFooterColumns = {
  __typename?: 'SettingsFooterColumns';
  title?: Maybe<Scalars['String']['output']>;
  image?: Maybe<SettingsFooterColumnsImage>;
  links?: Maybe<Array<Maybe<SettingsFooterColumnsLinks>>>;
};

export type SettingsFooterExtrasLinks = {
  __typename?: 'SettingsFooterExtrasLinks';
  label?: Maybe<Scalars['String']['output']>;
  link?: Maybe<Scalars['String']['output']>;
  ariaLabel?: Maybe<Scalars['String']['output']>;
};

export type SettingsFooterExtras = {
  __typename?: 'SettingsFooterExtras';
  title?: Maybe<Scalars['String']['output']>;
  links?: Maybe<Array<Maybe<SettingsFooterExtrasLinks>>>;
};

export type SettingsFooterContacts = {
  __typename?: 'SettingsFooterContacts';
  icon?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  link?: Maybe<Scalars['String']['output']>;
  ariaLabel?: Maybe<Scalars['String']['output']>;
};

export type SettingsFooterBottomSocial = {
  __typename?: 'SettingsFooterBottomSocial';
  icon?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  link?: Maybe<Scalars['String']['output']>;
  ariaLabel?: Maybe<Scalars['String']['output']>;
};

export type SettingsFooterBottomNavigation = {
  __typename?: 'SettingsFooterBottomNavigation';
  label?: Maybe<Scalars['String']['output']>;
  link?: Maybe<Scalars['String']['output']>;
  ariaLabel?: Maybe<Scalars['String']['output']>;
  newWindow?: Maybe<Scalars['Boolean']['output']>;
};

export type SettingsFooterBottom = {
  __typename?: 'SettingsFooterBottom';
  copyright?: Maybe<Scalars['String']['output']>;
  social?: Maybe<Array<Maybe<SettingsFooterBottomSocial>>>;
  navigation?: Maybe<Array<Maybe<SettingsFooterBottomNavigation>>>;
};

export type SettingsFooter = Node & Document & {
  __typename?: 'SettingsFooter';
  title: Scalars['String']['output'];
  columns?: Maybe<Array<Maybe<SettingsFooterColumns>>>;
  extras?: Maybe<Array<Maybe<SettingsFooterExtras>>>;
  address?: Maybe<Scalars['String']['output']>;
  contacts?: Maybe<Array<Maybe<SettingsFooterContacts>>>;
  bottom?: Maybe<SettingsFooterBottom>;
  disclaimer?: Maybe<Scalars['JSON']['output']>;
  id: Scalars['ID']['output'];
  _sys: SystemInfo;
  _values: Scalars['JSON']['output'];
};

export type SettingsSiteLogo = {
  __typename?: 'SettingsSiteLogo';
  src?: Maybe<Scalars['String']['output']>;
  width?: Maybe<Scalars['Float']['output']>;
  height?: Maybe<Scalars['Float']['output']>;
  aspectRatio?: Maybe<Scalars['Float']['output']>;
  format?: Maybe<Scalars['String']['output']>;
  alt?: Maybe<Scalars['String']['output']>;
};

export type SettingsSiteFounders = {
  __typename?: 'SettingsSiteFounders';
  name?: Maybe<Scalars['String']['output']>;
  occupation?: Maybe<Scalars['String']['output']>;
  socialLink?: Maybe<Scalars['String']['output']>;
};

export type SettingsSiteBusinessAddress = {
  __typename?: 'SettingsSiteBusinessAddress';
  street: Scalars['String']['output'];
  city: Scalars['String']['output'];
  state: Scalars['String']['output'];
  zip: Scalars['String']['output'];
};

export type SettingsSiteRating = {
  __typename?: 'SettingsSiteRating';
  value: Scalars['Float']['output'];
  outOf: Scalars['Float']['output'];
  reviews: Scalars['Float']['output'];
};

export type SettingsSite = Node & Document & {
  __typename?: 'SettingsSite';
  title: Scalars['String']['output'];
  name: Scalars['String']['output'];
  legalName: Scalars['String']['output'];
  baseUrl: Scalars['String']['output'];
  logo?: Maybe<SettingsSiteLogo>;
  description: Scalars['String']['output'];
  phone: Scalars['String']['output'];
  email: Scalars['String']['output'];
  foundingDate?: Maybe<Scalars['Float']['output']>;
  founders?: Maybe<Array<Maybe<SettingsSiteFounders>>>;
  businessAddress: SettingsSiteBusinessAddress;
  rating: SettingsSiteRating;
  socialLinks?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  gtmId?: Maybe<Scalars['String']['output']>;
  fbAppId?: Maybe<Scalars['String']['output']>;
  twitterAuthor?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  _sys: SystemInfo;
  _values: Scalars['JSON']['output'];
};

export type SettingsRedirectsRedirect_GroupsRedirects = {
  __typename?: 'SettingsRedirectsRedirect_groupsRedirects';
  from_url?: Maybe<Scalars['String']['output']>;
  to_url?: Maybe<Scalars['String']['output']>;
};

export type SettingsRedirectsRedirect_Groups = {
  __typename?: 'SettingsRedirectsRedirect_groups';
  name?: Maybe<Scalars['String']['output']>;
  redirects?: Maybe<Array<Maybe<SettingsRedirectsRedirect_GroupsRedirects>>>;
};

export type SettingsRedirects = Node & Document & {
  __typename?: 'SettingsRedirects';
  title: Scalars['String']['output'];
  redirect_groups?: Maybe<Array<Maybe<SettingsRedirectsRedirect_Groups>>>;
  id: Scalars['ID']['output'];
  _sys: SystemInfo;
  _values: Scalars['JSON']['output'];
};

export type SettingsSecurityCsp = {
  __typename?: 'SettingsSecurityCsp';
  directive?: Maybe<Scalars['String']['output']>;
  hosts?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type SettingsSecurityBlocked_Ips = {
  __typename?: 'SettingsSecurityBlocked_ips';
  ip_address?: Maybe<Scalars['String']['output']>;
  subnet_mask?: Maybe<Scalars['String']['output']>;
  date_added?: Maybe<Scalars['String']['output']>;
  note?: Maybe<Scalars['String']['output']>;
};

export type SettingsSecurity = Node & Document & {
  __typename?: 'SettingsSecurity';
  title: Scalars['String']['output'];
  csp?: Maybe<Array<Maybe<SettingsSecurityCsp>>>;
  blocked_ips?: Maybe<Array<Maybe<SettingsSecurityBlocked_Ips>>>;
  id: Scalars['ID']['output'];
  _sys: SystemInfo;
  _values: Scalars['JSON']['output'];
};

export type SettingsThreeStarOccList = Node & Document & {
  __typename?: 'SettingsThreeStarOccList';
  title: Scalars['String']['output'];
  occupations?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  id: Scalars['ID']['output'];
  _sys: SystemInfo;
  _values: Scalars['JSON']['output'];
};

export type SettingsStatesListTemplate = Node & Document & {
  __typename?: 'SettingsStatesListTemplate';
  title: Scalars['String']['output'];
  states?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  id: Scalars['ID']['output'];
  _sys: SystemInfo;
  _values: Scalars['JSON']['output'];
};

export type SettingsGroupDiCompanyRateTypesRates = {
  __typename?: 'SettingsGroupDICompanyRateTypesRates';
  name?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  rate?: Maybe<Scalars['Float']['output']>;
};

export type SettingsGroupDiCompanyRateTypesCompanies = {
  __typename?: 'SettingsGroupDICompanyRateTypesCompanies';
  name?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  rateType?: Maybe<Scalars['String']['output']>;
  hero?: Maybe<Scalars['String']['output']>;
};

export type SettingsGroupDiCompanyRateTypes = Node & Document & {
  __typename?: 'SettingsGroupDICompanyRateTypes';
  title: Scalars['String']['output'];
  rates?: Maybe<Array<Maybe<SettingsGroupDiCompanyRateTypesRates>>>;
  companies?: Maybe<Array<Maybe<SettingsGroupDiCompanyRateTypesCompanies>>>;
  id: Scalars['ID']['output'];
  _sys: SystemInfo;
  _values: Scalars['JSON']['output'];
};

export type SettingsNotFoundPageSeo = {
  __typename?: 'SettingsNotFoundPageSeo';
  title?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
};

export type SettingsNotFoundPageImage = {
  __typename?: 'SettingsNotFoundPageImage';
  src?: Maybe<Scalars['String']['output']>;
  width?: Maybe<Scalars['Float']['output']>;
  height?: Maybe<Scalars['Float']['output']>;
  aspectRatio?: Maybe<Scalars['Float']['output']>;
  format?: Maybe<Scalars['String']['output']>;
  alt?: Maybe<Scalars['String']['output']>;
};

export type SettingsNotFoundPageCta = {
  __typename?: 'SettingsNotFoundPageCta';
  label?: Maybe<Scalars['String']['output']>;
  link?: Maybe<Scalars['String']['output']>;
  ariaLabel?: Maybe<Scalars['String']['output']>;
};

export type SettingsNotFoundPage = Node & Document & {
  __typename?: 'SettingsNotFoundPage';
  title: Scalars['String']['output'];
  seo?: Maybe<SettingsNotFoundPageSeo>;
  subtitle?: Maybe<Scalars['String']['output']>;
  headingText?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  image?: Maybe<SettingsNotFoundPageImage>;
  cta?: Maybe<SettingsNotFoundPageCta>;
  id: Scalars['ID']['output'];
  _sys: SystemInfo;
  _values: Scalars['JSON']['output'];
};

export type SettingsAiRatesTableTableRates_By_Age = {
  __typename?: 'SettingsAIRatesTableTableRates_by_age';
  age_range?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  rates?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type SettingsAiRatesTableTable = {
  __typename?: 'SettingsAIRatesTableTable';
  states?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  rates_by_age?: Maybe<Array<Maybe<SettingsAiRatesTableTableRates_By_Age>>>;
};

export type SettingsAiRatesTable = Node & Document & {
  __typename?: 'SettingsAIRatesTable';
  title: Scalars['String']['output'];
  table?: Maybe<Array<Maybe<SettingsAiRatesTableTable>>>;
  id: Scalars['ID']['output'];
  _sys: SystemInfo;
  _values: Scalars['JSON']['output'];
};

export type Settings = SettingsNavigation | SettingsFooter | SettingsSite | SettingsRedirects | SettingsSecurity | SettingsThreeStarOccList | SettingsStatesListTemplate | SettingsGroupDiCompanyRateTypes | SettingsNotFoundPage | SettingsAiRatesTable;

export type SettingsNavigationLeftMegaMenuItemsImageFilter = {
  src?: InputMaybe<StringFilter>;
  width?: InputMaybe<NumberFilter>;
  height?: InputMaybe<NumberFilter>;
  aspectRatio?: InputMaybe<NumberFilter>;
  format?: InputMaybe<StringFilter>;
  alt?: InputMaybe<StringFilter>;
};

export type SettingsNavigationLeftMegaMenuItemsButtonsFilter = {
  label?: InputMaybe<StringFilter>;
  link?: InputMaybe<StringFilter>;
  ariaLabel?: InputMaybe<StringFilter>;
};

export type SettingsNavigationLeftMegaMenuItemsColumnsLinksFilter = {
  label?: InputMaybe<StringFilter>;
  link?: InputMaybe<StringFilter>;
  ariaLabel?: InputMaybe<StringFilter>;
};

export type SettingsNavigationLeftMegaMenuItemsColumnsFilter = {
  title?: InputMaybe<StringFilter>;
  links?: InputMaybe<SettingsNavigationLeftMegaMenuItemsColumnsLinksFilter>;
};

export type SettingsNavigationLeftMegaMenuItemsFilter = {
  title?: InputMaybe<StringFilter>;
  description?: InputMaybe<StringFilter>;
  icon?: InputMaybe<ImageFilter>;
  image?: InputMaybe<SettingsNavigationLeftMegaMenuItemsImageFilter>;
  buttons?: InputMaybe<SettingsNavigationLeftMegaMenuItemsButtonsFilter>;
  columns?: InputMaybe<SettingsNavigationLeftMegaMenuItemsColumnsFilter>;
};

export type SettingsNavigationLeftMegaMenuFilter = {
  title?: InputMaybe<StringFilter>;
  heading?: InputMaybe<StringFilter>;
  items?: InputMaybe<SettingsNavigationLeftMegaMenuItemsFilter>;
};

export type SettingsNavigationLeftSimpleMenuItemsFilter = {
  icon?: InputMaybe<ImageFilter>;
  type?: InputMaybe<StringFilter>;
  title?: InputMaybe<StringFilter>;
  link?: InputMaybe<StringFilter>;
};

export type SettingsNavigationLeftSimpleMenuFilter = {
  title?: InputMaybe<StringFilter>;
  items?: InputMaybe<SettingsNavigationLeftSimpleMenuItemsFilter>;
};

export type SettingsNavigationLeftFilter = {
  megaMenu?: InputMaybe<SettingsNavigationLeftMegaMenuFilter>;
  simpleMenu?: InputMaybe<SettingsNavigationLeftSimpleMenuFilter>;
};

export type SettingsNavigationRightLinkItemFilter = {
  label?: InputMaybe<StringFilter>;
  link?: InputMaybe<StringFilter>;
  ariaLabel?: InputMaybe<StringFilter>;
};

export type SettingsNavigationRightDropdownItemItemsFilter = {
  label?: InputMaybe<StringFilter>;
  link?: InputMaybe<StringFilter>;
  ariaLabel?: InputMaybe<StringFilter>;
};

export type SettingsNavigationRightDropdownItemFilter = {
  label?: InputMaybe<StringFilter>;
  items?: InputMaybe<SettingsNavigationRightDropdownItemItemsFilter>;
};

export type SettingsNavigationRightButtonItemFilter = {
  label?: InputMaybe<StringFilter>;
  link?: InputMaybe<StringFilter>;
  ariaLabel?: InputMaybe<StringFilter>;
};

export type SettingsNavigationRightFilter = {
  linkItem?: InputMaybe<SettingsNavigationRightLinkItemFilter>;
  dropdownItem?: InputMaybe<SettingsNavigationRightDropdownItemFilter>;
  buttonItem?: InputMaybe<SettingsNavigationRightButtonItemFilter>;
};

export type SettingsNavigationFilter = {
  title?: InputMaybe<StringFilter>;
  left?: InputMaybe<SettingsNavigationLeftFilter>;
  right?: InputMaybe<SettingsNavigationRightFilter>;
};

export type SettingsFooterColumnsImageFilter = {
  src?: InputMaybe<StringFilter>;
  width?: InputMaybe<NumberFilter>;
  height?: InputMaybe<NumberFilter>;
  aspectRatio?: InputMaybe<NumberFilter>;
  format?: InputMaybe<StringFilter>;
  alt?: InputMaybe<StringFilter>;
};

export type SettingsFooterColumnsLinksFilter = {
  label?: InputMaybe<StringFilter>;
  link?: InputMaybe<StringFilter>;
  ariaLabel?: InputMaybe<StringFilter>;
};

export type SettingsFooterColumnsFilter = {
  title?: InputMaybe<StringFilter>;
  image?: InputMaybe<SettingsFooterColumnsImageFilter>;
  links?: InputMaybe<SettingsFooterColumnsLinksFilter>;
};

export type SettingsFooterExtrasLinksFilter = {
  label?: InputMaybe<StringFilter>;
  link?: InputMaybe<StringFilter>;
  ariaLabel?: InputMaybe<StringFilter>;
};

export type SettingsFooterExtrasFilter = {
  title?: InputMaybe<StringFilter>;
  links?: InputMaybe<SettingsFooterExtrasLinksFilter>;
};

export type SettingsFooterContactsFilter = {
  icon?: InputMaybe<ImageFilter>;
  label?: InputMaybe<StringFilter>;
  link?: InputMaybe<StringFilter>;
  ariaLabel?: InputMaybe<StringFilter>;
};

export type SettingsFooterBottomSocialFilter = {
  icon?: InputMaybe<ImageFilter>;
  label?: InputMaybe<StringFilter>;
  link?: InputMaybe<StringFilter>;
  ariaLabel?: InputMaybe<StringFilter>;
};

export type SettingsFooterBottomNavigationFilter = {
  label?: InputMaybe<StringFilter>;
  link?: InputMaybe<StringFilter>;
  ariaLabel?: InputMaybe<StringFilter>;
  newWindow?: InputMaybe<BooleanFilter>;
};

export type SettingsFooterBottomFilter = {
  copyright?: InputMaybe<StringFilter>;
  social?: InputMaybe<SettingsFooterBottomSocialFilter>;
  navigation?: InputMaybe<SettingsFooterBottomNavigationFilter>;
};

export type SettingsFooterFilter = {
  title?: InputMaybe<StringFilter>;
  columns?: InputMaybe<SettingsFooterColumnsFilter>;
  extras?: InputMaybe<SettingsFooterExtrasFilter>;
  address?: InputMaybe<StringFilter>;
  contacts?: InputMaybe<SettingsFooterContactsFilter>;
  bottom?: InputMaybe<SettingsFooterBottomFilter>;
  disclaimer?: InputMaybe<RichTextFilter>;
};

export type SettingsSiteLogoFilter = {
  src?: InputMaybe<StringFilter>;
  width?: InputMaybe<NumberFilter>;
  height?: InputMaybe<NumberFilter>;
  aspectRatio?: InputMaybe<NumberFilter>;
  format?: InputMaybe<StringFilter>;
  alt?: InputMaybe<StringFilter>;
};

export type SettingsSiteFoundersFilter = {
  name?: InputMaybe<StringFilter>;
  occupation?: InputMaybe<StringFilter>;
  socialLink?: InputMaybe<StringFilter>;
};

export type SettingsSiteBusinessAddressFilter = {
  street?: InputMaybe<StringFilter>;
  city?: InputMaybe<StringFilter>;
  state?: InputMaybe<StringFilter>;
  zip?: InputMaybe<StringFilter>;
};

export type SettingsSiteRatingFilter = {
  value?: InputMaybe<NumberFilter>;
  outOf?: InputMaybe<NumberFilter>;
  reviews?: InputMaybe<NumberFilter>;
};

export type SettingsSiteFilter = {
  title?: InputMaybe<StringFilter>;
  name?: InputMaybe<StringFilter>;
  legalName?: InputMaybe<StringFilter>;
  baseUrl?: InputMaybe<StringFilter>;
  logo?: InputMaybe<SettingsSiteLogoFilter>;
  description?: InputMaybe<StringFilter>;
  phone?: InputMaybe<StringFilter>;
  email?: InputMaybe<StringFilter>;
  foundingDate?: InputMaybe<NumberFilter>;
  founders?: InputMaybe<SettingsSiteFoundersFilter>;
  businessAddress?: InputMaybe<SettingsSiteBusinessAddressFilter>;
  rating?: InputMaybe<SettingsSiteRatingFilter>;
  socialLinks?: InputMaybe<StringFilter>;
  gtmId?: InputMaybe<StringFilter>;
  fbAppId?: InputMaybe<StringFilter>;
  twitterAuthor?: InputMaybe<StringFilter>;
};

export type SettingsRedirectsRedirect_GroupsRedirectsFilter = {
  from_url?: InputMaybe<StringFilter>;
  to_url?: InputMaybe<StringFilter>;
};

export type SettingsRedirectsRedirect_GroupsFilter = {
  name?: InputMaybe<StringFilter>;
  redirects?: InputMaybe<SettingsRedirectsRedirect_GroupsRedirectsFilter>;
};

export type SettingsRedirectsFilter = {
  title?: InputMaybe<StringFilter>;
  redirect_groups?: InputMaybe<SettingsRedirectsRedirect_GroupsFilter>;
};

export type SettingsSecurityCspFilter = {
  directive?: InputMaybe<StringFilter>;
  hosts?: InputMaybe<StringFilter>;
};

export type SettingsSecurityBlocked_IpsFilter = {
  ip_address?: InputMaybe<StringFilter>;
  subnet_mask?: InputMaybe<StringFilter>;
  date_added?: InputMaybe<DatetimeFilter>;
  note?: InputMaybe<StringFilter>;
};

export type SettingsSecurityFilter = {
  title?: InputMaybe<StringFilter>;
  csp?: InputMaybe<SettingsSecurityCspFilter>;
  blocked_ips?: InputMaybe<SettingsSecurityBlocked_IpsFilter>;
};

export type SettingsThreeStarOccListFilter = {
  title?: InputMaybe<StringFilter>;
  occupations?: InputMaybe<StringFilter>;
};

export type SettingsStatesListTemplateFilter = {
  title?: InputMaybe<StringFilter>;
  states?: InputMaybe<StringFilter>;
};

export type SettingsGroupDiCompanyRateTypesRatesFilter = {
  name?: InputMaybe<StringFilter>;
  id?: InputMaybe<StringFilter>;
  rate?: InputMaybe<NumberFilter>;
};

export type SettingsGroupDiCompanyRateTypesCompaniesFilter = {
  name?: InputMaybe<StringFilter>;
  id?: InputMaybe<StringFilter>;
  rateType?: InputMaybe<StringFilter>;
  hero?: InputMaybe<ImageFilter>;
};

export type SettingsGroupDiCompanyRateTypesFilter = {
  title?: InputMaybe<StringFilter>;
  rates?: InputMaybe<SettingsGroupDiCompanyRateTypesRatesFilter>;
  companies?: InputMaybe<SettingsGroupDiCompanyRateTypesCompaniesFilter>;
};

export type SettingsNotFoundPageSeoFilter = {
  title?: InputMaybe<StringFilter>;
  description?: InputMaybe<StringFilter>;
};

export type SettingsNotFoundPageImageFilter = {
  src?: InputMaybe<StringFilter>;
  width?: InputMaybe<NumberFilter>;
  height?: InputMaybe<NumberFilter>;
  aspectRatio?: InputMaybe<NumberFilter>;
  format?: InputMaybe<StringFilter>;
  alt?: InputMaybe<StringFilter>;
};

export type SettingsNotFoundPageCtaFilter = {
  label?: InputMaybe<StringFilter>;
  link?: InputMaybe<StringFilter>;
  ariaLabel?: InputMaybe<StringFilter>;
};

export type SettingsNotFoundPageFilter = {
  title?: InputMaybe<StringFilter>;
  seo?: InputMaybe<SettingsNotFoundPageSeoFilter>;
  subtitle?: InputMaybe<StringFilter>;
  headingText?: InputMaybe<StringFilter>;
  text?: InputMaybe<StringFilter>;
  image?: InputMaybe<SettingsNotFoundPageImageFilter>;
  cta?: InputMaybe<SettingsNotFoundPageCtaFilter>;
};

export type SettingsAiRatesTableTableRates_By_AgeFilter = {
  age_range?: InputMaybe<StringFilter>;
  rates?: InputMaybe<StringFilter>;
};

export type SettingsAiRatesTableTableFilter = {
  states?: InputMaybe<StringFilter>;
  rates_by_age?: InputMaybe<SettingsAiRatesTableTableRates_By_AgeFilter>;
};

export type SettingsAiRatesTableFilter = {
  title?: InputMaybe<StringFilter>;
  table?: InputMaybe<SettingsAiRatesTableTableFilter>;
};

export type SettingsFilter = {
  navigation?: InputMaybe<SettingsNavigationFilter>;
  footer?: InputMaybe<SettingsFooterFilter>;
  site?: InputMaybe<SettingsSiteFilter>;
  redirects?: InputMaybe<SettingsRedirectsFilter>;
  security?: InputMaybe<SettingsSecurityFilter>;
  ThreeStarOccList?: InputMaybe<SettingsThreeStarOccListFilter>;
  StatesListTemplate?: InputMaybe<SettingsStatesListTemplateFilter>;
  GroupDICompanyRateTypes?: InputMaybe<SettingsGroupDiCompanyRateTypesFilter>;
  notFoundPage?: InputMaybe<SettingsNotFoundPageFilter>;
  AIRatesTable?: InputMaybe<SettingsAiRatesTableFilter>;
};

export type SettingsConnectionEdges = {
  __typename?: 'SettingsConnectionEdges';
  cursor: Scalars['String']['output'];
  node?: Maybe<Settings>;
};

export type SettingsConnection = Connection & {
  __typename?: 'SettingsConnection';
  pageInfo: PageInfo;
  totalCount: Scalars['Float']['output'];
  edges?: Maybe<Array<Maybe<SettingsConnectionEdges>>>;
};

export type FormLtdiManualFormManager = Manager;

export type FormLtdiManualFormExperts = {
  __typename?: 'FormLTDIManualFormExperts';
  imageSrc?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type FormLtdiManualFormMaternity = {
  __typename?: 'FormLTDIManualFormMaternity';
  income?: Maybe<Scalars['Float']['output']>;
  minHoursWorked?: Maybe<Scalars['Float']['output']>;
  excludedStates?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  calendarURL?: Maybe<Scalars['String']['output']>;
};

export type FormLtdiManualFormAltProductCta = {
  __typename?: 'FormLTDIManualFormAltProductCta';
  label?: Maybe<Scalars['String']['output']>;
  link?: Maybe<Scalars['String']['output']>;
};

export type FormLtdiManualFormAltProduct = {
  __typename?: 'FormLTDIManualFormAltProduct';
  imageSrc?: Maybe<Scalars['String']['output']>;
  headingRich?: Maybe<Scalars['JSON']['output']>;
  subHeadingRich?: Maybe<Scalars['JSON']['output']>;
  textRich?: Maybe<Scalars['JSON']['output']>;
  cta?: Maybe<FormLtdiManualFormAltProductCta>;
};

export type FormLtdiManualFormWhitelistOcc = {
  __typename?: 'FormLTDIManualFormWhitelistOcc';
  list?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type FormLtdiManualFormWhitelistHoursWorkedLimitOccs = {
  __typename?: 'FormLTDIManualFormWhitelistHoursWorkedLimitOccs';
  list?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type FormLtdiManualFormWhitelistRatingOcc = {
  __typename?: 'FormLTDIManualFormWhitelistRatingOcc';
  min?: Maybe<Scalars['Float']['output']>;
  list?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type FormLtdiManualFormWhitelist = {
  __typename?: 'FormLTDIManualFormWhitelist';
  occ?: Maybe<FormLtdiManualFormWhitelistOcc>;
  hoursWorkedLimitOccs?: Maybe<FormLtdiManualFormWhitelistHoursWorkedLimitOccs>;
  ratingOcc?: Maybe<FormLtdiManualFormWhitelistRatingOcc>;
};

export type FormLtdiManualFormDigitalOcc = {
  __typename?: 'FormLTDIManualFormDigitalOcc';
  list?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type FormLtdiManualFormDigitalHealthIssues = {
  __typename?: 'FormLTDIManualFormDigitalHealthIssues';
  list?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type FormLtdiManualFormDigital = {
  __typename?: 'FormLTDIManualFormDigital';
  occ?: Maybe<FormLtdiManualFormDigitalOcc>;
  healthIssues?: Maybe<FormLtdiManualFormDigitalHealthIssues>;
};

export type FormLtdiManualFormIneligibleIncome = {
  __typename?: 'FormLTDIManualFormIneligibleIncome';
  min?: Maybe<Scalars['Float']['output']>;
};

export type FormLtdiManualFormIneligibleOcc = {
  __typename?: 'FormLTDIManualFormIneligibleOcc';
  list?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type FormLtdiManualFormIneligibleHealthIssues = {
  __typename?: 'FormLTDIManualFormIneligibleHealthIssues';
  list?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type FormLtdiManualFormIneligibleHoursWorked = {
  __typename?: 'FormLTDIManualFormIneligibleHoursWorked';
  min?: Maybe<Scalars['Float']['output']>;
};

export type FormLtdiManualFormIneligible = {
  __typename?: 'FormLTDIManualFormIneligible';
  income?: Maybe<FormLtdiManualFormIneligibleIncome>;
  occ?: Maybe<FormLtdiManualFormIneligibleOcc>;
  healthIssues?: Maybe<FormLtdiManualFormIneligibleHealthIssues>;
  hoursWorked?: Maybe<FormLtdiManualFormIneligibleHoursWorked>;
};

export type FormLtdiManualFormDeclineDob = {
  __typename?: 'FormLTDIManualFormDeclineDob';
  min?: Maybe<Scalars['Float']['output']>;
  minErrorText?: Maybe<Scalars['String']['output']>;
  max?: Maybe<Scalars['Float']['output']>;
  maxErrorText?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
};

export type FormLtdiManualFormDeclineIncome = {
  __typename?: 'FormLTDIManualFormDeclineIncome';
  min?: Maybe<Scalars['Float']['output']>;
  message?: Maybe<Scalars['String']['output']>;
};

export type FormLtdiManualFormDeclineState = {
  __typename?: 'FormLTDIManualFormDeclineState';
  message?: Maybe<Scalars['String']['output']>;
  states?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type FormLtdiManualFormDeclineHoursWorked = {
  __typename?: 'FormLTDIManualFormDeclineHoursWorked';
  min?: Maybe<Scalars['Float']['output']>;
};

export type FormLtdiManualFormDeclineFamilyLeave = {
  __typename?: 'FormLTDIManualFormDeclineFamilyLeave';
  message?: Maybe<Scalars['String']['output']>;
};

export type FormLtdiManualFormDecline = {
  __typename?: 'FormLTDIManualFormDecline';
  headingText?: Maybe<Scalars['String']['output']>;
  dob?: Maybe<FormLtdiManualFormDeclineDob>;
  income?: Maybe<FormLtdiManualFormDeclineIncome>;
  state?: Maybe<FormLtdiManualFormDeclineState>;
  hoursWorked?: Maybe<FormLtdiManualFormDeclineHoursWorked>;
  familyLeave?: Maybe<FormLtdiManualFormDeclineFamilyLeave>;
};

export type FormLtdiManualFormGeneric = {
  __typename?: 'FormLTDIManualFormGeneric';
  headingText?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
};

export type FormLtdiManualForm = Node & Document & {
  __typename?: 'FormLTDIManualForm';
  dataType?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  incomeLimit?: Maybe<Scalars['Float']['output']>;
  bmiLimit?: Maybe<Scalars['Float']['output']>;
  flow?: Maybe<Scalars['String']['output']>;
  manager?: Maybe<FormLtdiManualFormManager>;
  calendarURL?: Maybe<Scalars['String']['output']>;
  physician?: Maybe<Scalars['Boolean']['output']>;
  buttonLabel?: Maybe<Scalars['String']['output']>;
  experts?: Maybe<Array<Maybe<FormLtdiManualFormExperts>>>;
  maternity?: Maybe<FormLtdiManualFormMaternity>;
  altProduct?: Maybe<FormLtdiManualFormAltProduct>;
  whitelist?: Maybe<FormLtdiManualFormWhitelist>;
  digital?: Maybe<FormLtdiManualFormDigital>;
  ineligible?: Maybe<FormLtdiManualFormIneligible>;
  decline?: Maybe<FormLtdiManualFormDecline>;
  generic?: Maybe<FormLtdiManualFormGeneric>;
  healthIssues?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  disclaimer?: Maybe<Scalars['JSON']['output']>;
  id: Scalars['ID']['output'];
  _sys: SystemInfo;
  _values: Scalars['JSON']['output'];
};

export type FormStdiDigitalFormIneligibleDob = {
  __typename?: 'FormSTDIDigitalFormIneligibleDob';
  min?: Maybe<Scalars['Float']['output']>;
  minErrorText?: Maybe<Scalars['String']['output']>;
  max?: Maybe<Scalars['Float']['output']>;
  maxErrorText?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
};

export type FormStdiDigitalFormIneligibleOcc = {
  __typename?: 'FormSTDIDigitalFormIneligibleOcc';
  message?: Maybe<Scalars['String']['output']>;
};

export type FormStdiDigitalFormIneligibleIncome = {
  __typename?: 'FormSTDIDigitalFormIneligibleIncome';
  min?: Maybe<Scalars['Float']['output']>;
  message?: Maybe<Scalars['String']['output']>;
};

export type FormStdiDigitalFormIneligibleHoursWorked = {
  __typename?: 'FormSTDIDigitalFormIneligibleHoursWorked';
  message?: Maybe<Scalars['String']['output']>;
  min?: Maybe<Scalars['Float']['output']>;
};

export type FormStdiDigitalFormIneligibleUnemployed = {
  __typename?: 'FormSTDIDigitalFormIneligibleUnemployed';
  message?: Maybe<Scalars['String']['output']>;
};

export type FormStdiDigitalFormIneligibleCitizenOrResident = {
  __typename?: 'FormSTDIDigitalFormIneligibleCitizenOrResident';
  message?: Maybe<Scalars['String']['output']>;
};

export type FormStdiDigitalFormIneligibleDisabled = {
  __typename?: 'FormSTDIDigitalFormIneligibleDisabled';
  message?: Maybe<Scalars['String']['output']>;
};

export type FormStdiDigitalFormIneligibleLicenseRevoked = {
  __typename?: 'FormSTDIDigitalFormIneligibleLicenseRevoked';
  message?: Maybe<Scalars['String']['output']>;
};

export type FormStdiDigitalFormIneligibleState = {
  __typename?: 'FormSTDIDigitalFormIneligibleState';
  message?: Maybe<Scalars['String']['output']>;
  states?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type FormStdiDigitalFormIneligible = {
  __typename?: 'FormSTDIDigitalFormIneligible';
  headingText?: Maybe<Scalars['String']['output']>;
  dob?: Maybe<FormStdiDigitalFormIneligibleDob>;
  occ?: Maybe<FormStdiDigitalFormIneligibleOcc>;
  income?: Maybe<FormStdiDigitalFormIneligibleIncome>;
  hoursWorked?: Maybe<FormStdiDigitalFormIneligibleHoursWorked>;
  unemployed?: Maybe<FormStdiDigitalFormIneligibleUnemployed>;
  citizenOrResident?: Maybe<FormStdiDigitalFormIneligibleCitizenOrResident>;
  disabled?: Maybe<FormStdiDigitalFormIneligibleDisabled>;
  licenseRevoked?: Maybe<FormStdiDigitalFormIneligibleLicenseRevoked>;
  state?: Maybe<FormStdiDigitalFormIneligibleState>;
};

export type FormStdiDigitalFormGeneric = {
  __typename?: 'FormSTDIDigitalFormGeneric';
  headingText?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
};

export type FormStdiDigitalFormFamilyCare = {
  __typename?: 'FormSTDIDigitalFormFamilyCare';
  label?: Maybe<Scalars['String']['output']>;
  content?: Maybe<Scalars['JSON']['output']>;
};

export type FormStdiDigitalForm = Node & Document & {
  __typename?: 'FormSTDIDigitalForm';
  dataType?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  bmiLimit?: Maybe<Scalars['Float']['output']>;
  buttonLabel?: Maybe<Scalars['String']['output']>;
  ineligible?: Maybe<FormStdiDigitalFormIneligible>;
  generic?: Maybe<FormStdiDigitalFormGeneric>;
  familyCare?: Maybe<FormStdiDigitalFormFamilyCare>;
  disclaimer?: Maybe<Scalars['JSON']['output']>;
  id: Scalars['ID']['output'];
  _sys: SystemInfo;
  _values: Scalars['JSON']['output'];
};

export type FormLtcManualFormManager = Manager;

export type FormLtcManualFormIneligibleDob = {
  __typename?: 'FormLTCManualFormIneligibleDob';
  min?: Maybe<Scalars['Float']['output']>;
  minErrorText?: Maybe<Scalars['String']['output']>;
  max?: Maybe<Scalars['Float']['output']>;
  maxErrorText?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
};

export type FormLtcManualFormIneligibleOcc = {
  __typename?: 'FormLTCManualFormIneligibleOcc';
  message?: Maybe<Scalars['String']['output']>;
};

export type FormLtcManualFormIneligibleIncome = {
  __typename?: 'FormLTCManualFormIneligibleIncome';
  min?: Maybe<Scalars['Float']['output']>;
  message?: Maybe<Scalars['String']['output']>;
};

export type FormLtcManualFormIneligibleState = {
  __typename?: 'FormLTCManualFormIneligibleState';
  message?: Maybe<Scalars['String']['output']>;
  states?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type FormLtcManualFormIneligible = {
  __typename?: 'FormLTCManualFormIneligible';
  headingText?: Maybe<Scalars['String']['output']>;
  dob?: Maybe<FormLtcManualFormIneligibleDob>;
  occ?: Maybe<FormLtcManualFormIneligibleOcc>;
  income?: Maybe<FormLtcManualFormIneligibleIncome>;
  state?: Maybe<FormLtcManualFormIneligibleState>;
};

export type FormLtcManualFormGeneric = {
  __typename?: 'FormLTCManualFormGeneric';
  headingText?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
};

export type FormLtcManualForm = Node & Document & {
  __typename?: 'FormLTCManualForm';
  dataType?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  incomeLimit?: Maybe<Scalars['Float']['output']>;
  manager?: Maybe<FormLtcManualFormManager>;
  calendarURL?: Maybe<Scalars['String']['output']>;
  buttonLabel?: Maybe<Scalars['String']['output']>;
  ineligible?: Maybe<FormLtcManualFormIneligible>;
  generic?: Maybe<FormLtcManualFormGeneric>;
  disclaimer?: Maybe<Scalars['JSON']['output']>;
  id: Scalars['ID']['output'];
  _sys: SystemInfo;
  _values: Scalars['JSON']['output'];
};

export type FormCiFormIneligibleDob = {
  __typename?: 'FormCIFormIneligibleDob';
  min?: Maybe<Scalars['Float']['output']>;
  minErrorText?: Maybe<Scalars['String']['output']>;
  max?: Maybe<Scalars['Float']['output']>;
  maxErrorText?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
};

export type FormCiFormIneligibleState = {
  __typename?: 'FormCIFormIneligibleState';
  message?: Maybe<Scalars['String']['output']>;
  states?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type FormCiFormIneligibleReplacing = {
  __typename?: 'FormCIFormIneligibleReplacing';
  message?: Maybe<Scalars['String']['output']>;
};

export type FormCiFormIneligibleHadCancer = {
  __typename?: 'FormCIFormIneligibleHadCancer';
  message?: Maybe<Scalars['String']['output']>;
};

export type FormCiFormIneligible = {
  __typename?: 'FormCIFormIneligible';
  headingText?: Maybe<Scalars['String']['output']>;
  dob?: Maybe<FormCiFormIneligibleDob>;
  state?: Maybe<FormCiFormIneligibleState>;
  replacing?: Maybe<FormCiFormIneligibleReplacing>;
  hadCancer?: Maybe<FormCiFormIneligibleHadCancer>;
};

export type FormCiFormGeneric = {
  __typename?: 'FormCIFormGeneric';
  headingText?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
};

export type FormCiForm = Node & Document & {
  __typename?: 'FormCIForm';
  dataType?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  flow?: Maybe<Scalars['String']['output']>;
  buttonLabel?: Maybe<Scalars['String']['output']>;
  enableContacts?: Maybe<Scalars['Boolean']['output']>;
  ineligible?: Maybe<FormCiFormIneligible>;
  generic?: Maybe<FormCiFormGeneric>;
  disclaimer?: Maybe<Scalars['JSON']['output']>;
  id: Scalars['ID']['output'];
  _sys: SystemInfo;
  _values: Scalars['JSON']['output'];
};

export type FormAeiFormPopup = {
  __typename?: 'FormAEIFormPopup';
  icon?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  link?: Maybe<Scalars['String']['output']>;
  hint?: Maybe<Scalars['String']['output']>;
};

export type FormAeiFormIneligibleAge = {
  __typename?: 'FormAEIFormIneligibleAge';
  min?: Maybe<Scalars['Float']['output']>;
  minErrorText?: Maybe<Scalars['String']['output']>;
  max?: Maybe<Scalars['Float']['output']>;
  maxErrorText?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
};

export type FormAeiFormIneligibleState = {
  __typename?: 'FormAEIFormIneligibleState';
  message?: Maybe<Scalars['String']['output']>;
  states?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type FormAeiFormIneligible = {
  __typename?: 'FormAEIFormIneligible';
  headingText?: Maybe<Scalars['String']['output']>;
  age?: Maybe<FormAeiFormIneligibleAge>;
  state?: Maybe<FormAeiFormIneligibleState>;
};

export type FormAeiFormGeneric = {
  __typename?: 'FormAEIFormGeneric';
  headingText?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
};

export type FormAeiForm = Node & Document & {
  __typename?: 'FormAEIForm';
  dataType?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  flow?: Maybe<Scalars['String']['output']>;
  buttonLabel?: Maybe<Scalars['String']['output']>;
  popup?: Maybe<Array<Maybe<FormAeiFormPopup>>>;
  ineligible?: Maybe<FormAeiFormIneligible>;
  generic?: Maybe<FormAeiFormGeneric>;
  disclaimer?: Maybe<Scalars['JSON']['output']>;
  id: Scalars['ID']['output'];
  _sys: SystemInfo;
  _values: Scalars['JSON']['output'];
};

export type FormGroupDiFormIneligibleMinEmployees = {
  __typename?: 'FormGroupDIFormIneligibleMinEmployees';
  min?: Maybe<Scalars['Float']['output']>;
  headingText?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  buttonLabel?: Maybe<Scalars['String']['output']>;
  buttonLink?: Maybe<Scalars['String']['output']>;
};

export type FormGroupDiFormIneligible = {
  __typename?: 'FormGroupDIFormIneligible';
  minEmployees?: Maybe<FormGroupDiFormIneligibleMinEmployees>;
};

export type FormGroupDiFormGeneric = {
  __typename?: 'FormGroupDIFormGeneric';
  headingText?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
};

export type FormGroupDiForm = Node & Document & {
  __typename?: 'FormGroupDIForm';
  dataType?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  calendarURL?: Maybe<Scalars['String']['output']>;
  buttonLabel?: Maybe<Scalars['String']['output']>;
  isInternal?: Maybe<Scalars['Boolean']['output']>;
  internalCalendarURL?: Maybe<Scalars['String']['output']>;
  ineligible?: Maybe<FormGroupDiFormIneligible>;
  generic?: Maybe<FormGroupDiFormGeneric>;
  disclaimer?: Maybe<Scalars['JSON']['output']>;
  id: Scalars['ID']['output'];
  _sys: SystemInfo;
  _values: Scalars['JSON']['output'];
};

export type FormLtdiDropticketFormPartner = Partner;

export type FormLtdiDropticketFormManager = Manager;

export type FormLtdiDropticketFormThankyou = {
  __typename?: 'FormLTDIDropticketFormThankyou';
  headingText?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
};

export type FormLtdiDropticketFormIneligibleDob = {
  __typename?: 'FormLTDIDropticketFormIneligibleDob';
  min?: Maybe<Scalars['Float']['output']>;
  minErrorText?: Maybe<Scalars['String']['output']>;
  max?: Maybe<Scalars['Float']['output']>;
  maxErrorText?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
};

export type FormLtdiDropticketFormIneligibleOcc = {
  __typename?: 'FormLTDIDropticketFormIneligibleOcc';
  message?: Maybe<Scalars['String']['output']>;
};

export type FormLtdiDropticketFormIneligibleIncome = {
  __typename?: 'FormLTDIDropticketFormIneligibleIncome';
  min?: Maybe<Scalars['Float']['output']>;
  message?: Maybe<Scalars['String']['output']>;
};

export type FormLtdiDropticketFormIneligibleState = {
  __typename?: 'FormLTDIDropticketFormIneligibleState';
  message?: Maybe<Scalars['String']['output']>;
  states?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type FormLtdiDropticketFormIneligible = {
  __typename?: 'FormLTDIDropticketFormIneligible';
  headingText?: Maybe<Scalars['String']['output']>;
  dob?: Maybe<FormLtdiDropticketFormIneligibleDob>;
  occ?: Maybe<FormLtdiDropticketFormIneligibleOcc>;
  income?: Maybe<FormLtdiDropticketFormIneligibleIncome>;
  state?: Maybe<FormLtdiDropticketFormIneligibleState>;
};

export type FormLtdiDropticketFormGeneric = {
  __typename?: 'FormLTDIDropticketFormGeneric';
  headingText?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
};

export type FormLtdiDropticketForm = Node & Document & {
  __typename?: 'FormLTDIDropticketForm';
  dataType?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  partner?: Maybe<FormLtdiDropticketFormPartner>;
  manager?: Maybe<FormLtdiDropticketFormManager>;
  calendarURL?: Maybe<Scalars['String']['output']>;
  buttonLabel?: Maybe<Scalars['String']['output']>;
  thankyou?: Maybe<FormLtdiDropticketFormThankyou>;
  ineligible?: Maybe<FormLtdiDropticketFormIneligible>;
  generic?: Maybe<FormLtdiDropticketFormGeneric>;
  disclaimer?: Maybe<Scalars['JSON']['output']>;
  id: Scalars['ID']['output'];
  _sys: SystemInfo;
  _values: Scalars['JSON']['output'];
};

export type FormLtcDropticketFormPartner = Partner;

export type FormLtcDropticketFormManager = Manager;

export type FormLtcDropticketFormThankyou = {
  __typename?: 'FormLTCDropticketFormThankyou';
  headingText?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
};

export type FormLtcDropticketFormIneligibleDob = {
  __typename?: 'FormLTCDropticketFormIneligibleDob';
  min?: Maybe<Scalars['Float']['output']>;
  minErrorText?: Maybe<Scalars['String']['output']>;
  max?: Maybe<Scalars['Float']['output']>;
  maxErrorText?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
};

export type FormLtcDropticketFormIneligibleIncome = {
  __typename?: 'FormLTCDropticketFormIneligibleIncome';
  min?: Maybe<Scalars['Float']['output']>;
  message?: Maybe<Scalars['String']['output']>;
};

export type FormLtcDropticketFormIneligibleState = {
  __typename?: 'FormLTCDropticketFormIneligibleState';
  message?: Maybe<Scalars['String']['output']>;
  states?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type FormLtcDropticketFormIneligible = {
  __typename?: 'FormLTCDropticketFormIneligible';
  headingText?: Maybe<Scalars['String']['output']>;
  dob?: Maybe<FormLtcDropticketFormIneligibleDob>;
  income?: Maybe<FormLtcDropticketFormIneligibleIncome>;
  state?: Maybe<FormLtcDropticketFormIneligibleState>;
};

export type FormLtcDropticketFormGeneric = {
  __typename?: 'FormLTCDropticketFormGeneric';
  headingText?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
};

export type FormLtcDropticketForm = Node & Document & {
  __typename?: 'FormLTCDropticketForm';
  dataType?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  partner?: Maybe<FormLtcDropticketFormPartner>;
  manager?: Maybe<FormLtcDropticketFormManager>;
  calendarURL?: Maybe<Scalars['String']['output']>;
  buttonLabel?: Maybe<Scalars['String']['output']>;
  thankyou?: Maybe<FormLtcDropticketFormThankyou>;
  ineligible?: Maybe<FormLtcDropticketFormIneligible>;
  generic?: Maybe<FormLtcDropticketFormGeneric>;
  disclaimer?: Maybe<Scalars['JSON']['output']>;
  id: Scalars['ID']['output'];
  _sys: SystemInfo;
  _values: Scalars['JSON']['output'];
};

export type FormGroupDiCalculatorFormHeadings = {
  __typename?: 'FormGroupDICalculatorFormHeadings';
  mainRich?: Maybe<Scalars['JSON']['output']>;
  contributionRich?: Maybe<Scalars['JSON']['output']>;
};

export type FormGroupDiCalculatorFormDefaults = {
  __typename?: 'FormGroupDICalculatorFormDefaults';
  numberOfEmployees?: Maybe<Scalars['Float']['output']>;
  contributionPercent?: Maybe<Scalars['Float']['output']>;
  companyType?: Maybe<Scalars['String']['output']>;
};

export type FormGroupDiCalculatorForm = Node & Document & {
  __typename?: 'FormGroupDICalculatorForm';
  dataType?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  headings?: Maybe<FormGroupDiCalculatorFormHeadings>;
  defaults?: Maybe<FormGroupDiCalculatorFormDefaults>;
  detailsRich?: Maybe<Scalars['JSON']['output']>;
  id: Scalars['ID']['output'];
  _sys: SystemInfo;
  _values: Scalars['JSON']['output'];
};

export type FormAgentSignupFormThankyou = {
  __typename?: 'FormAgentSignupFormThankyou';
  headingText?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
};

export type FormAgentSignupFormIneligibleState = {
  __typename?: 'FormAgentSignupFormIneligibleState';
  message?: Maybe<Scalars['String']['output']>;
  states?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type FormAgentSignupFormIneligible = {
  __typename?: 'FormAgentSignupFormIneligible';
  headingText?: Maybe<Scalars['String']['output']>;
  state?: Maybe<FormAgentSignupFormIneligibleState>;
};

export type FormAgentSignupFormGeneric = {
  __typename?: 'FormAgentSignupFormGeneric';
  headingText?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
};

export type FormAgentSignupForm = Node & Document & {
  __typename?: 'FormAgentSignupForm';
  dataType?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  heading?: Maybe<Scalars['String']['output']>;
  buttonLabel?: Maybe<Scalars['String']['output']>;
  textRich?: Maybe<Scalars['JSON']['output']>;
  thankyou?: Maybe<FormAgentSignupFormThankyou>;
  ineligible?: Maybe<FormAgentSignupFormIneligible>;
  generic?: Maybe<FormAgentSignupFormGeneric>;
  id: Scalars['ID']['output'];
  _sys: SystemInfo;
  _values: Scalars['JSON']['output'];
};

export type FormAgentSimpleFormThankyou = {
  __typename?: 'FormAgentSimpleFormThankyou';
  headingText?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
};

export type FormAgentSimpleFormGeneric = {
  __typename?: 'FormAgentSimpleFormGeneric';
  headingText?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
};

export type FormAgentSimpleForm = Node & Document & {
  __typename?: 'FormAgentSimpleForm';
  dataType?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  buttonLabel?: Maybe<Scalars['String']['output']>;
  intent?: Maybe<Scalars['String']['output']>;
  thankyou?: Maybe<FormAgentSimpleFormThankyou>;
  generic?: Maybe<FormAgentSimpleFormGeneric>;
  id: Scalars['ID']['output'];
  _sys: SystemInfo;
  _values: Scalars['JSON']['output'];
};

export type Form = FormLtdiManualForm | FormStdiDigitalForm | FormLtcManualForm | FormCiForm | FormAeiForm | FormGroupDiForm | FormLtdiDropticketForm | FormLtcDropticketForm | FormGroupDiCalculatorForm | FormAgentSignupForm | FormAgentSimpleForm;

export type FormLtdiManualFormManagerFilter = {
  manager?: InputMaybe<ManagerFilter>;
};

export type FormLtdiManualFormExpertsFilter = {
  imageSrc?: InputMaybe<ImageFilter>;
  name?: InputMaybe<StringFilter>;
  title?: InputMaybe<StringFilter>;
};

export type FormLtdiManualFormMaternityFilter = {
  income?: InputMaybe<NumberFilter>;
  minHoursWorked?: InputMaybe<NumberFilter>;
  excludedStates?: InputMaybe<StringFilter>;
  calendarURL?: InputMaybe<StringFilter>;
};

export type FormLtdiManualFormAltProductHeadingRichFormValueFilter = {
  fieldName?: InputMaybe<StringFilter>;
  usePossesive?: InputMaybe<BooleanFilter>;
  highlight?: InputMaybe<BooleanFilter>;
  fallback?: InputMaybe<StringFilter>;
};

export type FormLtdiManualFormAltProductHeadingRichFilter = {
  FormValue?: InputMaybe<FormLtdiManualFormAltProductHeadingRichFormValueFilter>;
};

export type FormLtdiManualFormAltProductSubHeadingRichHighlightFilter = {
  color?: InputMaybe<StringFilter>;
  body?: InputMaybe<StringFilter>;
};

export type FormLtdiManualFormAltProductSubHeadingRichFilter = {
  highlight?: InputMaybe<FormLtdiManualFormAltProductSubHeadingRichHighlightFilter>;
};

export type FormLtdiManualFormAltProductTextRichBreakFilter = {
  size?: InputMaybe<NumberFilter>;
};

export type FormLtdiManualFormAltProductTextRichFilter = {
  Break?: InputMaybe<FormLtdiManualFormAltProductTextRichBreakFilter>;
};

export type FormLtdiManualFormAltProductCtaFilter = {
  label?: InputMaybe<StringFilter>;
  link?: InputMaybe<StringFilter>;
};

export type FormLtdiManualFormAltProductFilter = {
  imageSrc?: InputMaybe<ImageFilter>;
  headingRich?: InputMaybe<FormLtdiManualFormAltProductHeadingRichFilter>;
  subHeadingRich?: InputMaybe<FormLtdiManualFormAltProductSubHeadingRichFilter>;
  textRich?: InputMaybe<FormLtdiManualFormAltProductTextRichFilter>;
  cta?: InputMaybe<FormLtdiManualFormAltProductCtaFilter>;
};

export type FormLtdiManualFormWhitelistOccFilter = {
  list?: InputMaybe<StringFilter>;
};

export type FormLtdiManualFormWhitelistHoursWorkedLimitOccsFilter = {
  list?: InputMaybe<StringFilter>;
};

export type FormLtdiManualFormWhitelistRatingOccFilter = {
  min?: InputMaybe<NumberFilter>;
  list?: InputMaybe<StringFilter>;
};

export type FormLtdiManualFormWhitelistFilter = {
  occ?: InputMaybe<FormLtdiManualFormWhitelistOccFilter>;
  hoursWorkedLimitOccs?: InputMaybe<FormLtdiManualFormWhitelistHoursWorkedLimitOccsFilter>;
  ratingOcc?: InputMaybe<FormLtdiManualFormWhitelistRatingOccFilter>;
};

export type FormLtdiManualFormDigitalOccFilter = {
  list?: InputMaybe<StringFilter>;
};

export type FormLtdiManualFormDigitalHealthIssuesFilter = {
  list?: InputMaybe<StringFilter>;
};

export type FormLtdiManualFormDigitalFilter = {
  occ?: InputMaybe<FormLtdiManualFormDigitalOccFilter>;
  healthIssues?: InputMaybe<FormLtdiManualFormDigitalHealthIssuesFilter>;
};

export type FormLtdiManualFormIneligibleIncomeFilter = {
  min?: InputMaybe<NumberFilter>;
};

export type FormLtdiManualFormIneligibleOccFilter = {
  list?: InputMaybe<StringFilter>;
};

export type FormLtdiManualFormIneligibleHealthIssuesFilter = {
  list?: InputMaybe<StringFilter>;
};

export type FormLtdiManualFormIneligibleHoursWorkedFilter = {
  min?: InputMaybe<NumberFilter>;
};

export type FormLtdiManualFormIneligibleFilter = {
  income?: InputMaybe<FormLtdiManualFormIneligibleIncomeFilter>;
  occ?: InputMaybe<FormLtdiManualFormIneligibleOccFilter>;
  healthIssues?: InputMaybe<FormLtdiManualFormIneligibleHealthIssuesFilter>;
  hoursWorked?: InputMaybe<FormLtdiManualFormIneligibleHoursWorkedFilter>;
};

export type FormLtdiManualFormDeclineDobFilter = {
  min?: InputMaybe<NumberFilter>;
  minErrorText?: InputMaybe<StringFilter>;
  max?: InputMaybe<NumberFilter>;
  maxErrorText?: InputMaybe<StringFilter>;
  message?: InputMaybe<StringFilter>;
};

export type FormLtdiManualFormDeclineIncomeFilter = {
  min?: InputMaybe<NumberFilter>;
  message?: InputMaybe<StringFilter>;
};

export type FormLtdiManualFormDeclineStateFilter = {
  message?: InputMaybe<StringFilter>;
  states?: InputMaybe<StringFilter>;
};

export type FormLtdiManualFormDeclineHoursWorkedFilter = {
  min?: InputMaybe<NumberFilter>;
};

export type FormLtdiManualFormDeclineFamilyLeaveFilter = {
  message?: InputMaybe<StringFilter>;
};

export type FormLtdiManualFormDeclineFilter = {
  headingText?: InputMaybe<StringFilter>;
  dob?: InputMaybe<FormLtdiManualFormDeclineDobFilter>;
  income?: InputMaybe<FormLtdiManualFormDeclineIncomeFilter>;
  state?: InputMaybe<FormLtdiManualFormDeclineStateFilter>;
  hoursWorked?: InputMaybe<FormLtdiManualFormDeclineHoursWorkedFilter>;
  familyLeave?: InputMaybe<FormLtdiManualFormDeclineFamilyLeaveFilter>;
};

export type FormLtdiManualFormGenericFilter = {
  headingText?: InputMaybe<StringFilter>;
  message?: InputMaybe<StringFilter>;
};

export type FormLtdiManualFormFilter = {
  dataType?: InputMaybe<StringFilter>;
  title?: InputMaybe<StringFilter>;
  incomeLimit?: InputMaybe<NumberFilter>;
  bmiLimit?: InputMaybe<NumberFilter>;
  flow?: InputMaybe<StringFilter>;
  manager?: InputMaybe<FormLtdiManualFormManagerFilter>;
  calendarURL?: InputMaybe<StringFilter>;
  physician?: InputMaybe<BooleanFilter>;
  buttonLabel?: InputMaybe<StringFilter>;
  experts?: InputMaybe<FormLtdiManualFormExpertsFilter>;
  maternity?: InputMaybe<FormLtdiManualFormMaternityFilter>;
  altProduct?: InputMaybe<FormLtdiManualFormAltProductFilter>;
  whitelist?: InputMaybe<FormLtdiManualFormWhitelistFilter>;
  digital?: InputMaybe<FormLtdiManualFormDigitalFilter>;
  ineligible?: InputMaybe<FormLtdiManualFormIneligibleFilter>;
  decline?: InputMaybe<FormLtdiManualFormDeclineFilter>;
  generic?: InputMaybe<FormLtdiManualFormGenericFilter>;
  healthIssues?: InputMaybe<StringFilter>;
  disclaimer?: InputMaybe<RichTextFilter>;
};

export type FormStdiDigitalFormIneligibleDobFilter = {
  min?: InputMaybe<NumberFilter>;
  minErrorText?: InputMaybe<StringFilter>;
  max?: InputMaybe<NumberFilter>;
  maxErrorText?: InputMaybe<StringFilter>;
  message?: InputMaybe<StringFilter>;
};

export type FormStdiDigitalFormIneligibleOccFilter = {
  message?: InputMaybe<StringFilter>;
};

export type FormStdiDigitalFormIneligibleIncomeFilter = {
  min?: InputMaybe<NumberFilter>;
  message?: InputMaybe<StringFilter>;
};

export type FormStdiDigitalFormIneligibleHoursWorkedFilter = {
  message?: InputMaybe<StringFilter>;
  min?: InputMaybe<NumberFilter>;
};

export type FormStdiDigitalFormIneligibleUnemployedFilter = {
  message?: InputMaybe<StringFilter>;
};

export type FormStdiDigitalFormIneligibleCitizenOrResidentFilter = {
  message?: InputMaybe<StringFilter>;
};

export type FormStdiDigitalFormIneligibleDisabledFilter = {
  message?: InputMaybe<StringFilter>;
};

export type FormStdiDigitalFormIneligibleLicenseRevokedFilter = {
  message?: InputMaybe<StringFilter>;
};

export type FormStdiDigitalFormIneligibleStateFilter = {
  message?: InputMaybe<StringFilter>;
  states?: InputMaybe<StringFilter>;
};

export type FormStdiDigitalFormIneligibleFilter = {
  headingText?: InputMaybe<StringFilter>;
  dob?: InputMaybe<FormStdiDigitalFormIneligibleDobFilter>;
  occ?: InputMaybe<FormStdiDigitalFormIneligibleOccFilter>;
  income?: InputMaybe<FormStdiDigitalFormIneligibleIncomeFilter>;
  hoursWorked?: InputMaybe<FormStdiDigitalFormIneligibleHoursWorkedFilter>;
  unemployed?: InputMaybe<FormStdiDigitalFormIneligibleUnemployedFilter>;
  citizenOrResident?: InputMaybe<FormStdiDigitalFormIneligibleCitizenOrResidentFilter>;
  disabled?: InputMaybe<FormStdiDigitalFormIneligibleDisabledFilter>;
  licenseRevoked?: InputMaybe<FormStdiDigitalFormIneligibleLicenseRevokedFilter>;
  state?: InputMaybe<FormStdiDigitalFormIneligibleStateFilter>;
};

export type FormStdiDigitalFormGenericFilter = {
  headingText?: InputMaybe<StringFilter>;
  message?: InputMaybe<StringFilter>;
};

export type FormStdiDigitalFormFamilyCareContentBreakFilter = {
  size?: InputMaybe<NumberFilter>;
};

export type FormStdiDigitalFormFamilyCareContentFilter = {
  Break?: InputMaybe<FormStdiDigitalFormFamilyCareContentBreakFilter>;
};

export type FormStdiDigitalFormFamilyCareFilter = {
  label?: InputMaybe<StringFilter>;
  content?: InputMaybe<FormStdiDigitalFormFamilyCareContentFilter>;
};

export type FormStdiDigitalFormFilter = {
  dataType?: InputMaybe<StringFilter>;
  title?: InputMaybe<StringFilter>;
  bmiLimit?: InputMaybe<NumberFilter>;
  buttonLabel?: InputMaybe<StringFilter>;
  ineligible?: InputMaybe<FormStdiDigitalFormIneligibleFilter>;
  generic?: InputMaybe<FormStdiDigitalFormGenericFilter>;
  familyCare?: InputMaybe<FormStdiDigitalFormFamilyCareFilter>;
  disclaimer?: InputMaybe<RichTextFilter>;
};

export type FormLtcManualFormManagerFilter = {
  manager?: InputMaybe<ManagerFilter>;
};

export type FormLtcManualFormIneligibleDobFilter = {
  min?: InputMaybe<NumberFilter>;
  minErrorText?: InputMaybe<StringFilter>;
  max?: InputMaybe<NumberFilter>;
  maxErrorText?: InputMaybe<StringFilter>;
  message?: InputMaybe<StringFilter>;
};

export type FormLtcManualFormIneligibleOccFilter = {
  message?: InputMaybe<StringFilter>;
};

export type FormLtcManualFormIneligibleIncomeFilter = {
  min?: InputMaybe<NumberFilter>;
  message?: InputMaybe<StringFilter>;
};

export type FormLtcManualFormIneligibleStateFilter = {
  message?: InputMaybe<StringFilter>;
  states?: InputMaybe<StringFilter>;
};

export type FormLtcManualFormIneligibleFilter = {
  headingText?: InputMaybe<StringFilter>;
  dob?: InputMaybe<FormLtcManualFormIneligibleDobFilter>;
  occ?: InputMaybe<FormLtcManualFormIneligibleOccFilter>;
  income?: InputMaybe<FormLtcManualFormIneligibleIncomeFilter>;
  state?: InputMaybe<FormLtcManualFormIneligibleStateFilter>;
};

export type FormLtcManualFormGenericFilter = {
  headingText?: InputMaybe<StringFilter>;
  message?: InputMaybe<StringFilter>;
};

export type FormLtcManualFormFilter = {
  dataType?: InputMaybe<StringFilter>;
  title?: InputMaybe<StringFilter>;
  incomeLimit?: InputMaybe<NumberFilter>;
  manager?: InputMaybe<FormLtcManualFormManagerFilter>;
  calendarURL?: InputMaybe<StringFilter>;
  buttonLabel?: InputMaybe<StringFilter>;
  ineligible?: InputMaybe<FormLtcManualFormIneligibleFilter>;
  generic?: InputMaybe<FormLtcManualFormGenericFilter>;
  disclaimer?: InputMaybe<RichTextFilter>;
};

export type FormCiFormIneligibleDobFilter = {
  min?: InputMaybe<NumberFilter>;
  minErrorText?: InputMaybe<StringFilter>;
  max?: InputMaybe<NumberFilter>;
  maxErrorText?: InputMaybe<StringFilter>;
  message?: InputMaybe<StringFilter>;
};

export type FormCiFormIneligibleStateFilter = {
  message?: InputMaybe<StringFilter>;
  states?: InputMaybe<StringFilter>;
};

export type FormCiFormIneligibleReplacingFilter = {
  message?: InputMaybe<StringFilter>;
};

export type FormCiFormIneligibleHadCancerFilter = {
  message?: InputMaybe<StringFilter>;
};

export type FormCiFormIneligibleFilter = {
  headingText?: InputMaybe<StringFilter>;
  dob?: InputMaybe<FormCiFormIneligibleDobFilter>;
  state?: InputMaybe<FormCiFormIneligibleStateFilter>;
  replacing?: InputMaybe<FormCiFormIneligibleReplacingFilter>;
  hadCancer?: InputMaybe<FormCiFormIneligibleHadCancerFilter>;
};

export type FormCiFormGenericFilter = {
  headingText?: InputMaybe<StringFilter>;
  message?: InputMaybe<StringFilter>;
};

export type FormCiFormFilter = {
  dataType?: InputMaybe<StringFilter>;
  title?: InputMaybe<StringFilter>;
  flow?: InputMaybe<StringFilter>;
  buttonLabel?: InputMaybe<StringFilter>;
  enableContacts?: InputMaybe<BooleanFilter>;
  ineligible?: InputMaybe<FormCiFormIneligibleFilter>;
  generic?: InputMaybe<FormCiFormGenericFilter>;
  disclaimer?: InputMaybe<RichTextFilter>;
};

export type FormAeiFormPopupFilter = {
  icon?: InputMaybe<ImageFilter>;
  title?: InputMaybe<StringFilter>;
  text?: InputMaybe<StringFilter>;
  label?: InputMaybe<StringFilter>;
  link?: InputMaybe<StringFilter>;
  hint?: InputMaybe<StringFilter>;
};

export type FormAeiFormIneligibleAgeFilter = {
  min?: InputMaybe<NumberFilter>;
  minErrorText?: InputMaybe<StringFilter>;
  max?: InputMaybe<NumberFilter>;
  maxErrorText?: InputMaybe<StringFilter>;
  message?: InputMaybe<StringFilter>;
};

export type FormAeiFormIneligibleStateFilter = {
  message?: InputMaybe<StringFilter>;
  states?: InputMaybe<StringFilter>;
};

export type FormAeiFormIneligibleFilter = {
  headingText?: InputMaybe<StringFilter>;
  age?: InputMaybe<FormAeiFormIneligibleAgeFilter>;
  state?: InputMaybe<FormAeiFormIneligibleStateFilter>;
};

export type FormAeiFormGenericFilter = {
  headingText?: InputMaybe<StringFilter>;
  message?: InputMaybe<StringFilter>;
};

export type FormAeiFormFilter = {
  dataType?: InputMaybe<StringFilter>;
  title?: InputMaybe<StringFilter>;
  flow?: InputMaybe<StringFilter>;
  buttonLabel?: InputMaybe<StringFilter>;
  popup?: InputMaybe<FormAeiFormPopupFilter>;
  ineligible?: InputMaybe<FormAeiFormIneligibleFilter>;
  generic?: InputMaybe<FormAeiFormGenericFilter>;
  disclaimer?: InputMaybe<RichTextFilter>;
};

export type FormGroupDiFormIneligibleMinEmployeesFilter = {
  min?: InputMaybe<NumberFilter>;
  headingText?: InputMaybe<StringFilter>;
  message?: InputMaybe<StringFilter>;
  buttonLabel?: InputMaybe<StringFilter>;
  buttonLink?: InputMaybe<StringFilter>;
};

export type FormGroupDiFormIneligibleFilter = {
  minEmployees?: InputMaybe<FormGroupDiFormIneligibleMinEmployeesFilter>;
};

export type FormGroupDiFormGenericFilter = {
  headingText?: InputMaybe<StringFilter>;
  message?: InputMaybe<StringFilter>;
};

export type FormGroupDiFormFilter = {
  dataType?: InputMaybe<StringFilter>;
  title?: InputMaybe<StringFilter>;
  calendarURL?: InputMaybe<StringFilter>;
  buttonLabel?: InputMaybe<StringFilter>;
  isInternal?: InputMaybe<BooleanFilter>;
  internalCalendarURL?: InputMaybe<StringFilter>;
  ineligible?: InputMaybe<FormGroupDiFormIneligibleFilter>;
  generic?: InputMaybe<FormGroupDiFormGenericFilter>;
  disclaimer?: InputMaybe<RichTextFilter>;
};

export type FormLtdiDropticketFormPartnerFilter = {
  partner?: InputMaybe<PartnerFilter>;
};

export type FormLtdiDropticketFormManagerFilter = {
  manager?: InputMaybe<ManagerFilter>;
};

export type FormLtdiDropticketFormThankyouFilter = {
  headingText?: InputMaybe<StringFilter>;
  text?: InputMaybe<StringFilter>;
};

export type FormLtdiDropticketFormIneligibleDobFilter = {
  min?: InputMaybe<NumberFilter>;
  minErrorText?: InputMaybe<StringFilter>;
  max?: InputMaybe<NumberFilter>;
  maxErrorText?: InputMaybe<StringFilter>;
  message?: InputMaybe<StringFilter>;
};

export type FormLtdiDropticketFormIneligibleOccFilter = {
  message?: InputMaybe<StringFilter>;
};

export type FormLtdiDropticketFormIneligibleIncomeFilter = {
  min?: InputMaybe<NumberFilter>;
  message?: InputMaybe<StringFilter>;
};

export type FormLtdiDropticketFormIneligibleStateFilter = {
  message?: InputMaybe<StringFilter>;
  states?: InputMaybe<StringFilter>;
};

export type FormLtdiDropticketFormIneligibleFilter = {
  headingText?: InputMaybe<StringFilter>;
  dob?: InputMaybe<FormLtdiDropticketFormIneligibleDobFilter>;
  occ?: InputMaybe<FormLtdiDropticketFormIneligibleOccFilter>;
  income?: InputMaybe<FormLtdiDropticketFormIneligibleIncomeFilter>;
  state?: InputMaybe<FormLtdiDropticketFormIneligibleStateFilter>;
};

export type FormLtdiDropticketFormGenericFilter = {
  headingText?: InputMaybe<StringFilter>;
  message?: InputMaybe<StringFilter>;
};

export type FormLtdiDropticketFormFilter = {
  dataType?: InputMaybe<StringFilter>;
  title?: InputMaybe<StringFilter>;
  partner?: InputMaybe<FormLtdiDropticketFormPartnerFilter>;
  manager?: InputMaybe<FormLtdiDropticketFormManagerFilter>;
  calendarURL?: InputMaybe<StringFilter>;
  buttonLabel?: InputMaybe<StringFilter>;
  thankyou?: InputMaybe<FormLtdiDropticketFormThankyouFilter>;
  ineligible?: InputMaybe<FormLtdiDropticketFormIneligibleFilter>;
  generic?: InputMaybe<FormLtdiDropticketFormGenericFilter>;
  disclaimer?: InputMaybe<RichTextFilter>;
};

export type FormLtcDropticketFormPartnerFilter = {
  partner?: InputMaybe<PartnerFilter>;
};

export type FormLtcDropticketFormManagerFilter = {
  manager?: InputMaybe<ManagerFilter>;
};

export type FormLtcDropticketFormThankyouFilter = {
  headingText?: InputMaybe<StringFilter>;
  text?: InputMaybe<StringFilter>;
};

export type FormLtcDropticketFormIneligibleDobFilter = {
  min?: InputMaybe<NumberFilter>;
  minErrorText?: InputMaybe<StringFilter>;
  max?: InputMaybe<NumberFilter>;
  maxErrorText?: InputMaybe<StringFilter>;
  message?: InputMaybe<StringFilter>;
};

export type FormLtcDropticketFormIneligibleIncomeFilter = {
  min?: InputMaybe<NumberFilter>;
  message?: InputMaybe<StringFilter>;
};

export type FormLtcDropticketFormIneligibleStateFilter = {
  message?: InputMaybe<StringFilter>;
  states?: InputMaybe<StringFilter>;
};

export type FormLtcDropticketFormIneligibleFilter = {
  headingText?: InputMaybe<StringFilter>;
  dob?: InputMaybe<FormLtcDropticketFormIneligibleDobFilter>;
  income?: InputMaybe<FormLtcDropticketFormIneligibleIncomeFilter>;
  state?: InputMaybe<FormLtcDropticketFormIneligibleStateFilter>;
};

export type FormLtcDropticketFormGenericFilter = {
  headingText?: InputMaybe<StringFilter>;
  message?: InputMaybe<StringFilter>;
};

export type FormLtcDropticketFormFilter = {
  dataType?: InputMaybe<StringFilter>;
  title?: InputMaybe<StringFilter>;
  partner?: InputMaybe<FormLtcDropticketFormPartnerFilter>;
  manager?: InputMaybe<FormLtcDropticketFormManagerFilter>;
  calendarURL?: InputMaybe<StringFilter>;
  buttonLabel?: InputMaybe<StringFilter>;
  thankyou?: InputMaybe<FormLtcDropticketFormThankyouFilter>;
  ineligible?: InputMaybe<FormLtcDropticketFormIneligibleFilter>;
  generic?: InputMaybe<FormLtcDropticketFormGenericFilter>;
  disclaimer?: InputMaybe<RichTextFilter>;
};

export type FormGroupDiCalculatorFormHeadingsContributionRichCompanyNameFilter = {
  usePossesive?: InputMaybe<BooleanFilter>;
  fallback?: InputMaybe<StringFilter>;
};

export type FormGroupDiCalculatorFormHeadingsContributionRichFilter = {
  CompanyName?: InputMaybe<FormGroupDiCalculatorFormHeadingsContributionRichCompanyNameFilter>;
};

export type FormGroupDiCalculatorFormHeadingsFilter = {
  mainRich?: InputMaybe<RichTextFilter>;
  contributionRich?: InputMaybe<FormGroupDiCalculatorFormHeadingsContributionRichFilter>;
};

export type FormGroupDiCalculatorFormDefaultsFilter = {
  numberOfEmployees?: InputMaybe<NumberFilter>;
  contributionPercent?: InputMaybe<NumberFilter>;
  companyType?: InputMaybe<StringFilter>;
};

export type FormGroupDiCalculatorFormFilter = {
  dataType?: InputMaybe<StringFilter>;
  title?: InputMaybe<StringFilter>;
  headings?: InputMaybe<FormGroupDiCalculatorFormHeadingsFilter>;
  defaults?: InputMaybe<FormGroupDiCalculatorFormDefaultsFilter>;
  detailsRich?: InputMaybe<RichTextFilter>;
};

export type FormAgentSignupFormThankyouFilter = {
  headingText?: InputMaybe<StringFilter>;
  text?: InputMaybe<StringFilter>;
};

export type FormAgentSignupFormIneligibleStateFilter = {
  message?: InputMaybe<StringFilter>;
  states?: InputMaybe<StringFilter>;
};

export type FormAgentSignupFormIneligibleFilter = {
  headingText?: InputMaybe<StringFilter>;
  state?: InputMaybe<FormAgentSignupFormIneligibleStateFilter>;
};

export type FormAgentSignupFormGenericFilter = {
  headingText?: InputMaybe<StringFilter>;
  message?: InputMaybe<StringFilter>;
};

export type FormAgentSignupFormFilter = {
  dataType?: InputMaybe<StringFilter>;
  title?: InputMaybe<StringFilter>;
  heading?: InputMaybe<StringFilter>;
  buttonLabel?: InputMaybe<StringFilter>;
  textRich?: InputMaybe<RichTextFilter>;
  thankyou?: InputMaybe<FormAgentSignupFormThankyouFilter>;
  ineligible?: InputMaybe<FormAgentSignupFormIneligibleFilter>;
  generic?: InputMaybe<FormAgentSignupFormGenericFilter>;
};

export type FormAgentSimpleFormThankyouFilter = {
  headingText?: InputMaybe<StringFilter>;
  text?: InputMaybe<StringFilter>;
};

export type FormAgentSimpleFormGenericFilter = {
  headingText?: InputMaybe<StringFilter>;
  message?: InputMaybe<StringFilter>;
};

export type FormAgentSimpleFormFilter = {
  dataType?: InputMaybe<StringFilter>;
  title?: InputMaybe<StringFilter>;
  buttonLabel?: InputMaybe<StringFilter>;
  intent?: InputMaybe<StringFilter>;
  thankyou?: InputMaybe<FormAgentSimpleFormThankyouFilter>;
  generic?: InputMaybe<FormAgentSimpleFormGenericFilter>;
};

export type FormFilter = {
  LTDIManualForm?: InputMaybe<FormLtdiManualFormFilter>;
  STDIDigitalForm?: InputMaybe<FormStdiDigitalFormFilter>;
  LTCManualForm?: InputMaybe<FormLtcManualFormFilter>;
  CIForm?: InputMaybe<FormCiFormFilter>;
  AEIForm?: InputMaybe<FormAeiFormFilter>;
  GroupDIForm?: InputMaybe<FormGroupDiFormFilter>;
  LTDIDropticketForm?: InputMaybe<FormLtdiDropticketFormFilter>;
  LTCDropticketForm?: InputMaybe<FormLtcDropticketFormFilter>;
  GroupDICalculatorForm?: InputMaybe<FormGroupDiCalculatorFormFilter>;
  AgentSignupForm?: InputMaybe<FormAgentSignupFormFilter>;
  AgentSimpleForm?: InputMaybe<FormAgentSimpleFormFilter>;
};

export type FormConnectionEdges = {
  __typename?: 'FormConnectionEdges';
  cursor: Scalars['String']['output'];
  node?: Maybe<Form>;
};

export type FormConnection = Connection & {
  __typename?: 'FormConnection';
  pageInfo: PageInfo;
  totalCount: Scalars['Float']['output'];
  edges?: Maybe<Array<Maybe<FormConnectionEdges>>>;
};

export type ManagerManagedProductsContents = {
  __typename?: 'ManagerManagedProductsContents';
  type?: Maybe<Scalars['String']['output']>;
  heading?: Maybe<Scalars['String']['output']>;
  subHeading?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
};

export type ManagerManagedProductsRating = {
  __typename?: 'ManagerManagedProductsRating';
  min?: Maybe<Scalars['Float']['output']>;
  max?: Maybe<Scalars['Float']['output']>;
};

export type ManagerManagedProducts = {
  __typename?: 'ManagerManagedProducts';
  product?: Maybe<Scalars['String']['output']>;
  calendlyUrl?: Maybe<Scalars['String']['output']>;
  ycbmUrl?: Maybe<Scalars['String']['output']>;
  contents?: Maybe<Array<Maybe<ManagerManagedProductsContents>>>;
  rating?: Maybe<ManagerManagedProductsRating>;
  states?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type Manager = Node & Document & {
  __typename?: 'Manager';
  title: Scalars['String']['output'];
  slackMentionId?: Maybe<Scalars['String']['output']>;
  referralName?: Maybe<Scalars['String']['output']>;
  salesPersonId?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  isFallback?: Maybe<Scalars['Boolean']['output']>;
  imageSrc?: Maybe<Scalars['String']['output']>;
  managedProducts?: Maybe<Array<Maybe<ManagerManagedProducts>>>;
  id: Scalars['ID']['output'];
  _sys: SystemInfo;
  _values: Scalars['JSON']['output'];
};

export type ManagerManagedProductsContentsFilter = {
  type?: InputMaybe<StringFilter>;
  heading?: InputMaybe<StringFilter>;
  subHeading?: InputMaybe<StringFilter>;
  text?: InputMaybe<StringFilter>;
};

export type ManagerManagedProductsRatingFilter = {
  min?: InputMaybe<NumberFilter>;
  max?: InputMaybe<NumberFilter>;
};

export type ManagerManagedProductsFilter = {
  product?: InputMaybe<StringFilter>;
  calendlyUrl?: InputMaybe<StringFilter>;
  ycbmUrl?: InputMaybe<StringFilter>;
  contents?: InputMaybe<ManagerManagedProductsContentsFilter>;
  rating?: InputMaybe<ManagerManagedProductsRatingFilter>;
  states?: InputMaybe<StringFilter>;
};

export type ManagerFilter = {
  title?: InputMaybe<StringFilter>;
  slackMentionId?: InputMaybe<StringFilter>;
  referralName?: InputMaybe<StringFilter>;
  salesPersonId?: InputMaybe<StringFilter>;
  phone?: InputMaybe<StringFilter>;
  isFallback?: InputMaybe<BooleanFilter>;
  imageSrc?: InputMaybe<ImageFilter>;
  managedProducts?: InputMaybe<ManagerManagedProductsFilter>;
};

export type ManagerConnectionEdges = {
  __typename?: 'ManagerConnectionEdges';
  cursor: Scalars['String']['output'];
  node?: Maybe<Manager>;
};

export type ManagerConnection = Connection & {
  __typename?: 'ManagerConnection';
  pageInfo: PageInfo;
  totalCount: Scalars['Float']['output'];
  edges?: Maybe<Array<Maybe<ManagerConnectionEdges>>>;
};

export type SpecialPageProposalSpecialPageSeo = {
  __typename?: 'SpecialPageProposalSpecialPageSeo';
  title?: Maybe<Scalars['String']['output']>;
};

export type SpecialPageProposalSpecialPageContentSectionHeroProposalLists = {
  __typename?: 'SpecialPageProposalSpecialPageContentSectionHeroProposalLists';
  title?: Maybe<Scalars['String']['output']>;
  items?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type SpecialPageProposalSpecialPageContentSectionHeroProposalLogos = {
  __typename?: 'SpecialPageProposalSpecialPageContentSectionHeroProposalLogos';
  highlightImgSrc?: Maybe<Scalars['String']['output']>;
  highlightText?: Maybe<Scalars['String']['output']>;
  logosText?: Maybe<Scalars['String']['output']>;
  logosList?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type SpecialPageProposalSpecialPageContentSectionHeroProposalImage = {
  __typename?: 'SpecialPageProposalSpecialPageContentSectionHeroProposalImage';
  src?: Maybe<Scalars['String']['output']>;
  width?: Maybe<Scalars['Float']['output']>;
  height?: Maybe<Scalars['Float']['output']>;
  aspectRatio?: Maybe<Scalars['Float']['output']>;
  format?: Maybe<Scalars['String']['output']>;
  alt?: Maybe<Scalars['String']['output']>;
  scale?: Maybe<Scalars['Float']['output']>;
};

export type SpecialPageProposalSpecialPageContentSectionHeroProposalButtons = {
  __typename?: 'SpecialPageProposalSpecialPageContentSectionHeroProposalButtons';
  label?: Maybe<Scalars['String']['output']>;
  link?: Maybe<Scalars['String']['output']>;
  ariaLabel?: Maybe<Scalars['String']['output']>;
};

export type SpecialPageProposalSpecialPageContentSectionHeroProposalFloatingItemsSingleIconLinkItem = {
  __typename?: 'SpecialPageProposalSpecialPageContentSectionHeroProposalFloatingItemsSingleIconLinkItem';
  icon?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  link?: Maybe<Scalars['String']['output']>;
};

export type SpecialPageProposalSpecialPageContentSectionHeroProposalFloatingItemsSingleIconTextItem = {
  __typename?: 'SpecialPageProposalSpecialPageContentSectionHeroProposalFloatingItemsSingleIconTextItem';
  icon?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
};

export type SpecialPageProposalSpecialPageContentSectionHeroProposalFloatingItemsGroupedIconTextItemItems = {
  __typename?: 'SpecialPageProposalSpecialPageContentSectionHeroProposalFloatingItemsGroupedIconTextItemItems';
  icon?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
};

export type SpecialPageProposalSpecialPageContentSectionHeroProposalFloatingItemsGroupedIconTextItem = {
  __typename?: 'SpecialPageProposalSpecialPageContentSectionHeroProposalFloatingItemsGroupedIconTextItem';
  items?: Maybe<Array<Maybe<SpecialPageProposalSpecialPageContentSectionHeroProposalFloatingItemsGroupedIconTextItemItems>>>;
};

export type SpecialPageProposalSpecialPageContentSectionHeroProposalFloatingItemsSingleImageTextItem = {
  __typename?: 'SpecialPageProposalSpecialPageContentSectionHeroProposalFloatingItemsSingleImageTextItem';
  image?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
};

export type SpecialPageProposalSpecialPageContentSectionHeroProposalFloatingItemsGroupedImageTextItemItems = {
  __typename?: 'SpecialPageProposalSpecialPageContentSectionHeroProposalFloatingItemsGroupedImageTextItemItems';
  image?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
};

export type SpecialPageProposalSpecialPageContentSectionHeroProposalFloatingItemsGroupedImageTextItem = {
  __typename?: 'SpecialPageProposalSpecialPageContentSectionHeroProposalFloatingItemsGroupedImageTextItem';
  items?: Maybe<Array<Maybe<SpecialPageProposalSpecialPageContentSectionHeroProposalFloatingItemsGroupedImageTextItemItems>>>;
};

export type SpecialPageProposalSpecialPageContentSectionHeroProposalFloatingItemsSingleImageItem = {
  __typename?: 'SpecialPageProposalSpecialPageContentSectionHeroProposalFloatingItemsSingleImageItem';
  image?: Maybe<Scalars['String']['output']>;
};

export type SpecialPageProposalSpecialPageContentSectionHeroProposalFloatingItems = SpecialPageProposalSpecialPageContentSectionHeroProposalFloatingItemsSingleIconLinkItem | SpecialPageProposalSpecialPageContentSectionHeroProposalFloatingItemsSingleIconTextItem | SpecialPageProposalSpecialPageContentSectionHeroProposalFloatingItemsGroupedIconTextItem | SpecialPageProposalSpecialPageContentSectionHeroProposalFloatingItemsSingleImageTextItem | SpecialPageProposalSpecialPageContentSectionHeroProposalFloatingItemsGroupedImageTextItem | SpecialPageProposalSpecialPageContentSectionHeroProposalFloatingItemsSingleImageItem;

export type SpecialPageProposalSpecialPageContentSectionHeroProposal = {
  __typename?: 'SpecialPageProposalSpecialPageContentSectionHeroProposal';
  title?: Maybe<Scalars['String']['output']>;
  headingSize?: Maybe<Scalars['String']['output']>;
  headingRich?: Maybe<Scalars['JSON']['output']>;
  subheadingRich?: Maybe<Scalars['JSON']['output']>;
  textRich?: Maybe<Scalars['JSON']['output']>;
  lists?: Maybe<Array<Maybe<SpecialPageProposalSpecialPageContentSectionHeroProposalLists>>>;
  logos?: Maybe<SpecialPageProposalSpecialPageContentSectionHeroProposalLogos>;
  image?: Maybe<SpecialPageProposalSpecialPageContentSectionHeroProposalImage>;
  buttons?: Maybe<Array<Maybe<SpecialPageProposalSpecialPageContentSectionHeroProposalButtons>>>;
  floatingItems?: Maybe<Array<Maybe<SpecialPageProposalSpecialPageContentSectionHeroProposalFloatingItems>>>;
};

export type SpecialPageProposalSpecialPageContentSectionLogosImages = {
  __typename?: 'SpecialPageProposalSpecialPageContentSectionLogosImages';
  image?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type SpecialPageProposalSpecialPageContentSectionLogos = {
  __typename?: 'SpecialPageProposalSpecialPageContentSectionLogos';
  headingText?: Maybe<Scalars['String']['output']>;
  images?: Maybe<Array<Maybe<SpecialPageProposalSpecialPageContentSectionLogosImages>>>;
};

export type SpecialPageProposalSpecialPageContentSectionImageBrzImage = {
  __typename?: 'SpecialPageProposalSpecialPageContentSectionImageBrzImage';
  title?: Maybe<Scalars['String']['output']>;
  src?: Maybe<Scalars['String']['output']>;
  width?: Maybe<Scalars['Float']['output']>;
  height?: Maybe<Scalars['Float']['output']>;
  aspectRatio?: Maybe<Scalars['Float']['output']>;
  format?: Maybe<Scalars['String']['output']>;
  alt?: Maybe<Scalars['String']['output']>;
  radius?: Maybe<Scalars['Float']['output']>;
};

export type SpecialPageProposalSpecialPageContentSectionImage = {
  __typename?: 'SpecialPageProposalSpecialPageContentSectionImage';
  brzImage?: Maybe<SpecialPageProposalSpecialPageContentSectionImageBrzImage>;
  scrollable?: Maybe<Scalars['Boolean']['output']>;
  spacing?: Maybe<Scalars['Float']['output']>;
  maxWidth?: Maybe<Scalars['String']['output']>;
  align?: Maybe<Scalars['String']['output']>;
};

export type SpecialPageProposalSpecialPageContentSectionHeading = {
  __typename?: 'SpecialPageProposalSpecialPageContentSectionHeading';
  align?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  headingLevel?: Maybe<Scalars['String']['output']>;
  headingText?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  marginBottom?: Maybe<Scalars['String']['output']>;
};

export type SpecialPageProposalSpecialPageContentSectionSideStatsItems = {
  __typename?: 'SpecialPageProposalSpecialPageContentSectionSideStatsItems';
  icon?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
};

export type SpecialPageProposalSpecialPageContentSectionSideStats = {
  __typename?: 'SpecialPageProposalSpecialPageContentSectionSideStats';
  headingText?: Maybe<Scalars['String']['output']>;
  textRich?: Maybe<Scalars['JSON']['output']>;
  items?: Maybe<Array<Maybe<SpecialPageProposalSpecialPageContentSectionSideStatsItems>>>;
};

export type SpecialPageProposalSpecialPageContent = SpecialPageProposalSpecialPageContentSectionHeroProposal | SpecialPageProposalSpecialPageContentSectionLogos | SpecialPageProposalSpecialPageContentSectionImage | SpecialPageProposalSpecialPageContentSectionHeading | SpecialPageProposalSpecialPageContentSectionSideStats;

export type SpecialPageProposalSpecialPageQuoteHelpTip = {
  __typename?: 'SpecialPageProposalSpecialPageQuoteHelpTip';
  headingText?: Maybe<Scalars['String']['output']>;
  contentRich?: Maybe<Scalars['JSON']['output']>;
};

export type SpecialPageProposalSpecialPageQuoteNotFoundError = {
  __typename?: 'SpecialPageProposalSpecialPageQuoteNotFoundError';
  headingText?: Maybe<Scalars['String']['output']>;
  textRich?: Maybe<Scalars['JSON']['output']>;
};

export type SpecialPageProposalSpecialPageQuoteGenericError = {
  __typename?: 'SpecialPageProposalSpecialPageQuoteGenericError';
  headingText?: Maybe<Scalars['String']['output']>;
  textRich?: Maybe<Scalars['JSON']['output']>;
};

export type SpecialPageProposalSpecialPageQuoteAnnuityColumns = {
  __typename?: 'SpecialPageProposalSpecialPageQuoteAnnuityColumns';
  label?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type SpecialPageProposalSpecialPageQuoteAnnuity = {
  __typename?: 'SpecialPageProposalSpecialPageQuoteAnnuity';
  headingText?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  productName?: Maybe<Scalars['String']['output']>;
  columns?: Maybe<Array<Maybe<SpecialPageProposalSpecialPageQuoteAnnuityColumns>>>;
  incomeLabel?: Maybe<Scalars['String']['output']>;
};

export type SpecialPageProposalSpecialPageQuote = {
  __typename?: 'SpecialPageProposalSpecialPageQuote';
  headingText?: Maybe<Scalars['String']['output']>;
  subheadingRich?: Maybe<Scalars['JSON']['output']>;
  helpTip?: Maybe<SpecialPageProposalSpecialPageQuoteHelpTip>;
  addonsHeadingText?: Maybe<Scalars['String']['output']>;
  notFoundError?: Maybe<SpecialPageProposalSpecialPageQuoteNotFoundError>;
  genericError?: Maybe<SpecialPageProposalSpecialPageQuoteGenericError>;
  annuity?: Maybe<SpecialPageProposalSpecialPageQuoteAnnuity>;
};

export type SpecialPageProposalSpecialPage = Node & Document & {
  __typename?: 'SpecialPageProposalSpecialPage';
  previewURL?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  seo?: Maybe<SpecialPageProposalSpecialPageSeo>;
  content?: Maybe<Array<Maybe<SpecialPageProposalSpecialPageContent>>>;
  quote?: Maybe<SpecialPageProposalSpecialPageQuote>;
  disclaimer?: Maybe<Scalars['JSON']['output']>;
  id: Scalars['ID']['output'];
  _sys: SystemInfo;
  _values: Scalars['JSON']['output'];
};

export type SpecialPageIneligibleSpecialPageSeo = {
  __typename?: 'SpecialPageIneligibleSpecialPageSeo';
  title?: Maybe<Scalars['String']['output']>;
};

export type SpecialPageIneligibleSpecialPageAccident = {
  __typename?: 'SpecialPageIneligibleSpecialPageAccident';
  imgSrc?: Maybe<Scalars['String']['output']>;
  headingRich?: Maybe<Scalars['JSON']['output']>;
  subheadingRich?: Maybe<Scalars['JSON']['output']>;
  textRich?: Maybe<Scalars['JSON']['output']>;
  ctaLabel?: Maybe<Scalars['String']['output']>;
};

export type SpecialPageIneligibleSpecialPageIneligibleProductsRef = Product;

export type SpecialPageIneligibleSpecialPageIneligibleProducts = {
  __typename?: 'SpecialPageIneligibleSpecialPageIneligibleProducts';
  title?: Maybe<Scalars['String']['output']>;
  ref?: Maybe<SpecialPageIneligibleSpecialPageIneligibleProductsRef>;
};

export type SpecialPageIneligibleSpecialPageIneligible = {
  __typename?: 'SpecialPageIneligibleSpecialPageIneligible';
  headingRich?: Maybe<Scalars['JSON']['output']>;
  subheadingRich?: Maybe<Scalars['JSON']['output']>;
  textRich?: Maybe<Scalars['JSON']['output']>;
  products?: Maybe<Array<Maybe<SpecialPageIneligibleSpecialPageIneligibleProducts>>>;
};

export type SpecialPageIneligibleSpecialPage = Node & Document & {
  __typename?: 'SpecialPageIneligibleSpecialPage';
  previewURL?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  seo?: Maybe<SpecialPageIneligibleSpecialPageSeo>;
  accident?: Maybe<SpecialPageIneligibleSpecialPageAccident>;
  ineligible?: Maybe<SpecialPageIneligibleSpecialPageIneligible>;
  id: Scalars['ID']['output'];
  _sys: SystemInfo;
  _values: Scalars['JSON']['output'];
};

export type SpecialPage = SpecialPageProposalSpecialPage | SpecialPageIneligibleSpecialPage;

export type SpecialPageProposalSpecialPageSeoFilter = {
  title?: InputMaybe<StringFilter>;
};

export type SpecialPageProposalSpecialPageContentSectionHeroProposalHeadingRichTextRotatorFilter = {
  items?: InputMaybe<StringFilter>;
};

export type SpecialPageProposalSpecialPageContentSectionHeroProposalHeadingRichBreakFilter = {
  size?: InputMaybe<NumberFilter>;
};

export type SpecialPageProposalSpecialPageContentSectionHeroProposalHeadingRichCompanyNameFilter = {
  usePossesive?: InputMaybe<BooleanFilter>;
  fallback?: InputMaybe<StringFilter>;
};

export type SpecialPageProposalSpecialPageContentSectionHeroProposalHeadingRichClientNameFilter = {
  useFirstName?: InputMaybe<BooleanFilter>;
  useLastName?: InputMaybe<BooleanFilter>;
  usePossesive?: InputMaybe<BooleanFilter>;
  highlight?: InputMaybe<BooleanFilter>;
  highlightColor?: InputMaybe<StringFilter>;
  fallback?: InputMaybe<StringFilter>;
};

export type SpecialPageProposalSpecialPageContentSectionHeroProposalHeadingRichCurrentYearFilter = {
  add?: InputMaybe<StringFilter>;
};

export type SpecialPageProposalSpecialPageContentSectionHeroProposalHeadingRichFilter = {
  TextRotator?: InputMaybe<SpecialPageProposalSpecialPageContentSectionHeroProposalHeadingRichTextRotatorFilter>;
  Break?: InputMaybe<SpecialPageProposalSpecialPageContentSectionHeroProposalHeadingRichBreakFilter>;
  CompanyName?: InputMaybe<SpecialPageProposalSpecialPageContentSectionHeroProposalHeadingRichCompanyNameFilter>;
  ClientName?: InputMaybe<SpecialPageProposalSpecialPageContentSectionHeroProposalHeadingRichClientNameFilter>;
  CurrentYear?: InputMaybe<SpecialPageProposalSpecialPageContentSectionHeroProposalHeadingRichCurrentYearFilter>;
};

export type SpecialPageProposalSpecialPageContentSectionHeroProposalSubheadingRichHighlightFilter = {
  color?: InputMaybe<StringFilter>;
  body?: InputMaybe<StringFilter>;
};

export type SpecialPageProposalSpecialPageContentSectionHeroProposalSubheadingRichFilter = {
  highlight?: InputMaybe<SpecialPageProposalSpecialPageContentSectionHeroProposalSubheadingRichHighlightFilter>;
};

export type SpecialPageProposalSpecialPageContentSectionHeroProposalTextRichHighlightFilter = {
  color?: InputMaybe<StringFilter>;
  body?: InputMaybe<StringFilter>;
};

export type SpecialPageProposalSpecialPageContentSectionHeroProposalTextRichFilter = {
  highlight?: InputMaybe<SpecialPageProposalSpecialPageContentSectionHeroProposalTextRichHighlightFilter>;
};

export type SpecialPageProposalSpecialPageContentSectionHeroProposalListsFilter = {
  title?: InputMaybe<StringFilter>;
  items?: InputMaybe<StringFilter>;
};

export type SpecialPageProposalSpecialPageContentSectionHeroProposalLogosFilter = {
  highlightImgSrc?: InputMaybe<ImageFilter>;
  highlightText?: InputMaybe<StringFilter>;
  logosText?: InputMaybe<StringFilter>;
  logosList?: InputMaybe<ImageFilter>;
};

export type SpecialPageProposalSpecialPageContentSectionHeroProposalImageFilter = {
  src?: InputMaybe<StringFilter>;
  width?: InputMaybe<NumberFilter>;
  height?: InputMaybe<NumberFilter>;
  aspectRatio?: InputMaybe<NumberFilter>;
  format?: InputMaybe<StringFilter>;
  alt?: InputMaybe<StringFilter>;
  scale?: InputMaybe<NumberFilter>;
};

export type SpecialPageProposalSpecialPageContentSectionHeroProposalButtonsFilter = {
  label?: InputMaybe<StringFilter>;
  link?: InputMaybe<StringFilter>;
  ariaLabel?: InputMaybe<StringFilter>;
};

export type SpecialPageProposalSpecialPageContentSectionHeroProposalFloatingItemsSingleIconLinkItemFilter = {
  icon?: InputMaybe<ImageFilter>;
  title?: InputMaybe<StringFilter>;
  text?: InputMaybe<StringFilter>;
  link?: InputMaybe<StringFilter>;
};

export type SpecialPageProposalSpecialPageContentSectionHeroProposalFloatingItemsSingleIconTextItemFilter = {
  icon?: InputMaybe<ImageFilter>;
  text?: InputMaybe<StringFilter>;
};

export type SpecialPageProposalSpecialPageContentSectionHeroProposalFloatingItemsGroupedIconTextItemItemsFilter = {
  icon?: InputMaybe<ImageFilter>;
  text?: InputMaybe<StringFilter>;
};

export type SpecialPageProposalSpecialPageContentSectionHeroProposalFloatingItemsGroupedIconTextItemFilter = {
  items?: InputMaybe<SpecialPageProposalSpecialPageContentSectionHeroProposalFloatingItemsGroupedIconTextItemItemsFilter>;
};

export type SpecialPageProposalSpecialPageContentSectionHeroProposalFloatingItemsSingleImageTextItemFilter = {
  image?: InputMaybe<ImageFilter>;
  text?: InputMaybe<StringFilter>;
};

export type SpecialPageProposalSpecialPageContentSectionHeroProposalFloatingItemsGroupedImageTextItemItemsFilter = {
  image?: InputMaybe<ImageFilter>;
  text?: InputMaybe<StringFilter>;
};

export type SpecialPageProposalSpecialPageContentSectionHeroProposalFloatingItemsGroupedImageTextItemFilter = {
  items?: InputMaybe<SpecialPageProposalSpecialPageContentSectionHeroProposalFloatingItemsGroupedImageTextItemItemsFilter>;
};

export type SpecialPageProposalSpecialPageContentSectionHeroProposalFloatingItemsSingleImageItemFilter = {
  image?: InputMaybe<ImageFilter>;
};

export type SpecialPageProposalSpecialPageContentSectionHeroProposalFloatingItemsFilter = {
  singleIconLinkItem?: InputMaybe<SpecialPageProposalSpecialPageContentSectionHeroProposalFloatingItemsSingleIconLinkItemFilter>;
  singleIconTextItem?: InputMaybe<SpecialPageProposalSpecialPageContentSectionHeroProposalFloatingItemsSingleIconTextItemFilter>;
  groupedIconTextItem?: InputMaybe<SpecialPageProposalSpecialPageContentSectionHeroProposalFloatingItemsGroupedIconTextItemFilter>;
  singleImageTextItem?: InputMaybe<SpecialPageProposalSpecialPageContentSectionHeroProposalFloatingItemsSingleImageTextItemFilter>;
  groupedImageTextItem?: InputMaybe<SpecialPageProposalSpecialPageContentSectionHeroProposalFloatingItemsGroupedImageTextItemFilter>;
  singleImageItem?: InputMaybe<SpecialPageProposalSpecialPageContentSectionHeroProposalFloatingItemsSingleImageItemFilter>;
};

export type SpecialPageProposalSpecialPageContentSectionHeroProposalFilter = {
  title?: InputMaybe<StringFilter>;
  headingSize?: InputMaybe<StringFilter>;
  headingRich?: InputMaybe<SpecialPageProposalSpecialPageContentSectionHeroProposalHeadingRichFilter>;
  subheadingRich?: InputMaybe<SpecialPageProposalSpecialPageContentSectionHeroProposalSubheadingRichFilter>;
  textRich?: InputMaybe<SpecialPageProposalSpecialPageContentSectionHeroProposalTextRichFilter>;
  lists?: InputMaybe<SpecialPageProposalSpecialPageContentSectionHeroProposalListsFilter>;
  logos?: InputMaybe<SpecialPageProposalSpecialPageContentSectionHeroProposalLogosFilter>;
  image?: InputMaybe<SpecialPageProposalSpecialPageContentSectionHeroProposalImageFilter>;
  buttons?: InputMaybe<SpecialPageProposalSpecialPageContentSectionHeroProposalButtonsFilter>;
  floatingItems?: InputMaybe<SpecialPageProposalSpecialPageContentSectionHeroProposalFloatingItemsFilter>;
};

export type SpecialPageProposalSpecialPageContentSectionLogosImagesFilter = {
  image?: InputMaybe<ImageFilter>;
  title?: InputMaybe<StringFilter>;
};

export type SpecialPageProposalSpecialPageContentSectionLogosFilter = {
  headingText?: InputMaybe<StringFilter>;
  images?: InputMaybe<SpecialPageProposalSpecialPageContentSectionLogosImagesFilter>;
};

export type SpecialPageProposalSpecialPageContentSectionImageBrzImageFilter = {
  title?: InputMaybe<StringFilter>;
  src?: InputMaybe<StringFilter>;
  width?: InputMaybe<NumberFilter>;
  height?: InputMaybe<NumberFilter>;
  aspectRatio?: InputMaybe<NumberFilter>;
  format?: InputMaybe<StringFilter>;
  alt?: InputMaybe<StringFilter>;
  radius?: InputMaybe<NumberFilter>;
};

export type SpecialPageProposalSpecialPageContentSectionImageFilter = {
  brzImage?: InputMaybe<SpecialPageProposalSpecialPageContentSectionImageBrzImageFilter>;
  scrollable?: InputMaybe<BooleanFilter>;
  spacing?: InputMaybe<NumberFilter>;
  maxWidth?: InputMaybe<StringFilter>;
  align?: InputMaybe<StringFilter>;
};

export type SpecialPageProposalSpecialPageContentSectionHeadingFilter = {
  align?: InputMaybe<StringFilter>;
  title?: InputMaybe<StringFilter>;
  headingLevel?: InputMaybe<StringFilter>;
  headingText?: InputMaybe<StringFilter>;
  text?: InputMaybe<StringFilter>;
  marginBottom?: InputMaybe<StringFilter>;
};

export type SpecialPageProposalSpecialPageContentSectionSideStatsItemsFilter = {
  icon?: InputMaybe<ImageFilter>;
  text?: InputMaybe<StringFilter>;
};

export type SpecialPageProposalSpecialPageContentSectionSideStatsFilter = {
  headingText?: InputMaybe<StringFilter>;
  textRich?: InputMaybe<RichTextFilter>;
  items?: InputMaybe<SpecialPageProposalSpecialPageContentSectionSideStatsItemsFilter>;
};

export type SpecialPageProposalSpecialPageContentFilter = {
  SectionHeroProposal?: InputMaybe<SpecialPageProposalSpecialPageContentSectionHeroProposalFilter>;
  SectionLogos?: InputMaybe<SpecialPageProposalSpecialPageContentSectionLogosFilter>;
  SectionImage?: InputMaybe<SpecialPageProposalSpecialPageContentSectionImageFilter>;
  SectionHeading?: InputMaybe<SpecialPageProposalSpecialPageContentSectionHeadingFilter>;
  SectionSideStats?: InputMaybe<SpecialPageProposalSpecialPageContentSectionSideStatsFilter>;
};

export type SpecialPageProposalSpecialPageQuoteSubheadingRichClientNameFilter = {
  useFirstName?: InputMaybe<BooleanFilter>;
  useLastName?: InputMaybe<BooleanFilter>;
  usePossesive?: InputMaybe<BooleanFilter>;
  highlight?: InputMaybe<BooleanFilter>;
  highlightColor?: InputMaybe<StringFilter>;
  fallback?: InputMaybe<StringFilter>;
};

export type SpecialPageProposalSpecialPageQuoteSubheadingRichFilter = {
  ClientName?: InputMaybe<SpecialPageProposalSpecialPageQuoteSubheadingRichClientNameFilter>;
};

export type SpecialPageProposalSpecialPageQuoteHelpTipFilter = {
  headingText?: InputMaybe<StringFilter>;
  contentRich?: InputMaybe<RichTextFilter>;
};

export type SpecialPageProposalSpecialPageQuoteNotFoundErrorFilter = {
  headingText?: InputMaybe<StringFilter>;
  textRich?: InputMaybe<RichTextFilter>;
};

export type SpecialPageProposalSpecialPageQuoteGenericErrorFilter = {
  headingText?: InputMaybe<StringFilter>;
  textRich?: InputMaybe<RichTextFilter>;
};

export type SpecialPageProposalSpecialPageQuoteAnnuityColumnsFilter = {
  label?: InputMaybe<StringFilter>;
  value?: InputMaybe<StringFilter>;
};

export type SpecialPageProposalSpecialPageQuoteAnnuityFilter = {
  headingText?: InputMaybe<StringFilter>;
  text?: InputMaybe<StringFilter>;
  productName?: InputMaybe<StringFilter>;
  columns?: InputMaybe<SpecialPageProposalSpecialPageQuoteAnnuityColumnsFilter>;
  incomeLabel?: InputMaybe<StringFilter>;
};

export type SpecialPageProposalSpecialPageQuoteFilter = {
  headingText?: InputMaybe<StringFilter>;
  subheadingRich?: InputMaybe<SpecialPageProposalSpecialPageQuoteSubheadingRichFilter>;
  helpTip?: InputMaybe<SpecialPageProposalSpecialPageQuoteHelpTipFilter>;
  addonsHeadingText?: InputMaybe<StringFilter>;
  notFoundError?: InputMaybe<SpecialPageProposalSpecialPageQuoteNotFoundErrorFilter>;
  genericError?: InputMaybe<SpecialPageProposalSpecialPageQuoteGenericErrorFilter>;
  annuity?: InputMaybe<SpecialPageProposalSpecialPageQuoteAnnuityFilter>;
};

export type SpecialPageProposalSpecialPageFilter = {
  previewURL?: InputMaybe<StringFilter>;
  title?: InputMaybe<StringFilter>;
  seo?: InputMaybe<SpecialPageProposalSpecialPageSeoFilter>;
  content?: InputMaybe<SpecialPageProposalSpecialPageContentFilter>;
  quote?: InputMaybe<SpecialPageProposalSpecialPageQuoteFilter>;
  disclaimer?: InputMaybe<RichTextFilter>;
};

export type SpecialPageIneligibleSpecialPageSeoFilter = {
  title?: InputMaybe<StringFilter>;
};

export type SpecialPageIneligibleSpecialPageAccidentHeadingRichClientNameFilter = {
  useFirstName?: InputMaybe<BooleanFilter>;
  useLastName?: InputMaybe<BooleanFilter>;
  usePossesive?: InputMaybe<BooleanFilter>;
  highlight?: InputMaybe<BooleanFilter>;
  highlightColor?: InputMaybe<StringFilter>;
  fallback?: InputMaybe<StringFilter>;
};

export type SpecialPageIneligibleSpecialPageAccidentHeadingRichFilter = {
  ClientName?: InputMaybe<SpecialPageIneligibleSpecialPageAccidentHeadingRichClientNameFilter>;
};

export type SpecialPageIneligibleSpecialPageAccidentSubheadingRichHighlightFilter = {
  color?: InputMaybe<StringFilter>;
  body?: InputMaybe<StringFilter>;
};

export type SpecialPageIneligibleSpecialPageAccidentSubheadingRichBreakFilter = {
  size?: InputMaybe<NumberFilter>;
};

export type SpecialPageIneligibleSpecialPageAccidentSubheadingRichFilter = {
  highlight?: InputMaybe<SpecialPageIneligibleSpecialPageAccidentSubheadingRichHighlightFilter>;
  Break?: InputMaybe<SpecialPageIneligibleSpecialPageAccidentSubheadingRichBreakFilter>;
};

export type SpecialPageIneligibleSpecialPageAccidentFilter = {
  imgSrc?: InputMaybe<ImageFilter>;
  headingRich?: InputMaybe<SpecialPageIneligibleSpecialPageAccidentHeadingRichFilter>;
  subheadingRich?: InputMaybe<SpecialPageIneligibleSpecialPageAccidentSubheadingRichFilter>;
  textRich?: InputMaybe<RichTextFilter>;
  ctaLabel?: InputMaybe<StringFilter>;
};

export type SpecialPageIneligibleSpecialPageIneligibleHeadingRichClientNameFilter = {
  useFirstName?: InputMaybe<BooleanFilter>;
  useLastName?: InputMaybe<BooleanFilter>;
  usePossesive?: InputMaybe<BooleanFilter>;
  highlight?: InputMaybe<BooleanFilter>;
  highlightColor?: InputMaybe<StringFilter>;
  fallback?: InputMaybe<StringFilter>;
};

export type SpecialPageIneligibleSpecialPageIneligibleHeadingRichFilter = {
  ClientName?: InputMaybe<SpecialPageIneligibleSpecialPageIneligibleHeadingRichClientNameFilter>;
};

export type SpecialPageIneligibleSpecialPageIneligibleSubheadingRichHighlightFilter = {
  color?: InputMaybe<StringFilter>;
  body?: InputMaybe<StringFilter>;
};

export type SpecialPageIneligibleSpecialPageIneligibleSubheadingRichBreakFilter = {
  size?: InputMaybe<NumberFilter>;
};

export type SpecialPageIneligibleSpecialPageIneligibleSubheadingRichFilter = {
  highlight?: InputMaybe<SpecialPageIneligibleSpecialPageIneligibleSubheadingRichHighlightFilter>;
  Break?: InputMaybe<SpecialPageIneligibleSpecialPageIneligibleSubheadingRichBreakFilter>;
};

export type SpecialPageIneligibleSpecialPageIneligibleProductsRefFilter = {
  product?: InputMaybe<ProductFilter>;
};

export type SpecialPageIneligibleSpecialPageIneligibleProductsFilter = {
  title?: InputMaybe<StringFilter>;
  ref?: InputMaybe<SpecialPageIneligibleSpecialPageIneligibleProductsRefFilter>;
};

export type SpecialPageIneligibleSpecialPageIneligibleFilter = {
  headingRich?: InputMaybe<SpecialPageIneligibleSpecialPageIneligibleHeadingRichFilter>;
  subheadingRich?: InputMaybe<SpecialPageIneligibleSpecialPageIneligibleSubheadingRichFilter>;
  textRich?: InputMaybe<RichTextFilter>;
  products?: InputMaybe<SpecialPageIneligibleSpecialPageIneligibleProductsFilter>;
};

export type SpecialPageIneligibleSpecialPageFilter = {
  previewURL?: InputMaybe<StringFilter>;
  title?: InputMaybe<StringFilter>;
  seo?: InputMaybe<SpecialPageIneligibleSpecialPageSeoFilter>;
  accident?: InputMaybe<SpecialPageIneligibleSpecialPageAccidentFilter>;
  ineligible?: InputMaybe<SpecialPageIneligibleSpecialPageIneligibleFilter>;
};

export type SpecialPageFilter = {
  ProposalSpecialPage?: InputMaybe<SpecialPageProposalSpecialPageFilter>;
  IneligibleSpecialPage?: InputMaybe<SpecialPageIneligibleSpecialPageFilter>;
};

export type SpecialPageConnectionEdges = {
  __typename?: 'SpecialPageConnectionEdges';
  cursor: Scalars['String']['output'];
  node?: Maybe<SpecialPage>;
};

export type SpecialPageConnection = Connection & {
  __typename?: 'SpecialPageConnection';
  pageInfo: PageInfo;
  totalCount: Scalars['Float']['output'];
  edges?: Maybe<Array<Maybe<SpecialPageConnectionEdges>>>;
};

export type Mutation = {
  __typename?: 'Mutation';
  addPendingDocument: DocumentNode;
  updateDocument: DocumentNode;
  deleteDocument: DocumentNode;
  createDocument: DocumentNode;
  updatePage: Page;
  createPage: Page;
  updateArticle: Article;
  createArticle: Article;
  updatePost: Post;
  createPost: Post;
  updateCategory: Category;
  createCategory: Category;
  updateAuthor: Author;
  createAuthor: Author;
  updateProduct: Product;
  createProduct: Product;
  updateTestimonial: Testimonial;
  createTestimonial: Testimonial;
  updatePartner: Partner;
  createPartner: Partner;
  updateCobrand: Cobrand;
  createCobrand: Cobrand;
  updateBga: Bga;
  createBga: Bga;
  updateNotification: Notification;
  createNotification: Notification;
  updateSettings: Settings;
  createSettings: Settings;
  updateForm: Form;
  createForm: Form;
  updateManager: Manager;
  createManager: Manager;
  updateSpecialPage: SpecialPage;
  createSpecialPage: SpecialPage;
};


export type MutationAddPendingDocumentArgs = {
  collection: Scalars['String']['input'];
  relativePath: Scalars['String']['input'];
  template?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateDocumentArgs = {
  collection?: InputMaybe<Scalars['String']['input']>;
  relativePath: Scalars['String']['input'];
  params: DocumentUpdateMutation;
};


export type MutationDeleteDocumentArgs = {
  collection?: InputMaybe<Scalars['String']['input']>;
  relativePath: Scalars['String']['input'];
};


export type MutationCreateDocumentArgs = {
  collection?: InputMaybe<Scalars['String']['input']>;
  relativePath: Scalars['String']['input'];
  params: DocumentMutation;
};


export type MutationUpdatePageArgs = {
  relativePath: Scalars['String']['input'];
  params: PageMutation;
};


export type MutationCreatePageArgs = {
  relativePath: Scalars['String']['input'];
  params: PageMutation;
};


export type MutationUpdateArticleArgs = {
  relativePath: Scalars['String']['input'];
  params: ArticleMutation;
};


export type MutationCreateArticleArgs = {
  relativePath: Scalars['String']['input'];
  params: ArticleMutation;
};


export type MutationUpdatePostArgs = {
  relativePath: Scalars['String']['input'];
  params: PostMutation;
};


export type MutationCreatePostArgs = {
  relativePath: Scalars['String']['input'];
  params: PostMutation;
};


export type MutationUpdateCategoryArgs = {
  relativePath: Scalars['String']['input'];
  params: CategoryMutation;
};


export type MutationCreateCategoryArgs = {
  relativePath: Scalars['String']['input'];
  params: CategoryMutation;
};


export type MutationUpdateAuthorArgs = {
  relativePath: Scalars['String']['input'];
  params: AuthorMutation;
};


export type MutationCreateAuthorArgs = {
  relativePath: Scalars['String']['input'];
  params: AuthorMutation;
};


export type MutationUpdateProductArgs = {
  relativePath: Scalars['String']['input'];
  params: ProductMutation;
};


export type MutationCreateProductArgs = {
  relativePath: Scalars['String']['input'];
  params: ProductMutation;
};


export type MutationUpdateTestimonialArgs = {
  relativePath: Scalars['String']['input'];
  params: TestimonialMutation;
};


export type MutationCreateTestimonialArgs = {
  relativePath: Scalars['String']['input'];
  params: TestimonialMutation;
};


export type MutationUpdatePartnerArgs = {
  relativePath: Scalars['String']['input'];
  params: PartnerMutation;
};


export type MutationCreatePartnerArgs = {
  relativePath: Scalars['String']['input'];
  params: PartnerMutation;
};


export type MutationUpdateCobrandArgs = {
  relativePath: Scalars['String']['input'];
  params: CobrandMutation;
};


export type MutationCreateCobrandArgs = {
  relativePath: Scalars['String']['input'];
  params: CobrandMutation;
};


export type MutationUpdateBgaArgs = {
  relativePath: Scalars['String']['input'];
  params: BgaMutation;
};


export type MutationCreateBgaArgs = {
  relativePath: Scalars['String']['input'];
  params: BgaMutation;
};


export type MutationUpdateNotificationArgs = {
  relativePath: Scalars['String']['input'];
  params: NotificationMutation;
};


export type MutationCreateNotificationArgs = {
  relativePath: Scalars['String']['input'];
  params: NotificationMutation;
};


export type MutationUpdateSettingsArgs = {
  relativePath: Scalars['String']['input'];
  params: SettingsMutation;
};


export type MutationCreateSettingsArgs = {
  relativePath: Scalars['String']['input'];
  params: SettingsMutation;
};


export type MutationUpdateFormArgs = {
  relativePath: Scalars['String']['input'];
  params: FormMutation;
};


export type MutationCreateFormArgs = {
  relativePath: Scalars['String']['input'];
  params: FormMutation;
};


export type MutationUpdateManagerArgs = {
  relativePath: Scalars['String']['input'];
  params: ManagerMutation;
};


export type MutationCreateManagerArgs = {
  relativePath: Scalars['String']['input'];
  params: ManagerMutation;
};


export type MutationUpdateSpecialPageArgs = {
  relativePath: Scalars['String']['input'];
  params: SpecialPageMutation;
};


export type MutationCreateSpecialPageArgs = {
  relativePath: Scalars['String']['input'];
  params: SpecialPageMutation;
};

export type DocumentUpdateMutation = {
  page?: InputMaybe<PageMutation>;
  article?: InputMaybe<ArticleMutation>;
  post?: InputMaybe<PostMutation>;
  category?: InputMaybe<CategoryMutation>;
  author?: InputMaybe<AuthorMutation>;
  product?: InputMaybe<ProductMutation>;
  testimonial?: InputMaybe<TestimonialMutation>;
  partner?: InputMaybe<PartnerMutation>;
  cobrand?: InputMaybe<CobrandMutation>;
  bga?: InputMaybe<BgaMutation>;
  notification?: InputMaybe<NotificationMutation>;
  settings?: InputMaybe<SettingsMutation>;
  form?: InputMaybe<FormMutation>;
  manager?: InputMaybe<ManagerMutation>;
  specialPage?: InputMaybe<SpecialPageMutation>;
  relativePath?: InputMaybe<Scalars['String']['input']>;
};

export type DocumentMutation = {
  page?: InputMaybe<PageMutation>;
  article?: InputMaybe<ArticleMutation>;
  post?: InputMaybe<PostMutation>;
  category?: InputMaybe<CategoryMutation>;
  author?: InputMaybe<AuthorMutation>;
  product?: InputMaybe<ProductMutation>;
  testimonial?: InputMaybe<TestimonialMutation>;
  partner?: InputMaybe<PartnerMutation>;
  cobrand?: InputMaybe<CobrandMutation>;
  bga?: InputMaybe<BgaMutation>;
  notification?: InputMaybe<NotificationMutation>;
  settings?: InputMaybe<SettingsMutation>;
  form?: InputMaybe<FormMutation>;
  manager?: InputMaybe<ManagerMutation>;
  specialPage?: InputMaybe<SpecialPageMutation>;
};

export type PageGenericSettingsPublishMutation = {
  published?: InputMaybe<Scalars['Boolean']['input']>;
  publishedDate?: InputMaybe<Scalars['String']['input']>;
};

export type PageBlogSettingsSeoImageMutation = {
  src?: InputMaybe<Scalars['String']['input']>;
  width?: InputMaybe<Scalars['Float']['input']>;
  height?: InputMaybe<Scalars['Float']['input']>;
  aspectRatio?: InputMaybe<Scalars['Float']['input']>;
  format?: InputMaybe<Scalars['String']['input']>;
  alt?: InputMaybe<Scalars['String']['input']>;
};

export type PageBlogSettingsSeoOrgMutation = {
  disable?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PageFormSettingsSeoFaqItemsMutation = {
  q?: InputMaybe<Scalars['String']['input']>;
  a?: InputMaybe<Scalars['String']['input']>;
};

export type PageBlogSettingsSeoFaqMutation = {
  disable?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  items?: InputMaybe<Array<InputMaybe<PageFormSettingsSeoFaqItemsMutation>>>;
};

export type PageFormSettingsSeoHowToImageMutation = {
  src?: InputMaybe<Scalars['String']['input']>;
  width?: InputMaybe<Scalars['Float']['input']>;
  height?: InputMaybe<Scalars['Float']['input']>;
  aspectRatio?: InputMaybe<Scalars['Float']['input']>;
  format?: InputMaybe<Scalars['String']['input']>;
  alt?: InputMaybe<Scalars['String']['input']>;
};

export type PageFormSettingsSeoHowToStepsMutation = {
  name?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
};

export type PageBlogSettingsSeoHowToMutation = {
  disable?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<PageFormSettingsSeoHowToImageMutation>;
  steps?: InputMaybe<Array<InputMaybe<PageFormSettingsSeoHowToStepsMutation>>>;
};

export type PageGenericSettingsSeoMutation = {
  title?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<PageBlogSettingsSeoImageMutation>;
  org?: InputMaybe<PageBlogSettingsSeoOrgMutation>;
  faq?: InputMaybe<PageBlogSettingsSeoFaqMutation>;
  howTo?: InputMaybe<PageBlogSettingsSeoHowToMutation>;
};

export type PageGenericSettingsSitemapMutation = {
  exclude?: InputMaybe<Scalars['Boolean']['input']>;
  breadcrumb?: InputMaybe<Scalars['String']['input']>;
  changefreq?: InputMaybe<Scalars['String']['input']>;
  priority?: InputMaybe<Scalars['Float']['input']>;
};

export type PageBlogSettingsNavigationRightSideButtonOverrideMutation = {
  label?: InputMaybe<Scalars['String']['input']>;
  link?: InputMaybe<Scalars['String']['input']>;
  ariaLabel?: InputMaybe<Scalars['String']['input']>;
};

export type PageGenericSettingsNavigationMutation = {
  disableLogo?: InputMaybe<Scalars['Boolean']['input']>;
  disableLeft?: InputMaybe<Scalars['Boolean']['input']>;
  disableRight?: InputMaybe<Scalars['Boolean']['input']>;
  disableButtons?: InputMaybe<Scalars['Boolean']['input']>;
  rightSideButtonOverride?: InputMaybe<PageBlogSettingsNavigationRightSideButtonOverrideMutation>;
};

export type PageGenericSettingsFooterMutation = {
  disableLinks?: InputMaybe<Scalars['Boolean']['input']>;
  disableBottom?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PageGenericSettingsDisclaimerMutation = {
  disable?: InputMaybe<Scalars['Boolean']['input']>;
  content?: InputMaybe<Scalars['JSON']['input']>;
};

export type PageGenericSettingsPartnerMutation = {
  partnerRef?: InputMaybe<Scalars['String']['input']>;
  cobrandRef?: InputMaybe<Scalars['String']['input']>;
};

export type PageGenericSettingsClientMutation = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PageGenericSettingsMutation = {
  publish?: InputMaybe<PageGenericSettingsPublishMutation>;
  seo?: InputMaybe<PageGenericSettingsSeoMutation>;
  sitemap?: InputMaybe<PageGenericSettingsSitemapMutation>;
  notification?: InputMaybe<Scalars['String']['input']>;
  navigation?: InputMaybe<PageGenericSettingsNavigationMutation>;
  footer?: InputMaybe<PageGenericSettingsFooterMutation>;
  disclaimer?: InputMaybe<PageGenericSettingsDisclaimerMutation>;
  partner?: InputMaybe<PageGenericSettingsPartnerMutation>;
  client?: InputMaybe<PageGenericSettingsClientMutation>;
};

export type PageGenericContentSectionHeroGenericListsMutation = {
  title?: InputMaybe<Scalars['String']['input']>;
  items?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type PageGenericContentSectionHeroGenericImageMutation = {
  src?: InputMaybe<Scalars['String']['input']>;
  width?: InputMaybe<Scalars['Float']['input']>;
  height?: InputMaybe<Scalars['Float']['input']>;
  aspectRatio?: InputMaybe<Scalars['Float']['input']>;
  format?: InputMaybe<Scalars['String']['input']>;
  alt?: InputMaybe<Scalars['String']['input']>;
  scale?: InputMaybe<Scalars['Float']['input']>;
};

export type PageGenericContentSectionHeroGenericButtonsMutation = {
  label?: InputMaybe<Scalars['String']['input']>;
  link?: InputMaybe<Scalars['String']['input']>;
  ariaLabel?: InputMaybe<Scalars['String']['input']>;
};

export type PageGenericContentSectionHeroGenericFloatingItemsSingleIconLinkItemMutation = {
  icon?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
  link?: InputMaybe<Scalars['String']['input']>;
};

export type PageGenericContentSectionHeroGenericFloatingItemsSingleIconTextItemMutation = {
  icon?: InputMaybe<Scalars['String']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
};

export type PageGenericContentSectionHeroGenericFloatingItemsGroupedIconTextItemItemsMutation = {
  icon?: InputMaybe<Scalars['String']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
};

export type PageGenericContentSectionHeroGenericFloatingItemsGroupedIconTextItemMutation = {
  items?: InputMaybe<Array<InputMaybe<PageGenericContentSectionHeroGenericFloatingItemsGroupedIconTextItemItemsMutation>>>;
};

export type PageGenericContentSectionHeroGenericFloatingItemsSingleImageTextItemMutation = {
  image?: InputMaybe<Scalars['String']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
};

export type PageGenericContentSectionHeroGenericFloatingItemsGroupedImageTextItemItemsMutation = {
  image?: InputMaybe<Scalars['String']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
};

export type PageGenericContentSectionHeroGenericFloatingItemsGroupedImageTextItemMutation = {
  items?: InputMaybe<Array<InputMaybe<PageGenericContentSectionHeroGenericFloatingItemsGroupedImageTextItemItemsMutation>>>;
};

export type PageGenericContentSectionHeroGenericFloatingItemsSingleImageItemMutation = {
  image?: InputMaybe<Scalars['String']['input']>;
};

export type PageGenericContentSectionHeroGenericFloatingItemsMutation = {
  singleIconLinkItem?: InputMaybe<PageGenericContentSectionHeroGenericFloatingItemsSingleIconLinkItemMutation>;
  singleIconTextItem?: InputMaybe<PageGenericContentSectionHeroGenericFloatingItemsSingleIconTextItemMutation>;
  groupedIconTextItem?: InputMaybe<PageGenericContentSectionHeroGenericFloatingItemsGroupedIconTextItemMutation>;
  singleImageTextItem?: InputMaybe<PageGenericContentSectionHeroGenericFloatingItemsSingleImageTextItemMutation>;
  groupedImageTextItem?: InputMaybe<PageGenericContentSectionHeroGenericFloatingItemsGroupedImageTextItemMutation>;
  singleImageItem?: InputMaybe<PageGenericContentSectionHeroGenericFloatingItemsSingleImageItemMutation>;
};

export type PageGenericContentSectionHeroGenericMutation = {
  title?: InputMaybe<Scalars['String']['input']>;
  headingSize?: InputMaybe<Scalars['String']['input']>;
  headingRich?: InputMaybe<Scalars['JSON']['input']>;
  subheadingRich?: InputMaybe<Scalars['JSON']['input']>;
  textRich?: InputMaybe<Scalars['JSON']['input']>;
  lists?: InputMaybe<Array<InputMaybe<PageGenericContentSectionHeroGenericListsMutation>>>;
  image?: InputMaybe<PageGenericContentSectionHeroGenericImageMutation>;
  simpleFormRef?: InputMaybe<Scalars['String']['input']>;
  buttons?: InputMaybe<Array<InputMaybe<PageGenericContentSectionHeroGenericButtonsMutation>>>;
  formRef?: InputMaybe<Scalars['String']['input']>;
  floatingItems?: InputMaybe<Array<InputMaybe<PageGenericContentSectionHeroGenericFloatingItemsMutation>>>;
};

export type PageGenericContentSectionHeroAgentImageMutation = {
  src?: InputMaybe<Scalars['String']['input']>;
  width?: InputMaybe<Scalars['Float']['input']>;
  height?: InputMaybe<Scalars['Float']['input']>;
  aspectRatio?: InputMaybe<Scalars['Float']['input']>;
  format?: InputMaybe<Scalars['String']['input']>;
  alt?: InputMaybe<Scalars['String']['input']>;
};

export type PageGenericContentSectionHeroAgentDefaultProductsMutation = {
  productRef?: InputMaybe<Scalars['String']['input']>;
};

export type PageGenericContentSectionHeroAgentDisplayMutation = {
  icon?: InputMaybe<Scalars['Boolean']['input']>;
  graphic?: InputMaybe<Scalars['Boolean']['input']>;
  actionLabel?: InputMaybe<Scalars['Boolean']['input']>;
  descriptionText?: InputMaybe<Scalars['Boolean']['input']>;
  descriptionItems?: InputMaybe<Scalars['Boolean']['input']>;
  disclaimer?: InputMaybe<Scalars['Boolean']['input']>;
  buttons?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PageGenericContentSectionHeroAgentMutation = {
  headingRich?: InputMaybe<Scalars['JSON']['input']>;
  fallbackHeadingRich?: InputMaybe<Scalars['JSON']['input']>;
  textRich?: InputMaybe<Scalars['JSON']['input']>;
  image?: InputMaybe<PageGenericContentSectionHeroAgentImageMutation>;
  defaultProducts?: InputMaybe<Array<InputMaybe<PageGenericContentSectionHeroAgentDefaultProductsMutation>>>;
  display?: InputMaybe<PageGenericContentSectionHeroAgentDisplayMutation>;
};

export type PageGenericContentSectionLogosImagesMutation = {
  image?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type PageGenericContentSectionLogosMutation = {
  headingText?: InputMaybe<Scalars['String']['input']>;
  images?: InputMaybe<Array<InputMaybe<PageGenericContentSectionLogosImagesMutation>>>;
};

export type PageGenericContentSectionBadgesBadgesMutation = {
  image?: InputMaybe<Scalars['String']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
};

export type PageGenericContentSectionBadgesMutation = {
  title?: InputMaybe<Scalars['String']['input']>;
  badges?: InputMaybe<Array<InputMaybe<PageGenericContentSectionBadgesBadgesMutation>>>;
};

export type PageGenericContentSectionTestimonialSliderItemsMutation = {
  ref?: InputMaybe<Scalars['String']['input']>;
};

export type PageGenericContentSectionTestimonialSliderMutation = {
  title?: InputMaybe<Scalars['String']['input']>;
  headingRich?: InputMaybe<Scalars['JSON']['input']>;
  highlight?: InputMaybe<Scalars['String']['input']>;
  textRich?: InputMaybe<Scalars['JSON']['input']>;
  items?: InputMaybe<Array<InputMaybe<PageGenericContentSectionTestimonialSliderItemsMutation>>>;
};

export type PageGenericContentSectionTestimonialGridItemsMutation = {
  ref?: InputMaybe<Scalars['String']['input']>;
};

export type PageGenericContentSectionTestimonialGridMutation = {
  headingText?: InputMaybe<Scalars['String']['input']>;
  items?: InputMaybe<Array<InputMaybe<PageGenericContentSectionTestimonialGridItemsMutation>>>;
};

export type PageGenericContentSectionFloatingCtaButtonsMutation = {
  label?: InputMaybe<Scalars['String']['input']>;
  link?: InputMaybe<Scalars['String']['input']>;
  ariaLabel?: InputMaybe<Scalars['String']['input']>;
};

export type PageGenericContentSectionFloatingCtaMutation = {
  headingText?: InputMaybe<Scalars['String']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
  buttons?: InputMaybe<Array<InputMaybe<PageGenericContentSectionFloatingCtaButtonsMutation>>>;
};

export type PageGenericContentSectionImageCtaButtonsMutation = {
  label?: InputMaybe<Scalars['String']['input']>;
  link?: InputMaybe<Scalars['String']['input']>;
  ariaLabel?: InputMaybe<Scalars['String']['input']>;
};

export type PageGenericContentSectionImageCtaMutation = {
  headingText?: InputMaybe<Scalars['String']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
  buttons?: InputMaybe<Array<InputMaybe<PageGenericContentSectionImageCtaButtonsMutation>>>;
  imageSrc?: InputMaybe<Scalars['String']['input']>;
};

export type PageGenericContentSectionProductsItemsMutation = {
  ref?: InputMaybe<Scalars['String']['input']>;
};

export type PageGenericContentSectionProductsDisplayMutation = {
  icon?: InputMaybe<Scalars['Boolean']['input']>;
  graphic?: InputMaybe<Scalars['Boolean']['input']>;
  actionLabel?: InputMaybe<Scalars['Boolean']['input']>;
  descriptionText?: InputMaybe<Scalars['Boolean']['input']>;
  descriptionItems?: InputMaybe<Scalars['Boolean']['input']>;
  disclaimer?: InputMaybe<Scalars['Boolean']['input']>;
  buttons?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PageGenericContentSectionProductsMutation = {
  headingRich?: InputMaybe<Scalars['JSON']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  items?: InputMaybe<Array<InputMaybe<PageGenericContentSectionProductsItemsMutation>>>;
  display?: InputMaybe<PageGenericContentSectionProductsDisplayMutation>;
};

export type PageGenericContentSectionProductsSimpleItemsMutation = {
  ref?: InputMaybe<Scalars['String']['input']>;
};

export type PageGenericContentSectionProductsSimpleDisplayMutation = {
  actionLabel?: InputMaybe<Scalars['Boolean']['input']>;
  descriptionText?: InputMaybe<Scalars['Boolean']['input']>;
  descriptionItems?: InputMaybe<Scalars['Boolean']['input']>;
  disclaimer?: InputMaybe<Scalars['Boolean']['input']>;
  buttons?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PageGenericContentSectionProductsSimpleMutation = {
  items?: InputMaybe<Array<InputMaybe<PageGenericContentSectionProductsSimpleItemsMutation>>>;
  display?: InputMaybe<PageGenericContentSectionProductsSimpleDisplayMutation>;
};

export type PageGenericContentSectionHowItWorksItemsButtonMutation = {
  label?: InputMaybe<Scalars['String']['input']>;
  link?: InputMaybe<Scalars['String']['input']>;
  ariaLabel?: InputMaybe<Scalars['String']['input']>;
};

export type PageGenericContentSectionHowItWorksItemsMutation = {
  image?: InputMaybe<Scalars['String']['input']>;
  headingText?: InputMaybe<Scalars['String']['input']>;
  subheadingText?: InputMaybe<Scalars['String']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
  button?: InputMaybe<PageGenericContentSectionHowItWorksItemsButtonMutation>;
};

export type PageGenericContentSectionHowItWorksDisplayMutation = {
  number?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PageGenericContentSectionHowItWorksMutation = {
  title?: InputMaybe<Scalars['String']['input']>;
  headingText?: InputMaybe<Scalars['String']['input']>;
  active?: InputMaybe<Scalars['Float']['input']>;
  items?: InputMaybe<Array<InputMaybe<PageGenericContentSectionHowItWorksItemsMutation>>>;
  display?: InputMaybe<PageGenericContentSectionHowItWorksDisplayMutation>;
};

export type PageGenericContentSectionIconColumnsColsMutation = {
  imageSrc?: InputMaybe<Scalars['String']['input']>;
  disableIconBg?: InputMaybe<Scalars['Boolean']['input']>;
  size?: InputMaybe<Scalars['Float']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  titleSize?: InputMaybe<Scalars['String']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
};

export type PageGenericContentSectionIconColumnsMutation = {
  title?: InputMaybe<Scalars['String']['input']>;
  headingText?: InputMaybe<Scalars['String']['input']>;
  subheadingText?: InputMaybe<Scalars['String']['input']>;
  colNum?: InputMaybe<Scalars['Float']['input']>;
  colSpacing?: InputMaybe<Scalars['Float']['input']>;
  bgColor?: InputMaybe<Scalars['String']['input']>;
  cols?: InputMaybe<Array<InputMaybe<PageGenericContentSectionIconColumnsColsMutation>>>;
};

export type PageGenericContentSectionBlogPostsPostsMutation = {
  ref?: InputMaybe<Scalars['String']['input']>;
};

export type PageGenericContentSectionBlogPostsMutation = {
  title?: InputMaybe<Scalars['String']['input']>;
  headingText?: InputMaybe<Scalars['String']['input']>;
  posts?: InputMaybe<Array<InputMaybe<PageGenericContentSectionBlogPostsPostsMutation>>>;
};

export type PageGenericContentSectionArticlesPostsMutation = {
  ref?: InputMaybe<Scalars['String']['input']>;
};

export type PageGenericContentSectionArticlesMutation = {
  title?: InputMaybe<Scalars['String']['input']>;
  headingText?: InputMaybe<Scalars['String']['input']>;
  posts?: InputMaybe<Array<InputMaybe<PageGenericContentSectionArticlesPostsMutation>>>;
};

export type PageGenericContentSectionCtaArticlesPostsCtaMutation = {
  label?: InputMaybe<Scalars['String']['input']>;
  link?: InputMaybe<Scalars['String']['input']>;
};

export type PageGenericContentSectionCtaArticlesPostsMutation = {
  tag?: InputMaybe<Scalars['String']['input']>;
  headingText?: InputMaybe<Scalars['String']['input']>;
  imageSrc?: InputMaybe<Scalars['String']['input']>;
  cta?: InputMaybe<PageGenericContentSectionCtaArticlesPostsCtaMutation>;
  ref?: InputMaybe<Scalars['String']['input']>;
};

export type PageGenericContentSectionCtaArticlesMutation = {
  posts?: InputMaybe<Array<InputMaybe<PageGenericContentSectionCtaArticlesPostsMutation>>>;
};

export type PageGenericContentSectionHelpfulArticlesCtaButtonMutation = {
  label?: InputMaybe<Scalars['String']['input']>;
  link?: InputMaybe<Scalars['String']['input']>;
};

export type PageGenericContentSectionHelpfulArticlesCtaMutation = {
  headingText?: InputMaybe<Scalars['String']['input']>;
  imageSrc?: InputMaybe<Scalars['String']['input']>;
  button?: InputMaybe<PageGenericContentSectionHelpfulArticlesCtaButtonMutation>;
};

export type PageGenericContentSectionHelpfulArticlesPostsMutation = {
  ref?: InputMaybe<Scalars['String']['input']>;
};

export type PageGenericContentSectionHelpfulArticlesMutation = {
  cta?: InputMaybe<PageGenericContentSectionHelpfulArticlesCtaMutation>;
  title?: InputMaybe<Scalars['String']['input']>;
  posts?: InputMaybe<Array<InputMaybe<PageGenericContentSectionHelpfulArticlesPostsMutation>>>;
};

export type PageGenericContentSectionStatsItemsMutation = {
  number?: InputMaybe<Scalars['Float']['input']>;
  unit?: InputMaybe<Scalars['String']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
};

export type PageGenericContentSectionStatsButtonMutation = {
  label?: InputMaybe<Scalars['String']['input']>;
  link?: InputMaybe<Scalars['String']['input']>;
  ariaLabel?: InputMaybe<Scalars['String']['input']>;
};

export type PageGenericContentSectionStatsQuoteMutation = {
  text?: InputMaybe<Scalars['String']['input']>;
  author?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type PageGenericContentSectionStatsMutation = {
  title?: InputMaybe<Scalars['String']['input']>;
  headingText?: InputMaybe<Scalars['String']['input']>;
  items?: InputMaybe<Array<InputMaybe<PageGenericContentSectionStatsItemsMutation>>>;
  secondaryHeading?: InputMaybe<Scalars['JSON']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
  button?: InputMaybe<PageGenericContentSectionStatsButtonMutation>;
  imageSrc?: InputMaybe<Scalars['String']['input']>;
  quote?: InputMaybe<PageGenericContentSectionStatsQuoteMutation>;
};

export type PageGenericContentSectionResourcesGroupsItemsMutation = {
  label?: InputMaybe<Scalars['String']['input']>;
  link?: InputMaybe<Scalars['String']['input']>;
  ariaLabel?: InputMaybe<Scalars['String']['input']>;
};

export type PageGenericContentSectionResourcesGroupsMutation = {
  title?: InputMaybe<Scalars['String']['input']>;
  items?: InputMaybe<Array<InputMaybe<PageGenericContentSectionResourcesGroupsItemsMutation>>>;
};

export type PageGenericContentSectionResourcesMutation = {
  title?: InputMaybe<Scalars['String']['input']>;
  headingText?: InputMaybe<Scalars['String']['input']>;
  imageSrc?: InputMaybe<Scalars['String']['input']>;
  groups?: InputMaybe<Array<InputMaybe<PageGenericContentSectionResourcesGroupsMutation>>>;
};

export type PageGenericContentSectionResourceHubGroupsArticlesLinkMutation = {
  label?: InputMaybe<Scalars['String']['input']>;
  link?: InputMaybe<Scalars['String']['input']>;
  ariaLabel?: InputMaybe<Scalars['String']['input']>;
};

export type PageGenericContentSectionResourceHubGroupsArticlesMutation = {
  title?: InputMaybe<Scalars['String']['input']>;
  textRich?: InputMaybe<Scalars['JSON']['input']>;
  link?: InputMaybe<PageGenericContentSectionResourceHubGroupsArticlesLinkMutation>;
};

export type PageGenericContentSectionResourceHubGroupsMutation = {
  title?: InputMaybe<Scalars['String']['input']>;
  tocTitle?: InputMaybe<Scalars['String']['input']>;
  articles?: InputMaybe<Array<InputMaybe<PageGenericContentSectionResourceHubGroupsArticlesMutation>>>;
};

export type PageGenericContentSectionResourceHubMutation = {
  title?: InputMaybe<Scalars['String']['input']>;
  headingText?: InputMaybe<Scalars['String']['input']>;
  imageSrc?: InputMaybe<Scalars['String']['input']>;
  groups?: InputMaybe<Array<InputMaybe<PageGenericContentSectionResourceHubGroupsMutation>>>;
};

export type PageGenericContentSectionFileResourcesFilterSettingsFiltersItemsMutation = {
  label?: InputMaybe<Scalars['String']['input']>;
  tag?: InputMaybe<Scalars['String']['input']>;
};

export type PageGenericContentSectionFileResourcesFilterSettingsFiltersMutation = {
  label?: InputMaybe<Scalars['String']['input']>;
  items?: InputMaybe<Array<InputMaybe<PageGenericContentSectionFileResourcesFilterSettingsFiltersItemsMutation>>>;
};

export type PageGenericContentSectionFileResourcesFilterSettingsMutation = {
  title?: InputMaybe<Scalars['String']['input']>;
  resetLabel?: InputMaybe<Scalars['String']['input']>;
  noItemsMessage?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Array<InputMaybe<PageGenericContentSectionFileResourcesFilterSettingsFiltersMutation>>>;
};

export type PageGenericContentSectionFileResourcesResourcesMutation = {
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  tooltip?: InputMaybe<Scalars['String']['input']>;
  link?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type PageGenericContentSectionFileResourcesMutation = {
  filterSettings?: InputMaybe<PageGenericContentSectionFileResourcesFilterSettingsMutation>;
  resources?: InputMaybe<Array<InputMaybe<PageGenericContentSectionFileResourcesResourcesMutation>>>;
};

export type PageGenericContentSectionOurStoryMutation = {
  headingText?: InputMaybe<Scalars['String']['input']>;
  subheadingText?: InputMaybe<Scalars['String']['input']>;
  textRich?: InputMaybe<Scalars['JSON']['input']>;
};

export type PageGenericContentSectionTeamItemsMutation = {
  image?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  about?: InputMaybe<Scalars['String']['input']>;
};

export type PageGenericContentSectionTeamMutation = {
  headingText?: InputMaybe<Scalars['String']['input']>;
  items?: InputMaybe<Array<InputMaybe<PageGenericContentSectionTeamItemsMutation>>>;
};

export type PageGenericContentSectionValuesItemsMutation = {
  icon?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
};

export type PageGenericContentSectionValuesMutation = {
  headingText?: InputMaybe<Scalars['String']['input']>;
  items?: InputMaybe<Array<InputMaybe<PageGenericContentSectionValuesItemsMutation>>>;
};

export type PageGenericContentSectionImageBrzImageMutation = {
  title?: InputMaybe<Scalars['String']['input']>;
  src?: InputMaybe<Scalars['String']['input']>;
  width?: InputMaybe<Scalars['Float']['input']>;
  height?: InputMaybe<Scalars['Float']['input']>;
  aspectRatio?: InputMaybe<Scalars['Float']['input']>;
  format?: InputMaybe<Scalars['String']['input']>;
  alt?: InputMaybe<Scalars['String']['input']>;
  radius?: InputMaybe<Scalars['Float']['input']>;
};

export type PageGenericContentSectionImageMutation = {
  brzImage?: InputMaybe<PageGenericContentSectionImageBrzImageMutation>;
  scrollable?: InputMaybe<Scalars['Boolean']['input']>;
  spacing?: InputMaybe<Scalars['Float']['input']>;
  maxWidth?: InputMaybe<Scalars['String']['input']>;
  align?: InputMaybe<Scalars['String']['input']>;
};

export type PageGenericContentSectionButtonsButtonsMutation = {
  label?: InputMaybe<Scalars['String']['input']>;
  link?: InputMaybe<Scalars['String']['input']>;
  ariaLabel?: InputMaybe<Scalars['String']['input']>;
  variant?: InputMaybe<Scalars['String']['input']>;
  color?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['String']['input']>;
};

export type PageGenericContentSectionButtonsMutation = {
  align?: InputMaybe<Scalars['String']['input']>;
  buttons?: InputMaybe<Array<InputMaybe<PageGenericContentSectionButtonsButtonsMutation>>>;
  spacing?: InputMaybe<Scalars['Float']['input']>;
};

export type PageGenericContentSectionPressItemsMutation = {
  headingText?: InputMaybe<Scalars['String']['input']>;
  link?: InputMaybe<Scalars['String']['input']>;
};

export type PageGenericContentSectionPressMutation = {
  headingText?: InputMaybe<Scalars['String']['input']>;
  textRich?: InputMaybe<Scalars['JSON']['input']>;
  items?: InputMaybe<Array<InputMaybe<PageGenericContentSectionPressItemsMutation>>>;
};

export type PageGenericContentSectionTwoColumnTextMutation = {
  title?: InputMaybe<Scalars['String']['input']>;
  headingText?: InputMaybe<Scalars['String']['input']>;
  imageSrc?: InputMaybe<Scalars['String']['input']>;
  textRich?: InputMaybe<Scalars['JSON']['input']>;
};

export type PageGenericContentSectionThreeColumnTextColsMutation = {
  title?: InputMaybe<Scalars['String']['input']>;
  textRich?: InputMaybe<Scalars['JSON']['input']>;
};

export type PageGenericContentSectionThreeColumnTextMutation = {
  headingText?: InputMaybe<Scalars['String']['input']>;
  cols?: InputMaybe<Array<InputMaybe<PageGenericContentSectionThreeColumnTextColsMutation>>>;
};

export type PageGenericContentSectionVibeButtonMutation = {
  label?: InputMaybe<Scalars['String']['input']>;
  link?: InputMaybe<Scalars['String']['input']>;
  ariaLabel?: InputMaybe<Scalars['String']['input']>;
};

export type PageGenericContentSectionVibeItemsMutation = {
  icon?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
};

export type PageGenericContentSectionVibeMutation = {
  title?: InputMaybe<Scalars['String']['input']>;
  headingText?: InputMaybe<Scalars['String']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
  button?: InputMaybe<PageGenericContentSectionVibeButtonMutation>;
  imageSrc?: InputMaybe<Scalars['String']['input']>;
  items?: InputMaybe<Array<InputMaybe<PageGenericContentSectionVibeItemsMutation>>>;
};

export type PageGenericContentSectionSellingPointsItemsMutation = {
  icon?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
};

export type PageGenericContentSectionSellingPointsMutation = {
  imageSrc?: InputMaybe<Scalars['String']['input']>;
  headingText?: InputMaybe<Scalars['String']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
  items?: InputMaybe<Array<InputMaybe<PageGenericContentSectionSellingPointsItemsMutation>>>;
};

export type PageGenericContentSectionOpeningsItemsMutation = {
  title?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  link?: InputMaybe<Scalars['String']['input']>;
};

export type PageGenericContentSectionOpeningsMutation = {
  sectionId?: InputMaybe<Scalars['String']['input']>;
  headingText?: InputMaybe<Scalars['String']['input']>;
  textRich?: InputMaybe<Scalars['JSON']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  items?: InputMaybe<Array<InputMaybe<PageGenericContentSectionOpeningsItemsMutation>>>;
};

export type PageGenericContentSectionStoryCardsItemsEmployeeStoryMutation = {
  textRich?: InputMaybe<Scalars['JSON']['input']>;
  author?: InputMaybe<Scalars['String']['input']>;
  authorTitle?: InputMaybe<Scalars['String']['input']>;
  authorImage?: InputMaybe<Scalars['String']['input']>;
};

export type PageGenericContentSectionStoryCardsItemsAchievementBrzImageMutation = {
  src?: InputMaybe<Scalars['String']['input']>;
  width?: InputMaybe<Scalars['Float']['input']>;
  height?: InputMaybe<Scalars['Float']['input']>;
  aspectRatio?: InputMaybe<Scalars['Float']['input']>;
  format?: InputMaybe<Scalars['String']['input']>;
  alt?: InputMaybe<Scalars['String']['input']>;
};

export type PageGenericContentSectionStoryCardsItemsAchievementMutation = {
  title?: InputMaybe<Scalars['String']['input']>;
  textRich?: InputMaybe<Scalars['JSON']['input']>;
  brzImage?: InputMaybe<PageGenericContentSectionStoryCardsItemsAchievementBrzImageMutation>;
  badgeImage?: InputMaybe<Scalars['String']['input']>;
};

export type PageGenericContentSectionStoryCardsItemsAnnouncementImagesMutation = {
  imageSrc?: InputMaybe<Scalars['String']['input']>;
  alt?: InputMaybe<Scalars['String']['input']>;
};

export type PageGenericContentSectionStoryCardsItemsAnnouncementMutation = {
  headingText?: InputMaybe<Scalars['String']['input']>;
  subheadingText?: InputMaybe<Scalars['String']['input']>;
  textRich?: InputMaybe<Scalars['JSON']['input']>;
  images?: InputMaybe<Array<InputMaybe<PageGenericContentSectionStoryCardsItemsAnnouncementImagesMutation>>>;
};

export type PageGenericContentSectionStoryCardsItemsMutation = {
  EmployeeStory?: InputMaybe<PageGenericContentSectionStoryCardsItemsEmployeeStoryMutation>;
  Achievement?: InputMaybe<PageGenericContentSectionStoryCardsItemsAchievementMutation>;
  Announcement?: InputMaybe<PageGenericContentSectionStoryCardsItemsAnnouncementMutation>;
};

export type PageGenericContentSectionStoryCardsMutation = {
  title?: InputMaybe<Scalars['String']['input']>;
  items?: InputMaybe<Array<InputMaybe<PageGenericContentSectionStoryCardsItemsMutation>>>;
};

export type PageGenericContentSectionOtherOffersItemsMutation = {
  headingText?: InputMaybe<Scalars['String']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
  imageSrc?: InputMaybe<Scalars['String']['input']>;
};

export type PageGenericContentSectionOtherOffersMutation = {
  headingText?: InputMaybe<Scalars['String']['input']>;
  items?: InputMaybe<Array<InputMaybe<PageGenericContentSectionOtherOffersItemsMutation>>>;
};

export type PageGenericContentSectionAccordionItemsMutation = {
  title?: InputMaybe<Scalars['String']['input']>;
  textRich?: InputMaybe<Scalars['JSON']['input']>;
};

export type PageGenericContentSectionAccordionMutation = {
  title?: InputMaybe<Scalars['String']['input']>;
  sectionId?: InputMaybe<Scalars['String']['input']>;
  items?: InputMaybe<Array<InputMaybe<PageGenericContentSectionAccordionItemsMutation>>>;
};

export type PageGenericContentSectionQuoteProposalHelpTipMutation = {
  headingText?: InputMaybe<Scalars['String']['input']>;
  contentRich?: InputMaybe<Scalars['JSON']['input']>;
};

export type PageGenericContentSectionQuoteProposalNotFoundErrorMutation = {
  headingText?: InputMaybe<Scalars['String']['input']>;
  textRich?: InputMaybe<Scalars['JSON']['input']>;
};

export type PageGenericContentSectionQuoteProposalGenericErrorMutation = {
  headingText?: InputMaybe<Scalars['String']['input']>;
  textRich?: InputMaybe<Scalars['JSON']['input']>;
};

export type PageGenericContentSectionQuoteProposalMutation = {
  headingText?: InputMaybe<Scalars['String']['input']>;
  subheadingRich?: InputMaybe<Scalars['JSON']['input']>;
  imageSrc?: InputMaybe<Scalars['String']['input']>;
  helpTip?: InputMaybe<PageGenericContentSectionQuoteProposalHelpTipMutation>;
  addonsHeadingText?: InputMaybe<Scalars['String']['input']>;
  notFoundError?: InputMaybe<PageGenericContentSectionQuoteProposalNotFoundErrorMutation>;
  genericError?: InputMaybe<PageGenericContentSectionQuoteProposalGenericErrorMutation>;
};

export type PageGenericContentSectionTableRowsMutation = {
  columns?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type PageGenericContentSectionTableMutation = {
  title?: InputMaybe<Scalars['String']['input']>;
  headingText?: InputMaybe<Scalars['String']['input']>;
  rows?: InputMaybe<Array<InputMaybe<PageGenericContentSectionTableRowsMutation>>>;
};

export type PageGenericContentSectionHeadingMutation = {
  align?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  headingLevel?: InputMaybe<Scalars['String']['input']>;
  headingText?: InputMaybe<Scalars['String']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
  marginBottom?: InputMaybe<Scalars['String']['input']>;
};

export type PageGenericContentSectionContentMutation = {
  align?: InputMaybe<Scalars['String']['input']>;
  maxWidth?: InputMaybe<Scalars['String']['input']>;
  contentRich?: InputMaybe<Scalars['JSON']['input']>;
};

export type PageGenericContentSectionSidebarContentRowsColsMutation = {
  contentRich?: InputMaybe<Scalars['JSON']['input']>;
};

export type PageGenericContentSectionSidebarContentRowsMutation = {
  cols?: InputMaybe<Array<InputMaybe<PageGenericContentSectionSidebarContentRowsColsMutation>>>;
};

export type PageGenericContentSectionSidebarContentMutation = {
  sidebarRich?: InputMaybe<Scalars['JSON']['input']>;
  rows?: InputMaybe<Array<InputMaybe<PageGenericContentSectionSidebarContentRowsMutation>>>;
};

export type PageGenericContentSectionHtmlMutation = {
  contentText?: InputMaybe<Scalars['String']['input']>;
};

export type PageGenericContentMutation = {
  SectionHeroGeneric?: InputMaybe<PageGenericContentSectionHeroGenericMutation>;
  SectionHeroAgent?: InputMaybe<PageGenericContentSectionHeroAgentMutation>;
  SectionLogos?: InputMaybe<PageGenericContentSectionLogosMutation>;
  SectionBadges?: InputMaybe<PageGenericContentSectionBadgesMutation>;
  SectionTestimonialSlider?: InputMaybe<PageGenericContentSectionTestimonialSliderMutation>;
  SectionTestimonialGrid?: InputMaybe<PageGenericContentSectionTestimonialGridMutation>;
  SectionFloatingCta?: InputMaybe<PageGenericContentSectionFloatingCtaMutation>;
  SectionImageCta?: InputMaybe<PageGenericContentSectionImageCtaMutation>;
  SectionProducts?: InputMaybe<PageGenericContentSectionProductsMutation>;
  SectionProductsSimple?: InputMaybe<PageGenericContentSectionProductsSimpleMutation>;
  SectionHowItWorks?: InputMaybe<PageGenericContentSectionHowItWorksMutation>;
  SectionIconColumns?: InputMaybe<PageGenericContentSectionIconColumnsMutation>;
  SectionBlogPosts?: InputMaybe<PageGenericContentSectionBlogPostsMutation>;
  SectionArticles?: InputMaybe<PageGenericContentSectionArticlesMutation>;
  SectionCtaArticles?: InputMaybe<PageGenericContentSectionCtaArticlesMutation>;
  SectionHelpfulArticles?: InputMaybe<PageGenericContentSectionHelpfulArticlesMutation>;
  SectionStats?: InputMaybe<PageGenericContentSectionStatsMutation>;
  SectionResources?: InputMaybe<PageGenericContentSectionResourcesMutation>;
  SectionResourceHub?: InputMaybe<PageGenericContentSectionResourceHubMutation>;
  SectionFileResources?: InputMaybe<PageGenericContentSectionFileResourcesMutation>;
  SectionOurStory?: InputMaybe<PageGenericContentSectionOurStoryMutation>;
  SectionTeam?: InputMaybe<PageGenericContentSectionTeamMutation>;
  SectionValues?: InputMaybe<PageGenericContentSectionValuesMutation>;
  SectionImage?: InputMaybe<PageGenericContentSectionImageMutation>;
  SectionButtons?: InputMaybe<PageGenericContentSectionButtonsMutation>;
  SectionPress?: InputMaybe<PageGenericContentSectionPressMutation>;
  SectionTwoColumnText?: InputMaybe<PageGenericContentSectionTwoColumnTextMutation>;
  SectionThreeColumnText?: InputMaybe<PageGenericContentSectionThreeColumnTextMutation>;
  SectionVibe?: InputMaybe<PageGenericContentSectionVibeMutation>;
  SectionSellingPoints?: InputMaybe<PageGenericContentSectionSellingPointsMutation>;
  SectionOpenings?: InputMaybe<PageGenericContentSectionOpeningsMutation>;
  SectionStoryCards?: InputMaybe<PageGenericContentSectionStoryCardsMutation>;
  SectionOtherOffers?: InputMaybe<PageGenericContentSectionOtherOffersMutation>;
  SectionAccordion?: InputMaybe<PageGenericContentSectionAccordionMutation>;
  SectionQuoteProposal?: InputMaybe<PageGenericContentSectionQuoteProposalMutation>;
  SectionTable?: InputMaybe<PageGenericContentSectionTableMutation>;
  SectionHeading?: InputMaybe<PageGenericContentSectionHeadingMutation>;
  SectionContent?: InputMaybe<PageGenericContentSectionContentMutation>;
  SectionSidebarContent?: InputMaybe<PageGenericContentSectionSidebarContentMutation>;
  SectionHTML?: InputMaybe<PageGenericContentSectionHtmlMutation>;
};

export type PageGenericMutation = {
  component?: InputMaybe<Scalars['String']['input']>;
  updatedDate?: InputMaybe<Scalars['String']['input']>;
  publishedDate?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  settings?: InputMaybe<PageGenericSettingsMutation>;
  content?: InputMaybe<Array<InputMaybe<PageGenericContentMutation>>>;
};

export type PageBlogSettingsPublishMutation = {
  published?: InputMaybe<Scalars['Boolean']['input']>;
  publishedDate?: InputMaybe<Scalars['String']['input']>;
};

export type PageFormSettingsSeoImageMutation = {
  src?: InputMaybe<Scalars['String']['input']>;
  width?: InputMaybe<Scalars['Float']['input']>;
  height?: InputMaybe<Scalars['Float']['input']>;
  aspectRatio?: InputMaybe<Scalars['Float']['input']>;
  format?: InputMaybe<Scalars['String']['input']>;
  alt?: InputMaybe<Scalars['String']['input']>;
};

export type PageFormSettingsSeoOrgMutation = {
  disable?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ArticleSettingsSeoFaqItemsMutation = {
  q?: InputMaybe<Scalars['String']['input']>;
  a?: InputMaybe<Scalars['String']['input']>;
};

export type PageFormSettingsSeoFaqMutation = {
  disable?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  items?: InputMaybe<Array<InputMaybe<ArticleSettingsSeoFaqItemsMutation>>>;
};

export type ArticleSettingsSeoHowToImageMutation = {
  src?: InputMaybe<Scalars['String']['input']>;
  width?: InputMaybe<Scalars['Float']['input']>;
  height?: InputMaybe<Scalars['Float']['input']>;
  aspectRatio?: InputMaybe<Scalars['Float']['input']>;
  format?: InputMaybe<Scalars['String']['input']>;
  alt?: InputMaybe<Scalars['String']['input']>;
};

export type ArticleSettingsSeoHowToStepsMutation = {
  name?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
};

export type PageFormSettingsSeoHowToMutation = {
  disable?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<ArticleSettingsSeoHowToImageMutation>;
  steps?: InputMaybe<Array<InputMaybe<ArticleSettingsSeoHowToStepsMutation>>>;
};

export type PageBlogSettingsSeoMutation = {
  title?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<PageFormSettingsSeoImageMutation>;
  org?: InputMaybe<PageFormSettingsSeoOrgMutation>;
  faq?: InputMaybe<PageFormSettingsSeoFaqMutation>;
  howTo?: InputMaybe<PageFormSettingsSeoHowToMutation>;
};

export type PageBlogSettingsSitemapMutation = {
  exclude?: InputMaybe<Scalars['Boolean']['input']>;
  breadcrumb?: InputMaybe<Scalars['String']['input']>;
  changefreq?: InputMaybe<Scalars['String']['input']>;
  priority?: InputMaybe<Scalars['Float']['input']>;
};

export type PageFormSettingsNavigationRightSideButtonOverrideMutation = {
  label?: InputMaybe<Scalars['String']['input']>;
  link?: InputMaybe<Scalars['String']['input']>;
  ariaLabel?: InputMaybe<Scalars['String']['input']>;
};

export type PageBlogSettingsNavigationMutation = {
  disableLogo?: InputMaybe<Scalars['Boolean']['input']>;
  disableLeft?: InputMaybe<Scalars['Boolean']['input']>;
  disableRight?: InputMaybe<Scalars['Boolean']['input']>;
  disableButtons?: InputMaybe<Scalars['Boolean']['input']>;
  rightSideButtonOverride?: InputMaybe<PageFormSettingsNavigationRightSideButtonOverrideMutation>;
};

export type PageBlogSettingsFooterMutation = {
  disableLinks?: InputMaybe<Scalars['Boolean']['input']>;
  disableBottom?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PageBlogSettingsDisclaimerMutation = {
  disable?: InputMaybe<Scalars['Boolean']['input']>;
  content?: InputMaybe<Scalars['JSON']['input']>;
};

export type PageBlogSettingsPartnerMutation = {
  partnerRef?: InputMaybe<Scalars['String']['input']>;
  cobrandRef?: InputMaybe<Scalars['String']['input']>;
};

export type PageBlogSettingsClientMutation = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PageBlogSettingsMutation = {
  publish?: InputMaybe<PageBlogSettingsPublishMutation>;
  seo?: InputMaybe<PageBlogSettingsSeoMutation>;
  sitemap?: InputMaybe<PageBlogSettingsSitemapMutation>;
  notification?: InputMaybe<Scalars['String']['input']>;
  navigation?: InputMaybe<PageBlogSettingsNavigationMutation>;
  footer?: InputMaybe<PageBlogSettingsFooterMutation>;
  disclaimer?: InputMaybe<PageBlogSettingsDisclaimerMutation>;
  partner?: InputMaybe<PageBlogSettingsPartnerMutation>;
  client?: InputMaybe<PageBlogSettingsClientMutation>;
};

export type PageBlogCategoriesMutation = {
  ref?: InputMaybe<Scalars['String']['input']>;
};

export type PageBlogPopularMutation = {
  ref?: InputMaybe<Scalars['String']['input']>;
};

export type PageBlogCtaButtonsMutation = {
  label?: InputMaybe<Scalars['String']['input']>;
  link?: InputMaybe<Scalars['String']['input']>;
  ariaLabel?: InputMaybe<Scalars['String']['input']>;
};

export type PageBlogCtaMutation = {
  headingText?: InputMaybe<Scalars['String']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
  buttons?: InputMaybe<Array<InputMaybe<PageBlogCtaButtonsMutation>>>;
};

export type PageBlogMutation = {
  component?: InputMaybe<Scalars['String']['input']>;
  updatedDate?: InputMaybe<Scalars['String']['input']>;
  publishedDate?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  settings?: InputMaybe<PageBlogSettingsMutation>;
  heading?: InputMaybe<Scalars['String']['input']>;
  categories?: InputMaybe<Array<InputMaybe<PageBlogCategoriesMutation>>>;
  popular?: InputMaybe<Array<InputMaybe<PageBlogPopularMutation>>>;
  cta?: InputMaybe<PageBlogCtaMutation>;
};

export type PageFormSettingsPublishMutation = {
  published?: InputMaybe<Scalars['Boolean']['input']>;
  publishedDate?: InputMaybe<Scalars['String']['input']>;
};

export type ArticleSettingsSeoImageMutation = {
  src?: InputMaybe<Scalars['String']['input']>;
  width?: InputMaybe<Scalars['Float']['input']>;
  height?: InputMaybe<Scalars['Float']['input']>;
  aspectRatio?: InputMaybe<Scalars['Float']['input']>;
  format?: InputMaybe<Scalars['String']['input']>;
  alt?: InputMaybe<Scalars['String']['input']>;
};

export type ArticleSettingsSeoOrgMutation = {
  disable?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PostSettingsSeoFaqItemsMutation = {
  q?: InputMaybe<Scalars['String']['input']>;
  a?: InputMaybe<Scalars['String']['input']>;
};

export type ArticleSettingsSeoFaqMutation = {
  disable?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  items?: InputMaybe<Array<InputMaybe<PostSettingsSeoFaqItemsMutation>>>;
};

export type PostSettingsSeoHowToImageMutation = {
  src?: InputMaybe<Scalars['String']['input']>;
  width?: InputMaybe<Scalars['Float']['input']>;
  height?: InputMaybe<Scalars['Float']['input']>;
  aspectRatio?: InputMaybe<Scalars['Float']['input']>;
  format?: InputMaybe<Scalars['String']['input']>;
  alt?: InputMaybe<Scalars['String']['input']>;
};

export type PostSettingsSeoHowToStepsMutation = {
  name?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
};

export type ArticleSettingsSeoHowToMutation = {
  disable?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<PostSettingsSeoHowToImageMutation>;
  steps?: InputMaybe<Array<InputMaybe<PostSettingsSeoHowToStepsMutation>>>;
};

export type PageFormSettingsSeoMutation = {
  title?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<ArticleSettingsSeoImageMutation>;
  org?: InputMaybe<ArticleSettingsSeoOrgMutation>;
  faq?: InputMaybe<ArticleSettingsSeoFaqMutation>;
  howTo?: InputMaybe<ArticleSettingsSeoHowToMutation>;
};

export type PageFormSettingsSitemapMutation = {
  exclude?: InputMaybe<Scalars['Boolean']['input']>;
  breadcrumb?: InputMaybe<Scalars['String']['input']>;
  changefreq?: InputMaybe<Scalars['String']['input']>;
  priority?: InputMaybe<Scalars['Float']['input']>;
};

export type ArticleSettingsNavigationRightSideButtonOverrideMutation = {
  label?: InputMaybe<Scalars['String']['input']>;
  link?: InputMaybe<Scalars['String']['input']>;
  ariaLabel?: InputMaybe<Scalars['String']['input']>;
};

export type PageFormSettingsNavigationMutation = {
  disableLogo?: InputMaybe<Scalars['Boolean']['input']>;
  disableLeft?: InputMaybe<Scalars['Boolean']['input']>;
  disableRight?: InputMaybe<Scalars['Boolean']['input']>;
  disableButtons?: InputMaybe<Scalars['Boolean']['input']>;
  rightSideButtonOverride?: InputMaybe<ArticleSettingsNavigationRightSideButtonOverrideMutation>;
};

export type PageFormSettingsFooterMutation = {
  disableLinks?: InputMaybe<Scalars['Boolean']['input']>;
  disableBottom?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PageFormSettingsDisclaimerMutation = {
  disable?: InputMaybe<Scalars['Boolean']['input']>;
  content?: InputMaybe<Scalars['JSON']['input']>;
};

export type PageFormSettingsPartnerMutation = {
  partnerRef?: InputMaybe<Scalars['String']['input']>;
  cobrandRef?: InputMaybe<Scalars['String']['input']>;
};

export type PageFormSettingsClientMutation = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PageFormSettingsMutation = {
  publish?: InputMaybe<PageFormSettingsPublishMutation>;
  seo?: InputMaybe<PageFormSettingsSeoMutation>;
  sitemap?: InputMaybe<PageFormSettingsSitemapMutation>;
  notification?: InputMaybe<Scalars['String']['input']>;
  navigation?: InputMaybe<PageFormSettingsNavigationMutation>;
  footer?: InputMaybe<PageFormSettingsFooterMutation>;
  disclaimer?: InputMaybe<PageFormSettingsDisclaimerMutation>;
  partner?: InputMaybe<PageFormSettingsPartnerMutation>;
  client?: InputMaybe<PageFormSettingsClientMutation>;
};

export type PageFormCarrierButtonMutation = {
  label?: InputMaybe<Scalars['String']['input']>;
  link?: InputMaybe<Scalars['String']['input']>;
  ariaLabel?: InputMaybe<Scalars['String']['input']>;
  hint?: InputMaybe<Scalars['String']['input']>;
};

export type PageFormCarrierMutation = {
  logo?: InputMaybe<Scalars['String']['input']>;
  headingText?: InputMaybe<Scalars['String']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
  button?: InputMaybe<PageFormCarrierButtonMutation>;
};

export type PageFormFormImagesMutation = {
  image?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type PageFormFormMutation = {
  title?: InputMaybe<Scalars['String']['input']>;
  headingText?: InputMaybe<Scalars['String']['input']>;
  subheadingText?: InputMaybe<Scalars['String']['input']>;
  images?: InputMaybe<Array<InputMaybe<PageFormFormImagesMutation>>>;
  settings?: InputMaybe<Scalars['String']['input']>;
};

export type PageFormCalendarMutation = {
  headingText?: InputMaybe<Scalars['String']['input']>;
  subheadingText?: InputMaybe<Scalars['String']['input']>;
};

export type PageFormSidebarHelpLinksMutation = {
  label?: InputMaybe<Scalars['String']['input']>;
  link?: InputMaybe<Scalars['String']['input']>;
  ariaLabel?: InputMaybe<Scalars['String']['input']>;
};

export type PageFormSidebarHelpMutation = {
  title?: InputMaybe<Scalars['String']['input']>;
  links?: InputMaybe<Array<InputMaybe<PageFormSidebarHelpLinksMutation>>>;
};

export type PageFormSidebarItemsMutation = {
  title?: InputMaybe<Scalars['String']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
};

export type PageFormSidebarContactsItemsMutation = {
  textRich?: InputMaybe<Scalars['JSON']['input']>;
  sub?: InputMaybe<Scalars['String']['input']>;
};

export type PageFormSidebarContactsMutation = {
  title?: InputMaybe<Scalars['String']['input']>;
  items?: InputMaybe<Array<InputMaybe<PageFormSidebarContactsItemsMutation>>>;
};

export type PageFormSidebarMutation = {
  help?: InputMaybe<PageFormSidebarHelpMutation>;
  headingText?: InputMaybe<Scalars['String']['input']>;
  subheadingText?: InputMaybe<Scalars['String']['input']>;
  items?: InputMaybe<Array<InputMaybe<PageFormSidebarItemsMutation>>>;
  contacts?: InputMaybe<PageFormSidebarContactsMutation>;
  testimonial?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<Scalars['String']['input']>;
};

export type PageFormMutation = {
  component?: InputMaybe<Scalars['String']['input']>;
  updatedDate?: InputMaybe<Scalars['String']['input']>;
  publishedDate?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  settings?: InputMaybe<PageFormSettingsMutation>;
  carrier?: InputMaybe<PageFormCarrierMutation>;
  form?: InputMaybe<PageFormFormMutation>;
  calendar?: InputMaybe<PageFormCalendarMutation>;
  sidebar?: InputMaybe<PageFormSidebarMutation>;
};

export type PageMutation = {
  Generic?: InputMaybe<PageGenericMutation>;
  Blog?: InputMaybe<PageBlogMutation>;
  Form?: InputMaybe<PageFormMutation>;
};

export type ArticleSettingsPublishMutation = {
  published?: InputMaybe<Scalars['Boolean']['input']>;
  publishedDate?: InputMaybe<Scalars['String']['input']>;
};

export type PostSettingsSeoImageMutation = {
  src?: InputMaybe<Scalars['String']['input']>;
  width?: InputMaybe<Scalars['Float']['input']>;
  height?: InputMaybe<Scalars['Float']['input']>;
  aspectRatio?: InputMaybe<Scalars['Float']['input']>;
  format?: InputMaybe<Scalars['String']['input']>;
  alt?: InputMaybe<Scalars['String']['input']>;
};

export type PostSettingsSeoOrgMutation = {
  disable?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CategorySettingsSeoFaqItemsMutation = {
  q?: InputMaybe<Scalars['String']['input']>;
  a?: InputMaybe<Scalars['String']['input']>;
};

export type PostSettingsSeoFaqMutation = {
  disable?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  items?: InputMaybe<Array<InputMaybe<CategorySettingsSeoFaqItemsMutation>>>;
};

export type CategorySettingsSeoHowToImageMutation = {
  src?: InputMaybe<Scalars['String']['input']>;
  width?: InputMaybe<Scalars['Float']['input']>;
  height?: InputMaybe<Scalars['Float']['input']>;
  aspectRatio?: InputMaybe<Scalars['Float']['input']>;
  format?: InputMaybe<Scalars['String']['input']>;
  alt?: InputMaybe<Scalars['String']['input']>;
};

export type CategorySettingsSeoHowToStepsMutation = {
  name?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
};

export type PostSettingsSeoHowToMutation = {
  disable?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<CategorySettingsSeoHowToImageMutation>;
  steps?: InputMaybe<Array<InputMaybe<CategorySettingsSeoHowToStepsMutation>>>;
};

export type ArticleSettingsSeoMutation = {
  title?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<PostSettingsSeoImageMutation>;
  org?: InputMaybe<PostSettingsSeoOrgMutation>;
  faq?: InputMaybe<PostSettingsSeoFaqMutation>;
  howTo?: InputMaybe<PostSettingsSeoHowToMutation>;
};

export type ArticleSettingsSitemapMutation = {
  exclude?: InputMaybe<Scalars['Boolean']['input']>;
  breadcrumb?: InputMaybe<Scalars['String']['input']>;
  changefreq?: InputMaybe<Scalars['String']['input']>;
  priority?: InputMaybe<Scalars['Float']['input']>;
};

export type PostSettingsNavigationRightSideButtonOverrideMutation = {
  label?: InputMaybe<Scalars['String']['input']>;
  link?: InputMaybe<Scalars['String']['input']>;
  ariaLabel?: InputMaybe<Scalars['String']['input']>;
};

export type ArticleSettingsNavigationMutation = {
  disableLogo?: InputMaybe<Scalars['Boolean']['input']>;
  disableLeft?: InputMaybe<Scalars['Boolean']['input']>;
  disableRight?: InputMaybe<Scalars['Boolean']['input']>;
  disableButtons?: InputMaybe<Scalars['Boolean']['input']>;
  rightSideButtonOverride?: InputMaybe<PostSettingsNavigationRightSideButtonOverrideMutation>;
};

export type ArticleSettingsFooterMutation = {
  disableLinks?: InputMaybe<Scalars['Boolean']['input']>;
  disableBottom?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ArticleSettingsDisclaimerMutation = {
  disable?: InputMaybe<Scalars['Boolean']['input']>;
  content?: InputMaybe<Scalars['JSON']['input']>;
};

export type ArticleSettingsPartnerMutation = {
  partnerRef?: InputMaybe<Scalars['String']['input']>;
  cobrandRef?: InputMaybe<Scalars['String']['input']>;
};

export type ArticleSettingsClientMutation = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ArticleSettingsMutation = {
  publish?: InputMaybe<ArticleSettingsPublishMutation>;
  seo?: InputMaybe<ArticleSettingsSeoMutation>;
  sitemap?: InputMaybe<ArticleSettingsSitemapMutation>;
  notification?: InputMaybe<Scalars['String']['input']>;
  navigation?: InputMaybe<ArticleSettingsNavigationMutation>;
  footer?: InputMaybe<ArticleSettingsFooterMutation>;
  disclaimer?: InputMaybe<ArticleSettingsDisclaimerMutation>;
  partner?: InputMaybe<ArticleSettingsPartnerMutation>;
  client?: InputMaybe<ArticleSettingsClientMutation>;
};

export type ArticleReadtimeMutation = {
  text?: InputMaybe<Scalars['String']['input']>;
  minutes?: InputMaybe<Scalars['Float']['input']>;
  time?: InputMaybe<Scalars['Float']['input']>;
  words?: InputMaybe<Scalars['Float']['input']>;
};

export type ArticleWidgetsMutation = {
  image?: InputMaybe<Scalars['String']['input']>;
  heading?: InputMaybe<Scalars['String']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  link?: InputMaybe<Scalars['String']['input']>;
};

export type ArticleCtaButtonsMutation = {
  label?: InputMaybe<Scalars['String']['input']>;
  link?: InputMaybe<Scalars['String']['input']>;
  ariaLabel?: InputMaybe<Scalars['String']['input']>;
};

export type ArticleCtaMutation = {
  headingText?: InputMaybe<Scalars['String']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
  buttons?: InputMaybe<Array<InputMaybe<ArticleCtaButtonsMutation>>>;
};

export type ArticleRelatedMutation = {
  ref?: InputMaybe<Scalars['String']['input']>;
};

export type ArticleMutation = {
  component?: InputMaybe<Scalars['String']['input']>;
  updatedDate?: InputMaybe<Scalars['String']['input']>;
  publishedDate?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  settings?: InputMaybe<ArticleSettingsMutation>;
  readtime?: InputMaybe<ArticleReadtimeMutation>;
  cover?: InputMaybe<Scalars['String']['input']>;
  thumbnail?: InputMaybe<Scalars['String']['input']>;
  headingRich?: InputMaybe<Scalars['JSON']['input']>;
  subtitleRich?: InputMaybe<Scalars['String']['input']>;
  excerptText?: InputMaybe<Scalars['String']['input']>;
  category?: InputMaybe<Scalars['String']['input']>;
  author?: InputMaybe<Scalars['String']['input']>;
  reviewer?: InputMaybe<Scalars['String']['input']>;
  widgets?: InputMaybe<Array<InputMaybe<ArticleWidgetsMutation>>>;
  cta?: InputMaybe<ArticleCtaMutation>;
  related?: InputMaybe<Array<InputMaybe<ArticleRelatedMutation>>>;
  body?: InputMaybe<Scalars['JSON']['input']>;
};

export type PostSettingsPublishMutation = {
  published?: InputMaybe<Scalars['Boolean']['input']>;
  publishedDate?: InputMaybe<Scalars['String']['input']>;
};

export type CategorySettingsSeoImageMutation = {
  src?: InputMaybe<Scalars['String']['input']>;
  width?: InputMaybe<Scalars['Float']['input']>;
  height?: InputMaybe<Scalars['Float']['input']>;
  aspectRatio?: InputMaybe<Scalars['Float']['input']>;
  format?: InputMaybe<Scalars['String']['input']>;
  alt?: InputMaybe<Scalars['String']['input']>;
};

export type CategorySettingsSeoOrgMutation = {
  disable?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AuthorSettingsSeoFaqItemsMutation = {
  q?: InputMaybe<Scalars['String']['input']>;
  a?: InputMaybe<Scalars['String']['input']>;
};

export type CategorySettingsSeoFaqMutation = {
  disable?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  items?: InputMaybe<Array<InputMaybe<AuthorSettingsSeoFaqItemsMutation>>>;
};

export type AuthorSettingsSeoHowToImageMutation = {
  src?: InputMaybe<Scalars['String']['input']>;
  width?: InputMaybe<Scalars['Float']['input']>;
  height?: InputMaybe<Scalars['Float']['input']>;
  aspectRatio?: InputMaybe<Scalars['Float']['input']>;
  format?: InputMaybe<Scalars['String']['input']>;
  alt?: InputMaybe<Scalars['String']['input']>;
};

export type AuthorSettingsSeoHowToStepsMutation = {
  name?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
};

export type CategorySettingsSeoHowToMutation = {
  disable?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<AuthorSettingsSeoHowToImageMutation>;
  steps?: InputMaybe<Array<InputMaybe<AuthorSettingsSeoHowToStepsMutation>>>;
};

export type PostSettingsSeoMutation = {
  title?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<CategorySettingsSeoImageMutation>;
  org?: InputMaybe<CategorySettingsSeoOrgMutation>;
  faq?: InputMaybe<CategorySettingsSeoFaqMutation>;
  howTo?: InputMaybe<CategorySettingsSeoHowToMutation>;
};

export type PostSettingsSitemapMutation = {
  exclude?: InputMaybe<Scalars['Boolean']['input']>;
  breadcrumb?: InputMaybe<Scalars['String']['input']>;
  changefreq?: InputMaybe<Scalars['String']['input']>;
  priority?: InputMaybe<Scalars['Float']['input']>;
};

export type CategorySettingsNavigationRightSideButtonOverrideMutation = {
  label?: InputMaybe<Scalars['String']['input']>;
  link?: InputMaybe<Scalars['String']['input']>;
  ariaLabel?: InputMaybe<Scalars['String']['input']>;
};

export type PostSettingsNavigationMutation = {
  disableLogo?: InputMaybe<Scalars['Boolean']['input']>;
  disableLeft?: InputMaybe<Scalars['Boolean']['input']>;
  disableRight?: InputMaybe<Scalars['Boolean']['input']>;
  disableButtons?: InputMaybe<Scalars['Boolean']['input']>;
  rightSideButtonOverride?: InputMaybe<CategorySettingsNavigationRightSideButtonOverrideMutation>;
};

export type PostSettingsFooterMutation = {
  disableLinks?: InputMaybe<Scalars['Boolean']['input']>;
  disableBottom?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PostSettingsDisclaimerMutation = {
  disable?: InputMaybe<Scalars['Boolean']['input']>;
  content?: InputMaybe<Scalars['JSON']['input']>;
};

export type PostSettingsPartnerMutation = {
  partnerRef?: InputMaybe<Scalars['String']['input']>;
  cobrandRef?: InputMaybe<Scalars['String']['input']>;
};

export type PostSettingsClientMutation = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PostSettingsMutation = {
  publish?: InputMaybe<PostSettingsPublishMutation>;
  seo?: InputMaybe<PostSettingsSeoMutation>;
  sitemap?: InputMaybe<PostSettingsSitemapMutation>;
  notification?: InputMaybe<Scalars['String']['input']>;
  navigation?: InputMaybe<PostSettingsNavigationMutation>;
  footer?: InputMaybe<PostSettingsFooterMutation>;
  disclaimer?: InputMaybe<PostSettingsDisclaimerMutation>;
  partner?: InputMaybe<PostSettingsPartnerMutation>;
  client?: InputMaybe<PostSettingsClientMutation>;
};

export type PostReadtimeMutation = {
  text?: InputMaybe<Scalars['String']['input']>;
  minutes?: InputMaybe<Scalars['Float']['input']>;
  time?: InputMaybe<Scalars['Float']['input']>;
  words?: InputMaybe<Scalars['Float']['input']>;
};

export type PostWidgetsMutation = {
  image?: InputMaybe<Scalars['String']['input']>;
  heading?: InputMaybe<Scalars['String']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  link?: InputMaybe<Scalars['String']['input']>;
};

export type PostCtaButtonsMutation = {
  label?: InputMaybe<Scalars['String']['input']>;
  link?: InputMaybe<Scalars['String']['input']>;
  ariaLabel?: InputMaybe<Scalars['String']['input']>;
};

export type PostCtaMutation = {
  headingText?: InputMaybe<Scalars['String']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
  buttons?: InputMaybe<Array<InputMaybe<PostCtaButtonsMutation>>>;
};

export type PostRelatedMutation = {
  ref?: InputMaybe<Scalars['String']['input']>;
};

export type PostMutation = {
  component?: InputMaybe<Scalars['String']['input']>;
  updatedDate?: InputMaybe<Scalars['String']['input']>;
  publishedDate?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  settings?: InputMaybe<PostSettingsMutation>;
  readtime?: InputMaybe<PostReadtimeMutation>;
  cover?: InputMaybe<Scalars['String']['input']>;
  thumbnail?: InputMaybe<Scalars['String']['input']>;
  headingRich?: InputMaybe<Scalars['JSON']['input']>;
  excerptText?: InputMaybe<Scalars['String']['input']>;
  category?: InputMaybe<Scalars['String']['input']>;
  author?: InputMaybe<Scalars['String']['input']>;
  reviewer?: InputMaybe<Scalars['String']['input']>;
  widgets?: InputMaybe<Array<InputMaybe<PostWidgetsMutation>>>;
  cta?: InputMaybe<PostCtaMutation>;
  related?: InputMaybe<Array<InputMaybe<PostRelatedMutation>>>;
  body?: InputMaybe<Scalars['JSON']['input']>;
};

export type CategorySettingsPublishMutation = {
  published?: InputMaybe<Scalars['Boolean']['input']>;
  publishedDate?: InputMaybe<Scalars['String']['input']>;
};

export type AuthorSettingsSeoImageMutation = {
  src?: InputMaybe<Scalars['String']['input']>;
  width?: InputMaybe<Scalars['Float']['input']>;
  height?: InputMaybe<Scalars['Float']['input']>;
  aspectRatio?: InputMaybe<Scalars['Float']['input']>;
  format?: InputMaybe<Scalars['String']['input']>;
  alt?: InputMaybe<Scalars['String']['input']>;
};

export type AuthorSettingsSeoOrgMutation = {
  disable?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AuthorSettingsSeoFaqMutation = {
  disable?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  items?: InputMaybe<Array<InputMaybe<AuthorSettingsSeoFaqItemsMutation>>>;
};

export type AuthorSettingsSeoHowToMutation = {
  disable?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<AuthorSettingsSeoHowToImageMutation>;
  steps?: InputMaybe<Array<InputMaybe<AuthorSettingsSeoHowToStepsMutation>>>;
};

export type CategorySettingsSeoMutation = {
  title?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<AuthorSettingsSeoImageMutation>;
  org?: InputMaybe<AuthorSettingsSeoOrgMutation>;
  faq?: InputMaybe<AuthorSettingsSeoFaqMutation>;
  howTo?: InputMaybe<AuthorSettingsSeoHowToMutation>;
};

export type CategorySettingsSitemapMutation = {
  exclude?: InputMaybe<Scalars['Boolean']['input']>;
  breadcrumb?: InputMaybe<Scalars['String']['input']>;
  changefreq?: InputMaybe<Scalars['String']['input']>;
  priority?: InputMaybe<Scalars['Float']['input']>;
};

export type AuthorSettingsNavigationRightSideButtonOverrideMutation = {
  label?: InputMaybe<Scalars['String']['input']>;
  link?: InputMaybe<Scalars['String']['input']>;
  ariaLabel?: InputMaybe<Scalars['String']['input']>;
};

export type CategorySettingsNavigationMutation = {
  disableLogo?: InputMaybe<Scalars['Boolean']['input']>;
  disableLeft?: InputMaybe<Scalars['Boolean']['input']>;
  disableRight?: InputMaybe<Scalars['Boolean']['input']>;
  disableButtons?: InputMaybe<Scalars['Boolean']['input']>;
  rightSideButtonOverride?: InputMaybe<AuthorSettingsNavigationRightSideButtonOverrideMutation>;
};

export type CategorySettingsFooterMutation = {
  disableLinks?: InputMaybe<Scalars['Boolean']['input']>;
  disableBottom?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CategorySettingsDisclaimerMutation = {
  disable?: InputMaybe<Scalars['Boolean']['input']>;
  content?: InputMaybe<Scalars['JSON']['input']>;
};

export type CategorySettingsPartnerMutation = {
  partnerRef?: InputMaybe<Scalars['String']['input']>;
  cobrandRef?: InputMaybe<Scalars['String']['input']>;
};

export type CategorySettingsClientMutation = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CategorySettingsMutation = {
  publish?: InputMaybe<CategorySettingsPublishMutation>;
  seo?: InputMaybe<CategorySettingsSeoMutation>;
  sitemap?: InputMaybe<CategorySettingsSitemapMutation>;
  notification?: InputMaybe<Scalars['String']['input']>;
  navigation?: InputMaybe<CategorySettingsNavigationMutation>;
  footer?: InputMaybe<CategorySettingsFooterMutation>;
  disclaimer?: InputMaybe<CategorySettingsDisclaimerMutation>;
  partner?: InputMaybe<CategorySettingsPartnerMutation>;
  client?: InputMaybe<CategorySettingsClientMutation>;
};

export type CategoryMutation = {
  component?: InputMaybe<Scalars['String']['input']>;
  updatedDate?: InputMaybe<Scalars['String']['input']>;
  publishedDate?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  settings?: InputMaybe<CategorySettingsMutation>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type AuthorSettingsPublishMutation = {
  published?: InputMaybe<Scalars['Boolean']['input']>;
  publishedDate?: InputMaybe<Scalars['String']['input']>;
};

export type AuthorSettingsSeoMutation = {
  title?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<AuthorSettingsSeoImageMutation>;
  org?: InputMaybe<AuthorSettingsSeoOrgMutation>;
  faq?: InputMaybe<AuthorSettingsSeoFaqMutation>;
  howTo?: InputMaybe<AuthorSettingsSeoHowToMutation>;
};

export type AuthorSettingsSitemapMutation = {
  exclude?: InputMaybe<Scalars['Boolean']['input']>;
  breadcrumb?: InputMaybe<Scalars['String']['input']>;
  changefreq?: InputMaybe<Scalars['String']['input']>;
  priority?: InputMaybe<Scalars['Float']['input']>;
};

export type AuthorSettingsNavigationMutation = {
  disableLogo?: InputMaybe<Scalars['Boolean']['input']>;
  disableLeft?: InputMaybe<Scalars['Boolean']['input']>;
  disableRight?: InputMaybe<Scalars['Boolean']['input']>;
  disableButtons?: InputMaybe<Scalars['Boolean']['input']>;
  rightSideButtonOverride?: InputMaybe<AuthorSettingsNavigationRightSideButtonOverrideMutation>;
};

export type AuthorSettingsFooterMutation = {
  disableLinks?: InputMaybe<Scalars['Boolean']['input']>;
  disableBottom?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AuthorSettingsDisclaimerMutation = {
  disable?: InputMaybe<Scalars['Boolean']['input']>;
  content?: InputMaybe<Scalars['JSON']['input']>;
};

export type AuthorSettingsPartnerMutation = {
  partnerRef?: InputMaybe<Scalars['String']['input']>;
  cobrandRef?: InputMaybe<Scalars['String']['input']>;
};

export type AuthorSettingsClientMutation = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AuthorSettingsMutation = {
  publish?: InputMaybe<AuthorSettingsPublishMutation>;
  seo?: InputMaybe<AuthorSettingsSeoMutation>;
  sitemap?: InputMaybe<AuthorSettingsSitemapMutation>;
  notification?: InputMaybe<Scalars['String']['input']>;
  navigation?: InputMaybe<AuthorSettingsNavigationMutation>;
  footer?: InputMaybe<AuthorSettingsFooterMutation>;
  disclaimer?: InputMaybe<AuthorSettingsDisclaimerMutation>;
  partner?: InputMaybe<AuthorSettingsPartnerMutation>;
  client?: InputMaybe<AuthorSettingsClientMutation>;
};

export type AuthorMutation = {
  component?: InputMaybe<Scalars['String']['input']>;
  updatedDate?: InputMaybe<Scalars['String']['input']>;
  publishedDate?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  settings?: InputMaybe<AuthorSettingsMutation>;
  name?: InputMaybe<Scalars['String']['input']>;
  jobTitle?: InputMaybe<Scalars['String']['input']>;
  avatar?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  bio?: InputMaybe<Scalars['JSON']['input']>;
};

export type ProductButtonsMutation = {
  label?: InputMaybe<Scalars['String']['input']>;
  link?: InputMaybe<Scalars['String']['input']>;
  ariaLabel?: InputMaybe<Scalars['String']['input']>;
  agentLink?: InputMaybe<Scalars['String']['input']>;
};

export type ProductMutation = {
  dataType?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  productGroup?: InputMaybe<Scalars['String']['input']>;
  shortName?: InputMaybe<Scalars['String']['input']>;
  icon?: InputMaybe<Scalars['String']['input']>;
  graphic?: InputMaybe<Scalars['String']['input']>;
  actionLabel?: InputMaybe<Scalars['String']['input']>;
  descriptionText?: InputMaybe<Scalars['String']['input']>;
  descriptionItems?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  disclaimer?: InputMaybe<Scalars['String']['input']>;
  buttons?: InputMaybe<Array<InputMaybe<ProductButtonsMutation>>>;
};

export type TestimonialMutation = {
  dataType?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  stars?: InputMaybe<Scalars['Float']['input']>;
  author?: InputMaybe<Scalars['String']['input']>;
  authorTitle?: InputMaybe<Scalars['String']['input']>;
  link?: InputMaybe<Scalars['String']['input']>;
  body?: InputMaybe<Scalars['JSON']['input']>;
};

export type PartnerLogoMutation = {
  src?: InputMaybe<Scalars['String']['input']>;
};

export type PartnerMutation = {
  dataType?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  pid?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  logo?: InputMaybe<PartnerLogoMutation>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  ctaLink?: InputMaybe<Scalars['String']['input']>;
  products?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  disclaimer?: InputMaybe<Scalars['String']['input']>;
};

export type CobrandMutation = {
  dataType?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  logoSrc?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
};

export type BgaProductsRefsMutation = {
  productRef?: InputMaybe<Scalars['String']['input']>;
};

export type BgaMutation = {
  dataType?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  urlSlug?: InputMaybe<Scalars['String']['input']>;
  logoSrc?: InputMaybe<Scalars['String']['input']>;
  mobileLogoSrc?: InputMaybe<Scalars['String']['input']>;
  websiteDisplayName?: InputMaybe<Scalars['String']['input']>;
  ctaLink?: InputMaybe<Scalars['String']['input']>;
  productsRefs?: InputMaybe<Array<InputMaybe<BgaProductsRefsMutation>>>;
};

export type NotificationMutation = {
  title?: InputMaybe<Scalars['String']['input']>;
  color?: InputMaybe<Scalars['String']['input']>;
  body?: InputMaybe<Scalars['JSON']['input']>;
};

export type SettingsNavigationLeftMegaMenuItemsImageMutation = {
  src?: InputMaybe<Scalars['String']['input']>;
  width?: InputMaybe<Scalars['Float']['input']>;
  height?: InputMaybe<Scalars['Float']['input']>;
  aspectRatio?: InputMaybe<Scalars['Float']['input']>;
  format?: InputMaybe<Scalars['String']['input']>;
  alt?: InputMaybe<Scalars['String']['input']>;
};

export type SettingsNavigationLeftMegaMenuItemsButtonsMutation = {
  label?: InputMaybe<Scalars['String']['input']>;
  link?: InputMaybe<Scalars['String']['input']>;
  ariaLabel?: InputMaybe<Scalars['String']['input']>;
};

export type SettingsNavigationLeftMegaMenuItemsColumnsLinksMutation = {
  label?: InputMaybe<Scalars['String']['input']>;
  link?: InputMaybe<Scalars['String']['input']>;
  ariaLabel?: InputMaybe<Scalars['String']['input']>;
};

export type SettingsNavigationLeftMegaMenuItemsColumnsMutation = {
  title?: InputMaybe<Scalars['String']['input']>;
  links?: InputMaybe<Array<InputMaybe<SettingsNavigationLeftMegaMenuItemsColumnsLinksMutation>>>;
};

export type SettingsNavigationLeftMegaMenuItemsMutation = {
  title?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  icon?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<SettingsNavigationLeftMegaMenuItemsImageMutation>;
  buttons?: InputMaybe<Array<InputMaybe<SettingsNavigationLeftMegaMenuItemsButtonsMutation>>>;
  columns?: InputMaybe<Array<InputMaybe<SettingsNavigationLeftMegaMenuItemsColumnsMutation>>>;
};

export type SettingsNavigationLeftMegaMenuMutation = {
  title?: InputMaybe<Scalars['String']['input']>;
  heading?: InputMaybe<Scalars['String']['input']>;
  items?: InputMaybe<Array<InputMaybe<SettingsNavigationLeftMegaMenuItemsMutation>>>;
};

export type SettingsNavigationLeftSimpleMenuItemsMutation = {
  icon?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  link?: InputMaybe<Scalars['String']['input']>;
};

export type SettingsNavigationLeftSimpleMenuMutation = {
  title?: InputMaybe<Scalars['String']['input']>;
  items?: InputMaybe<Array<InputMaybe<SettingsNavigationLeftSimpleMenuItemsMutation>>>;
};

export type SettingsNavigationLeftMutation = {
  megaMenu?: InputMaybe<SettingsNavigationLeftMegaMenuMutation>;
  simpleMenu?: InputMaybe<SettingsNavigationLeftSimpleMenuMutation>;
};

export type SettingsNavigationRightLinkItemMutation = {
  label?: InputMaybe<Scalars['String']['input']>;
  link?: InputMaybe<Scalars['String']['input']>;
  ariaLabel?: InputMaybe<Scalars['String']['input']>;
};

export type SettingsNavigationRightDropdownItemItemsMutation = {
  label?: InputMaybe<Scalars['String']['input']>;
  link?: InputMaybe<Scalars['String']['input']>;
  ariaLabel?: InputMaybe<Scalars['String']['input']>;
};

export type SettingsNavigationRightDropdownItemMutation = {
  label?: InputMaybe<Scalars['String']['input']>;
  items?: InputMaybe<Array<InputMaybe<SettingsNavigationRightDropdownItemItemsMutation>>>;
};

export type SettingsNavigationRightButtonItemMutation = {
  label?: InputMaybe<Scalars['String']['input']>;
  link?: InputMaybe<Scalars['String']['input']>;
  ariaLabel?: InputMaybe<Scalars['String']['input']>;
};

export type SettingsNavigationRightMutation = {
  linkItem?: InputMaybe<SettingsNavigationRightLinkItemMutation>;
  dropdownItem?: InputMaybe<SettingsNavigationRightDropdownItemMutation>;
  buttonItem?: InputMaybe<SettingsNavigationRightButtonItemMutation>;
};

export type SettingsNavigationMutation = {
  title?: InputMaybe<Scalars['String']['input']>;
  left?: InputMaybe<Array<InputMaybe<SettingsNavigationLeftMutation>>>;
  right?: InputMaybe<Array<InputMaybe<SettingsNavigationRightMutation>>>;
};

export type SettingsFooterColumnsImageMutation = {
  src?: InputMaybe<Scalars['String']['input']>;
  width?: InputMaybe<Scalars['Float']['input']>;
  height?: InputMaybe<Scalars['Float']['input']>;
  aspectRatio?: InputMaybe<Scalars['Float']['input']>;
  format?: InputMaybe<Scalars['String']['input']>;
  alt?: InputMaybe<Scalars['String']['input']>;
};

export type SettingsFooterColumnsLinksMutation = {
  label?: InputMaybe<Scalars['String']['input']>;
  link?: InputMaybe<Scalars['String']['input']>;
  ariaLabel?: InputMaybe<Scalars['String']['input']>;
};

export type SettingsFooterColumnsMutation = {
  title?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<SettingsFooterColumnsImageMutation>;
  links?: InputMaybe<Array<InputMaybe<SettingsFooterColumnsLinksMutation>>>;
};

export type SettingsFooterExtrasLinksMutation = {
  label?: InputMaybe<Scalars['String']['input']>;
  link?: InputMaybe<Scalars['String']['input']>;
  ariaLabel?: InputMaybe<Scalars['String']['input']>;
};

export type SettingsFooterExtrasMutation = {
  title?: InputMaybe<Scalars['String']['input']>;
  links?: InputMaybe<Array<InputMaybe<SettingsFooterExtrasLinksMutation>>>;
};

export type SettingsFooterContactsMutation = {
  icon?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  link?: InputMaybe<Scalars['String']['input']>;
  ariaLabel?: InputMaybe<Scalars['String']['input']>;
};

export type SettingsFooterBottomSocialMutation = {
  icon?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  link?: InputMaybe<Scalars['String']['input']>;
  ariaLabel?: InputMaybe<Scalars['String']['input']>;
};

export type SettingsFooterBottomNavigationMutation = {
  label?: InputMaybe<Scalars['String']['input']>;
  link?: InputMaybe<Scalars['String']['input']>;
  ariaLabel?: InputMaybe<Scalars['String']['input']>;
  newWindow?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SettingsFooterBottomMutation = {
  copyright?: InputMaybe<Scalars['String']['input']>;
  social?: InputMaybe<Array<InputMaybe<SettingsFooterBottomSocialMutation>>>;
  navigation?: InputMaybe<Array<InputMaybe<SettingsFooterBottomNavigationMutation>>>;
};

export type SettingsFooterMutation = {
  title?: InputMaybe<Scalars['String']['input']>;
  columns?: InputMaybe<Array<InputMaybe<SettingsFooterColumnsMutation>>>;
  extras?: InputMaybe<Array<InputMaybe<SettingsFooterExtrasMutation>>>;
  address?: InputMaybe<Scalars['String']['input']>;
  contacts?: InputMaybe<Array<InputMaybe<SettingsFooterContactsMutation>>>;
  bottom?: InputMaybe<SettingsFooterBottomMutation>;
  disclaimer?: InputMaybe<Scalars['JSON']['input']>;
};

export type SettingsSiteLogoMutation = {
  src?: InputMaybe<Scalars['String']['input']>;
  width?: InputMaybe<Scalars['Float']['input']>;
  height?: InputMaybe<Scalars['Float']['input']>;
  aspectRatio?: InputMaybe<Scalars['Float']['input']>;
  format?: InputMaybe<Scalars['String']['input']>;
  alt?: InputMaybe<Scalars['String']['input']>;
};

export type SettingsSiteFoundersMutation = {
  name?: InputMaybe<Scalars['String']['input']>;
  occupation?: InputMaybe<Scalars['String']['input']>;
  socialLink?: InputMaybe<Scalars['String']['input']>;
};

export type SettingsSiteBusinessAddressMutation = {
  street?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  zip?: InputMaybe<Scalars['String']['input']>;
};

export type SettingsSiteRatingMutation = {
  value?: InputMaybe<Scalars['Float']['input']>;
  outOf?: InputMaybe<Scalars['Float']['input']>;
  reviews?: InputMaybe<Scalars['Float']['input']>;
};

export type SettingsSiteMutation = {
  title?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  legalName?: InputMaybe<Scalars['String']['input']>;
  baseUrl?: InputMaybe<Scalars['String']['input']>;
  logo?: InputMaybe<SettingsSiteLogoMutation>;
  description?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  foundingDate?: InputMaybe<Scalars['Float']['input']>;
  founders?: InputMaybe<Array<InputMaybe<SettingsSiteFoundersMutation>>>;
  businessAddress?: InputMaybe<SettingsSiteBusinessAddressMutation>;
  rating?: InputMaybe<SettingsSiteRatingMutation>;
  socialLinks?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  gtmId?: InputMaybe<Scalars['String']['input']>;
  fbAppId?: InputMaybe<Scalars['String']['input']>;
  twitterAuthor?: InputMaybe<Scalars['String']['input']>;
};

export type SettingsRedirectsRedirect_GroupsRedirectsMutation = {
  from_url?: InputMaybe<Scalars['String']['input']>;
  to_url?: InputMaybe<Scalars['String']['input']>;
};

export type SettingsRedirectsRedirect_GroupsMutation = {
  name?: InputMaybe<Scalars['String']['input']>;
  redirects?: InputMaybe<Array<InputMaybe<SettingsRedirectsRedirect_GroupsRedirectsMutation>>>;
};

export type SettingsRedirectsMutation = {
  title?: InputMaybe<Scalars['String']['input']>;
  redirect_groups?: InputMaybe<Array<InputMaybe<SettingsRedirectsRedirect_GroupsMutation>>>;
};

export type SettingsSecurityCspMutation = {
  directive?: InputMaybe<Scalars['String']['input']>;
  hosts?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type SettingsSecurityBlocked_IpsMutation = {
  ip_address?: InputMaybe<Scalars['String']['input']>;
  subnet_mask?: InputMaybe<Scalars['String']['input']>;
  date_added?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
};

export type SettingsSecurityMutation = {
  title?: InputMaybe<Scalars['String']['input']>;
  csp?: InputMaybe<Array<InputMaybe<SettingsSecurityCspMutation>>>;
  blocked_ips?: InputMaybe<Array<InputMaybe<SettingsSecurityBlocked_IpsMutation>>>;
};

export type SettingsThreeStarOccListMutation = {
  title?: InputMaybe<Scalars['String']['input']>;
  occupations?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type SettingsStatesListTemplateMutation = {
  title?: InputMaybe<Scalars['String']['input']>;
  states?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type SettingsGroupDiCompanyRateTypesRatesMutation = {
  name?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  rate?: InputMaybe<Scalars['Float']['input']>;
};

export type SettingsGroupDiCompanyRateTypesCompaniesMutation = {
  name?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  rateType?: InputMaybe<Scalars['String']['input']>;
  hero?: InputMaybe<Scalars['String']['input']>;
};

export type SettingsGroupDiCompanyRateTypesMutation = {
  title?: InputMaybe<Scalars['String']['input']>;
  rates?: InputMaybe<Array<InputMaybe<SettingsGroupDiCompanyRateTypesRatesMutation>>>;
  companies?: InputMaybe<Array<InputMaybe<SettingsGroupDiCompanyRateTypesCompaniesMutation>>>;
};

export type SettingsNotFoundPageSeoMutation = {
  title?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
};

export type SettingsNotFoundPageImageMutation = {
  src?: InputMaybe<Scalars['String']['input']>;
  width?: InputMaybe<Scalars['Float']['input']>;
  height?: InputMaybe<Scalars['Float']['input']>;
  aspectRatio?: InputMaybe<Scalars['Float']['input']>;
  format?: InputMaybe<Scalars['String']['input']>;
  alt?: InputMaybe<Scalars['String']['input']>;
};

export type SettingsNotFoundPageCtaMutation = {
  label?: InputMaybe<Scalars['String']['input']>;
  link?: InputMaybe<Scalars['String']['input']>;
  ariaLabel?: InputMaybe<Scalars['String']['input']>;
};

export type SettingsNotFoundPageMutation = {
  title?: InputMaybe<Scalars['String']['input']>;
  seo?: InputMaybe<SettingsNotFoundPageSeoMutation>;
  subtitle?: InputMaybe<Scalars['String']['input']>;
  headingText?: InputMaybe<Scalars['String']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<SettingsNotFoundPageImageMutation>;
  cta?: InputMaybe<SettingsNotFoundPageCtaMutation>;
};

export type SettingsAiRatesTableTableRates_By_AgeMutation = {
  age_range?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  rates?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type SettingsAiRatesTableTableMutation = {
  states?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  rates_by_age?: InputMaybe<Array<InputMaybe<SettingsAiRatesTableTableRates_By_AgeMutation>>>;
};

export type SettingsAiRatesTableMutation = {
  title?: InputMaybe<Scalars['String']['input']>;
  table?: InputMaybe<Array<InputMaybe<SettingsAiRatesTableTableMutation>>>;
};

export type SettingsMutation = {
  navigation?: InputMaybe<SettingsNavigationMutation>;
  footer?: InputMaybe<SettingsFooterMutation>;
  site?: InputMaybe<SettingsSiteMutation>;
  redirects?: InputMaybe<SettingsRedirectsMutation>;
  security?: InputMaybe<SettingsSecurityMutation>;
  ThreeStarOccList?: InputMaybe<SettingsThreeStarOccListMutation>;
  StatesListTemplate?: InputMaybe<SettingsStatesListTemplateMutation>;
  GroupDICompanyRateTypes?: InputMaybe<SettingsGroupDiCompanyRateTypesMutation>;
  notFoundPage?: InputMaybe<SettingsNotFoundPageMutation>;
  AIRatesTable?: InputMaybe<SettingsAiRatesTableMutation>;
};

export type FormLtdiManualFormExpertsMutation = {
  imageSrc?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type FormLtdiManualFormMaternityMutation = {
  income?: InputMaybe<Scalars['Float']['input']>;
  minHoursWorked?: InputMaybe<Scalars['Float']['input']>;
  excludedStates?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  calendarURL?: InputMaybe<Scalars['String']['input']>;
};

export type FormLtdiManualFormAltProductCtaMutation = {
  label?: InputMaybe<Scalars['String']['input']>;
  link?: InputMaybe<Scalars['String']['input']>;
};

export type FormLtdiManualFormAltProductMutation = {
  imageSrc?: InputMaybe<Scalars['String']['input']>;
  headingRich?: InputMaybe<Scalars['JSON']['input']>;
  subHeadingRich?: InputMaybe<Scalars['JSON']['input']>;
  textRich?: InputMaybe<Scalars['JSON']['input']>;
  cta?: InputMaybe<FormLtdiManualFormAltProductCtaMutation>;
};

export type FormLtdiManualFormWhitelistOccMutation = {
  list?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type FormLtdiManualFormWhitelistHoursWorkedLimitOccsMutation = {
  list?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type FormLtdiManualFormWhitelistRatingOccMutation = {
  min?: InputMaybe<Scalars['Float']['input']>;
  list?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type FormLtdiManualFormWhitelistMutation = {
  occ?: InputMaybe<FormLtdiManualFormWhitelistOccMutation>;
  hoursWorkedLimitOccs?: InputMaybe<FormLtdiManualFormWhitelistHoursWorkedLimitOccsMutation>;
  ratingOcc?: InputMaybe<FormLtdiManualFormWhitelistRatingOccMutation>;
};

export type FormLtdiManualFormDigitalOccMutation = {
  list?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type FormLtdiManualFormDigitalHealthIssuesMutation = {
  list?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type FormLtdiManualFormDigitalMutation = {
  occ?: InputMaybe<FormLtdiManualFormDigitalOccMutation>;
  healthIssues?: InputMaybe<FormLtdiManualFormDigitalHealthIssuesMutation>;
};

export type FormLtdiManualFormIneligibleIncomeMutation = {
  min?: InputMaybe<Scalars['Float']['input']>;
};

export type FormLtdiManualFormIneligibleOccMutation = {
  list?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type FormLtdiManualFormIneligibleHealthIssuesMutation = {
  list?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type FormLtdiManualFormIneligibleHoursWorkedMutation = {
  min?: InputMaybe<Scalars['Float']['input']>;
};

export type FormLtdiManualFormIneligibleMutation = {
  income?: InputMaybe<FormLtdiManualFormIneligibleIncomeMutation>;
  occ?: InputMaybe<FormLtdiManualFormIneligibleOccMutation>;
  healthIssues?: InputMaybe<FormLtdiManualFormIneligibleHealthIssuesMutation>;
  hoursWorked?: InputMaybe<FormLtdiManualFormIneligibleHoursWorkedMutation>;
};

export type FormLtdiManualFormDeclineDobMutation = {
  min?: InputMaybe<Scalars['Float']['input']>;
  minErrorText?: InputMaybe<Scalars['String']['input']>;
  max?: InputMaybe<Scalars['Float']['input']>;
  maxErrorText?: InputMaybe<Scalars['String']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
};

export type FormLtdiManualFormDeclineIncomeMutation = {
  min?: InputMaybe<Scalars['Float']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
};

export type FormLtdiManualFormDeclineStateMutation = {
  message?: InputMaybe<Scalars['String']['input']>;
  states?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type FormLtdiManualFormDeclineHoursWorkedMutation = {
  min?: InputMaybe<Scalars['Float']['input']>;
};

export type FormLtdiManualFormDeclineFamilyLeaveMutation = {
  message?: InputMaybe<Scalars['String']['input']>;
};

export type FormLtdiManualFormDeclineMutation = {
  headingText?: InputMaybe<Scalars['String']['input']>;
  dob?: InputMaybe<FormLtdiManualFormDeclineDobMutation>;
  income?: InputMaybe<FormLtdiManualFormDeclineIncomeMutation>;
  state?: InputMaybe<FormLtdiManualFormDeclineStateMutation>;
  hoursWorked?: InputMaybe<FormLtdiManualFormDeclineHoursWorkedMutation>;
  familyLeave?: InputMaybe<FormLtdiManualFormDeclineFamilyLeaveMutation>;
};

export type FormLtdiManualFormGenericMutation = {
  headingText?: InputMaybe<Scalars['String']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
};

export type FormLtdiManualFormMutation = {
  dataType?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  incomeLimit?: InputMaybe<Scalars['Float']['input']>;
  bmiLimit?: InputMaybe<Scalars['Float']['input']>;
  flow?: InputMaybe<Scalars['String']['input']>;
  manager?: InputMaybe<Scalars['String']['input']>;
  calendarURL?: InputMaybe<Scalars['String']['input']>;
  physician?: InputMaybe<Scalars['Boolean']['input']>;
  buttonLabel?: InputMaybe<Scalars['String']['input']>;
  experts?: InputMaybe<Array<InputMaybe<FormLtdiManualFormExpertsMutation>>>;
  maternity?: InputMaybe<FormLtdiManualFormMaternityMutation>;
  altProduct?: InputMaybe<FormLtdiManualFormAltProductMutation>;
  whitelist?: InputMaybe<FormLtdiManualFormWhitelistMutation>;
  digital?: InputMaybe<FormLtdiManualFormDigitalMutation>;
  ineligible?: InputMaybe<FormLtdiManualFormIneligibleMutation>;
  decline?: InputMaybe<FormLtdiManualFormDeclineMutation>;
  generic?: InputMaybe<FormLtdiManualFormGenericMutation>;
  healthIssues?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  disclaimer?: InputMaybe<Scalars['JSON']['input']>;
};

export type FormStdiDigitalFormIneligibleDobMutation = {
  min?: InputMaybe<Scalars['Float']['input']>;
  minErrorText?: InputMaybe<Scalars['String']['input']>;
  max?: InputMaybe<Scalars['Float']['input']>;
  maxErrorText?: InputMaybe<Scalars['String']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
};

export type FormStdiDigitalFormIneligibleOccMutation = {
  message?: InputMaybe<Scalars['String']['input']>;
};

export type FormStdiDigitalFormIneligibleIncomeMutation = {
  min?: InputMaybe<Scalars['Float']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
};

export type FormStdiDigitalFormIneligibleHoursWorkedMutation = {
  message?: InputMaybe<Scalars['String']['input']>;
  min?: InputMaybe<Scalars['Float']['input']>;
};

export type FormStdiDigitalFormIneligibleUnemployedMutation = {
  message?: InputMaybe<Scalars['String']['input']>;
};

export type FormStdiDigitalFormIneligibleCitizenOrResidentMutation = {
  message?: InputMaybe<Scalars['String']['input']>;
};

export type FormStdiDigitalFormIneligibleDisabledMutation = {
  message?: InputMaybe<Scalars['String']['input']>;
};

export type FormStdiDigitalFormIneligibleLicenseRevokedMutation = {
  message?: InputMaybe<Scalars['String']['input']>;
};

export type FormStdiDigitalFormIneligibleStateMutation = {
  message?: InputMaybe<Scalars['String']['input']>;
  states?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type FormStdiDigitalFormIneligibleMutation = {
  headingText?: InputMaybe<Scalars['String']['input']>;
  dob?: InputMaybe<FormStdiDigitalFormIneligibleDobMutation>;
  occ?: InputMaybe<FormStdiDigitalFormIneligibleOccMutation>;
  income?: InputMaybe<FormStdiDigitalFormIneligibleIncomeMutation>;
  hoursWorked?: InputMaybe<FormStdiDigitalFormIneligibleHoursWorkedMutation>;
  unemployed?: InputMaybe<FormStdiDigitalFormIneligibleUnemployedMutation>;
  citizenOrResident?: InputMaybe<FormStdiDigitalFormIneligibleCitizenOrResidentMutation>;
  disabled?: InputMaybe<FormStdiDigitalFormIneligibleDisabledMutation>;
  licenseRevoked?: InputMaybe<FormStdiDigitalFormIneligibleLicenseRevokedMutation>;
  state?: InputMaybe<FormStdiDigitalFormIneligibleStateMutation>;
};

export type FormStdiDigitalFormGenericMutation = {
  headingText?: InputMaybe<Scalars['String']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
};

export type FormStdiDigitalFormFamilyCareMutation = {
  label?: InputMaybe<Scalars['String']['input']>;
  content?: InputMaybe<Scalars['JSON']['input']>;
};

export type FormStdiDigitalFormMutation = {
  dataType?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  bmiLimit?: InputMaybe<Scalars['Float']['input']>;
  buttonLabel?: InputMaybe<Scalars['String']['input']>;
  ineligible?: InputMaybe<FormStdiDigitalFormIneligibleMutation>;
  generic?: InputMaybe<FormStdiDigitalFormGenericMutation>;
  familyCare?: InputMaybe<FormStdiDigitalFormFamilyCareMutation>;
  disclaimer?: InputMaybe<Scalars['JSON']['input']>;
};

export type FormLtcManualFormIneligibleDobMutation = {
  min?: InputMaybe<Scalars['Float']['input']>;
  minErrorText?: InputMaybe<Scalars['String']['input']>;
  max?: InputMaybe<Scalars['Float']['input']>;
  maxErrorText?: InputMaybe<Scalars['String']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
};

export type FormLtcManualFormIneligibleOccMutation = {
  message?: InputMaybe<Scalars['String']['input']>;
};

export type FormLtcManualFormIneligibleIncomeMutation = {
  min?: InputMaybe<Scalars['Float']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
};

export type FormLtcManualFormIneligibleStateMutation = {
  message?: InputMaybe<Scalars['String']['input']>;
  states?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type FormLtcManualFormIneligibleMutation = {
  headingText?: InputMaybe<Scalars['String']['input']>;
  dob?: InputMaybe<FormLtcManualFormIneligibleDobMutation>;
  occ?: InputMaybe<FormLtcManualFormIneligibleOccMutation>;
  income?: InputMaybe<FormLtcManualFormIneligibleIncomeMutation>;
  state?: InputMaybe<FormLtcManualFormIneligibleStateMutation>;
};

export type FormLtcManualFormGenericMutation = {
  headingText?: InputMaybe<Scalars['String']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
};

export type FormLtcManualFormMutation = {
  dataType?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  incomeLimit?: InputMaybe<Scalars['Float']['input']>;
  manager?: InputMaybe<Scalars['String']['input']>;
  calendarURL?: InputMaybe<Scalars['String']['input']>;
  buttonLabel?: InputMaybe<Scalars['String']['input']>;
  ineligible?: InputMaybe<FormLtcManualFormIneligibleMutation>;
  generic?: InputMaybe<FormLtcManualFormGenericMutation>;
  disclaimer?: InputMaybe<Scalars['JSON']['input']>;
};

export type FormCiFormIneligibleDobMutation = {
  min?: InputMaybe<Scalars['Float']['input']>;
  minErrorText?: InputMaybe<Scalars['String']['input']>;
  max?: InputMaybe<Scalars['Float']['input']>;
  maxErrorText?: InputMaybe<Scalars['String']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
};

export type FormCiFormIneligibleStateMutation = {
  message?: InputMaybe<Scalars['String']['input']>;
  states?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type FormCiFormIneligibleReplacingMutation = {
  message?: InputMaybe<Scalars['String']['input']>;
};

export type FormCiFormIneligibleHadCancerMutation = {
  message?: InputMaybe<Scalars['String']['input']>;
};

export type FormCiFormIneligibleMutation = {
  headingText?: InputMaybe<Scalars['String']['input']>;
  dob?: InputMaybe<FormCiFormIneligibleDobMutation>;
  state?: InputMaybe<FormCiFormIneligibleStateMutation>;
  replacing?: InputMaybe<FormCiFormIneligibleReplacingMutation>;
  hadCancer?: InputMaybe<FormCiFormIneligibleHadCancerMutation>;
};

export type FormCiFormGenericMutation = {
  headingText?: InputMaybe<Scalars['String']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
};

export type FormCiFormMutation = {
  dataType?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  flow?: InputMaybe<Scalars['String']['input']>;
  buttonLabel?: InputMaybe<Scalars['String']['input']>;
  enableContacts?: InputMaybe<Scalars['Boolean']['input']>;
  ineligible?: InputMaybe<FormCiFormIneligibleMutation>;
  generic?: InputMaybe<FormCiFormGenericMutation>;
  disclaimer?: InputMaybe<Scalars['JSON']['input']>;
};

export type FormAeiFormPopupMutation = {
  icon?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  link?: InputMaybe<Scalars['String']['input']>;
  hint?: InputMaybe<Scalars['String']['input']>;
};

export type FormAeiFormIneligibleAgeMutation = {
  min?: InputMaybe<Scalars['Float']['input']>;
  minErrorText?: InputMaybe<Scalars['String']['input']>;
  max?: InputMaybe<Scalars['Float']['input']>;
  maxErrorText?: InputMaybe<Scalars['String']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
};

export type FormAeiFormIneligibleStateMutation = {
  message?: InputMaybe<Scalars['String']['input']>;
  states?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type FormAeiFormIneligibleMutation = {
  headingText?: InputMaybe<Scalars['String']['input']>;
  age?: InputMaybe<FormAeiFormIneligibleAgeMutation>;
  state?: InputMaybe<FormAeiFormIneligibleStateMutation>;
};

export type FormAeiFormGenericMutation = {
  headingText?: InputMaybe<Scalars['String']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
};

export type FormAeiFormMutation = {
  dataType?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  flow?: InputMaybe<Scalars['String']['input']>;
  buttonLabel?: InputMaybe<Scalars['String']['input']>;
  popup?: InputMaybe<Array<InputMaybe<FormAeiFormPopupMutation>>>;
  ineligible?: InputMaybe<FormAeiFormIneligibleMutation>;
  generic?: InputMaybe<FormAeiFormGenericMutation>;
  disclaimer?: InputMaybe<Scalars['JSON']['input']>;
};

export type FormGroupDiFormIneligibleMinEmployeesMutation = {
  min?: InputMaybe<Scalars['Float']['input']>;
  headingText?: InputMaybe<Scalars['String']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  buttonLabel?: InputMaybe<Scalars['String']['input']>;
  buttonLink?: InputMaybe<Scalars['String']['input']>;
};

export type FormGroupDiFormIneligibleMutation = {
  minEmployees?: InputMaybe<FormGroupDiFormIneligibleMinEmployeesMutation>;
};

export type FormGroupDiFormGenericMutation = {
  headingText?: InputMaybe<Scalars['String']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
};

export type FormGroupDiFormMutation = {
  dataType?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  calendarURL?: InputMaybe<Scalars['String']['input']>;
  buttonLabel?: InputMaybe<Scalars['String']['input']>;
  isInternal?: InputMaybe<Scalars['Boolean']['input']>;
  internalCalendarURL?: InputMaybe<Scalars['String']['input']>;
  ineligible?: InputMaybe<FormGroupDiFormIneligibleMutation>;
  generic?: InputMaybe<FormGroupDiFormGenericMutation>;
  disclaimer?: InputMaybe<Scalars['JSON']['input']>;
};

export type FormLtdiDropticketFormThankyouMutation = {
  headingText?: InputMaybe<Scalars['String']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
};

export type FormLtdiDropticketFormIneligibleDobMutation = {
  min?: InputMaybe<Scalars['Float']['input']>;
  minErrorText?: InputMaybe<Scalars['String']['input']>;
  max?: InputMaybe<Scalars['Float']['input']>;
  maxErrorText?: InputMaybe<Scalars['String']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
};

export type FormLtdiDropticketFormIneligibleOccMutation = {
  message?: InputMaybe<Scalars['String']['input']>;
};

export type FormLtdiDropticketFormIneligibleIncomeMutation = {
  min?: InputMaybe<Scalars['Float']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
};

export type FormLtdiDropticketFormIneligibleStateMutation = {
  message?: InputMaybe<Scalars['String']['input']>;
  states?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type FormLtdiDropticketFormIneligibleMutation = {
  headingText?: InputMaybe<Scalars['String']['input']>;
  dob?: InputMaybe<FormLtdiDropticketFormIneligibleDobMutation>;
  occ?: InputMaybe<FormLtdiDropticketFormIneligibleOccMutation>;
  income?: InputMaybe<FormLtdiDropticketFormIneligibleIncomeMutation>;
  state?: InputMaybe<FormLtdiDropticketFormIneligibleStateMutation>;
};

export type FormLtdiDropticketFormGenericMutation = {
  headingText?: InputMaybe<Scalars['String']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
};

export type FormLtdiDropticketFormMutation = {
  dataType?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  partner?: InputMaybe<Scalars['String']['input']>;
  manager?: InputMaybe<Scalars['String']['input']>;
  calendarURL?: InputMaybe<Scalars['String']['input']>;
  buttonLabel?: InputMaybe<Scalars['String']['input']>;
  thankyou?: InputMaybe<FormLtdiDropticketFormThankyouMutation>;
  ineligible?: InputMaybe<FormLtdiDropticketFormIneligibleMutation>;
  generic?: InputMaybe<FormLtdiDropticketFormGenericMutation>;
  disclaimer?: InputMaybe<Scalars['JSON']['input']>;
};

export type FormLtcDropticketFormThankyouMutation = {
  headingText?: InputMaybe<Scalars['String']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
};

export type FormLtcDropticketFormIneligibleDobMutation = {
  min?: InputMaybe<Scalars['Float']['input']>;
  minErrorText?: InputMaybe<Scalars['String']['input']>;
  max?: InputMaybe<Scalars['Float']['input']>;
  maxErrorText?: InputMaybe<Scalars['String']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
};

export type FormLtcDropticketFormIneligibleIncomeMutation = {
  min?: InputMaybe<Scalars['Float']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
};

export type FormLtcDropticketFormIneligibleStateMutation = {
  message?: InputMaybe<Scalars['String']['input']>;
  states?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type FormLtcDropticketFormIneligibleMutation = {
  headingText?: InputMaybe<Scalars['String']['input']>;
  dob?: InputMaybe<FormLtcDropticketFormIneligibleDobMutation>;
  income?: InputMaybe<FormLtcDropticketFormIneligibleIncomeMutation>;
  state?: InputMaybe<FormLtcDropticketFormIneligibleStateMutation>;
};

export type FormLtcDropticketFormGenericMutation = {
  headingText?: InputMaybe<Scalars['String']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
};

export type FormLtcDropticketFormMutation = {
  dataType?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  partner?: InputMaybe<Scalars['String']['input']>;
  manager?: InputMaybe<Scalars['String']['input']>;
  calendarURL?: InputMaybe<Scalars['String']['input']>;
  buttonLabel?: InputMaybe<Scalars['String']['input']>;
  thankyou?: InputMaybe<FormLtcDropticketFormThankyouMutation>;
  ineligible?: InputMaybe<FormLtcDropticketFormIneligibleMutation>;
  generic?: InputMaybe<FormLtcDropticketFormGenericMutation>;
  disclaimer?: InputMaybe<Scalars['JSON']['input']>;
};

export type FormGroupDiCalculatorFormHeadingsMutation = {
  mainRich?: InputMaybe<Scalars['JSON']['input']>;
  contributionRich?: InputMaybe<Scalars['JSON']['input']>;
};

export type FormGroupDiCalculatorFormDefaultsMutation = {
  numberOfEmployees?: InputMaybe<Scalars['Float']['input']>;
  contributionPercent?: InputMaybe<Scalars['Float']['input']>;
  companyType?: InputMaybe<Scalars['String']['input']>;
};

export type FormGroupDiCalculatorFormMutation = {
  dataType?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  headings?: InputMaybe<FormGroupDiCalculatorFormHeadingsMutation>;
  defaults?: InputMaybe<FormGroupDiCalculatorFormDefaultsMutation>;
  detailsRich?: InputMaybe<Scalars['JSON']['input']>;
};

export type FormAgentSignupFormThankyouMutation = {
  headingText?: InputMaybe<Scalars['String']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
};

export type FormAgentSignupFormIneligibleStateMutation = {
  message?: InputMaybe<Scalars['String']['input']>;
  states?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type FormAgentSignupFormIneligibleMutation = {
  headingText?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<FormAgentSignupFormIneligibleStateMutation>;
};

export type FormAgentSignupFormGenericMutation = {
  headingText?: InputMaybe<Scalars['String']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
};

export type FormAgentSignupFormMutation = {
  dataType?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  heading?: InputMaybe<Scalars['String']['input']>;
  buttonLabel?: InputMaybe<Scalars['String']['input']>;
  textRich?: InputMaybe<Scalars['JSON']['input']>;
  thankyou?: InputMaybe<FormAgentSignupFormThankyouMutation>;
  ineligible?: InputMaybe<FormAgentSignupFormIneligibleMutation>;
  generic?: InputMaybe<FormAgentSignupFormGenericMutation>;
};

export type FormAgentSimpleFormThankyouMutation = {
  headingText?: InputMaybe<Scalars['String']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
};

export type FormAgentSimpleFormGenericMutation = {
  headingText?: InputMaybe<Scalars['String']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
};

export type FormAgentSimpleFormMutation = {
  dataType?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  buttonLabel?: InputMaybe<Scalars['String']['input']>;
  intent?: InputMaybe<Scalars['String']['input']>;
  thankyou?: InputMaybe<FormAgentSimpleFormThankyouMutation>;
  generic?: InputMaybe<FormAgentSimpleFormGenericMutation>;
};

export type FormMutation = {
  LTDIManualForm?: InputMaybe<FormLtdiManualFormMutation>;
  STDIDigitalForm?: InputMaybe<FormStdiDigitalFormMutation>;
  LTCManualForm?: InputMaybe<FormLtcManualFormMutation>;
  CIForm?: InputMaybe<FormCiFormMutation>;
  AEIForm?: InputMaybe<FormAeiFormMutation>;
  GroupDIForm?: InputMaybe<FormGroupDiFormMutation>;
  LTDIDropticketForm?: InputMaybe<FormLtdiDropticketFormMutation>;
  LTCDropticketForm?: InputMaybe<FormLtcDropticketFormMutation>;
  GroupDICalculatorForm?: InputMaybe<FormGroupDiCalculatorFormMutation>;
  AgentSignupForm?: InputMaybe<FormAgentSignupFormMutation>;
  AgentSimpleForm?: InputMaybe<FormAgentSimpleFormMutation>;
};

export type ManagerManagedProductsContentsMutation = {
  type?: InputMaybe<Scalars['String']['input']>;
  heading?: InputMaybe<Scalars['String']['input']>;
  subHeading?: InputMaybe<Scalars['String']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
};

export type ManagerManagedProductsRatingMutation = {
  min?: InputMaybe<Scalars['Float']['input']>;
  max?: InputMaybe<Scalars['Float']['input']>;
};

export type ManagerManagedProductsMutation = {
  product?: InputMaybe<Scalars['String']['input']>;
  calendlyUrl?: InputMaybe<Scalars['String']['input']>;
  ycbmUrl?: InputMaybe<Scalars['String']['input']>;
  contents?: InputMaybe<Array<InputMaybe<ManagerManagedProductsContentsMutation>>>;
  rating?: InputMaybe<ManagerManagedProductsRatingMutation>;
  states?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ManagerMutation = {
  title?: InputMaybe<Scalars['String']['input']>;
  slackMentionId?: InputMaybe<Scalars['String']['input']>;
  referralName?: InputMaybe<Scalars['String']['input']>;
  salesPersonId?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  isFallback?: InputMaybe<Scalars['Boolean']['input']>;
  imageSrc?: InputMaybe<Scalars['String']['input']>;
  managedProducts?: InputMaybe<Array<InputMaybe<ManagerManagedProductsMutation>>>;
};

export type SpecialPageProposalSpecialPageSeoMutation = {
  title?: InputMaybe<Scalars['String']['input']>;
};

export type SpecialPageProposalSpecialPageContentSectionHeroProposalListsMutation = {
  title?: InputMaybe<Scalars['String']['input']>;
  items?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type SpecialPageProposalSpecialPageContentSectionHeroProposalLogosMutation = {
  highlightImgSrc?: InputMaybe<Scalars['String']['input']>;
  highlightText?: InputMaybe<Scalars['String']['input']>;
  logosText?: InputMaybe<Scalars['String']['input']>;
  logosList?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type SpecialPageProposalSpecialPageContentSectionHeroProposalImageMutation = {
  src?: InputMaybe<Scalars['String']['input']>;
  width?: InputMaybe<Scalars['Float']['input']>;
  height?: InputMaybe<Scalars['Float']['input']>;
  aspectRatio?: InputMaybe<Scalars['Float']['input']>;
  format?: InputMaybe<Scalars['String']['input']>;
  alt?: InputMaybe<Scalars['String']['input']>;
  scale?: InputMaybe<Scalars['Float']['input']>;
};

export type SpecialPageProposalSpecialPageContentSectionHeroProposalButtonsMutation = {
  label?: InputMaybe<Scalars['String']['input']>;
  link?: InputMaybe<Scalars['String']['input']>;
  ariaLabel?: InputMaybe<Scalars['String']['input']>;
};

export type SpecialPageProposalSpecialPageContentSectionHeroProposalFloatingItemsSingleIconLinkItemMutation = {
  icon?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
  link?: InputMaybe<Scalars['String']['input']>;
};

export type SpecialPageProposalSpecialPageContentSectionHeroProposalFloatingItemsSingleIconTextItemMutation = {
  icon?: InputMaybe<Scalars['String']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
};

export type SpecialPageProposalSpecialPageContentSectionHeroProposalFloatingItemsGroupedIconTextItemItemsMutation = {
  icon?: InputMaybe<Scalars['String']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
};

export type SpecialPageProposalSpecialPageContentSectionHeroProposalFloatingItemsGroupedIconTextItemMutation = {
  items?: InputMaybe<Array<InputMaybe<SpecialPageProposalSpecialPageContentSectionHeroProposalFloatingItemsGroupedIconTextItemItemsMutation>>>;
};

export type SpecialPageProposalSpecialPageContentSectionHeroProposalFloatingItemsSingleImageTextItemMutation = {
  image?: InputMaybe<Scalars['String']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
};

export type SpecialPageProposalSpecialPageContentSectionHeroProposalFloatingItemsGroupedImageTextItemItemsMutation = {
  image?: InputMaybe<Scalars['String']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
};

export type SpecialPageProposalSpecialPageContentSectionHeroProposalFloatingItemsGroupedImageTextItemMutation = {
  items?: InputMaybe<Array<InputMaybe<SpecialPageProposalSpecialPageContentSectionHeroProposalFloatingItemsGroupedImageTextItemItemsMutation>>>;
};

export type SpecialPageProposalSpecialPageContentSectionHeroProposalFloatingItemsSingleImageItemMutation = {
  image?: InputMaybe<Scalars['String']['input']>;
};

export type SpecialPageProposalSpecialPageContentSectionHeroProposalFloatingItemsMutation = {
  singleIconLinkItem?: InputMaybe<SpecialPageProposalSpecialPageContentSectionHeroProposalFloatingItemsSingleIconLinkItemMutation>;
  singleIconTextItem?: InputMaybe<SpecialPageProposalSpecialPageContentSectionHeroProposalFloatingItemsSingleIconTextItemMutation>;
  groupedIconTextItem?: InputMaybe<SpecialPageProposalSpecialPageContentSectionHeroProposalFloatingItemsGroupedIconTextItemMutation>;
  singleImageTextItem?: InputMaybe<SpecialPageProposalSpecialPageContentSectionHeroProposalFloatingItemsSingleImageTextItemMutation>;
  groupedImageTextItem?: InputMaybe<SpecialPageProposalSpecialPageContentSectionHeroProposalFloatingItemsGroupedImageTextItemMutation>;
  singleImageItem?: InputMaybe<SpecialPageProposalSpecialPageContentSectionHeroProposalFloatingItemsSingleImageItemMutation>;
};

export type SpecialPageProposalSpecialPageContentSectionHeroProposalMutation = {
  title?: InputMaybe<Scalars['String']['input']>;
  headingSize?: InputMaybe<Scalars['String']['input']>;
  headingRich?: InputMaybe<Scalars['JSON']['input']>;
  subheadingRich?: InputMaybe<Scalars['JSON']['input']>;
  textRich?: InputMaybe<Scalars['JSON']['input']>;
  lists?: InputMaybe<Array<InputMaybe<SpecialPageProposalSpecialPageContentSectionHeroProposalListsMutation>>>;
  logos?: InputMaybe<SpecialPageProposalSpecialPageContentSectionHeroProposalLogosMutation>;
  image?: InputMaybe<SpecialPageProposalSpecialPageContentSectionHeroProposalImageMutation>;
  buttons?: InputMaybe<Array<InputMaybe<SpecialPageProposalSpecialPageContentSectionHeroProposalButtonsMutation>>>;
  floatingItems?: InputMaybe<Array<InputMaybe<SpecialPageProposalSpecialPageContentSectionHeroProposalFloatingItemsMutation>>>;
};

export type SpecialPageProposalSpecialPageContentSectionLogosImagesMutation = {
  image?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type SpecialPageProposalSpecialPageContentSectionLogosMutation = {
  headingText?: InputMaybe<Scalars['String']['input']>;
  images?: InputMaybe<Array<InputMaybe<SpecialPageProposalSpecialPageContentSectionLogosImagesMutation>>>;
};

export type SpecialPageProposalSpecialPageContentSectionImageBrzImageMutation = {
  title?: InputMaybe<Scalars['String']['input']>;
  src?: InputMaybe<Scalars['String']['input']>;
  width?: InputMaybe<Scalars['Float']['input']>;
  height?: InputMaybe<Scalars['Float']['input']>;
  aspectRatio?: InputMaybe<Scalars['Float']['input']>;
  format?: InputMaybe<Scalars['String']['input']>;
  alt?: InputMaybe<Scalars['String']['input']>;
  radius?: InputMaybe<Scalars['Float']['input']>;
};

export type SpecialPageProposalSpecialPageContentSectionImageMutation = {
  brzImage?: InputMaybe<SpecialPageProposalSpecialPageContentSectionImageBrzImageMutation>;
  scrollable?: InputMaybe<Scalars['Boolean']['input']>;
  spacing?: InputMaybe<Scalars['Float']['input']>;
  maxWidth?: InputMaybe<Scalars['String']['input']>;
  align?: InputMaybe<Scalars['String']['input']>;
};

export type SpecialPageProposalSpecialPageContentSectionHeadingMutation = {
  align?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  headingLevel?: InputMaybe<Scalars['String']['input']>;
  headingText?: InputMaybe<Scalars['String']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
  marginBottom?: InputMaybe<Scalars['String']['input']>;
};

export type SpecialPageProposalSpecialPageContentSectionSideStatsItemsMutation = {
  icon?: InputMaybe<Scalars['String']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
};

export type SpecialPageProposalSpecialPageContentSectionSideStatsMutation = {
  headingText?: InputMaybe<Scalars['String']['input']>;
  textRich?: InputMaybe<Scalars['JSON']['input']>;
  items?: InputMaybe<Array<InputMaybe<SpecialPageProposalSpecialPageContentSectionSideStatsItemsMutation>>>;
};

export type SpecialPageProposalSpecialPageContentMutation = {
  SectionHeroProposal?: InputMaybe<SpecialPageProposalSpecialPageContentSectionHeroProposalMutation>;
  SectionLogos?: InputMaybe<SpecialPageProposalSpecialPageContentSectionLogosMutation>;
  SectionImage?: InputMaybe<SpecialPageProposalSpecialPageContentSectionImageMutation>;
  SectionHeading?: InputMaybe<SpecialPageProposalSpecialPageContentSectionHeadingMutation>;
  SectionSideStats?: InputMaybe<SpecialPageProposalSpecialPageContentSectionSideStatsMutation>;
};

export type SpecialPageProposalSpecialPageQuoteHelpTipMutation = {
  headingText?: InputMaybe<Scalars['String']['input']>;
  contentRich?: InputMaybe<Scalars['JSON']['input']>;
};

export type SpecialPageProposalSpecialPageQuoteNotFoundErrorMutation = {
  headingText?: InputMaybe<Scalars['String']['input']>;
  textRich?: InputMaybe<Scalars['JSON']['input']>;
};

export type SpecialPageProposalSpecialPageQuoteGenericErrorMutation = {
  headingText?: InputMaybe<Scalars['String']['input']>;
  textRich?: InputMaybe<Scalars['JSON']['input']>;
};

export type SpecialPageProposalSpecialPageQuoteAnnuityColumnsMutation = {
  label?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type SpecialPageProposalSpecialPageQuoteAnnuityMutation = {
  headingText?: InputMaybe<Scalars['String']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
  productName?: InputMaybe<Scalars['String']['input']>;
  columns?: InputMaybe<Array<InputMaybe<SpecialPageProposalSpecialPageQuoteAnnuityColumnsMutation>>>;
  incomeLabel?: InputMaybe<Scalars['String']['input']>;
};

export type SpecialPageProposalSpecialPageQuoteMutation = {
  headingText?: InputMaybe<Scalars['String']['input']>;
  subheadingRich?: InputMaybe<Scalars['JSON']['input']>;
  helpTip?: InputMaybe<SpecialPageProposalSpecialPageQuoteHelpTipMutation>;
  addonsHeadingText?: InputMaybe<Scalars['String']['input']>;
  notFoundError?: InputMaybe<SpecialPageProposalSpecialPageQuoteNotFoundErrorMutation>;
  genericError?: InputMaybe<SpecialPageProposalSpecialPageQuoteGenericErrorMutation>;
  annuity?: InputMaybe<SpecialPageProposalSpecialPageQuoteAnnuityMutation>;
};

export type SpecialPageProposalSpecialPageMutation = {
  previewURL?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  seo?: InputMaybe<SpecialPageProposalSpecialPageSeoMutation>;
  content?: InputMaybe<Array<InputMaybe<SpecialPageProposalSpecialPageContentMutation>>>;
  quote?: InputMaybe<SpecialPageProposalSpecialPageQuoteMutation>;
  disclaimer?: InputMaybe<Scalars['JSON']['input']>;
};

export type SpecialPageIneligibleSpecialPageSeoMutation = {
  title?: InputMaybe<Scalars['String']['input']>;
};

export type SpecialPageIneligibleSpecialPageAccidentMutation = {
  imgSrc?: InputMaybe<Scalars['String']['input']>;
  headingRich?: InputMaybe<Scalars['JSON']['input']>;
  subheadingRich?: InputMaybe<Scalars['JSON']['input']>;
  textRich?: InputMaybe<Scalars['JSON']['input']>;
  ctaLabel?: InputMaybe<Scalars['String']['input']>;
};

export type SpecialPageIneligibleSpecialPageIneligibleProductsMutation = {
  title?: InputMaybe<Scalars['String']['input']>;
  ref?: InputMaybe<Scalars['String']['input']>;
};

export type SpecialPageIneligibleSpecialPageIneligibleMutation = {
  headingRich?: InputMaybe<Scalars['JSON']['input']>;
  subheadingRich?: InputMaybe<Scalars['JSON']['input']>;
  textRich?: InputMaybe<Scalars['JSON']['input']>;
  products?: InputMaybe<Array<InputMaybe<SpecialPageIneligibleSpecialPageIneligibleProductsMutation>>>;
};

export type SpecialPageIneligibleSpecialPageMutation = {
  previewURL?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  seo?: InputMaybe<SpecialPageIneligibleSpecialPageSeoMutation>;
  accident?: InputMaybe<SpecialPageIneligibleSpecialPageAccidentMutation>;
  ineligible?: InputMaybe<SpecialPageIneligibleSpecialPageIneligibleMutation>;
};

export type SpecialPageMutation = {
  ProposalSpecialPage?: InputMaybe<SpecialPageProposalSpecialPageMutation>;
  IneligibleSpecialPage?: InputMaybe<SpecialPageIneligibleSpecialPageMutation>;
};

type PageParts_PageGeneric_Fragment = { __typename: 'PageGeneric', component?: string | null, updatedDate?: string | null, publishedDate?: string | null, title: string, settings?: { __typename: 'PageGenericSettings', publish?: { __typename: 'PageGenericSettingsPublish', published?: boolean | null, publishedDate?: string | null } | null, seo?: { __typename: 'PageGenericSettingsSeo', title?: string | null, url?: string | null, description?: string | null, image?: { __typename: 'PageBlogSettingsSeoImage', src?: string | null, width?: number | null, height?: number | null, aspectRatio?: number | null, format?: string | null, alt?: string | null } | null, org?: { __typename: 'PageBlogSettingsSeoOrg', disable?: boolean | null } | null, faq?: { __typename: 'PageBlogSettingsSeoFaq', disable?: boolean | null, name?: string | null, items?: Array<{ __typename: 'PageFormSettingsSeoFaqItems', q?: string | null, a?: string | null } | null> | null } | null, howTo?: { __typename: 'PageBlogSettingsSeoHowTo', disable?: boolean | null, name?: string | null, description?: string | null, image?: { __typename: 'PageFormSettingsSeoHowToImage', src?: string | null, width?: number | null, height?: number | null, aspectRatio?: number | null, format?: string | null, alt?: string | null } | null, steps?: Array<{ __typename: 'PageFormSettingsSeoHowToSteps', name?: string | null, url?: string | null, text?: string | null } | null> | null } | null } | null, sitemap?: { __typename: 'PageGenericSettingsSitemap', exclude?: boolean | null, breadcrumb?: string | null, changefreq?: string | null, priority?: number | null } | null, navigation?: { __typename: 'PageGenericSettingsNavigation', disableLogo?: boolean | null, disableLeft?: boolean | null, disableRight?: boolean | null, disableButtons?: boolean | null, rightSideButtonOverride?: { __typename: 'PageBlogSettingsNavigationRightSideButtonOverride', label?: string | null, link?: string | null, ariaLabel?: string | null } | null } | null, footer?: { __typename: 'PageGenericSettingsFooter', disableLinks?: boolean | null, disableBottom?: boolean | null } | null, disclaimer?: { __typename: 'PageGenericSettingsDisclaimer', disable?: boolean | null, content?: any | null } | null, partner?: { __typename: 'PageGenericSettingsPartner' } | null, client?: { __typename: 'PageGenericSettingsClient', enabled?: boolean | null } | null } | null, content?: Array<{ __typename: 'PageGenericContentSectionHeroGeneric', title?: string | null, headingSize?: string | null, headingRich?: any | null, subheadingRich?: any | null, textRich?: any | null, lists?: Array<{ __typename: 'PageGenericContentSectionHeroGenericLists', title?: string | null, items?: Array<string | null> | null } | null> | null, image?: { __typename: 'PageGenericContentSectionHeroGenericImage', src?: string | null, width?: number | null, height?: number | null, aspectRatio?: number | null, format?: string | null, alt?: string | null, scale?: number | null } | null, buttons?: Array<{ __typename: 'PageGenericContentSectionHeroGenericButtons', label?: string | null, link?: string | null, ariaLabel?: string | null } | null> | null, floatingItems?: Array<{ __typename: 'PageGenericContentSectionHeroGenericFloatingItemsSingleIconLinkItem', icon?: string | null, title?: string | null, text?: string | null, link?: string | null } | { __typename: 'PageGenericContentSectionHeroGenericFloatingItemsSingleIconTextItem', icon?: string | null, text?: string | null } | { __typename: 'PageGenericContentSectionHeroGenericFloatingItemsGroupedIconTextItem', items?: Array<{ __typename: 'PageGenericContentSectionHeroGenericFloatingItemsGroupedIconTextItemItems', icon?: string | null, text?: string | null } | null> | null } | { __typename: 'PageGenericContentSectionHeroGenericFloatingItemsSingleImageTextItem', image?: string | null, text?: string | null } | { __typename: 'PageGenericContentSectionHeroGenericFloatingItemsGroupedImageTextItem', items?: Array<{ __typename: 'PageGenericContentSectionHeroGenericFloatingItemsGroupedImageTextItemItems', image?: string | null, text?: string | null } | null> | null } | { __typename: 'PageGenericContentSectionHeroGenericFloatingItemsSingleImageItem', image?: string | null } | null> | null } | { __typename: 'PageGenericContentSectionHeroAgent', headingRich?: any | null, fallbackHeadingRich?: any | null, textRich?: any | null, image?: { __typename: 'PageGenericContentSectionHeroAgentImage', src?: string | null, width?: number | null, height?: number | null, aspectRatio?: number | null, format?: string | null, alt?: string | null } | null, defaultProducts?: Array<{ __typename: 'PageGenericContentSectionHeroAgentDefaultProducts' } | null> | null, display?: { __typename: 'PageGenericContentSectionHeroAgentDisplay', icon?: boolean | null, graphic?: boolean | null, actionLabel?: boolean | null, descriptionText?: boolean | null, descriptionItems?: boolean | null, disclaimer?: boolean | null, buttons?: boolean | null } | null } | { __typename: 'PageGenericContentSectionLogos', headingText?: string | null, images?: Array<{ __typename: 'PageGenericContentSectionLogosImages', image?: string | null, title?: string | null } | null> | null } | { __typename: 'PageGenericContentSectionBadges', title?: string | null, badges?: Array<{ __typename: 'PageGenericContentSectionBadgesBadges', image?: string | null, text?: string | null } | null> | null } | { __typename: 'PageGenericContentSectionTestimonialSlider', title?: string | null, headingRich?: any | null, highlight?: string | null, textRich?: any | null, items?: Array<{ __typename: 'PageGenericContentSectionTestimonialSliderItems' } | null> | null } | { __typename: 'PageGenericContentSectionTestimonialGrid', headingText?: string | null, items?: Array<{ __typename: 'PageGenericContentSectionTestimonialGridItems' } | null> | null } | { __typename: 'PageGenericContentSectionFloatingCta', headingText?: string | null, text?: string | null, buttons?: Array<{ __typename: 'PageGenericContentSectionFloatingCtaButtons', label?: string | null, link?: string | null, ariaLabel?: string | null } | null> | null } | { __typename: 'PageGenericContentSectionImageCta', headingText?: string | null, text?: string | null, imageSrc?: string | null, buttons?: Array<{ __typename: 'PageGenericContentSectionImageCtaButtons', label?: string | null, link?: string | null, ariaLabel?: string | null } | null> | null } | { __typename: 'PageGenericContentSectionProducts', headingRich?: any | null, text?: string | null, title?: string | null, items?: Array<{ __typename: 'PageGenericContentSectionProductsItems' } | null> | null, display?: { __typename: 'PageGenericContentSectionProductsDisplay', icon?: boolean | null, graphic?: boolean | null, actionLabel?: boolean | null, descriptionText?: boolean | null, descriptionItems?: boolean | null, disclaimer?: boolean | null, buttons?: boolean | null } | null } | { __typename: 'PageGenericContentSectionProductsSimple', items?: Array<{ __typename: 'PageGenericContentSectionProductsSimpleItems' } | null> | null, display?: { __typename: 'PageGenericContentSectionProductsSimpleDisplay', actionLabel?: boolean | null, descriptionText?: boolean | null, descriptionItems?: boolean | null, disclaimer?: boolean | null, buttons?: boolean | null } | null } | { __typename: 'PageGenericContentSectionHowItWorks', title?: string | null, headingText?: string | null, active?: number | null, items?: Array<{ __typename: 'PageGenericContentSectionHowItWorksItems', image?: string | null, headingText?: string | null, subheadingText?: string | null, text?: string | null, button?: { __typename: 'PageGenericContentSectionHowItWorksItemsButton', label?: string | null, link?: string | null, ariaLabel?: string | null } | null } | null> | null, display?: { __typename: 'PageGenericContentSectionHowItWorksDisplay', number?: boolean | null } | null } | { __typename: 'PageGenericContentSectionIconColumns', title?: string | null, headingText?: string | null, subheadingText?: string | null, colNum?: number | null, colSpacing?: number | null, bgColor?: string | null, cols?: Array<{ __typename: 'PageGenericContentSectionIconColumnsCols', imageSrc?: string | null, disableIconBg?: boolean | null, size?: number | null, title?: string | null, titleSize?: string | null, text?: string | null } | null> | null } | { __typename: 'PageGenericContentSectionBlogPosts', title?: string | null, headingText?: string | null, posts?: Array<{ __typename: 'PageGenericContentSectionBlogPostsPosts' } | null> | null } | { __typename: 'PageGenericContentSectionArticles', title?: string | null, headingText?: string | null, posts?: Array<{ __typename: 'PageGenericContentSectionArticlesPosts' } | null> | null } | { __typename: 'PageGenericContentSectionCtaArticles', posts?: Array<{ __typename: 'PageGenericContentSectionCtaArticlesPosts', tag?: string | null, headingText?: string | null, imageSrc?: string | null, cta?: { __typename: 'PageGenericContentSectionCtaArticlesPostsCta', label?: string | null, link?: string | null } | null } | null> | null } | { __typename: 'PageGenericContentSectionHelpfulArticles', title?: string | null, cta?: { __typename: 'PageGenericContentSectionHelpfulArticlesCta', headingText?: string | null, imageSrc?: string | null, button?: { __typename: 'PageGenericContentSectionHelpfulArticlesCtaButton', label?: string | null, link?: string | null } | null } | null, posts?: Array<{ __typename: 'PageGenericContentSectionHelpfulArticlesPosts' } | null> | null } | { __typename: 'PageGenericContentSectionStats', title?: string | null, headingText?: string | null, secondaryHeading?: any | null, text?: string | null, imageSrc?: string | null, items?: Array<{ __typename: 'PageGenericContentSectionStatsItems', number?: number | null, unit?: string | null, text?: string | null } | null> | null, button?: { __typename: 'PageGenericContentSectionStatsButton', label?: string | null, link?: string | null, ariaLabel?: string | null } | null, quote?: { __typename: 'PageGenericContentSectionStatsQuote', text?: string | null, author?: string | null, title?: string | null } | null } | { __typename: 'PageGenericContentSectionResources', title?: string | null, headingText?: string | null, imageSrc?: string | null, groups?: Array<{ __typename: 'PageGenericContentSectionResourcesGroups', title?: string | null, items?: Array<{ __typename: 'PageGenericContentSectionResourcesGroupsItems', label?: string | null, link?: string | null, ariaLabel?: string | null } | null> | null } | null> | null } | { __typename: 'PageGenericContentSectionResourceHub', title?: string | null, headingText?: string | null, imageSrc?: string | null, groups?: Array<{ __typename: 'PageGenericContentSectionResourceHubGroups', title?: string | null, tocTitle?: string | null, articles?: Array<{ __typename: 'PageGenericContentSectionResourceHubGroupsArticles', title?: string | null, textRich?: any | null, link?: { __typename: 'PageGenericContentSectionResourceHubGroupsArticlesLink', label?: string | null, link?: string | null, ariaLabel?: string | null } | null } | null> | null } | null> | null } | { __typename: 'PageGenericContentSectionFileResources', filterSettings?: { __typename: 'PageGenericContentSectionFileResourcesFilterSettings', title?: string | null, resetLabel?: string | null, noItemsMessage?: string | null, filters?: Array<{ __typename: 'PageGenericContentSectionFileResourcesFilterSettingsFilters', label?: string | null, items?: Array<{ __typename: 'PageGenericContentSectionFileResourcesFilterSettingsFiltersItems', label?: string | null, tag?: string | null } | null> | null } | null> | null } | null, resources?: Array<{ __typename: 'PageGenericContentSectionFileResourcesResources', title?: string | null, type?: string | null, tooltip?: string | null, link?: string | null, tags?: Array<string | null> | null } | null> | null } | { __typename: 'PageGenericContentSectionOurStory', headingText?: string | null, subheadingText?: string | null, textRich?: any | null } | { __typename: 'PageGenericContentSectionTeam', headingText?: string | null, items?: Array<{ __typename: 'PageGenericContentSectionTeamItems', image?: string | null, name?: string | null, title?: string | null, about?: string | null } | null> | null } | { __typename: 'PageGenericContentSectionValues', headingText?: string | null, items?: Array<{ __typename: 'PageGenericContentSectionValuesItems', icon?: string | null, title?: string | null, text?: string | null } | null> | null } | { __typename: 'PageGenericContentSectionImage', scrollable?: boolean | null, spacing?: number | null, maxWidth?: string | null, align?: string | null, brzImage?: { __typename: 'PageGenericContentSectionImageBrzImage', title?: string | null, src?: string | null, width?: number | null, height?: number | null, aspectRatio?: number | null, format?: string | null, alt?: string | null, radius?: number | null } | null } | { __typename: 'PageGenericContentSectionButtons', align?: string | null, spacing?: number | null, buttons?: Array<{ __typename: 'PageGenericContentSectionButtonsButtons', label?: string | null, link?: string | null, ariaLabel?: string | null, variant?: string | null, color?: string | null, size?: string | null } | null> | null } | { __typename: 'PageGenericContentSectionPress', headingText?: string | null, textRich?: any | null, items?: Array<{ __typename: 'PageGenericContentSectionPressItems', headingText?: string | null, link?: string | null } | null> | null } | { __typename: 'PageGenericContentSectionTwoColumnText', title?: string | null, headingText?: string | null, imageSrc?: string | null, textRich?: any | null } | { __typename: 'PageGenericContentSectionThreeColumnText', headingText?: string | null, cols?: Array<{ __typename: 'PageGenericContentSectionThreeColumnTextCols', title?: string | null, textRich?: any | null } | null> | null } | { __typename: 'PageGenericContentSectionVibe', title?: string | null, headingText?: string | null, text?: string | null, imageSrc?: string | null, button?: { __typename: 'PageGenericContentSectionVibeButton', label?: string | null, link?: string | null, ariaLabel?: string | null } | null, items?: Array<{ __typename: 'PageGenericContentSectionVibeItems', icon?: string | null, title?: string | null, text?: string | null } | null> | null } | { __typename: 'PageGenericContentSectionSellingPoints', imageSrc?: string | null, headingText?: string | null, text?: string | null, items?: Array<{ __typename: 'PageGenericContentSectionSellingPointsItems', icon?: string | null, title?: string | null, text?: string | null } | null> | null } | { __typename: 'PageGenericContentSectionOpenings', sectionId?: string | null, headingText?: string | null, textRich?: any | null, title?: string | null, items?: Array<{ __typename: 'PageGenericContentSectionOpeningsItems', title?: string | null, location?: string | null, link?: string | null } | null> | null } | { __typename: 'PageGenericContentSectionStoryCards', title?: string | null, items?: Array<{ __typename: 'PageGenericContentSectionStoryCardsItemsEmployeeStory', textRich?: any | null, author?: string | null, authorTitle?: string | null, authorImage?: string | null } | { __typename: 'PageGenericContentSectionStoryCardsItemsAchievement', title?: string | null, textRich?: any | null, badgeImage?: string | null, brzImage?: { __typename: 'PageGenericContentSectionStoryCardsItemsAchievementBrzImage', src?: string | null, width?: number | null, height?: number | null, aspectRatio?: number | null, format?: string | null, alt?: string | null } | null } | { __typename: 'PageGenericContentSectionStoryCardsItemsAnnouncement', headingText?: string | null, subheadingText?: string | null, textRich?: any | null, images?: Array<{ __typename: 'PageGenericContentSectionStoryCardsItemsAnnouncementImages', imageSrc?: string | null, alt?: string | null } | null> | null } | null> | null } | { __typename: 'PageGenericContentSectionOtherOffers', headingText?: string | null, items?: Array<{ __typename: 'PageGenericContentSectionOtherOffersItems', headingText?: string | null, text?: string | null, imageSrc?: string | null } | null> | null } | { __typename: 'PageGenericContentSectionAccordion', title?: string | null, sectionId?: string | null, items?: Array<{ __typename: 'PageGenericContentSectionAccordionItems', title?: string | null, textRich?: any | null } | null> | null } | { __typename: 'PageGenericContentSectionQuoteProposal', headingText?: string | null, subheadingRich?: any | null, imageSrc?: string | null, addonsHeadingText?: string | null, helpTip?: { __typename: 'PageGenericContentSectionQuoteProposalHelpTip', headingText?: string | null, contentRich?: any | null } | null, notFoundError?: { __typename: 'PageGenericContentSectionQuoteProposalNotFoundError', headingText?: string | null, textRich?: any | null } | null, genericError?: { __typename: 'PageGenericContentSectionQuoteProposalGenericError', headingText?: string | null, textRich?: any | null } | null } | { __typename: 'PageGenericContentSectionTable', title?: string | null, headingText?: string | null, rows?: Array<{ __typename: 'PageGenericContentSectionTableRows', columns?: Array<string | null> | null } | null> | null } | { __typename: 'PageGenericContentSectionHeading', align?: string | null, title?: string | null, headingLevel?: string | null, headingText?: string | null, text?: string | null, marginBottom?: string | null } | { __typename: 'PageGenericContentSectionContent', align?: string | null, maxWidth?: string | null, contentRich?: any | null } | { __typename: 'PageGenericContentSectionSidebarContent', sidebarRich?: any | null, rows?: Array<{ __typename: 'PageGenericContentSectionSidebarContentRows', cols?: Array<{ __typename: 'PageGenericContentSectionSidebarContentRowsCols', contentRich?: any | null } | null> | null } | null> | null } | { __typename: 'PageGenericContentSectionHTML', contentText?: string | null } | null> | null };

type PageParts_PageBlog_Fragment = { __typename: 'PageBlog', component?: string | null, updatedDate?: string | null, publishedDate?: string | null, title: string, heading?: string | null, settings?: { __typename: 'PageBlogSettings', publish?: { __typename: 'PageBlogSettingsPublish', published?: boolean | null, publishedDate?: string | null } | null, seo?: { __typename: 'PageBlogSettingsSeo', title?: string | null, url?: string | null, description?: string | null, image?: { __typename: 'PageFormSettingsSeoImage', src?: string | null, width?: number | null, height?: number | null, aspectRatio?: number | null, format?: string | null, alt?: string | null } | null, org?: { __typename: 'PageFormSettingsSeoOrg', disable?: boolean | null } | null, faq?: { __typename: 'PageFormSettingsSeoFaq', disable?: boolean | null, name?: string | null, items?: Array<{ __typename: 'ArticleSettingsSeoFaqItems', q?: string | null, a?: string | null } | null> | null } | null, howTo?: { __typename: 'PageFormSettingsSeoHowTo', disable?: boolean | null, name?: string | null, description?: string | null, image?: { __typename: 'ArticleSettingsSeoHowToImage', src?: string | null, width?: number | null, height?: number | null, aspectRatio?: number | null, format?: string | null, alt?: string | null } | null, steps?: Array<{ __typename: 'ArticleSettingsSeoHowToSteps', name?: string | null, url?: string | null, text?: string | null } | null> | null } | null } | null, sitemap?: { __typename: 'PageBlogSettingsSitemap', exclude?: boolean | null, breadcrumb?: string | null, changefreq?: string | null, priority?: number | null } | null, navigation?: { __typename: 'PageBlogSettingsNavigation', disableLogo?: boolean | null, disableLeft?: boolean | null, disableRight?: boolean | null, disableButtons?: boolean | null, rightSideButtonOverride?: { __typename: 'PageFormSettingsNavigationRightSideButtonOverride', label?: string | null, link?: string | null, ariaLabel?: string | null } | null } | null, footer?: { __typename: 'PageBlogSettingsFooter', disableLinks?: boolean | null, disableBottom?: boolean | null } | null, disclaimer?: { __typename: 'PageBlogSettingsDisclaimer', disable?: boolean | null, content?: any | null } | null, partner?: { __typename: 'PageBlogSettingsPartner' } | null, client?: { __typename: 'PageBlogSettingsClient', enabled?: boolean | null } | null } | null, categories?: Array<{ __typename: 'PageBlogCategories' } | null> | null, popular?: Array<{ __typename: 'PageBlogPopular' } | null> | null, cta?: { __typename: 'PageBlogCta', headingText?: string | null, text?: string | null, buttons?: Array<{ __typename: 'PageBlogCtaButtons', label?: string | null, link?: string | null, ariaLabel?: string | null } | null> | null } | null };

type PageParts_PageForm_Fragment = { __typename: 'PageForm', component?: string | null, updatedDate?: string | null, publishedDate?: string | null, title: string, settings?: { __typename: 'PageFormSettings', publish?: { __typename: 'PageFormSettingsPublish', published?: boolean | null, publishedDate?: string | null } | null, seo?: { __typename: 'PageFormSettingsSeo', title?: string | null, url?: string | null, description?: string | null, image?: { __typename: 'ArticleSettingsSeoImage', src?: string | null, width?: number | null, height?: number | null, aspectRatio?: number | null, format?: string | null, alt?: string | null } | null, org?: { __typename: 'ArticleSettingsSeoOrg', disable?: boolean | null } | null, faq?: { __typename: 'ArticleSettingsSeoFaq', disable?: boolean | null, name?: string | null, items?: Array<{ __typename: 'PostSettingsSeoFaqItems', q?: string | null, a?: string | null } | null> | null } | null, howTo?: { __typename: 'ArticleSettingsSeoHowTo', disable?: boolean | null, name?: string | null, description?: string | null, image?: { __typename: 'PostSettingsSeoHowToImage', src?: string | null, width?: number | null, height?: number | null, aspectRatio?: number | null, format?: string | null, alt?: string | null } | null, steps?: Array<{ __typename: 'PostSettingsSeoHowToSteps', name?: string | null, url?: string | null, text?: string | null } | null> | null } | null } | null, sitemap?: { __typename: 'PageFormSettingsSitemap', exclude?: boolean | null, breadcrumb?: string | null, changefreq?: string | null, priority?: number | null } | null, navigation?: { __typename: 'PageFormSettingsNavigation', disableLogo?: boolean | null, disableLeft?: boolean | null, disableRight?: boolean | null, disableButtons?: boolean | null, rightSideButtonOverride?: { __typename: 'ArticleSettingsNavigationRightSideButtonOverride', label?: string | null, link?: string | null, ariaLabel?: string | null } | null } | null, footer?: { __typename: 'PageFormSettingsFooter', disableLinks?: boolean | null, disableBottom?: boolean | null } | null, disclaimer?: { __typename: 'PageFormSettingsDisclaimer', disable?: boolean | null, content?: any | null } | null, partner?: { __typename: 'PageFormSettingsPartner' } | null, client?: { __typename: 'PageFormSettingsClient', enabled?: boolean | null } | null } | null, carrier?: { __typename: 'PageFormCarrier', logo?: string | null, headingText?: string | null, text?: string | null, button?: { __typename: 'PageFormCarrierButton', label?: string | null, link?: string | null, ariaLabel?: string | null, hint?: string | null } | null } | null, form?: { __typename: 'PageFormForm', title?: string | null, headingText?: string | null, subheadingText?: string | null, images?: Array<{ __typename: 'PageFormFormImages', image?: string | null, title?: string | null } | null> | null } | null, calendar?: { __typename: 'PageFormCalendar', headingText?: string | null, subheadingText?: string | null } | null, sidebar?: { __typename: 'PageFormSidebar', headingText?: string | null, subheadingText?: string | null, image?: string | null, help?: { __typename: 'PageFormSidebarHelp', title?: string | null, links?: Array<{ __typename: 'PageFormSidebarHelpLinks', label?: string | null, link?: string | null, ariaLabel?: string | null } | null> | null } | null, items?: Array<{ __typename: 'PageFormSidebarItems', title?: string | null, text?: string | null } | null> | null, contacts?: { __typename: 'PageFormSidebarContacts', title?: string | null, items?: Array<{ __typename: 'PageFormSidebarContactsItems', textRich?: any | null, sub?: string | null } | null> | null } | null } | null };

export type PagePartsFragment = PageParts_PageGeneric_Fragment | PageParts_PageBlog_Fragment | PageParts_PageForm_Fragment;

export type ArticlePartsFragment = { __typename: 'Article', component?: string | null, updatedDate?: string | null, publishedDate?: string | null, title: string, cover?: string | null, thumbnail?: string | null, headingRich?: any | null, subtitleRich?: string | null, excerptText?: string | null, body?: any | null, settings?: { __typename: 'ArticleSettings', publish?: { __typename: 'ArticleSettingsPublish', published?: boolean | null, publishedDate?: string | null } | null, seo?: { __typename: 'ArticleSettingsSeo', title?: string | null, url?: string | null, description?: string | null, image?: { __typename: 'PostSettingsSeoImage', src?: string | null, width?: number | null, height?: number | null, aspectRatio?: number | null, format?: string | null, alt?: string | null } | null, org?: { __typename: 'PostSettingsSeoOrg', disable?: boolean | null } | null, faq?: { __typename: 'PostSettingsSeoFaq', disable?: boolean | null, name?: string | null, items?: Array<{ __typename: 'CategorySettingsSeoFaqItems', q?: string | null, a?: string | null } | null> | null } | null, howTo?: { __typename: 'PostSettingsSeoHowTo', disable?: boolean | null, name?: string | null, description?: string | null, image?: { __typename: 'CategorySettingsSeoHowToImage', src?: string | null, width?: number | null, height?: number | null, aspectRatio?: number | null, format?: string | null, alt?: string | null } | null, steps?: Array<{ __typename: 'CategorySettingsSeoHowToSteps', name?: string | null, url?: string | null, text?: string | null } | null> | null } | null } | null, sitemap?: { __typename: 'ArticleSettingsSitemap', exclude?: boolean | null, breadcrumb?: string | null, changefreq?: string | null, priority?: number | null } | null, navigation?: { __typename: 'ArticleSettingsNavigation', disableLogo?: boolean | null, disableLeft?: boolean | null, disableRight?: boolean | null, disableButtons?: boolean | null, rightSideButtonOverride?: { __typename: 'PostSettingsNavigationRightSideButtonOverride', label?: string | null, link?: string | null, ariaLabel?: string | null } | null } | null, footer?: { __typename: 'ArticleSettingsFooter', disableLinks?: boolean | null, disableBottom?: boolean | null } | null, disclaimer?: { __typename: 'ArticleSettingsDisclaimer', disable?: boolean | null, content?: any | null } | null, partner?: { __typename: 'ArticleSettingsPartner' } | null, client?: { __typename: 'ArticleSettingsClient', enabled?: boolean | null } | null } | null, readtime?: { __typename: 'ArticleReadtime', text?: string | null, minutes?: number | null, time?: number | null, words?: number | null } | null, widgets?: Array<{ __typename: 'ArticleWidgets', image?: string | null, heading?: string | null, text?: string | null, label?: string | null, link?: string | null } | null> | null, cta?: { __typename: 'ArticleCta', headingText?: string | null, text?: string | null, buttons?: Array<{ __typename: 'ArticleCtaButtons', label?: string | null, link?: string | null, ariaLabel?: string | null } | null> | null } | null, related?: Array<{ __typename: 'ArticleRelated' } | null> | null };

export type PostPartsFragment = { __typename: 'Post', component?: string | null, updatedDate?: string | null, publishedDate?: string | null, title: string, cover?: string | null, thumbnail?: string | null, headingRich?: any | null, excerptText?: string | null, body?: any | null, settings?: { __typename: 'PostSettings', publish?: { __typename: 'PostSettingsPublish', published?: boolean | null, publishedDate?: string | null } | null, seo?: { __typename: 'PostSettingsSeo', title?: string | null, url?: string | null, description?: string | null, image?: { __typename: 'CategorySettingsSeoImage', src?: string | null, width?: number | null, height?: number | null, aspectRatio?: number | null, format?: string | null, alt?: string | null } | null, org?: { __typename: 'CategorySettingsSeoOrg', disable?: boolean | null } | null, faq?: { __typename: 'CategorySettingsSeoFaq', disable?: boolean | null, name?: string | null, items?: Array<{ __typename: 'AuthorSettingsSeoFaqItems', q?: string | null, a?: string | null } | null> | null } | null, howTo?: { __typename: 'CategorySettingsSeoHowTo', disable?: boolean | null, name?: string | null, description?: string | null, image?: { __typename: 'AuthorSettingsSeoHowToImage', src?: string | null, width?: number | null, height?: number | null, aspectRatio?: number | null, format?: string | null, alt?: string | null } | null, steps?: Array<{ __typename: 'AuthorSettingsSeoHowToSteps', name?: string | null, url?: string | null, text?: string | null } | null> | null } | null } | null, sitemap?: { __typename: 'PostSettingsSitemap', exclude?: boolean | null, breadcrumb?: string | null, changefreq?: string | null, priority?: number | null } | null, navigation?: { __typename: 'PostSettingsNavigation', disableLogo?: boolean | null, disableLeft?: boolean | null, disableRight?: boolean | null, disableButtons?: boolean | null, rightSideButtonOverride?: { __typename: 'CategorySettingsNavigationRightSideButtonOverride', label?: string | null, link?: string | null, ariaLabel?: string | null } | null } | null, footer?: { __typename: 'PostSettingsFooter', disableLinks?: boolean | null, disableBottom?: boolean | null } | null, disclaimer?: { __typename: 'PostSettingsDisclaimer', disable?: boolean | null, content?: any | null } | null, partner?: { __typename: 'PostSettingsPartner' } | null, client?: { __typename: 'PostSettingsClient', enabled?: boolean | null } | null } | null, readtime?: { __typename: 'PostReadtime', text?: string | null, minutes?: number | null, time?: number | null, words?: number | null } | null, widgets?: Array<{ __typename: 'PostWidgets', image?: string | null, heading?: string | null, text?: string | null, label?: string | null, link?: string | null } | null> | null, cta?: { __typename: 'PostCta', headingText?: string | null, text?: string | null, buttons?: Array<{ __typename: 'PostCtaButtons', label?: string | null, link?: string | null, ariaLabel?: string | null } | null> | null } | null, related?: Array<{ __typename: 'PostRelated' } | null> | null };

export type CategoryPartsFragment = { __typename: 'Category', component?: string | null, updatedDate?: string | null, publishedDate?: string | null, title: string, name?: string | null, settings?: { __typename: 'CategorySettings', publish?: { __typename: 'CategorySettingsPublish', published?: boolean | null, publishedDate?: string | null } | null, seo?: { __typename: 'CategorySettingsSeo', title?: string | null, url?: string | null, description?: string | null, image?: { __typename: 'AuthorSettingsSeoImage', src?: string | null, width?: number | null, height?: number | null, aspectRatio?: number | null, format?: string | null, alt?: string | null } | null, org?: { __typename: 'AuthorSettingsSeoOrg', disable?: boolean | null } | null, faq?: { __typename: 'AuthorSettingsSeoFaq', disable?: boolean | null, name?: string | null, items?: Array<{ __typename: 'AuthorSettingsSeoFaqItems', q?: string | null, a?: string | null } | null> | null } | null, howTo?: { __typename: 'AuthorSettingsSeoHowTo', disable?: boolean | null, name?: string | null, description?: string | null, image?: { __typename: 'AuthorSettingsSeoHowToImage', src?: string | null, width?: number | null, height?: number | null, aspectRatio?: number | null, format?: string | null, alt?: string | null } | null, steps?: Array<{ __typename: 'AuthorSettingsSeoHowToSteps', name?: string | null, url?: string | null, text?: string | null } | null> | null } | null } | null, sitemap?: { __typename: 'CategorySettingsSitemap', exclude?: boolean | null, breadcrumb?: string | null, changefreq?: string | null, priority?: number | null } | null, navigation?: { __typename: 'CategorySettingsNavigation', disableLogo?: boolean | null, disableLeft?: boolean | null, disableRight?: boolean | null, disableButtons?: boolean | null, rightSideButtonOverride?: { __typename: 'AuthorSettingsNavigationRightSideButtonOverride', label?: string | null, link?: string | null, ariaLabel?: string | null } | null } | null, footer?: { __typename: 'CategorySettingsFooter', disableLinks?: boolean | null, disableBottom?: boolean | null } | null, disclaimer?: { __typename: 'CategorySettingsDisclaimer', disable?: boolean | null, content?: any | null } | null, partner?: { __typename: 'CategorySettingsPartner' } | null, client?: { __typename: 'CategorySettingsClient', enabled?: boolean | null } | null } | null };

export type AuthorPartsFragment = { __typename: 'Author', component?: string | null, updatedDate?: string | null, publishedDate?: string | null, title: string, name?: string | null, jobTitle?: string | null, avatar?: string | null, email?: string | null, bio?: any | null, settings?: { __typename: 'AuthorSettings', publish?: { __typename: 'AuthorSettingsPublish', published?: boolean | null, publishedDate?: string | null } | null, seo?: { __typename: 'AuthorSettingsSeo', title?: string | null, url?: string | null, description?: string | null, image?: { __typename: 'AuthorSettingsSeoImage', src?: string | null, width?: number | null, height?: number | null, aspectRatio?: number | null, format?: string | null, alt?: string | null } | null, org?: { __typename: 'AuthorSettingsSeoOrg', disable?: boolean | null } | null, faq?: { __typename: 'AuthorSettingsSeoFaq', disable?: boolean | null, name?: string | null, items?: Array<{ __typename: 'AuthorSettingsSeoFaqItems', q?: string | null, a?: string | null } | null> | null } | null, howTo?: { __typename: 'AuthorSettingsSeoHowTo', disable?: boolean | null, name?: string | null, description?: string | null, image?: { __typename: 'AuthorSettingsSeoHowToImage', src?: string | null, width?: number | null, height?: number | null, aspectRatio?: number | null, format?: string | null, alt?: string | null } | null, steps?: Array<{ __typename: 'AuthorSettingsSeoHowToSteps', name?: string | null, url?: string | null, text?: string | null } | null> | null } | null } | null, sitemap?: { __typename: 'AuthorSettingsSitemap', exclude?: boolean | null, breadcrumb?: string | null, changefreq?: string | null, priority?: number | null } | null, navigation?: { __typename: 'AuthorSettingsNavigation', disableLogo?: boolean | null, disableLeft?: boolean | null, disableRight?: boolean | null, disableButtons?: boolean | null, rightSideButtonOverride?: { __typename: 'AuthorSettingsNavigationRightSideButtonOverride', label?: string | null, link?: string | null, ariaLabel?: string | null } | null } | null, footer?: { __typename: 'AuthorSettingsFooter', disableLinks?: boolean | null, disableBottom?: boolean | null } | null, disclaimer?: { __typename: 'AuthorSettingsDisclaimer', disable?: boolean | null, content?: any | null } | null, partner?: { __typename: 'AuthorSettingsPartner' } | null, client?: { __typename: 'AuthorSettingsClient', enabled?: boolean | null } | null } | null };

export type ProductPartsFragment = { __typename: 'Product', dataType?: string | null, title: string, productGroup: string, shortName?: string | null, icon?: string | null, graphic?: string | null, actionLabel?: string | null, descriptionText?: string | null, descriptionItems?: Array<string | null> | null, disclaimer?: string | null, buttons?: Array<{ __typename: 'ProductButtons', label?: string | null, link?: string | null, ariaLabel?: string | null, agentLink?: string | null } | null> | null };

export type TestimonialPartsFragment = { __typename: 'Testimonial', dataType?: string | null, title: string, stars?: number | null, author?: string | null, authorTitle?: string | null, link?: string | null, body?: any | null };

export type PartnerPartsFragment = { __typename: 'Partner', dataType?: string | null, title: string, pid?: string | null, enabled?: boolean | null, displayName?: string | null, ctaLink?: string | null, products?: Array<string | null> | null, disclaimer?: string | null, logo?: { __typename: 'PartnerLogo', src?: string | null } | null };

export type CobrandPartsFragment = { __typename: 'Cobrand', dataType?: string | null, title: string, logoSrc?: string | null, displayName?: string | null };

export type BgaPartsFragment = { __typename: 'Bga', dataType?: string | null, title: string, urlSlug?: string | null, logoSrc?: string | null, mobileLogoSrc?: string | null, websiteDisplayName?: string | null, ctaLink?: string | null, productsRefs?: Array<{ __typename: 'BgaProductsRefs' } | null> | null };

export type NotificationPartsFragment = { __typename: 'Notification', title: string, color?: string | null, body?: any | null };

type SettingsParts_SettingsNavigation_Fragment = { __typename: 'SettingsNavigation', title: string, left?: Array<{ __typename: 'SettingsNavigationLeftMegaMenu', title?: string | null, heading?: string | null, items?: Array<{ __typename: 'SettingsNavigationLeftMegaMenuItems', title?: string | null, description?: string | null, icon?: string | null, image?: { __typename: 'SettingsNavigationLeftMegaMenuItemsImage', src?: string | null, width?: number | null, height?: number | null, aspectRatio?: number | null, format?: string | null, alt?: string | null } | null, buttons?: Array<{ __typename: 'SettingsNavigationLeftMegaMenuItemsButtons', label?: string | null, link?: string | null, ariaLabel?: string | null } | null> | null, columns?: Array<{ __typename: 'SettingsNavigationLeftMegaMenuItemsColumns', title?: string | null, links?: Array<{ __typename: 'SettingsNavigationLeftMegaMenuItemsColumnsLinks', label?: string | null, link?: string | null, ariaLabel?: string | null } | null> | null } | null> | null } | null> | null } | { __typename: 'SettingsNavigationLeftSimpleMenu', title?: string | null, items?: Array<{ __typename: 'SettingsNavigationLeftSimpleMenuItems', icon?: string | null, type?: string | null, title?: string | null, link?: string | null } | null> | null } | null> | null, right?: Array<{ __typename: 'SettingsNavigationRightLinkItem', label?: string | null, link?: string | null, ariaLabel?: string | null } | { __typename: 'SettingsNavigationRightDropdownItem', label?: string | null, items?: Array<{ __typename: 'SettingsNavigationRightDropdownItemItems', label?: string | null, link?: string | null, ariaLabel?: string | null } | null> | null } | { __typename: 'SettingsNavigationRightButtonItem', label?: string | null, link?: string | null, ariaLabel?: string | null } | null> | null };

type SettingsParts_SettingsFooter_Fragment = { __typename: 'SettingsFooter', title: string, address?: string | null, disclaimer?: any | null, columns?: Array<{ __typename: 'SettingsFooterColumns', title?: string | null, image?: { __typename: 'SettingsFooterColumnsImage', src?: string | null, width?: number | null, height?: number | null, aspectRatio?: number | null, format?: string | null, alt?: string | null } | null, links?: Array<{ __typename: 'SettingsFooterColumnsLinks', label?: string | null, link?: string | null, ariaLabel?: string | null } | null> | null } | null> | null, extras?: Array<{ __typename: 'SettingsFooterExtras', title?: string | null, links?: Array<{ __typename: 'SettingsFooterExtrasLinks', label?: string | null, link?: string | null, ariaLabel?: string | null } | null> | null } | null> | null, contacts?: Array<{ __typename: 'SettingsFooterContacts', icon?: string | null, label?: string | null, link?: string | null, ariaLabel?: string | null } | null> | null, bottom?: { __typename: 'SettingsFooterBottom', copyright?: string | null, social?: Array<{ __typename: 'SettingsFooterBottomSocial', icon?: string | null, label?: string | null, link?: string | null, ariaLabel?: string | null } | null> | null, navigation?: Array<{ __typename: 'SettingsFooterBottomNavigation', label?: string | null, link?: string | null, ariaLabel?: string | null, newWindow?: boolean | null } | null> | null } | null };

type SettingsParts_SettingsSite_Fragment = { __typename: 'SettingsSite', title: string, name: string, legalName: string, baseUrl: string, description: string, phone: string, email: string, foundingDate?: number | null, socialLinks?: Array<string | null> | null, gtmId?: string | null, fbAppId?: string | null, twitterAuthor?: string | null, logo?: { __typename: 'SettingsSiteLogo', src?: string | null, width?: number | null, height?: number | null, aspectRatio?: number | null, format?: string | null, alt?: string | null } | null, founders?: Array<{ __typename: 'SettingsSiteFounders', name?: string | null, occupation?: string | null, socialLink?: string | null } | null> | null, businessAddress: { __typename: 'SettingsSiteBusinessAddress', street: string, city: string, state: string, zip: string }, rating: { __typename: 'SettingsSiteRating', value: number, outOf: number, reviews: number } };

type SettingsParts_SettingsRedirects_Fragment = { __typename: 'SettingsRedirects', title: string, redirect_groups?: Array<{ __typename: 'SettingsRedirectsRedirect_groups', name?: string | null, redirects?: Array<{ __typename: 'SettingsRedirectsRedirect_groupsRedirects', from_url?: string | null, to_url?: string | null } | null> | null } | null> | null };

type SettingsParts_SettingsSecurity_Fragment = { __typename: 'SettingsSecurity', title: string, csp?: Array<{ __typename: 'SettingsSecurityCsp', directive?: string | null, hosts?: Array<string | null> | null } | null> | null, blocked_ips?: Array<{ __typename: 'SettingsSecurityBlocked_ips', ip_address?: string | null, subnet_mask?: string | null, date_added?: string | null, note?: string | null } | null> | null };

type SettingsParts_SettingsThreeStarOccList_Fragment = { __typename: 'SettingsThreeStarOccList', title: string, occupations?: Array<string | null> | null };

type SettingsParts_SettingsStatesListTemplate_Fragment = { __typename: 'SettingsStatesListTemplate', title: string, states?: Array<string | null> | null };

type SettingsParts_SettingsGroupDiCompanyRateTypes_Fragment = { __typename: 'SettingsGroupDICompanyRateTypes', title: string, rates?: Array<{ __typename: 'SettingsGroupDICompanyRateTypesRates', name?: string | null, id?: string | null, rate?: number | null } | null> | null, companies?: Array<{ __typename: 'SettingsGroupDICompanyRateTypesCompanies', name?: string | null, id?: string | null, rateType?: string | null, hero?: string | null } | null> | null };

type SettingsParts_SettingsNotFoundPage_Fragment = { __typename: 'SettingsNotFoundPage', title: string, subtitle?: string | null, headingText?: string | null, text?: string | null, seo?: { __typename: 'SettingsNotFoundPageSeo', title?: string | null, description?: string | null } | null, image?: { __typename: 'SettingsNotFoundPageImage', src?: string | null, width?: number | null, height?: number | null, aspectRatio?: number | null, format?: string | null, alt?: string | null } | null, cta?: { __typename: 'SettingsNotFoundPageCta', label?: string | null, link?: string | null, ariaLabel?: string | null } | null };

type SettingsParts_SettingsAiRatesTable_Fragment = { __typename: 'SettingsAIRatesTable', title: string, table?: Array<{ __typename: 'SettingsAIRatesTableTable', states?: Array<string | null> | null, rates_by_age?: Array<{ __typename: 'SettingsAIRatesTableTableRates_by_age', age_range?: Array<string | null> | null, rates?: Array<string | null> | null } | null> | null } | null> | null };

export type SettingsPartsFragment = SettingsParts_SettingsNavigation_Fragment | SettingsParts_SettingsFooter_Fragment | SettingsParts_SettingsSite_Fragment | SettingsParts_SettingsRedirects_Fragment | SettingsParts_SettingsSecurity_Fragment | SettingsParts_SettingsThreeStarOccList_Fragment | SettingsParts_SettingsStatesListTemplate_Fragment | SettingsParts_SettingsGroupDiCompanyRateTypes_Fragment | SettingsParts_SettingsNotFoundPage_Fragment | SettingsParts_SettingsAiRatesTable_Fragment;

type FormParts_FormLtdiManualForm_Fragment = { __typename: 'FormLTDIManualForm', dataType?: string | null, title: string, incomeLimit?: number | null, bmiLimit?: number | null, flow?: string | null, calendarURL?: string | null, physician?: boolean | null, buttonLabel?: string | null, healthIssues?: Array<string | null> | null, disclaimer?: any | null, experts?: Array<{ __typename: 'FormLTDIManualFormExperts', imageSrc?: string | null, name?: string | null, title?: string | null } | null> | null, maternity?: { __typename: 'FormLTDIManualFormMaternity', income?: number | null, minHoursWorked?: number | null, excludedStates?: Array<string | null> | null, calendarURL?: string | null } | null, altProduct?: { __typename: 'FormLTDIManualFormAltProduct', imageSrc?: string | null, headingRich?: any | null, subHeadingRich?: any | null, textRich?: any | null, cta?: { __typename: 'FormLTDIManualFormAltProductCta', label?: string | null, link?: string | null } | null } | null, whitelist?: { __typename: 'FormLTDIManualFormWhitelist', occ?: { __typename: 'FormLTDIManualFormWhitelistOcc', list?: Array<string | null> | null } | null, hoursWorkedLimitOccs?: { __typename: 'FormLTDIManualFormWhitelistHoursWorkedLimitOccs', list?: Array<string | null> | null } | null, ratingOcc?: { __typename: 'FormLTDIManualFormWhitelistRatingOcc', min?: number | null, list?: Array<string | null> | null } | null } | null, digital?: { __typename: 'FormLTDIManualFormDigital', occ?: { __typename: 'FormLTDIManualFormDigitalOcc', list?: Array<string | null> | null } | null, healthIssues?: { __typename: 'FormLTDIManualFormDigitalHealthIssues', list?: Array<string | null> | null } | null } | null, ineligible?: { __typename: 'FormLTDIManualFormIneligible', income?: { __typename: 'FormLTDIManualFormIneligibleIncome', min?: number | null } | null, occ?: { __typename: 'FormLTDIManualFormIneligibleOcc', list?: Array<string | null> | null } | null, healthIssues?: { __typename: 'FormLTDIManualFormIneligibleHealthIssues', list?: Array<string | null> | null } | null, hoursWorked?: { __typename: 'FormLTDIManualFormIneligibleHoursWorked', min?: number | null } | null } | null, decline?: { __typename: 'FormLTDIManualFormDecline', headingText?: string | null, dob?: { __typename: 'FormLTDIManualFormDeclineDob', min?: number | null, minErrorText?: string | null, max?: number | null, maxErrorText?: string | null, message?: string | null } | null, income?: { __typename: 'FormLTDIManualFormDeclineIncome', min?: number | null, message?: string | null } | null, state?: { __typename: 'FormLTDIManualFormDeclineState', message?: string | null, states?: Array<string | null> | null } | null, hoursWorked?: { __typename: 'FormLTDIManualFormDeclineHoursWorked', min?: number | null } | null, familyLeave?: { __typename: 'FormLTDIManualFormDeclineFamilyLeave', message?: string | null } | null } | null, generic?: { __typename: 'FormLTDIManualFormGeneric', headingText?: string | null, message?: string | null } | null };

type FormParts_FormStdiDigitalForm_Fragment = { __typename: 'FormSTDIDigitalForm', dataType?: string | null, title: string, bmiLimit?: number | null, buttonLabel?: string | null, disclaimer?: any | null, ineligible?: { __typename: 'FormSTDIDigitalFormIneligible', headingText?: string | null, dob?: { __typename: 'FormSTDIDigitalFormIneligibleDob', min?: number | null, minErrorText?: string | null, max?: number | null, maxErrorText?: string | null, message?: string | null } | null, occ?: { __typename: 'FormSTDIDigitalFormIneligibleOcc', message?: string | null } | null, income?: { __typename: 'FormSTDIDigitalFormIneligibleIncome', min?: number | null, message?: string | null } | null, hoursWorked?: { __typename: 'FormSTDIDigitalFormIneligibleHoursWorked', message?: string | null, min?: number | null } | null, unemployed?: { __typename: 'FormSTDIDigitalFormIneligibleUnemployed', message?: string | null } | null, citizenOrResident?: { __typename: 'FormSTDIDigitalFormIneligibleCitizenOrResident', message?: string | null } | null, disabled?: { __typename: 'FormSTDIDigitalFormIneligibleDisabled', message?: string | null } | null, licenseRevoked?: { __typename: 'FormSTDIDigitalFormIneligibleLicenseRevoked', message?: string | null } | null, state?: { __typename: 'FormSTDIDigitalFormIneligibleState', message?: string | null, states?: Array<string | null> | null } | null } | null, generic?: { __typename: 'FormSTDIDigitalFormGeneric', headingText?: string | null, message?: string | null } | null, familyCare?: { __typename: 'FormSTDIDigitalFormFamilyCare', label?: string | null, content?: any | null } | null };

type FormParts_FormLtcManualForm_Fragment = { __typename: 'FormLTCManualForm', dataType?: string | null, title: string, incomeLimit?: number | null, calendarURL?: string | null, buttonLabel?: string | null, disclaimer?: any | null, ineligible?: { __typename: 'FormLTCManualFormIneligible', headingText?: string | null, dob?: { __typename: 'FormLTCManualFormIneligibleDob', min?: number | null, minErrorText?: string | null, max?: number | null, maxErrorText?: string | null, message?: string | null } | null, occ?: { __typename: 'FormLTCManualFormIneligibleOcc', message?: string | null } | null, income?: { __typename: 'FormLTCManualFormIneligibleIncome', min?: number | null, message?: string | null } | null, state?: { __typename: 'FormLTCManualFormIneligibleState', message?: string | null, states?: Array<string | null> | null } | null } | null, generic?: { __typename: 'FormLTCManualFormGeneric', headingText?: string | null, message?: string | null } | null };

type FormParts_FormCiForm_Fragment = { __typename: 'FormCIForm', dataType?: string | null, title: string, flow?: string | null, buttonLabel?: string | null, enableContacts?: boolean | null, disclaimer?: any | null, ineligible?: { __typename: 'FormCIFormIneligible', headingText?: string | null, dob?: { __typename: 'FormCIFormIneligibleDob', min?: number | null, minErrorText?: string | null, max?: number | null, maxErrorText?: string | null, message?: string | null } | null, state?: { __typename: 'FormCIFormIneligibleState', message?: string | null, states?: Array<string | null> | null } | null, replacing?: { __typename: 'FormCIFormIneligibleReplacing', message?: string | null } | null, hadCancer?: { __typename: 'FormCIFormIneligibleHadCancer', message?: string | null } | null } | null, generic?: { __typename: 'FormCIFormGeneric', headingText?: string | null, message?: string | null } | null };

type FormParts_FormAeiForm_Fragment = { __typename: 'FormAEIForm', dataType?: string | null, title: string, flow?: string | null, buttonLabel?: string | null, disclaimer?: any | null, popup?: Array<{ __typename: 'FormAEIFormPopup', icon?: string | null, title?: string | null, text?: string | null, label?: string | null, link?: string | null, hint?: string | null } | null> | null, ineligible?: { __typename: 'FormAEIFormIneligible', headingText?: string | null, age?: { __typename: 'FormAEIFormIneligibleAge', min?: number | null, minErrorText?: string | null, max?: number | null, maxErrorText?: string | null, message?: string | null } | null, state?: { __typename: 'FormAEIFormIneligibleState', message?: string | null, states?: Array<string | null> | null } | null } | null, generic?: { __typename: 'FormAEIFormGeneric', headingText?: string | null, message?: string | null } | null };

type FormParts_FormGroupDiForm_Fragment = { __typename: 'FormGroupDIForm', dataType?: string | null, title: string, calendarURL?: string | null, buttonLabel?: string | null, isInternal?: boolean | null, internalCalendarURL?: string | null, disclaimer?: any | null, ineligible?: { __typename: 'FormGroupDIFormIneligible', minEmployees?: { __typename: 'FormGroupDIFormIneligibleMinEmployees', min?: number | null, headingText?: string | null, message?: string | null, buttonLabel?: string | null, buttonLink?: string | null } | null } | null, generic?: { __typename: 'FormGroupDIFormGeneric', headingText?: string | null, message?: string | null } | null };

type FormParts_FormLtdiDropticketForm_Fragment = { __typename: 'FormLTDIDropticketForm', dataType?: string | null, title: string, calendarURL?: string | null, buttonLabel?: string | null, disclaimer?: any | null, thankyou?: { __typename: 'FormLTDIDropticketFormThankyou', headingText?: string | null, text?: string | null } | null, ineligible?: { __typename: 'FormLTDIDropticketFormIneligible', headingText?: string | null, dob?: { __typename: 'FormLTDIDropticketFormIneligibleDob', min?: number | null, minErrorText?: string | null, max?: number | null, maxErrorText?: string | null, message?: string | null } | null, occ?: { __typename: 'FormLTDIDropticketFormIneligibleOcc', message?: string | null } | null, income?: { __typename: 'FormLTDIDropticketFormIneligibleIncome', min?: number | null, message?: string | null } | null, state?: { __typename: 'FormLTDIDropticketFormIneligibleState', message?: string | null, states?: Array<string | null> | null } | null } | null, generic?: { __typename: 'FormLTDIDropticketFormGeneric', headingText?: string | null, message?: string | null } | null };

type FormParts_FormLtcDropticketForm_Fragment = { __typename: 'FormLTCDropticketForm', dataType?: string | null, title: string, calendarURL?: string | null, buttonLabel?: string | null, disclaimer?: any | null, thankyou?: { __typename: 'FormLTCDropticketFormThankyou', headingText?: string | null, text?: string | null } | null, ineligible?: { __typename: 'FormLTCDropticketFormIneligible', headingText?: string | null, dob?: { __typename: 'FormLTCDropticketFormIneligibleDob', min?: number | null, minErrorText?: string | null, max?: number | null, maxErrorText?: string | null, message?: string | null } | null, income?: { __typename: 'FormLTCDropticketFormIneligibleIncome', min?: number | null, message?: string | null } | null, state?: { __typename: 'FormLTCDropticketFormIneligibleState', message?: string | null, states?: Array<string | null> | null } | null } | null, generic?: { __typename: 'FormLTCDropticketFormGeneric', headingText?: string | null, message?: string | null } | null };

type FormParts_FormGroupDiCalculatorForm_Fragment = { __typename: 'FormGroupDICalculatorForm', dataType?: string | null, title: string, detailsRich?: any | null, headings?: { __typename: 'FormGroupDICalculatorFormHeadings', mainRich?: any | null, contributionRich?: any | null } | null, defaults?: { __typename: 'FormGroupDICalculatorFormDefaults', numberOfEmployees?: number | null, contributionPercent?: number | null, companyType?: string | null } | null };

type FormParts_FormAgentSignupForm_Fragment = { __typename: 'FormAgentSignupForm', dataType?: string | null, title: string, heading?: string | null, buttonLabel?: string | null, textRich?: any | null, thankyou?: { __typename: 'FormAgentSignupFormThankyou', headingText?: string | null, text?: string | null } | null, ineligible?: { __typename: 'FormAgentSignupFormIneligible', headingText?: string | null, state?: { __typename: 'FormAgentSignupFormIneligibleState', message?: string | null, states?: Array<string | null> | null } | null } | null, generic?: { __typename: 'FormAgentSignupFormGeneric', headingText?: string | null, message?: string | null } | null };

type FormParts_FormAgentSimpleForm_Fragment = { __typename: 'FormAgentSimpleForm', dataType?: string | null, title: string, buttonLabel?: string | null, intent?: string | null, thankyou?: { __typename: 'FormAgentSimpleFormThankyou', headingText?: string | null, text?: string | null } | null, generic?: { __typename: 'FormAgentSimpleFormGeneric', headingText?: string | null, message?: string | null } | null };

export type FormPartsFragment = FormParts_FormLtdiManualForm_Fragment | FormParts_FormStdiDigitalForm_Fragment | FormParts_FormLtcManualForm_Fragment | FormParts_FormCiForm_Fragment | FormParts_FormAeiForm_Fragment | FormParts_FormGroupDiForm_Fragment | FormParts_FormLtdiDropticketForm_Fragment | FormParts_FormLtcDropticketForm_Fragment | FormParts_FormGroupDiCalculatorForm_Fragment | FormParts_FormAgentSignupForm_Fragment | FormParts_FormAgentSimpleForm_Fragment;

export type ManagerPartsFragment = { __typename: 'Manager', title: string, slackMentionId?: string | null, referralName?: string | null, salesPersonId?: string | null, phone?: string | null, isFallback?: boolean | null, imageSrc?: string | null, managedProducts?: Array<{ __typename: 'ManagerManagedProducts', product?: string | null, calendlyUrl?: string | null, ycbmUrl?: string | null, states?: Array<string | null> | null, contents?: Array<{ __typename: 'ManagerManagedProductsContents', type?: string | null, heading?: string | null, subHeading?: string | null, text?: string | null } | null> | null, rating?: { __typename: 'ManagerManagedProductsRating', min?: number | null, max?: number | null } | null } | null> | null };

type SpecialPageParts_SpecialPageProposalSpecialPage_Fragment = { __typename: 'SpecialPageProposalSpecialPage', previewURL?: string | null, title: string, disclaimer?: any | null, seo?: { __typename: 'SpecialPageProposalSpecialPageSeo', title?: string | null } | null, content?: Array<{ __typename: 'SpecialPageProposalSpecialPageContentSectionHeroProposal', title?: string | null, headingSize?: string | null, headingRich?: any | null, subheadingRich?: any | null, textRich?: any | null, lists?: Array<{ __typename: 'SpecialPageProposalSpecialPageContentSectionHeroProposalLists', title?: string | null, items?: Array<string | null> | null } | null> | null, logos?: { __typename: 'SpecialPageProposalSpecialPageContentSectionHeroProposalLogos', highlightImgSrc?: string | null, highlightText?: string | null, logosText?: string | null, logosList?: Array<string | null> | null } | null, image?: { __typename: 'SpecialPageProposalSpecialPageContentSectionHeroProposalImage', src?: string | null, width?: number | null, height?: number | null, aspectRatio?: number | null, format?: string | null, alt?: string | null, scale?: number | null } | null, buttons?: Array<{ __typename: 'SpecialPageProposalSpecialPageContentSectionHeroProposalButtons', label?: string | null, link?: string | null, ariaLabel?: string | null } | null> | null, floatingItems?: Array<{ __typename: 'SpecialPageProposalSpecialPageContentSectionHeroProposalFloatingItemsSingleIconLinkItem', icon?: string | null, title?: string | null, text?: string | null, link?: string | null } | { __typename: 'SpecialPageProposalSpecialPageContentSectionHeroProposalFloatingItemsSingleIconTextItem', icon?: string | null, text?: string | null } | { __typename: 'SpecialPageProposalSpecialPageContentSectionHeroProposalFloatingItemsGroupedIconTextItem', items?: Array<{ __typename: 'SpecialPageProposalSpecialPageContentSectionHeroProposalFloatingItemsGroupedIconTextItemItems', icon?: string | null, text?: string | null } | null> | null } | { __typename: 'SpecialPageProposalSpecialPageContentSectionHeroProposalFloatingItemsSingleImageTextItem', image?: string | null, text?: string | null } | { __typename: 'SpecialPageProposalSpecialPageContentSectionHeroProposalFloatingItemsGroupedImageTextItem', items?: Array<{ __typename: 'SpecialPageProposalSpecialPageContentSectionHeroProposalFloatingItemsGroupedImageTextItemItems', image?: string | null, text?: string | null } | null> | null } | { __typename: 'SpecialPageProposalSpecialPageContentSectionHeroProposalFloatingItemsSingleImageItem', image?: string | null } | null> | null } | { __typename: 'SpecialPageProposalSpecialPageContentSectionLogos', headingText?: string | null, images?: Array<{ __typename: 'SpecialPageProposalSpecialPageContentSectionLogosImages', image?: string | null, title?: string | null } | null> | null } | { __typename: 'SpecialPageProposalSpecialPageContentSectionImage', scrollable?: boolean | null, spacing?: number | null, maxWidth?: string | null, align?: string | null, brzImage?: { __typename: 'SpecialPageProposalSpecialPageContentSectionImageBrzImage', title?: string | null, src?: string | null, width?: number | null, height?: number | null, aspectRatio?: number | null, format?: string | null, alt?: string | null, radius?: number | null } | null } | { __typename: 'SpecialPageProposalSpecialPageContentSectionHeading', align?: string | null, title?: string | null, headingLevel?: string | null, headingText?: string | null, text?: string | null, marginBottom?: string | null } | { __typename: 'SpecialPageProposalSpecialPageContentSectionSideStats', headingText?: string | null, textRich?: any | null, items?: Array<{ __typename: 'SpecialPageProposalSpecialPageContentSectionSideStatsItems', icon?: string | null, text?: string | null } | null> | null } | null> | null, quote?: { __typename: 'SpecialPageProposalSpecialPageQuote', headingText?: string | null, subheadingRich?: any | null, addonsHeadingText?: string | null, helpTip?: { __typename: 'SpecialPageProposalSpecialPageQuoteHelpTip', headingText?: string | null, contentRich?: any | null } | null, notFoundError?: { __typename: 'SpecialPageProposalSpecialPageQuoteNotFoundError', headingText?: string | null, textRich?: any | null } | null, genericError?: { __typename: 'SpecialPageProposalSpecialPageQuoteGenericError', headingText?: string | null, textRich?: any | null } | null, annuity?: { __typename: 'SpecialPageProposalSpecialPageQuoteAnnuity', headingText?: string | null, text?: string | null, productName?: string | null, incomeLabel?: string | null, columns?: Array<{ __typename: 'SpecialPageProposalSpecialPageQuoteAnnuityColumns', label?: string | null, value?: string | null } | null> | null } | null } | null };

type SpecialPageParts_SpecialPageIneligibleSpecialPage_Fragment = { __typename: 'SpecialPageIneligibleSpecialPage', previewURL?: string | null, title: string, seo?: { __typename: 'SpecialPageIneligibleSpecialPageSeo', title?: string | null } | null, accident?: { __typename: 'SpecialPageIneligibleSpecialPageAccident', imgSrc?: string | null, headingRich?: any | null, subheadingRich?: any | null, textRich?: any | null, ctaLabel?: string | null } | null, ineligible?: { __typename: 'SpecialPageIneligibleSpecialPageIneligible', headingRich?: any | null, subheadingRich?: any | null, textRich?: any | null, products?: Array<{ __typename: 'SpecialPageIneligibleSpecialPageIneligibleProducts', title?: string | null } | null> | null } | null };

export type SpecialPagePartsFragment = SpecialPageParts_SpecialPageProposalSpecialPage_Fragment | SpecialPageParts_SpecialPageIneligibleSpecialPage_Fragment;

export type PageQueryVariables = Exact<{
  relativePath: Scalars['String']['input'];
}>;


export type PageQuery = { __typename?: 'Query', page: { __typename: 'PageGeneric', id: string, component?: string | null, updatedDate?: string | null, publishedDate?: string | null, title: string, _sys: { __typename?: 'SystemInfo', filename: string, basename: string, breadcrumbs: Array<string>, path: string, relativePath: string, extension: string }, settings?: { __typename: 'PageGenericSettings', publish?: { __typename: 'PageGenericSettingsPublish', published?: boolean | null, publishedDate?: string | null } | null, seo?: { __typename: 'PageGenericSettingsSeo', title?: string | null, url?: string | null, description?: string | null, image?: { __typename: 'PageBlogSettingsSeoImage', src?: string | null, width?: number | null, height?: number | null, aspectRatio?: number | null, format?: string | null, alt?: string | null } | null, org?: { __typename: 'PageBlogSettingsSeoOrg', disable?: boolean | null } | null, faq?: { __typename: 'PageBlogSettingsSeoFaq', disable?: boolean | null, name?: string | null, items?: Array<{ __typename: 'PageFormSettingsSeoFaqItems', q?: string | null, a?: string | null } | null> | null } | null, howTo?: { __typename: 'PageBlogSettingsSeoHowTo', disable?: boolean | null, name?: string | null, description?: string | null, image?: { __typename: 'PageFormSettingsSeoHowToImage', src?: string | null, width?: number | null, height?: number | null, aspectRatio?: number | null, format?: string | null, alt?: string | null } | null, steps?: Array<{ __typename: 'PageFormSettingsSeoHowToSteps', name?: string | null, url?: string | null, text?: string | null } | null> | null } | null } | null, sitemap?: { __typename: 'PageGenericSettingsSitemap', exclude?: boolean | null, breadcrumb?: string | null, changefreq?: string | null, priority?: number | null } | null, navigation?: { __typename: 'PageGenericSettingsNavigation', disableLogo?: boolean | null, disableLeft?: boolean | null, disableRight?: boolean | null, disableButtons?: boolean | null, rightSideButtonOverride?: { __typename: 'PageBlogSettingsNavigationRightSideButtonOverride', label?: string | null, link?: string | null, ariaLabel?: string | null } | null } | null, footer?: { __typename: 'PageGenericSettingsFooter', disableLinks?: boolean | null, disableBottom?: boolean | null } | null, disclaimer?: { __typename: 'PageGenericSettingsDisclaimer', disable?: boolean | null, content?: any | null } | null, partner?: { __typename: 'PageGenericSettingsPartner' } | null, client?: { __typename: 'PageGenericSettingsClient', enabled?: boolean | null } | null } | null, content?: Array<{ __typename: 'PageGenericContentSectionHeroGeneric', title?: string | null, headingSize?: string | null, headingRich?: any | null, subheadingRich?: any | null, textRich?: any | null, lists?: Array<{ __typename: 'PageGenericContentSectionHeroGenericLists', title?: string | null, items?: Array<string | null> | null } | null> | null, image?: { __typename: 'PageGenericContentSectionHeroGenericImage', src?: string | null, width?: number | null, height?: number | null, aspectRatio?: number | null, format?: string | null, alt?: string | null, scale?: number | null } | null, buttons?: Array<{ __typename: 'PageGenericContentSectionHeroGenericButtons', label?: string | null, link?: string | null, ariaLabel?: string | null } | null> | null, floatingItems?: Array<{ __typename: 'PageGenericContentSectionHeroGenericFloatingItemsSingleIconLinkItem', icon?: string | null, title?: string | null, text?: string | null, link?: string | null } | { __typename: 'PageGenericContentSectionHeroGenericFloatingItemsSingleIconTextItem', icon?: string | null, text?: string | null } | { __typename: 'PageGenericContentSectionHeroGenericFloatingItemsGroupedIconTextItem', items?: Array<{ __typename: 'PageGenericContentSectionHeroGenericFloatingItemsGroupedIconTextItemItems', icon?: string | null, text?: string | null } | null> | null } | { __typename: 'PageGenericContentSectionHeroGenericFloatingItemsSingleImageTextItem', image?: string | null, text?: string | null } | { __typename: 'PageGenericContentSectionHeroGenericFloatingItemsGroupedImageTextItem', items?: Array<{ __typename: 'PageGenericContentSectionHeroGenericFloatingItemsGroupedImageTextItemItems', image?: string | null, text?: string | null } | null> | null } | { __typename: 'PageGenericContentSectionHeroGenericFloatingItemsSingleImageItem', image?: string | null } | null> | null } | { __typename: 'PageGenericContentSectionHeroAgent', headingRich?: any | null, fallbackHeadingRich?: any | null, textRich?: any | null, image?: { __typename: 'PageGenericContentSectionHeroAgentImage', src?: string | null, width?: number | null, height?: number | null, aspectRatio?: number | null, format?: string | null, alt?: string | null } | null, defaultProducts?: Array<{ __typename: 'PageGenericContentSectionHeroAgentDefaultProducts' } | null> | null, display?: { __typename: 'PageGenericContentSectionHeroAgentDisplay', icon?: boolean | null, graphic?: boolean | null, actionLabel?: boolean | null, descriptionText?: boolean | null, descriptionItems?: boolean | null, disclaimer?: boolean | null, buttons?: boolean | null } | null } | { __typename: 'PageGenericContentSectionLogos', headingText?: string | null, images?: Array<{ __typename: 'PageGenericContentSectionLogosImages', image?: string | null, title?: string | null } | null> | null } | { __typename: 'PageGenericContentSectionBadges', title?: string | null, badges?: Array<{ __typename: 'PageGenericContentSectionBadgesBadges', image?: string | null, text?: string | null } | null> | null } | { __typename: 'PageGenericContentSectionTestimonialSlider', title?: string | null, headingRich?: any | null, highlight?: string | null, textRich?: any | null, items?: Array<{ __typename: 'PageGenericContentSectionTestimonialSliderItems' } | null> | null } | { __typename: 'PageGenericContentSectionTestimonialGrid', headingText?: string | null, items?: Array<{ __typename: 'PageGenericContentSectionTestimonialGridItems' } | null> | null } | { __typename: 'PageGenericContentSectionFloatingCta', headingText?: string | null, text?: string | null, buttons?: Array<{ __typename: 'PageGenericContentSectionFloatingCtaButtons', label?: string | null, link?: string | null, ariaLabel?: string | null } | null> | null } | { __typename: 'PageGenericContentSectionImageCta', headingText?: string | null, text?: string | null, imageSrc?: string | null, buttons?: Array<{ __typename: 'PageGenericContentSectionImageCtaButtons', label?: string | null, link?: string | null, ariaLabel?: string | null } | null> | null } | { __typename: 'PageGenericContentSectionProducts', headingRich?: any | null, text?: string | null, title?: string | null, items?: Array<{ __typename: 'PageGenericContentSectionProductsItems' } | null> | null, display?: { __typename: 'PageGenericContentSectionProductsDisplay', icon?: boolean | null, graphic?: boolean | null, actionLabel?: boolean | null, descriptionText?: boolean | null, descriptionItems?: boolean | null, disclaimer?: boolean | null, buttons?: boolean | null } | null } | { __typename: 'PageGenericContentSectionProductsSimple', items?: Array<{ __typename: 'PageGenericContentSectionProductsSimpleItems' } | null> | null, display?: { __typename: 'PageGenericContentSectionProductsSimpleDisplay', actionLabel?: boolean | null, descriptionText?: boolean | null, descriptionItems?: boolean | null, disclaimer?: boolean | null, buttons?: boolean | null } | null } | { __typename: 'PageGenericContentSectionHowItWorks', title?: string | null, headingText?: string | null, active?: number | null, items?: Array<{ __typename: 'PageGenericContentSectionHowItWorksItems', image?: string | null, headingText?: string | null, subheadingText?: string | null, text?: string | null, button?: { __typename: 'PageGenericContentSectionHowItWorksItemsButton', label?: string | null, link?: string | null, ariaLabel?: string | null } | null } | null> | null, display?: { __typename: 'PageGenericContentSectionHowItWorksDisplay', number?: boolean | null } | null } | { __typename: 'PageGenericContentSectionIconColumns', title?: string | null, headingText?: string | null, subheadingText?: string | null, colNum?: number | null, colSpacing?: number | null, bgColor?: string | null, cols?: Array<{ __typename: 'PageGenericContentSectionIconColumnsCols', imageSrc?: string | null, disableIconBg?: boolean | null, size?: number | null, title?: string | null, titleSize?: string | null, text?: string | null } | null> | null } | { __typename: 'PageGenericContentSectionBlogPosts', title?: string | null, headingText?: string | null, posts?: Array<{ __typename: 'PageGenericContentSectionBlogPostsPosts' } | null> | null } | { __typename: 'PageGenericContentSectionArticles', title?: string | null, headingText?: string | null, posts?: Array<{ __typename: 'PageGenericContentSectionArticlesPosts' } | null> | null } | { __typename: 'PageGenericContentSectionCtaArticles', posts?: Array<{ __typename: 'PageGenericContentSectionCtaArticlesPosts', tag?: string | null, headingText?: string | null, imageSrc?: string | null, cta?: { __typename: 'PageGenericContentSectionCtaArticlesPostsCta', label?: string | null, link?: string | null } | null } | null> | null } | { __typename: 'PageGenericContentSectionHelpfulArticles', title?: string | null, cta?: { __typename: 'PageGenericContentSectionHelpfulArticlesCta', headingText?: string | null, imageSrc?: string | null, button?: { __typename: 'PageGenericContentSectionHelpfulArticlesCtaButton', label?: string | null, link?: string | null } | null } | null, posts?: Array<{ __typename: 'PageGenericContentSectionHelpfulArticlesPosts' } | null> | null } | { __typename: 'PageGenericContentSectionStats', title?: string | null, headingText?: string | null, secondaryHeading?: any | null, text?: string | null, imageSrc?: string | null, items?: Array<{ __typename: 'PageGenericContentSectionStatsItems', number?: number | null, unit?: string | null, text?: string | null } | null> | null, button?: { __typename: 'PageGenericContentSectionStatsButton', label?: string | null, link?: string | null, ariaLabel?: string | null } | null, quote?: { __typename: 'PageGenericContentSectionStatsQuote', text?: string | null, author?: string | null, title?: string | null } | null } | { __typename: 'PageGenericContentSectionResources', title?: string | null, headingText?: string | null, imageSrc?: string | null, groups?: Array<{ __typename: 'PageGenericContentSectionResourcesGroups', title?: string | null, items?: Array<{ __typename: 'PageGenericContentSectionResourcesGroupsItems', label?: string | null, link?: string | null, ariaLabel?: string | null } | null> | null } | null> | null } | { __typename: 'PageGenericContentSectionResourceHub', title?: string | null, headingText?: string | null, imageSrc?: string | null, groups?: Array<{ __typename: 'PageGenericContentSectionResourceHubGroups', title?: string | null, tocTitle?: string | null, articles?: Array<{ __typename: 'PageGenericContentSectionResourceHubGroupsArticles', title?: string | null, textRich?: any | null, link?: { __typename: 'PageGenericContentSectionResourceHubGroupsArticlesLink', label?: string | null, link?: string | null, ariaLabel?: string | null } | null } | null> | null } | null> | null } | { __typename: 'PageGenericContentSectionFileResources', filterSettings?: { __typename: 'PageGenericContentSectionFileResourcesFilterSettings', title?: string | null, resetLabel?: string | null, noItemsMessage?: string | null, filters?: Array<{ __typename: 'PageGenericContentSectionFileResourcesFilterSettingsFilters', label?: string | null, items?: Array<{ __typename: 'PageGenericContentSectionFileResourcesFilterSettingsFiltersItems', label?: string | null, tag?: string | null } | null> | null } | null> | null } | null, resources?: Array<{ __typename: 'PageGenericContentSectionFileResourcesResources', title?: string | null, type?: string | null, tooltip?: string | null, link?: string | null, tags?: Array<string | null> | null } | null> | null } | { __typename: 'PageGenericContentSectionOurStory', headingText?: string | null, subheadingText?: string | null, textRich?: any | null } | { __typename: 'PageGenericContentSectionTeam', headingText?: string | null, items?: Array<{ __typename: 'PageGenericContentSectionTeamItems', image?: string | null, name?: string | null, title?: string | null, about?: string | null } | null> | null } | { __typename: 'PageGenericContentSectionValues', headingText?: string | null, items?: Array<{ __typename: 'PageGenericContentSectionValuesItems', icon?: string | null, title?: string | null, text?: string | null } | null> | null } | { __typename: 'PageGenericContentSectionImage', scrollable?: boolean | null, spacing?: number | null, maxWidth?: string | null, align?: string | null, brzImage?: { __typename: 'PageGenericContentSectionImageBrzImage', title?: string | null, src?: string | null, width?: number | null, height?: number | null, aspectRatio?: number | null, format?: string | null, alt?: string | null, radius?: number | null } | null } | { __typename: 'PageGenericContentSectionButtons', align?: string | null, spacing?: number | null, buttons?: Array<{ __typename: 'PageGenericContentSectionButtonsButtons', label?: string | null, link?: string | null, ariaLabel?: string | null, variant?: string | null, color?: string | null, size?: string | null } | null> | null } | { __typename: 'PageGenericContentSectionPress', headingText?: string | null, textRich?: any | null, items?: Array<{ __typename: 'PageGenericContentSectionPressItems', headingText?: string | null, link?: string | null } | null> | null } | { __typename: 'PageGenericContentSectionTwoColumnText', title?: string | null, headingText?: string | null, imageSrc?: string | null, textRich?: any | null } | { __typename: 'PageGenericContentSectionThreeColumnText', headingText?: string | null, cols?: Array<{ __typename: 'PageGenericContentSectionThreeColumnTextCols', title?: string | null, textRich?: any | null } | null> | null } | { __typename: 'PageGenericContentSectionVibe', title?: string | null, headingText?: string | null, text?: string | null, imageSrc?: string | null, button?: { __typename: 'PageGenericContentSectionVibeButton', label?: string | null, link?: string | null, ariaLabel?: string | null } | null, items?: Array<{ __typename: 'PageGenericContentSectionVibeItems', icon?: string | null, title?: string | null, text?: string | null } | null> | null } | { __typename: 'PageGenericContentSectionSellingPoints', imageSrc?: string | null, headingText?: string | null, text?: string | null, items?: Array<{ __typename: 'PageGenericContentSectionSellingPointsItems', icon?: string | null, title?: string | null, text?: string | null } | null> | null } | { __typename: 'PageGenericContentSectionOpenings', sectionId?: string | null, headingText?: string | null, textRich?: any | null, title?: string | null, items?: Array<{ __typename: 'PageGenericContentSectionOpeningsItems', title?: string | null, location?: string | null, link?: string | null } | null> | null } | { __typename: 'PageGenericContentSectionStoryCards', title?: string | null, items?: Array<{ __typename: 'PageGenericContentSectionStoryCardsItemsEmployeeStory', textRich?: any | null, author?: string | null, authorTitle?: string | null, authorImage?: string | null } | { __typename: 'PageGenericContentSectionStoryCardsItemsAchievement', title?: string | null, textRich?: any | null, badgeImage?: string | null, brzImage?: { __typename: 'PageGenericContentSectionStoryCardsItemsAchievementBrzImage', src?: string | null, width?: number | null, height?: number | null, aspectRatio?: number | null, format?: string | null, alt?: string | null } | null } | { __typename: 'PageGenericContentSectionStoryCardsItemsAnnouncement', headingText?: string | null, subheadingText?: string | null, textRich?: any | null, images?: Array<{ __typename: 'PageGenericContentSectionStoryCardsItemsAnnouncementImages', imageSrc?: string | null, alt?: string | null } | null> | null } | null> | null } | { __typename: 'PageGenericContentSectionOtherOffers', headingText?: string | null, items?: Array<{ __typename: 'PageGenericContentSectionOtherOffersItems', headingText?: string | null, text?: string | null, imageSrc?: string | null } | null> | null } | { __typename: 'PageGenericContentSectionAccordion', title?: string | null, sectionId?: string | null, items?: Array<{ __typename: 'PageGenericContentSectionAccordionItems', title?: string | null, textRich?: any | null } | null> | null } | { __typename: 'PageGenericContentSectionQuoteProposal', headingText?: string | null, subheadingRich?: any | null, imageSrc?: string | null, addonsHeadingText?: string | null, helpTip?: { __typename: 'PageGenericContentSectionQuoteProposalHelpTip', headingText?: string | null, contentRich?: any | null } | null, notFoundError?: { __typename: 'PageGenericContentSectionQuoteProposalNotFoundError', headingText?: string | null, textRich?: any | null } | null, genericError?: { __typename: 'PageGenericContentSectionQuoteProposalGenericError', headingText?: string | null, textRich?: any | null } | null } | { __typename: 'PageGenericContentSectionTable', title?: string | null, headingText?: string | null, rows?: Array<{ __typename: 'PageGenericContentSectionTableRows', columns?: Array<string | null> | null } | null> | null } | { __typename: 'PageGenericContentSectionHeading', align?: string | null, title?: string | null, headingLevel?: string | null, headingText?: string | null, text?: string | null, marginBottom?: string | null } | { __typename: 'PageGenericContentSectionContent', align?: string | null, maxWidth?: string | null, contentRich?: any | null } | { __typename: 'PageGenericContentSectionSidebarContent', sidebarRich?: any | null, rows?: Array<{ __typename: 'PageGenericContentSectionSidebarContentRows', cols?: Array<{ __typename: 'PageGenericContentSectionSidebarContentRowsCols', contentRich?: any | null } | null> | null } | null> | null } | { __typename: 'PageGenericContentSectionHTML', contentText?: string | null } | null> | null } | { __typename: 'PageBlog', id: string, component?: string | null, updatedDate?: string | null, publishedDate?: string | null, title: string, heading?: string | null, _sys: { __typename?: 'SystemInfo', filename: string, basename: string, breadcrumbs: Array<string>, path: string, relativePath: string, extension: string }, settings?: { __typename: 'PageBlogSettings', publish?: { __typename: 'PageBlogSettingsPublish', published?: boolean | null, publishedDate?: string | null } | null, seo?: { __typename: 'PageBlogSettingsSeo', title?: string | null, url?: string | null, description?: string | null, image?: { __typename: 'PageFormSettingsSeoImage', src?: string | null, width?: number | null, height?: number | null, aspectRatio?: number | null, format?: string | null, alt?: string | null } | null, org?: { __typename: 'PageFormSettingsSeoOrg', disable?: boolean | null } | null, faq?: { __typename: 'PageFormSettingsSeoFaq', disable?: boolean | null, name?: string | null, items?: Array<{ __typename: 'ArticleSettingsSeoFaqItems', q?: string | null, a?: string | null } | null> | null } | null, howTo?: { __typename: 'PageFormSettingsSeoHowTo', disable?: boolean | null, name?: string | null, description?: string | null, image?: { __typename: 'ArticleSettingsSeoHowToImage', src?: string | null, width?: number | null, height?: number | null, aspectRatio?: number | null, format?: string | null, alt?: string | null } | null, steps?: Array<{ __typename: 'ArticleSettingsSeoHowToSteps', name?: string | null, url?: string | null, text?: string | null } | null> | null } | null } | null, sitemap?: { __typename: 'PageBlogSettingsSitemap', exclude?: boolean | null, breadcrumb?: string | null, changefreq?: string | null, priority?: number | null } | null, navigation?: { __typename: 'PageBlogSettingsNavigation', disableLogo?: boolean | null, disableLeft?: boolean | null, disableRight?: boolean | null, disableButtons?: boolean | null, rightSideButtonOverride?: { __typename: 'PageFormSettingsNavigationRightSideButtonOverride', label?: string | null, link?: string | null, ariaLabel?: string | null } | null } | null, footer?: { __typename: 'PageBlogSettingsFooter', disableLinks?: boolean | null, disableBottom?: boolean | null } | null, disclaimer?: { __typename: 'PageBlogSettingsDisclaimer', disable?: boolean | null, content?: any | null } | null, partner?: { __typename: 'PageBlogSettingsPartner' } | null, client?: { __typename: 'PageBlogSettingsClient', enabled?: boolean | null } | null } | null, categories?: Array<{ __typename: 'PageBlogCategories' } | null> | null, popular?: Array<{ __typename: 'PageBlogPopular' } | null> | null, cta?: { __typename: 'PageBlogCta', headingText?: string | null, text?: string | null, buttons?: Array<{ __typename: 'PageBlogCtaButtons', label?: string | null, link?: string | null, ariaLabel?: string | null } | null> | null } | null } | { __typename: 'PageForm', id: string, component?: string | null, updatedDate?: string | null, publishedDate?: string | null, title: string, _sys: { __typename?: 'SystemInfo', filename: string, basename: string, breadcrumbs: Array<string>, path: string, relativePath: string, extension: string }, settings?: { __typename: 'PageFormSettings', publish?: { __typename: 'PageFormSettingsPublish', published?: boolean | null, publishedDate?: string | null } | null, seo?: { __typename: 'PageFormSettingsSeo', title?: string | null, url?: string | null, description?: string | null, image?: { __typename: 'ArticleSettingsSeoImage', src?: string | null, width?: number | null, height?: number | null, aspectRatio?: number | null, format?: string | null, alt?: string | null } | null, org?: { __typename: 'ArticleSettingsSeoOrg', disable?: boolean | null } | null, faq?: { __typename: 'ArticleSettingsSeoFaq', disable?: boolean | null, name?: string | null, items?: Array<{ __typename: 'PostSettingsSeoFaqItems', q?: string | null, a?: string | null } | null> | null } | null, howTo?: { __typename: 'ArticleSettingsSeoHowTo', disable?: boolean | null, name?: string | null, description?: string | null, image?: { __typename: 'PostSettingsSeoHowToImage', src?: string | null, width?: number | null, height?: number | null, aspectRatio?: number | null, format?: string | null, alt?: string | null } | null, steps?: Array<{ __typename: 'PostSettingsSeoHowToSteps', name?: string | null, url?: string | null, text?: string | null } | null> | null } | null } | null, sitemap?: { __typename: 'PageFormSettingsSitemap', exclude?: boolean | null, breadcrumb?: string | null, changefreq?: string | null, priority?: number | null } | null, navigation?: { __typename: 'PageFormSettingsNavigation', disableLogo?: boolean | null, disableLeft?: boolean | null, disableRight?: boolean | null, disableButtons?: boolean | null, rightSideButtonOverride?: { __typename: 'ArticleSettingsNavigationRightSideButtonOverride', label?: string | null, link?: string | null, ariaLabel?: string | null } | null } | null, footer?: { __typename: 'PageFormSettingsFooter', disableLinks?: boolean | null, disableBottom?: boolean | null } | null, disclaimer?: { __typename: 'PageFormSettingsDisclaimer', disable?: boolean | null, content?: any | null } | null, partner?: { __typename: 'PageFormSettingsPartner' } | null, client?: { __typename: 'PageFormSettingsClient', enabled?: boolean | null } | null } | null, carrier?: { __typename: 'PageFormCarrier', logo?: string | null, headingText?: string | null, text?: string | null, button?: { __typename: 'PageFormCarrierButton', label?: string | null, link?: string | null, ariaLabel?: string | null, hint?: string | null } | null } | null, form?: { __typename: 'PageFormForm', title?: string | null, headingText?: string | null, subheadingText?: string | null, images?: Array<{ __typename: 'PageFormFormImages', image?: string | null, title?: string | null } | null> | null } | null, calendar?: { __typename: 'PageFormCalendar', headingText?: string | null, subheadingText?: string | null } | null, sidebar?: { __typename: 'PageFormSidebar', headingText?: string | null, subheadingText?: string | null, image?: string | null, help?: { __typename: 'PageFormSidebarHelp', title?: string | null, links?: Array<{ __typename: 'PageFormSidebarHelpLinks', label?: string | null, link?: string | null, ariaLabel?: string | null } | null> | null } | null, items?: Array<{ __typename: 'PageFormSidebarItems', title?: string | null, text?: string | null } | null> | null, contacts?: { __typename: 'PageFormSidebarContacts', title?: string | null, items?: Array<{ __typename: 'PageFormSidebarContactsItems', textRich?: any | null, sub?: string | null } | null> | null } | null } | null } };

export type PageConnectionQueryVariables = Exact<{
  before?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Float']['input']>;
  last?: InputMaybe<Scalars['Float']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<PageFilter>;
}>;


export type PageConnectionQuery = { __typename?: 'Query', pageConnection: { __typename?: 'PageConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', hasPreviousPage: boolean, hasNextPage: boolean, startCursor: string, endCursor: string }, edges?: Array<{ __typename?: 'PageConnectionEdges', cursor: string, node?: { __typename: 'PageGeneric', id: string, component?: string | null, updatedDate?: string | null, publishedDate?: string | null, title: string, _sys: { __typename?: 'SystemInfo', filename: string, basename: string, breadcrumbs: Array<string>, path: string, relativePath: string, extension: string }, settings?: { __typename: 'PageGenericSettings', publish?: { __typename: 'PageGenericSettingsPublish', published?: boolean | null, publishedDate?: string | null } | null, seo?: { __typename: 'PageGenericSettingsSeo', title?: string | null, url?: string | null, description?: string | null, image?: { __typename: 'PageBlogSettingsSeoImage', src?: string | null, width?: number | null, height?: number | null, aspectRatio?: number | null, format?: string | null, alt?: string | null } | null, org?: { __typename: 'PageBlogSettingsSeoOrg', disable?: boolean | null } | null, faq?: { __typename: 'PageBlogSettingsSeoFaq', disable?: boolean | null, name?: string | null, items?: Array<{ __typename: 'PageFormSettingsSeoFaqItems', q?: string | null, a?: string | null } | null> | null } | null, howTo?: { __typename: 'PageBlogSettingsSeoHowTo', disable?: boolean | null, name?: string | null, description?: string | null, image?: { __typename: 'PageFormSettingsSeoHowToImage', src?: string | null, width?: number | null, height?: number | null, aspectRatio?: number | null, format?: string | null, alt?: string | null } | null, steps?: Array<{ __typename: 'PageFormSettingsSeoHowToSteps', name?: string | null, url?: string | null, text?: string | null } | null> | null } | null } | null, sitemap?: { __typename: 'PageGenericSettingsSitemap', exclude?: boolean | null, breadcrumb?: string | null, changefreq?: string | null, priority?: number | null } | null, navigation?: { __typename: 'PageGenericSettingsNavigation', disableLogo?: boolean | null, disableLeft?: boolean | null, disableRight?: boolean | null, disableButtons?: boolean | null, rightSideButtonOverride?: { __typename: 'PageBlogSettingsNavigationRightSideButtonOverride', label?: string | null, link?: string | null, ariaLabel?: string | null } | null } | null, footer?: { __typename: 'PageGenericSettingsFooter', disableLinks?: boolean | null, disableBottom?: boolean | null } | null, disclaimer?: { __typename: 'PageGenericSettingsDisclaimer', disable?: boolean | null, content?: any | null } | null, partner?: { __typename: 'PageGenericSettingsPartner' } | null, client?: { __typename: 'PageGenericSettingsClient', enabled?: boolean | null } | null } | null, content?: Array<{ __typename: 'PageGenericContentSectionHeroGeneric', title?: string | null, headingSize?: string | null, headingRich?: any | null, subheadingRich?: any | null, textRich?: any | null, lists?: Array<{ __typename: 'PageGenericContentSectionHeroGenericLists', title?: string | null, items?: Array<string | null> | null } | null> | null, image?: { __typename: 'PageGenericContentSectionHeroGenericImage', src?: string | null, width?: number | null, height?: number | null, aspectRatio?: number | null, format?: string | null, alt?: string | null, scale?: number | null } | null, buttons?: Array<{ __typename: 'PageGenericContentSectionHeroGenericButtons', label?: string | null, link?: string | null, ariaLabel?: string | null } | null> | null, floatingItems?: Array<{ __typename: 'PageGenericContentSectionHeroGenericFloatingItemsSingleIconLinkItem', icon?: string | null, title?: string | null, text?: string | null, link?: string | null } | { __typename: 'PageGenericContentSectionHeroGenericFloatingItemsSingleIconTextItem', icon?: string | null, text?: string | null } | { __typename: 'PageGenericContentSectionHeroGenericFloatingItemsGroupedIconTextItem', items?: Array<{ __typename: 'PageGenericContentSectionHeroGenericFloatingItemsGroupedIconTextItemItems', icon?: string | null, text?: string | null } | null> | null } | { __typename: 'PageGenericContentSectionHeroGenericFloatingItemsSingleImageTextItem', image?: string | null, text?: string | null } | { __typename: 'PageGenericContentSectionHeroGenericFloatingItemsGroupedImageTextItem', items?: Array<{ __typename: 'PageGenericContentSectionHeroGenericFloatingItemsGroupedImageTextItemItems', image?: string | null, text?: string | null } | null> | null } | { __typename: 'PageGenericContentSectionHeroGenericFloatingItemsSingleImageItem', image?: string | null } | null> | null } | { __typename: 'PageGenericContentSectionHeroAgent', headingRich?: any | null, fallbackHeadingRich?: any | null, textRich?: any | null, image?: { __typename: 'PageGenericContentSectionHeroAgentImage', src?: string | null, width?: number | null, height?: number | null, aspectRatio?: number | null, format?: string | null, alt?: string | null } | null, defaultProducts?: Array<{ __typename: 'PageGenericContentSectionHeroAgentDefaultProducts' } | null> | null, display?: { __typename: 'PageGenericContentSectionHeroAgentDisplay', icon?: boolean | null, graphic?: boolean | null, actionLabel?: boolean | null, descriptionText?: boolean | null, descriptionItems?: boolean | null, disclaimer?: boolean | null, buttons?: boolean | null } | null } | { __typename: 'PageGenericContentSectionLogos', headingText?: string | null, images?: Array<{ __typename: 'PageGenericContentSectionLogosImages', image?: string | null, title?: string | null } | null> | null } | { __typename: 'PageGenericContentSectionBadges', title?: string | null, badges?: Array<{ __typename: 'PageGenericContentSectionBadgesBadges', image?: string | null, text?: string | null } | null> | null } | { __typename: 'PageGenericContentSectionTestimonialSlider', title?: string | null, headingRich?: any | null, highlight?: string | null, textRich?: any | null, items?: Array<{ __typename: 'PageGenericContentSectionTestimonialSliderItems' } | null> | null } | { __typename: 'PageGenericContentSectionTestimonialGrid', headingText?: string | null, items?: Array<{ __typename: 'PageGenericContentSectionTestimonialGridItems' } | null> | null } | { __typename: 'PageGenericContentSectionFloatingCta', headingText?: string | null, text?: string | null, buttons?: Array<{ __typename: 'PageGenericContentSectionFloatingCtaButtons', label?: string | null, link?: string | null, ariaLabel?: string | null } | null> | null } | { __typename: 'PageGenericContentSectionImageCta', headingText?: string | null, text?: string | null, imageSrc?: string | null, buttons?: Array<{ __typename: 'PageGenericContentSectionImageCtaButtons', label?: string | null, link?: string | null, ariaLabel?: string | null } | null> | null } | { __typename: 'PageGenericContentSectionProducts', headingRich?: any | null, text?: string | null, title?: string | null, items?: Array<{ __typename: 'PageGenericContentSectionProductsItems' } | null> | null, display?: { __typename: 'PageGenericContentSectionProductsDisplay', icon?: boolean | null, graphic?: boolean | null, actionLabel?: boolean | null, descriptionText?: boolean | null, descriptionItems?: boolean | null, disclaimer?: boolean | null, buttons?: boolean | null } | null } | { __typename: 'PageGenericContentSectionProductsSimple', items?: Array<{ __typename: 'PageGenericContentSectionProductsSimpleItems' } | null> | null, display?: { __typename: 'PageGenericContentSectionProductsSimpleDisplay', actionLabel?: boolean | null, descriptionText?: boolean | null, descriptionItems?: boolean | null, disclaimer?: boolean | null, buttons?: boolean | null } | null } | { __typename: 'PageGenericContentSectionHowItWorks', title?: string | null, headingText?: string | null, active?: number | null, items?: Array<{ __typename: 'PageGenericContentSectionHowItWorksItems', image?: string | null, headingText?: string | null, subheadingText?: string | null, text?: string | null, button?: { __typename: 'PageGenericContentSectionHowItWorksItemsButton', label?: string | null, link?: string | null, ariaLabel?: string | null } | null } | null> | null, display?: { __typename: 'PageGenericContentSectionHowItWorksDisplay', number?: boolean | null } | null } | { __typename: 'PageGenericContentSectionIconColumns', title?: string | null, headingText?: string | null, subheadingText?: string | null, colNum?: number | null, colSpacing?: number | null, bgColor?: string | null, cols?: Array<{ __typename: 'PageGenericContentSectionIconColumnsCols', imageSrc?: string | null, disableIconBg?: boolean | null, size?: number | null, title?: string | null, titleSize?: string | null, text?: string | null } | null> | null } | { __typename: 'PageGenericContentSectionBlogPosts', title?: string | null, headingText?: string | null, posts?: Array<{ __typename: 'PageGenericContentSectionBlogPostsPosts' } | null> | null } | { __typename: 'PageGenericContentSectionArticles', title?: string | null, headingText?: string | null, posts?: Array<{ __typename: 'PageGenericContentSectionArticlesPosts' } | null> | null } | { __typename: 'PageGenericContentSectionCtaArticles', posts?: Array<{ __typename: 'PageGenericContentSectionCtaArticlesPosts', tag?: string | null, headingText?: string | null, imageSrc?: string | null, cta?: { __typename: 'PageGenericContentSectionCtaArticlesPostsCta', label?: string | null, link?: string | null } | null } | null> | null } | { __typename: 'PageGenericContentSectionHelpfulArticles', title?: string | null, cta?: { __typename: 'PageGenericContentSectionHelpfulArticlesCta', headingText?: string | null, imageSrc?: string | null, button?: { __typename: 'PageGenericContentSectionHelpfulArticlesCtaButton', label?: string | null, link?: string | null } | null } | null, posts?: Array<{ __typename: 'PageGenericContentSectionHelpfulArticlesPosts' } | null> | null } | { __typename: 'PageGenericContentSectionStats', title?: string | null, headingText?: string | null, secondaryHeading?: any | null, text?: string | null, imageSrc?: string | null, items?: Array<{ __typename: 'PageGenericContentSectionStatsItems', number?: number | null, unit?: string | null, text?: string | null } | null> | null, button?: { __typename: 'PageGenericContentSectionStatsButton', label?: string | null, link?: string | null, ariaLabel?: string | null } | null, quote?: { __typename: 'PageGenericContentSectionStatsQuote', text?: string | null, author?: string | null, title?: string | null } | null } | { __typename: 'PageGenericContentSectionResources', title?: string | null, headingText?: string | null, imageSrc?: string | null, groups?: Array<{ __typename: 'PageGenericContentSectionResourcesGroups', title?: string | null, items?: Array<{ __typename: 'PageGenericContentSectionResourcesGroupsItems', label?: string | null, link?: string | null, ariaLabel?: string | null } | null> | null } | null> | null } | { __typename: 'PageGenericContentSectionResourceHub', title?: string | null, headingText?: string | null, imageSrc?: string | null, groups?: Array<{ __typename: 'PageGenericContentSectionResourceHubGroups', title?: string | null, tocTitle?: string | null, articles?: Array<{ __typename: 'PageGenericContentSectionResourceHubGroupsArticles', title?: string | null, textRich?: any | null, link?: { __typename: 'PageGenericContentSectionResourceHubGroupsArticlesLink', label?: string | null, link?: string | null, ariaLabel?: string | null } | null } | null> | null } | null> | null } | { __typename: 'PageGenericContentSectionFileResources', filterSettings?: { __typename: 'PageGenericContentSectionFileResourcesFilterSettings', title?: string | null, resetLabel?: string | null, noItemsMessage?: string | null, filters?: Array<{ __typename: 'PageGenericContentSectionFileResourcesFilterSettingsFilters', label?: string | null, items?: Array<{ __typename: 'PageGenericContentSectionFileResourcesFilterSettingsFiltersItems', label?: string | null, tag?: string | null } | null> | null } | null> | null } | null, resources?: Array<{ __typename: 'PageGenericContentSectionFileResourcesResources', title?: string | null, type?: string | null, tooltip?: string | null, link?: string | null, tags?: Array<string | null> | null } | null> | null } | { __typename: 'PageGenericContentSectionOurStory', headingText?: string | null, subheadingText?: string | null, textRich?: any | null } | { __typename: 'PageGenericContentSectionTeam', headingText?: string | null, items?: Array<{ __typename: 'PageGenericContentSectionTeamItems', image?: string | null, name?: string | null, title?: string | null, about?: string | null } | null> | null } | { __typename: 'PageGenericContentSectionValues', headingText?: string | null, items?: Array<{ __typename: 'PageGenericContentSectionValuesItems', icon?: string | null, title?: string | null, text?: string | null } | null> | null } | { __typename: 'PageGenericContentSectionImage', scrollable?: boolean | null, spacing?: number | null, maxWidth?: string | null, align?: string | null, brzImage?: { __typename: 'PageGenericContentSectionImageBrzImage', title?: string | null, src?: string | null, width?: number | null, height?: number | null, aspectRatio?: number | null, format?: string | null, alt?: string | null, radius?: number | null } | null } | { __typename: 'PageGenericContentSectionButtons', align?: string | null, spacing?: number | null, buttons?: Array<{ __typename: 'PageGenericContentSectionButtonsButtons', label?: string | null, link?: string | null, ariaLabel?: string | null, variant?: string | null, color?: string | null, size?: string | null } | null> | null } | { __typename: 'PageGenericContentSectionPress', headingText?: string | null, textRich?: any | null, items?: Array<{ __typename: 'PageGenericContentSectionPressItems', headingText?: string | null, link?: string | null } | null> | null } | { __typename: 'PageGenericContentSectionTwoColumnText', title?: string | null, headingText?: string | null, imageSrc?: string | null, textRich?: any | null } | { __typename: 'PageGenericContentSectionThreeColumnText', headingText?: string | null, cols?: Array<{ __typename: 'PageGenericContentSectionThreeColumnTextCols', title?: string | null, textRich?: any | null } | null> | null } | { __typename: 'PageGenericContentSectionVibe', title?: string | null, headingText?: string | null, text?: string | null, imageSrc?: string | null, button?: { __typename: 'PageGenericContentSectionVibeButton', label?: string | null, link?: string | null, ariaLabel?: string | null } | null, items?: Array<{ __typename: 'PageGenericContentSectionVibeItems', icon?: string | null, title?: string | null, text?: string | null } | null> | null } | { __typename: 'PageGenericContentSectionSellingPoints', imageSrc?: string | null, headingText?: string | null, text?: string | null, items?: Array<{ __typename: 'PageGenericContentSectionSellingPointsItems', icon?: string | null, title?: string | null, text?: string | null } | null> | null } | { __typename: 'PageGenericContentSectionOpenings', sectionId?: string | null, headingText?: string | null, textRich?: any | null, title?: string | null, items?: Array<{ __typename: 'PageGenericContentSectionOpeningsItems', title?: string | null, location?: string | null, link?: string | null } | null> | null } | { __typename: 'PageGenericContentSectionStoryCards', title?: string | null, items?: Array<{ __typename: 'PageGenericContentSectionStoryCardsItemsEmployeeStory', textRich?: any | null, author?: string | null, authorTitle?: string | null, authorImage?: string | null } | { __typename: 'PageGenericContentSectionStoryCardsItemsAchievement', title?: string | null, textRich?: any | null, badgeImage?: string | null, brzImage?: { __typename: 'PageGenericContentSectionStoryCardsItemsAchievementBrzImage', src?: string | null, width?: number | null, height?: number | null, aspectRatio?: number | null, format?: string | null, alt?: string | null } | null } | { __typename: 'PageGenericContentSectionStoryCardsItemsAnnouncement', headingText?: string | null, subheadingText?: string | null, textRich?: any | null, images?: Array<{ __typename: 'PageGenericContentSectionStoryCardsItemsAnnouncementImages', imageSrc?: string | null, alt?: string | null } | null> | null } | null> | null } | { __typename: 'PageGenericContentSectionOtherOffers', headingText?: string | null, items?: Array<{ __typename: 'PageGenericContentSectionOtherOffersItems', headingText?: string | null, text?: string | null, imageSrc?: string | null } | null> | null } | { __typename: 'PageGenericContentSectionAccordion', title?: string | null, sectionId?: string | null, items?: Array<{ __typename: 'PageGenericContentSectionAccordionItems', title?: string | null, textRich?: any | null } | null> | null } | { __typename: 'PageGenericContentSectionQuoteProposal', headingText?: string | null, subheadingRich?: any | null, imageSrc?: string | null, addonsHeadingText?: string | null, helpTip?: { __typename: 'PageGenericContentSectionQuoteProposalHelpTip', headingText?: string | null, contentRich?: any | null } | null, notFoundError?: { __typename: 'PageGenericContentSectionQuoteProposalNotFoundError', headingText?: string | null, textRich?: any | null } | null, genericError?: { __typename: 'PageGenericContentSectionQuoteProposalGenericError', headingText?: string | null, textRich?: any | null } | null } | { __typename: 'PageGenericContentSectionTable', title?: string | null, headingText?: string | null, rows?: Array<{ __typename: 'PageGenericContentSectionTableRows', columns?: Array<string | null> | null } | null> | null } | { __typename: 'PageGenericContentSectionHeading', align?: string | null, title?: string | null, headingLevel?: string | null, headingText?: string | null, text?: string | null, marginBottom?: string | null } | { __typename: 'PageGenericContentSectionContent', align?: string | null, maxWidth?: string | null, contentRich?: any | null } | { __typename: 'PageGenericContentSectionSidebarContent', sidebarRich?: any | null, rows?: Array<{ __typename: 'PageGenericContentSectionSidebarContentRows', cols?: Array<{ __typename: 'PageGenericContentSectionSidebarContentRowsCols', contentRich?: any | null } | null> | null } | null> | null } | { __typename: 'PageGenericContentSectionHTML', contentText?: string | null } | null> | null } | { __typename: 'PageBlog', id: string, component?: string | null, updatedDate?: string | null, publishedDate?: string | null, title: string, heading?: string | null, _sys: { __typename?: 'SystemInfo', filename: string, basename: string, breadcrumbs: Array<string>, path: string, relativePath: string, extension: string }, settings?: { __typename: 'PageBlogSettings', publish?: { __typename: 'PageBlogSettingsPublish', published?: boolean | null, publishedDate?: string | null } | null, seo?: { __typename: 'PageBlogSettingsSeo', title?: string | null, url?: string | null, description?: string | null, image?: { __typename: 'PageFormSettingsSeoImage', src?: string | null, width?: number | null, height?: number | null, aspectRatio?: number | null, format?: string | null, alt?: string | null } | null, org?: { __typename: 'PageFormSettingsSeoOrg', disable?: boolean | null } | null, faq?: { __typename: 'PageFormSettingsSeoFaq', disable?: boolean | null, name?: string | null, items?: Array<{ __typename: 'ArticleSettingsSeoFaqItems', q?: string | null, a?: string | null } | null> | null } | null, howTo?: { __typename: 'PageFormSettingsSeoHowTo', disable?: boolean | null, name?: string | null, description?: string | null, image?: { __typename: 'ArticleSettingsSeoHowToImage', src?: string | null, width?: number | null, height?: number | null, aspectRatio?: number | null, format?: string | null, alt?: string | null } | null, steps?: Array<{ __typename: 'ArticleSettingsSeoHowToSteps', name?: string | null, url?: string | null, text?: string | null } | null> | null } | null } | null, sitemap?: { __typename: 'PageBlogSettingsSitemap', exclude?: boolean | null, breadcrumb?: string | null, changefreq?: string | null, priority?: number | null } | null, navigation?: { __typename: 'PageBlogSettingsNavigation', disableLogo?: boolean | null, disableLeft?: boolean | null, disableRight?: boolean | null, disableButtons?: boolean | null, rightSideButtonOverride?: { __typename: 'PageFormSettingsNavigationRightSideButtonOverride', label?: string | null, link?: string | null, ariaLabel?: string | null } | null } | null, footer?: { __typename: 'PageBlogSettingsFooter', disableLinks?: boolean | null, disableBottom?: boolean | null } | null, disclaimer?: { __typename: 'PageBlogSettingsDisclaimer', disable?: boolean | null, content?: any | null } | null, partner?: { __typename: 'PageBlogSettingsPartner' } | null, client?: { __typename: 'PageBlogSettingsClient', enabled?: boolean | null } | null } | null, categories?: Array<{ __typename: 'PageBlogCategories' } | null> | null, popular?: Array<{ __typename: 'PageBlogPopular' } | null> | null, cta?: { __typename: 'PageBlogCta', headingText?: string | null, text?: string | null, buttons?: Array<{ __typename: 'PageBlogCtaButtons', label?: string | null, link?: string | null, ariaLabel?: string | null } | null> | null } | null } | { __typename: 'PageForm', id: string, component?: string | null, updatedDate?: string | null, publishedDate?: string | null, title: string, _sys: { __typename?: 'SystemInfo', filename: string, basename: string, breadcrumbs: Array<string>, path: string, relativePath: string, extension: string }, settings?: { __typename: 'PageFormSettings', publish?: { __typename: 'PageFormSettingsPublish', published?: boolean | null, publishedDate?: string | null } | null, seo?: { __typename: 'PageFormSettingsSeo', title?: string | null, url?: string | null, description?: string | null, image?: { __typename: 'ArticleSettingsSeoImage', src?: string | null, width?: number | null, height?: number | null, aspectRatio?: number | null, format?: string | null, alt?: string | null } | null, org?: { __typename: 'ArticleSettingsSeoOrg', disable?: boolean | null } | null, faq?: { __typename: 'ArticleSettingsSeoFaq', disable?: boolean | null, name?: string | null, items?: Array<{ __typename: 'PostSettingsSeoFaqItems', q?: string | null, a?: string | null } | null> | null } | null, howTo?: { __typename: 'ArticleSettingsSeoHowTo', disable?: boolean | null, name?: string | null, description?: string | null, image?: { __typename: 'PostSettingsSeoHowToImage', src?: string | null, width?: number | null, height?: number | null, aspectRatio?: number | null, format?: string | null, alt?: string | null } | null, steps?: Array<{ __typename: 'PostSettingsSeoHowToSteps', name?: string | null, url?: string | null, text?: string | null } | null> | null } | null } | null, sitemap?: { __typename: 'PageFormSettingsSitemap', exclude?: boolean | null, breadcrumb?: string | null, changefreq?: string | null, priority?: number | null } | null, navigation?: { __typename: 'PageFormSettingsNavigation', disableLogo?: boolean | null, disableLeft?: boolean | null, disableRight?: boolean | null, disableButtons?: boolean | null, rightSideButtonOverride?: { __typename: 'ArticleSettingsNavigationRightSideButtonOverride', label?: string | null, link?: string | null, ariaLabel?: string | null } | null } | null, footer?: { __typename: 'PageFormSettingsFooter', disableLinks?: boolean | null, disableBottom?: boolean | null } | null, disclaimer?: { __typename: 'PageFormSettingsDisclaimer', disable?: boolean | null, content?: any | null } | null, partner?: { __typename: 'PageFormSettingsPartner' } | null, client?: { __typename: 'PageFormSettingsClient', enabled?: boolean | null } | null } | null, carrier?: { __typename: 'PageFormCarrier', logo?: string | null, headingText?: string | null, text?: string | null, button?: { __typename: 'PageFormCarrierButton', label?: string | null, link?: string | null, ariaLabel?: string | null, hint?: string | null } | null } | null, form?: { __typename: 'PageFormForm', title?: string | null, headingText?: string | null, subheadingText?: string | null, images?: Array<{ __typename: 'PageFormFormImages', image?: string | null, title?: string | null } | null> | null } | null, calendar?: { __typename: 'PageFormCalendar', headingText?: string | null, subheadingText?: string | null } | null, sidebar?: { __typename: 'PageFormSidebar', headingText?: string | null, subheadingText?: string | null, image?: string | null, help?: { __typename: 'PageFormSidebarHelp', title?: string | null, links?: Array<{ __typename: 'PageFormSidebarHelpLinks', label?: string | null, link?: string | null, ariaLabel?: string | null } | null> | null } | null, items?: Array<{ __typename: 'PageFormSidebarItems', title?: string | null, text?: string | null } | null> | null, contacts?: { __typename: 'PageFormSidebarContacts', title?: string | null, items?: Array<{ __typename: 'PageFormSidebarContactsItems', textRich?: any | null, sub?: string | null } | null> | null } | null } | null } | null } | null> | null } };

export type ArticleQueryVariables = Exact<{
  relativePath: Scalars['String']['input'];
}>;


export type ArticleQuery = { __typename?: 'Query', article: { __typename: 'Article', id: string, component?: string | null, updatedDate?: string | null, publishedDate?: string | null, title: string, cover?: string | null, thumbnail?: string | null, headingRich?: any | null, subtitleRich?: string | null, excerptText?: string | null, body?: any | null, _sys: { __typename?: 'SystemInfo', filename: string, basename: string, breadcrumbs: Array<string>, path: string, relativePath: string, extension: string }, settings?: { __typename: 'ArticleSettings', publish?: { __typename: 'ArticleSettingsPublish', published?: boolean | null, publishedDate?: string | null } | null, seo?: { __typename: 'ArticleSettingsSeo', title?: string | null, url?: string | null, description?: string | null, image?: { __typename: 'PostSettingsSeoImage', src?: string | null, width?: number | null, height?: number | null, aspectRatio?: number | null, format?: string | null, alt?: string | null } | null, org?: { __typename: 'PostSettingsSeoOrg', disable?: boolean | null } | null, faq?: { __typename: 'PostSettingsSeoFaq', disable?: boolean | null, name?: string | null, items?: Array<{ __typename: 'CategorySettingsSeoFaqItems', q?: string | null, a?: string | null } | null> | null } | null, howTo?: { __typename: 'PostSettingsSeoHowTo', disable?: boolean | null, name?: string | null, description?: string | null, image?: { __typename: 'CategorySettingsSeoHowToImage', src?: string | null, width?: number | null, height?: number | null, aspectRatio?: number | null, format?: string | null, alt?: string | null } | null, steps?: Array<{ __typename: 'CategorySettingsSeoHowToSteps', name?: string | null, url?: string | null, text?: string | null } | null> | null } | null } | null, sitemap?: { __typename: 'ArticleSettingsSitemap', exclude?: boolean | null, breadcrumb?: string | null, changefreq?: string | null, priority?: number | null } | null, navigation?: { __typename: 'ArticleSettingsNavigation', disableLogo?: boolean | null, disableLeft?: boolean | null, disableRight?: boolean | null, disableButtons?: boolean | null, rightSideButtonOverride?: { __typename: 'PostSettingsNavigationRightSideButtonOverride', label?: string | null, link?: string | null, ariaLabel?: string | null } | null } | null, footer?: { __typename: 'ArticleSettingsFooter', disableLinks?: boolean | null, disableBottom?: boolean | null } | null, disclaimer?: { __typename: 'ArticleSettingsDisclaimer', disable?: boolean | null, content?: any | null } | null, partner?: { __typename: 'ArticleSettingsPartner' } | null, client?: { __typename: 'ArticleSettingsClient', enabled?: boolean | null } | null } | null, readtime?: { __typename: 'ArticleReadtime', text?: string | null, minutes?: number | null, time?: number | null, words?: number | null } | null, widgets?: Array<{ __typename: 'ArticleWidgets', image?: string | null, heading?: string | null, text?: string | null, label?: string | null, link?: string | null } | null> | null, cta?: { __typename: 'ArticleCta', headingText?: string | null, text?: string | null, buttons?: Array<{ __typename: 'ArticleCtaButtons', label?: string | null, link?: string | null, ariaLabel?: string | null } | null> | null } | null, related?: Array<{ __typename: 'ArticleRelated' } | null> | null } };

export type ArticleConnectionQueryVariables = Exact<{
  before?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Float']['input']>;
  last?: InputMaybe<Scalars['Float']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ArticleFilter>;
}>;


export type ArticleConnectionQuery = { __typename?: 'Query', articleConnection: { __typename?: 'ArticleConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', hasPreviousPage: boolean, hasNextPage: boolean, startCursor: string, endCursor: string }, edges?: Array<{ __typename?: 'ArticleConnectionEdges', cursor: string, node?: { __typename: 'Article', id: string, component?: string | null, updatedDate?: string | null, publishedDate?: string | null, title: string, cover?: string | null, thumbnail?: string | null, headingRich?: any | null, subtitleRich?: string | null, excerptText?: string | null, body?: any | null, _sys: { __typename?: 'SystemInfo', filename: string, basename: string, breadcrumbs: Array<string>, path: string, relativePath: string, extension: string }, settings?: { __typename: 'ArticleSettings', publish?: { __typename: 'ArticleSettingsPublish', published?: boolean | null, publishedDate?: string | null } | null, seo?: { __typename: 'ArticleSettingsSeo', title?: string | null, url?: string | null, description?: string | null, image?: { __typename: 'PostSettingsSeoImage', src?: string | null, width?: number | null, height?: number | null, aspectRatio?: number | null, format?: string | null, alt?: string | null } | null, org?: { __typename: 'PostSettingsSeoOrg', disable?: boolean | null } | null, faq?: { __typename: 'PostSettingsSeoFaq', disable?: boolean | null, name?: string | null, items?: Array<{ __typename: 'CategorySettingsSeoFaqItems', q?: string | null, a?: string | null } | null> | null } | null, howTo?: { __typename: 'PostSettingsSeoHowTo', disable?: boolean | null, name?: string | null, description?: string | null, image?: { __typename: 'CategorySettingsSeoHowToImage', src?: string | null, width?: number | null, height?: number | null, aspectRatio?: number | null, format?: string | null, alt?: string | null } | null, steps?: Array<{ __typename: 'CategorySettingsSeoHowToSteps', name?: string | null, url?: string | null, text?: string | null } | null> | null } | null } | null, sitemap?: { __typename: 'ArticleSettingsSitemap', exclude?: boolean | null, breadcrumb?: string | null, changefreq?: string | null, priority?: number | null } | null, navigation?: { __typename: 'ArticleSettingsNavigation', disableLogo?: boolean | null, disableLeft?: boolean | null, disableRight?: boolean | null, disableButtons?: boolean | null, rightSideButtonOverride?: { __typename: 'PostSettingsNavigationRightSideButtonOverride', label?: string | null, link?: string | null, ariaLabel?: string | null } | null } | null, footer?: { __typename: 'ArticleSettingsFooter', disableLinks?: boolean | null, disableBottom?: boolean | null } | null, disclaimer?: { __typename: 'ArticleSettingsDisclaimer', disable?: boolean | null, content?: any | null } | null, partner?: { __typename: 'ArticleSettingsPartner' } | null, client?: { __typename: 'ArticleSettingsClient', enabled?: boolean | null } | null } | null, readtime?: { __typename: 'ArticleReadtime', text?: string | null, minutes?: number | null, time?: number | null, words?: number | null } | null, widgets?: Array<{ __typename: 'ArticleWidgets', image?: string | null, heading?: string | null, text?: string | null, label?: string | null, link?: string | null } | null> | null, cta?: { __typename: 'ArticleCta', headingText?: string | null, text?: string | null, buttons?: Array<{ __typename: 'ArticleCtaButtons', label?: string | null, link?: string | null, ariaLabel?: string | null } | null> | null } | null, related?: Array<{ __typename: 'ArticleRelated' } | null> | null } | null } | null> | null } };

export type PostQueryVariables = Exact<{
  relativePath: Scalars['String']['input'];
}>;


export type PostQuery = { __typename?: 'Query', post: { __typename: 'Post', id: string, component?: string | null, updatedDate?: string | null, publishedDate?: string | null, title: string, cover?: string | null, thumbnail?: string | null, headingRich?: any | null, excerptText?: string | null, body?: any | null, _sys: { __typename?: 'SystemInfo', filename: string, basename: string, breadcrumbs: Array<string>, path: string, relativePath: string, extension: string }, settings?: { __typename: 'PostSettings', publish?: { __typename: 'PostSettingsPublish', published?: boolean | null, publishedDate?: string | null } | null, seo?: { __typename: 'PostSettingsSeo', title?: string | null, url?: string | null, description?: string | null, image?: { __typename: 'CategorySettingsSeoImage', src?: string | null, width?: number | null, height?: number | null, aspectRatio?: number | null, format?: string | null, alt?: string | null } | null, org?: { __typename: 'CategorySettingsSeoOrg', disable?: boolean | null } | null, faq?: { __typename: 'CategorySettingsSeoFaq', disable?: boolean | null, name?: string | null, items?: Array<{ __typename: 'AuthorSettingsSeoFaqItems', q?: string | null, a?: string | null } | null> | null } | null, howTo?: { __typename: 'CategorySettingsSeoHowTo', disable?: boolean | null, name?: string | null, description?: string | null, image?: { __typename: 'AuthorSettingsSeoHowToImage', src?: string | null, width?: number | null, height?: number | null, aspectRatio?: number | null, format?: string | null, alt?: string | null } | null, steps?: Array<{ __typename: 'AuthorSettingsSeoHowToSteps', name?: string | null, url?: string | null, text?: string | null } | null> | null } | null } | null, sitemap?: { __typename: 'PostSettingsSitemap', exclude?: boolean | null, breadcrumb?: string | null, changefreq?: string | null, priority?: number | null } | null, navigation?: { __typename: 'PostSettingsNavigation', disableLogo?: boolean | null, disableLeft?: boolean | null, disableRight?: boolean | null, disableButtons?: boolean | null, rightSideButtonOverride?: { __typename: 'CategorySettingsNavigationRightSideButtonOverride', label?: string | null, link?: string | null, ariaLabel?: string | null } | null } | null, footer?: { __typename: 'PostSettingsFooter', disableLinks?: boolean | null, disableBottom?: boolean | null } | null, disclaimer?: { __typename: 'PostSettingsDisclaimer', disable?: boolean | null, content?: any | null } | null, partner?: { __typename: 'PostSettingsPartner' } | null, client?: { __typename: 'PostSettingsClient', enabled?: boolean | null } | null } | null, readtime?: { __typename: 'PostReadtime', text?: string | null, minutes?: number | null, time?: number | null, words?: number | null } | null, widgets?: Array<{ __typename: 'PostWidgets', image?: string | null, heading?: string | null, text?: string | null, label?: string | null, link?: string | null } | null> | null, cta?: { __typename: 'PostCta', headingText?: string | null, text?: string | null, buttons?: Array<{ __typename: 'PostCtaButtons', label?: string | null, link?: string | null, ariaLabel?: string | null } | null> | null } | null, related?: Array<{ __typename: 'PostRelated' } | null> | null } };

export type PostConnectionQueryVariables = Exact<{
  before?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Float']['input']>;
  last?: InputMaybe<Scalars['Float']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<PostFilter>;
}>;


export type PostConnectionQuery = { __typename?: 'Query', postConnection: { __typename?: 'PostConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', hasPreviousPage: boolean, hasNextPage: boolean, startCursor: string, endCursor: string }, edges?: Array<{ __typename?: 'PostConnectionEdges', cursor: string, node?: { __typename: 'Post', id: string, component?: string | null, updatedDate?: string | null, publishedDate?: string | null, title: string, cover?: string | null, thumbnail?: string | null, headingRich?: any | null, excerptText?: string | null, body?: any | null, _sys: { __typename?: 'SystemInfo', filename: string, basename: string, breadcrumbs: Array<string>, path: string, relativePath: string, extension: string }, settings?: { __typename: 'PostSettings', publish?: { __typename: 'PostSettingsPublish', published?: boolean | null, publishedDate?: string | null } | null, seo?: { __typename: 'PostSettingsSeo', title?: string | null, url?: string | null, description?: string | null, image?: { __typename: 'CategorySettingsSeoImage', src?: string | null, width?: number | null, height?: number | null, aspectRatio?: number | null, format?: string | null, alt?: string | null } | null, org?: { __typename: 'CategorySettingsSeoOrg', disable?: boolean | null } | null, faq?: { __typename: 'CategorySettingsSeoFaq', disable?: boolean | null, name?: string | null, items?: Array<{ __typename: 'AuthorSettingsSeoFaqItems', q?: string | null, a?: string | null } | null> | null } | null, howTo?: { __typename: 'CategorySettingsSeoHowTo', disable?: boolean | null, name?: string | null, description?: string | null, image?: { __typename: 'AuthorSettingsSeoHowToImage', src?: string | null, width?: number | null, height?: number | null, aspectRatio?: number | null, format?: string | null, alt?: string | null } | null, steps?: Array<{ __typename: 'AuthorSettingsSeoHowToSteps', name?: string | null, url?: string | null, text?: string | null } | null> | null } | null } | null, sitemap?: { __typename: 'PostSettingsSitemap', exclude?: boolean | null, breadcrumb?: string | null, changefreq?: string | null, priority?: number | null } | null, navigation?: { __typename: 'PostSettingsNavigation', disableLogo?: boolean | null, disableLeft?: boolean | null, disableRight?: boolean | null, disableButtons?: boolean | null, rightSideButtonOverride?: { __typename: 'CategorySettingsNavigationRightSideButtonOverride', label?: string | null, link?: string | null, ariaLabel?: string | null } | null } | null, footer?: { __typename: 'PostSettingsFooter', disableLinks?: boolean | null, disableBottom?: boolean | null } | null, disclaimer?: { __typename: 'PostSettingsDisclaimer', disable?: boolean | null, content?: any | null } | null, partner?: { __typename: 'PostSettingsPartner' } | null, client?: { __typename: 'PostSettingsClient', enabled?: boolean | null } | null } | null, readtime?: { __typename: 'PostReadtime', text?: string | null, minutes?: number | null, time?: number | null, words?: number | null } | null, widgets?: Array<{ __typename: 'PostWidgets', image?: string | null, heading?: string | null, text?: string | null, label?: string | null, link?: string | null } | null> | null, cta?: { __typename: 'PostCta', headingText?: string | null, text?: string | null, buttons?: Array<{ __typename: 'PostCtaButtons', label?: string | null, link?: string | null, ariaLabel?: string | null } | null> | null } | null, related?: Array<{ __typename: 'PostRelated' } | null> | null } | null } | null> | null } };

export type CategoryQueryVariables = Exact<{
  relativePath: Scalars['String']['input'];
}>;


export type CategoryQuery = { __typename?: 'Query', category: { __typename: 'Category', id: string, component?: string | null, updatedDate?: string | null, publishedDate?: string | null, title: string, name?: string | null, _sys: { __typename?: 'SystemInfo', filename: string, basename: string, breadcrumbs: Array<string>, path: string, relativePath: string, extension: string }, settings?: { __typename: 'CategorySettings', publish?: { __typename: 'CategorySettingsPublish', published?: boolean | null, publishedDate?: string | null } | null, seo?: { __typename: 'CategorySettingsSeo', title?: string | null, url?: string | null, description?: string | null, image?: { __typename: 'AuthorSettingsSeoImage', src?: string | null, width?: number | null, height?: number | null, aspectRatio?: number | null, format?: string | null, alt?: string | null } | null, org?: { __typename: 'AuthorSettingsSeoOrg', disable?: boolean | null } | null, faq?: { __typename: 'AuthorSettingsSeoFaq', disable?: boolean | null, name?: string | null, items?: Array<{ __typename: 'AuthorSettingsSeoFaqItems', q?: string | null, a?: string | null } | null> | null } | null, howTo?: { __typename: 'AuthorSettingsSeoHowTo', disable?: boolean | null, name?: string | null, description?: string | null, image?: { __typename: 'AuthorSettingsSeoHowToImage', src?: string | null, width?: number | null, height?: number | null, aspectRatio?: number | null, format?: string | null, alt?: string | null } | null, steps?: Array<{ __typename: 'AuthorSettingsSeoHowToSteps', name?: string | null, url?: string | null, text?: string | null } | null> | null } | null } | null, sitemap?: { __typename: 'CategorySettingsSitemap', exclude?: boolean | null, breadcrumb?: string | null, changefreq?: string | null, priority?: number | null } | null, navigation?: { __typename: 'CategorySettingsNavigation', disableLogo?: boolean | null, disableLeft?: boolean | null, disableRight?: boolean | null, disableButtons?: boolean | null, rightSideButtonOverride?: { __typename: 'AuthorSettingsNavigationRightSideButtonOverride', label?: string | null, link?: string | null, ariaLabel?: string | null } | null } | null, footer?: { __typename: 'CategorySettingsFooter', disableLinks?: boolean | null, disableBottom?: boolean | null } | null, disclaimer?: { __typename: 'CategorySettingsDisclaimer', disable?: boolean | null, content?: any | null } | null, partner?: { __typename: 'CategorySettingsPartner' } | null, client?: { __typename: 'CategorySettingsClient', enabled?: boolean | null } | null } | null } };

export type CategoryConnectionQueryVariables = Exact<{
  before?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Float']['input']>;
  last?: InputMaybe<Scalars['Float']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<CategoryFilter>;
}>;


export type CategoryConnectionQuery = { __typename?: 'Query', categoryConnection: { __typename?: 'CategoryConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', hasPreviousPage: boolean, hasNextPage: boolean, startCursor: string, endCursor: string }, edges?: Array<{ __typename?: 'CategoryConnectionEdges', cursor: string, node?: { __typename: 'Category', id: string, component?: string | null, updatedDate?: string | null, publishedDate?: string | null, title: string, name?: string | null, _sys: { __typename?: 'SystemInfo', filename: string, basename: string, breadcrumbs: Array<string>, path: string, relativePath: string, extension: string }, settings?: { __typename: 'CategorySettings', publish?: { __typename: 'CategorySettingsPublish', published?: boolean | null, publishedDate?: string | null } | null, seo?: { __typename: 'CategorySettingsSeo', title?: string | null, url?: string | null, description?: string | null, image?: { __typename: 'AuthorSettingsSeoImage', src?: string | null, width?: number | null, height?: number | null, aspectRatio?: number | null, format?: string | null, alt?: string | null } | null, org?: { __typename: 'AuthorSettingsSeoOrg', disable?: boolean | null } | null, faq?: { __typename: 'AuthorSettingsSeoFaq', disable?: boolean | null, name?: string | null, items?: Array<{ __typename: 'AuthorSettingsSeoFaqItems', q?: string | null, a?: string | null } | null> | null } | null, howTo?: { __typename: 'AuthorSettingsSeoHowTo', disable?: boolean | null, name?: string | null, description?: string | null, image?: { __typename: 'AuthorSettingsSeoHowToImage', src?: string | null, width?: number | null, height?: number | null, aspectRatio?: number | null, format?: string | null, alt?: string | null } | null, steps?: Array<{ __typename: 'AuthorSettingsSeoHowToSteps', name?: string | null, url?: string | null, text?: string | null } | null> | null } | null } | null, sitemap?: { __typename: 'CategorySettingsSitemap', exclude?: boolean | null, breadcrumb?: string | null, changefreq?: string | null, priority?: number | null } | null, navigation?: { __typename: 'CategorySettingsNavigation', disableLogo?: boolean | null, disableLeft?: boolean | null, disableRight?: boolean | null, disableButtons?: boolean | null, rightSideButtonOverride?: { __typename: 'AuthorSettingsNavigationRightSideButtonOverride', label?: string | null, link?: string | null, ariaLabel?: string | null } | null } | null, footer?: { __typename: 'CategorySettingsFooter', disableLinks?: boolean | null, disableBottom?: boolean | null } | null, disclaimer?: { __typename: 'CategorySettingsDisclaimer', disable?: boolean | null, content?: any | null } | null, partner?: { __typename: 'CategorySettingsPartner' } | null, client?: { __typename: 'CategorySettingsClient', enabled?: boolean | null } | null } | null } | null } | null> | null } };

export type AuthorQueryVariables = Exact<{
  relativePath: Scalars['String']['input'];
}>;


export type AuthorQuery = { __typename?: 'Query', author: { __typename: 'Author', id: string, component?: string | null, updatedDate?: string | null, publishedDate?: string | null, title: string, name?: string | null, jobTitle?: string | null, avatar?: string | null, email?: string | null, bio?: any | null, _sys: { __typename?: 'SystemInfo', filename: string, basename: string, breadcrumbs: Array<string>, path: string, relativePath: string, extension: string }, settings?: { __typename: 'AuthorSettings', publish?: { __typename: 'AuthorSettingsPublish', published?: boolean | null, publishedDate?: string | null } | null, seo?: { __typename: 'AuthorSettingsSeo', title?: string | null, url?: string | null, description?: string | null, image?: { __typename: 'AuthorSettingsSeoImage', src?: string | null, width?: number | null, height?: number | null, aspectRatio?: number | null, format?: string | null, alt?: string | null } | null, org?: { __typename: 'AuthorSettingsSeoOrg', disable?: boolean | null } | null, faq?: { __typename: 'AuthorSettingsSeoFaq', disable?: boolean | null, name?: string | null, items?: Array<{ __typename: 'AuthorSettingsSeoFaqItems', q?: string | null, a?: string | null } | null> | null } | null, howTo?: { __typename: 'AuthorSettingsSeoHowTo', disable?: boolean | null, name?: string | null, description?: string | null, image?: { __typename: 'AuthorSettingsSeoHowToImage', src?: string | null, width?: number | null, height?: number | null, aspectRatio?: number | null, format?: string | null, alt?: string | null } | null, steps?: Array<{ __typename: 'AuthorSettingsSeoHowToSteps', name?: string | null, url?: string | null, text?: string | null } | null> | null } | null } | null, sitemap?: { __typename: 'AuthorSettingsSitemap', exclude?: boolean | null, breadcrumb?: string | null, changefreq?: string | null, priority?: number | null } | null, navigation?: { __typename: 'AuthorSettingsNavigation', disableLogo?: boolean | null, disableLeft?: boolean | null, disableRight?: boolean | null, disableButtons?: boolean | null, rightSideButtonOverride?: { __typename: 'AuthorSettingsNavigationRightSideButtonOverride', label?: string | null, link?: string | null, ariaLabel?: string | null } | null } | null, footer?: { __typename: 'AuthorSettingsFooter', disableLinks?: boolean | null, disableBottom?: boolean | null } | null, disclaimer?: { __typename: 'AuthorSettingsDisclaimer', disable?: boolean | null, content?: any | null } | null, partner?: { __typename: 'AuthorSettingsPartner' } | null, client?: { __typename: 'AuthorSettingsClient', enabled?: boolean | null } | null } | null } };

export type AuthorConnectionQueryVariables = Exact<{
  before?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Float']['input']>;
  last?: InputMaybe<Scalars['Float']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<AuthorFilter>;
}>;


export type AuthorConnectionQuery = { __typename?: 'Query', authorConnection: { __typename?: 'AuthorConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', hasPreviousPage: boolean, hasNextPage: boolean, startCursor: string, endCursor: string }, edges?: Array<{ __typename?: 'AuthorConnectionEdges', cursor: string, node?: { __typename: 'Author', id: string, component?: string | null, updatedDate?: string | null, publishedDate?: string | null, title: string, name?: string | null, jobTitle?: string | null, avatar?: string | null, email?: string | null, bio?: any | null, _sys: { __typename?: 'SystemInfo', filename: string, basename: string, breadcrumbs: Array<string>, path: string, relativePath: string, extension: string }, settings?: { __typename: 'AuthorSettings', publish?: { __typename: 'AuthorSettingsPublish', published?: boolean | null, publishedDate?: string | null } | null, seo?: { __typename: 'AuthorSettingsSeo', title?: string | null, url?: string | null, description?: string | null, image?: { __typename: 'AuthorSettingsSeoImage', src?: string | null, width?: number | null, height?: number | null, aspectRatio?: number | null, format?: string | null, alt?: string | null } | null, org?: { __typename: 'AuthorSettingsSeoOrg', disable?: boolean | null } | null, faq?: { __typename: 'AuthorSettingsSeoFaq', disable?: boolean | null, name?: string | null, items?: Array<{ __typename: 'AuthorSettingsSeoFaqItems', q?: string | null, a?: string | null } | null> | null } | null, howTo?: { __typename: 'AuthorSettingsSeoHowTo', disable?: boolean | null, name?: string | null, description?: string | null, image?: { __typename: 'AuthorSettingsSeoHowToImage', src?: string | null, width?: number | null, height?: number | null, aspectRatio?: number | null, format?: string | null, alt?: string | null } | null, steps?: Array<{ __typename: 'AuthorSettingsSeoHowToSteps', name?: string | null, url?: string | null, text?: string | null } | null> | null } | null } | null, sitemap?: { __typename: 'AuthorSettingsSitemap', exclude?: boolean | null, breadcrumb?: string | null, changefreq?: string | null, priority?: number | null } | null, navigation?: { __typename: 'AuthorSettingsNavigation', disableLogo?: boolean | null, disableLeft?: boolean | null, disableRight?: boolean | null, disableButtons?: boolean | null, rightSideButtonOverride?: { __typename: 'AuthorSettingsNavigationRightSideButtonOverride', label?: string | null, link?: string | null, ariaLabel?: string | null } | null } | null, footer?: { __typename: 'AuthorSettingsFooter', disableLinks?: boolean | null, disableBottom?: boolean | null } | null, disclaimer?: { __typename: 'AuthorSettingsDisclaimer', disable?: boolean | null, content?: any | null } | null, partner?: { __typename: 'AuthorSettingsPartner' } | null, client?: { __typename: 'AuthorSettingsClient', enabled?: boolean | null } | null } | null } | null } | null> | null } };

export type ProductQueryVariables = Exact<{
  relativePath: Scalars['String']['input'];
}>;


export type ProductQuery = { __typename?: 'Query', product: { __typename: 'Product', id: string, dataType?: string | null, title: string, productGroup: string, shortName?: string | null, icon?: string | null, graphic?: string | null, actionLabel?: string | null, descriptionText?: string | null, descriptionItems?: Array<string | null> | null, disclaimer?: string | null, _sys: { __typename?: 'SystemInfo', filename: string, basename: string, breadcrumbs: Array<string>, path: string, relativePath: string, extension: string }, buttons?: Array<{ __typename: 'ProductButtons', label?: string | null, link?: string | null, ariaLabel?: string | null, agentLink?: string | null } | null> | null } };

export type ProductConnectionQueryVariables = Exact<{
  before?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Float']['input']>;
  last?: InputMaybe<Scalars['Float']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ProductFilter>;
}>;


export type ProductConnectionQuery = { __typename?: 'Query', productConnection: { __typename?: 'ProductConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', hasPreviousPage: boolean, hasNextPage: boolean, startCursor: string, endCursor: string }, edges?: Array<{ __typename?: 'ProductConnectionEdges', cursor: string, node?: { __typename: 'Product', id: string, dataType?: string | null, title: string, productGroup: string, shortName?: string | null, icon?: string | null, graphic?: string | null, actionLabel?: string | null, descriptionText?: string | null, descriptionItems?: Array<string | null> | null, disclaimer?: string | null, _sys: { __typename?: 'SystemInfo', filename: string, basename: string, breadcrumbs: Array<string>, path: string, relativePath: string, extension: string }, buttons?: Array<{ __typename: 'ProductButtons', label?: string | null, link?: string | null, ariaLabel?: string | null, agentLink?: string | null } | null> | null } | null } | null> | null } };

export type TestimonialQueryVariables = Exact<{
  relativePath: Scalars['String']['input'];
}>;


export type TestimonialQuery = { __typename?: 'Query', testimonial: { __typename: 'Testimonial', id: string, dataType?: string | null, title: string, stars?: number | null, author?: string | null, authorTitle?: string | null, link?: string | null, body?: any | null, _sys: { __typename?: 'SystemInfo', filename: string, basename: string, breadcrumbs: Array<string>, path: string, relativePath: string, extension: string } } };

export type TestimonialConnectionQueryVariables = Exact<{
  before?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Float']['input']>;
  last?: InputMaybe<Scalars['Float']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<TestimonialFilter>;
}>;


export type TestimonialConnectionQuery = { __typename?: 'Query', testimonialConnection: { __typename?: 'TestimonialConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', hasPreviousPage: boolean, hasNextPage: boolean, startCursor: string, endCursor: string }, edges?: Array<{ __typename?: 'TestimonialConnectionEdges', cursor: string, node?: { __typename: 'Testimonial', id: string, dataType?: string | null, title: string, stars?: number | null, author?: string | null, authorTitle?: string | null, link?: string | null, body?: any | null, _sys: { __typename?: 'SystemInfo', filename: string, basename: string, breadcrumbs: Array<string>, path: string, relativePath: string, extension: string } } | null } | null> | null } };

export type PartnerQueryVariables = Exact<{
  relativePath: Scalars['String']['input'];
}>;


export type PartnerQuery = { __typename?: 'Query', partner: { __typename: 'Partner', id: string, dataType?: string | null, title: string, pid?: string | null, enabled?: boolean | null, displayName?: string | null, ctaLink?: string | null, products?: Array<string | null> | null, disclaimer?: string | null, _sys: { __typename?: 'SystemInfo', filename: string, basename: string, breadcrumbs: Array<string>, path: string, relativePath: string, extension: string }, logo?: { __typename: 'PartnerLogo', src?: string | null } | null } };

export type PartnerConnectionQueryVariables = Exact<{
  before?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Float']['input']>;
  last?: InputMaybe<Scalars['Float']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<PartnerFilter>;
}>;


export type PartnerConnectionQuery = { __typename?: 'Query', partnerConnection: { __typename?: 'PartnerConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', hasPreviousPage: boolean, hasNextPage: boolean, startCursor: string, endCursor: string }, edges?: Array<{ __typename?: 'PartnerConnectionEdges', cursor: string, node?: { __typename: 'Partner', id: string, dataType?: string | null, title: string, pid?: string | null, enabled?: boolean | null, displayName?: string | null, ctaLink?: string | null, products?: Array<string | null> | null, disclaimer?: string | null, _sys: { __typename?: 'SystemInfo', filename: string, basename: string, breadcrumbs: Array<string>, path: string, relativePath: string, extension: string }, logo?: { __typename: 'PartnerLogo', src?: string | null } | null } | null } | null> | null } };

export type CobrandQueryVariables = Exact<{
  relativePath: Scalars['String']['input'];
}>;


export type CobrandQuery = { __typename?: 'Query', cobrand: { __typename: 'Cobrand', id: string, dataType?: string | null, title: string, logoSrc?: string | null, displayName?: string | null, _sys: { __typename?: 'SystemInfo', filename: string, basename: string, breadcrumbs: Array<string>, path: string, relativePath: string, extension: string } } };

export type CobrandConnectionQueryVariables = Exact<{
  before?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Float']['input']>;
  last?: InputMaybe<Scalars['Float']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<CobrandFilter>;
}>;


export type CobrandConnectionQuery = { __typename?: 'Query', cobrandConnection: { __typename?: 'CobrandConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', hasPreviousPage: boolean, hasNextPage: boolean, startCursor: string, endCursor: string }, edges?: Array<{ __typename?: 'CobrandConnectionEdges', cursor: string, node?: { __typename: 'Cobrand', id: string, dataType?: string | null, title: string, logoSrc?: string | null, displayName?: string | null, _sys: { __typename?: 'SystemInfo', filename: string, basename: string, breadcrumbs: Array<string>, path: string, relativePath: string, extension: string } } | null } | null> | null } };

export type BgaQueryVariables = Exact<{
  relativePath: Scalars['String']['input'];
}>;


export type BgaQuery = { __typename?: 'Query', bga: { __typename: 'Bga', id: string, dataType?: string | null, title: string, urlSlug?: string | null, logoSrc?: string | null, mobileLogoSrc?: string | null, websiteDisplayName?: string | null, ctaLink?: string | null, _sys: { __typename?: 'SystemInfo', filename: string, basename: string, breadcrumbs: Array<string>, path: string, relativePath: string, extension: string }, productsRefs?: Array<{ __typename: 'BgaProductsRefs' } | null> | null } };

export type BgaConnectionQueryVariables = Exact<{
  before?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Float']['input']>;
  last?: InputMaybe<Scalars['Float']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<BgaFilter>;
}>;


export type BgaConnectionQuery = { __typename?: 'Query', bgaConnection: { __typename?: 'BgaConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', hasPreviousPage: boolean, hasNextPage: boolean, startCursor: string, endCursor: string }, edges?: Array<{ __typename?: 'BgaConnectionEdges', cursor: string, node?: { __typename: 'Bga', id: string, dataType?: string | null, title: string, urlSlug?: string | null, logoSrc?: string | null, mobileLogoSrc?: string | null, websiteDisplayName?: string | null, ctaLink?: string | null, _sys: { __typename?: 'SystemInfo', filename: string, basename: string, breadcrumbs: Array<string>, path: string, relativePath: string, extension: string }, productsRefs?: Array<{ __typename: 'BgaProductsRefs' } | null> | null } | null } | null> | null } };

export type NotificationQueryVariables = Exact<{
  relativePath: Scalars['String']['input'];
}>;


export type NotificationQuery = { __typename?: 'Query', notification: { __typename: 'Notification', id: string, title: string, color?: string | null, body?: any | null, _sys: { __typename?: 'SystemInfo', filename: string, basename: string, breadcrumbs: Array<string>, path: string, relativePath: string, extension: string } } };

export type NotificationConnectionQueryVariables = Exact<{
  before?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Float']['input']>;
  last?: InputMaybe<Scalars['Float']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<NotificationFilter>;
}>;


export type NotificationConnectionQuery = { __typename?: 'Query', notificationConnection: { __typename?: 'NotificationConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', hasPreviousPage: boolean, hasNextPage: boolean, startCursor: string, endCursor: string }, edges?: Array<{ __typename?: 'NotificationConnectionEdges', cursor: string, node?: { __typename: 'Notification', id: string, title: string, color?: string | null, body?: any | null, _sys: { __typename?: 'SystemInfo', filename: string, basename: string, breadcrumbs: Array<string>, path: string, relativePath: string, extension: string } } | null } | null> | null } };

export type SettingsQueryVariables = Exact<{
  relativePath: Scalars['String']['input'];
}>;


export type SettingsQuery = { __typename?: 'Query', settings: { __typename: 'SettingsNavigation', id: string, title: string, _sys: { __typename?: 'SystemInfo', filename: string, basename: string, breadcrumbs: Array<string>, path: string, relativePath: string, extension: string }, left?: Array<{ __typename: 'SettingsNavigationLeftMegaMenu', title?: string | null, heading?: string | null, items?: Array<{ __typename: 'SettingsNavigationLeftMegaMenuItems', title?: string | null, description?: string | null, icon?: string | null, image?: { __typename: 'SettingsNavigationLeftMegaMenuItemsImage', src?: string | null, width?: number | null, height?: number | null, aspectRatio?: number | null, format?: string | null, alt?: string | null } | null, buttons?: Array<{ __typename: 'SettingsNavigationLeftMegaMenuItemsButtons', label?: string | null, link?: string | null, ariaLabel?: string | null } | null> | null, columns?: Array<{ __typename: 'SettingsNavigationLeftMegaMenuItemsColumns', title?: string | null, links?: Array<{ __typename: 'SettingsNavigationLeftMegaMenuItemsColumnsLinks', label?: string | null, link?: string | null, ariaLabel?: string | null } | null> | null } | null> | null } | null> | null } | { __typename: 'SettingsNavigationLeftSimpleMenu', title?: string | null, items?: Array<{ __typename: 'SettingsNavigationLeftSimpleMenuItems', icon?: string | null, type?: string | null, title?: string | null, link?: string | null } | null> | null } | null> | null, right?: Array<{ __typename: 'SettingsNavigationRightLinkItem', label?: string | null, link?: string | null, ariaLabel?: string | null } | { __typename: 'SettingsNavigationRightDropdownItem', label?: string | null, items?: Array<{ __typename: 'SettingsNavigationRightDropdownItemItems', label?: string | null, link?: string | null, ariaLabel?: string | null } | null> | null } | { __typename: 'SettingsNavigationRightButtonItem', label?: string | null, link?: string | null, ariaLabel?: string | null } | null> | null } | { __typename: 'SettingsFooter', id: string, title: string, address?: string | null, disclaimer?: any | null, _sys: { __typename?: 'SystemInfo', filename: string, basename: string, breadcrumbs: Array<string>, path: string, relativePath: string, extension: string }, columns?: Array<{ __typename: 'SettingsFooterColumns', title?: string | null, image?: { __typename: 'SettingsFooterColumnsImage', src?: string | null, width?: number | null, height?: number | null, aspectRatio?: number | null, format?: string | null, alt?: string | null } | null, links?: Array<{ __typename: 'SettingsFooterColumnsLinks', label?: string | null, link?: string | null, ariaLabel?: string | null } | null> | null } | null> | null, extras?: Array<{ __typename: 'SettingsFooterExtras', title?: string | null, links?: Array<{ __typename: 'SettingsFooterExtrasLinks', label?: string | null, link?: string | null, ariaLabel?: string | null } | null> | null } | null> | null, contacts?: Array<{ __typename: 'SettingsFooterContacts', icon?: string | null, label?: string | null, link?: string | null, ariaLabel?: string | null } | null> | null, bottom?: { __typename: 'SettingsFooterBottom', copyright?: string | null, social?: Array<{ __typename: 'SettingsFooterBottomSocial', icon?: string | null, label?: string | null, link?: string | null, ariaLabel?: string | null } | null> | null, navigation?: Array<{ __typename: 'SettingsFooterBottomNavigation', label?: string | null, link?: string | null, ariaLabel?: string | null, newWindow?: boolean | null } | null> | null } | null } | { __typename: 'SettingsSite', id: string, title: string, name: string, legalName: string, baseUrl: string, description: string, phone: string, email: string, foundingDate?: number | null, socialLinks?: Array<string | null> | null, gtmId?: string | null, fbAppId?: string | null, twitterAuthor?: string | null, _sys: { __typename?: 'SystemInfo', filename: string, basename: string, breadcrumbs: Array<string>, path: string, relativePath: string, extension: string }, logo?: { __typename: 'SettingsSiteLogo', src?: string | null, width?: number | null, height?: number | null, aspectRatio?: number | null, format?: string | null, alt?: string | null } | null, founders?: Array<{ __typename: 'SettingsSiteFounders', name?: string | null, occupation?: string | null, socialLink?: string | null } | null> | null, businessAddress: { __typename: 'SettingsSiteBusinessAddress', street: string, city: string, state: string, zip: string }, rating: { __typename: 'SettingsSiteRating', value: number, outOf: number, reviews: number } } | { __typename: 'SettingsRedirects', id: string, title: string, _sys: { __typename?: 'SystemInfo', filename: string, basename: string, breadcrumbs: Array<string>, path: string, relativePath: string, extension: string }, redirect_groups?: Array<{ __typename: 'SettingsRedirectsRedirect_groups', name?: string | null, redirects?: Array<{ __typename: 'SettingsRedirectsRedirect_groupsRedirects', from_url?: string | null, to_url?: string | null } | null> | null } | null> | null } | { __typename: 'SettingsSecurity', id: string, title: string, _sys: { __typename?: 'SystemInfo', filename: string, basename: string, breadcrumbs: Array<string>, path: string, relativePath: string, extension: string }, csp?: Array<{ __typename: 'SettingsSecurityCsp', directive?: string | null, hosts?: Array<string | null> | null } | null> | null, blocked_ips?: Array<{ __typename: 'SettingsSecurityBlocked_ips', ip_address?: string | null, subnet_mask?: string | null, date_added?: string | null, note?: string | null } | null> | null } | { __typename: 'SettingsThreeStarOccList', id: string, title: string, occupations?: Array<string | null> | null, _sys: { __typename?: 'SystemInfo', filename: string, basename: string, breadcrumbs: Array<string>, path: string, relativePath: string, extension: string } } | { __typename: 'SettingsStatesListTemplate', id: string, title: string, states?: Array<string | null> | null, _sys: { __typename?: 'SystemInfo', filename: string, basename: string, breadcrumbs: Array<string>, path: string, relativePath: string, extension: string } } | { __typename: 'SettingsGroupDICompanyRateTypes', id: string, title: string, _sys: { __typename?: 'SystemInfo', filename: string, basename: string, breadcrumbs: Array<string>, path: string, relativePath: string, extension: string }, rates?: Array<{ __typename: 'SettingsGroupDICompanyRateTypesRates', name?: string | null, id?: string | null, rate?: number | null } | null> | null, companies?: Array<{ __typename: 'SettingsGroupDICompanyRateTypesCompanies', name?: string | null, id?: string | null, rateType?: string | null, hero?: string | null } | null> | null } | { __typename: 'SettingsNotFoundPage', id: string, title: string, subtitle?: string | null, headingText?: string | null, text?: string | null, _sys: { __typename?: 'SystemInfo', filename: string, basename: string, breadcrumbs: Array<string>, path: string, relativePath: string, extension: string }, seo?: { __typename: 'SettingsNotFoundPageSeo', title?: string | null, description?: string | null } | null, image?: { __typename: 'SettingsNotFoundPageImage', src?: string | null, width?: number | null, height?: number | null, aspectRatio?: number | null, format?: string | null, alt?: string | null } | null, cta?: { __typename: 'SettingsNotFoundPageCta', label?: string | null, link?: string | null, ariaLabel?: string | null } | null } | { __typename: 'SettingsAIRatesTable', id: string, title: string, _sys: { __typename?: 'SystemInfo', filename: string, basename: string, breadcrumbs: Array<string>, path: string, relativePath: string, extension: string }, table?: Array<{ __typename: 'SettingsAIRatesTableTable', states?: Array<string | null> | null, rates_by_age?: Array<{ __typename: 'SettingsAIRatesTableTableRates_by_age', age_range?: Array<string | null> | null, rates?: Array<string | null> | null } | null> | null } | null> | null } };

export type SettingsConnectionQueryVariables = Exact<{
  before?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Float']['input']>;
  last?: InputMaybe<Scalars['Float']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<SettingsFilter>;
}>;


export type SettingsConnectionQuery = { __typename?: 'Query', settingsConnection: { __typename?: 'SettingsConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', hasPreviousPage: boolean, hasNextPage: boolean, startCursor: string, endCursor: string }, edges?: Array<{ __typename?: 'SettingsConnectionEdges', cursor: string, node?: { __typename: 'SettingsNavigation', id: string, title: string, _sys: { __typename?: 'SystemInfo', filename: string, basename: string, breadcrumbs: Array<string>, path: string, relativePath: string, extension: string }, left?: Array<{ __typename: 'SettingsNavigationLeftMegaMenu', title?: string | null, heading?: string | null, items?: Array<{ __typename: 'SettingsNavigationLeftMegaMenuItems', title?: string | null, description?: string | null, icon?: string | null, image?: { __typename: 'SettingsNavigationLeftMegaMenuItemsImage', src?: string | null, width?: number | null, height?: number | null, aspectRatio?: number | null, format?: string | null, alt?: string | null } | null, buttons?: Array<{ __typename: 'SettingsNavigationLeftMegaMenuItemsButtons', label?: string | null, link?: string | null, ariaLabel?: string | null } | null> | null, columns?: Array<{ __typename: 'SettingsNavigationLeftMegaMenuItemsColumns', title?: string | null, links?: Array<{ __typename: 'SettingsNavigationLeftMegaMenuItemsColumnsLinks', label?: string | null, link?: string | null, ariaLabel?: string | null } | null> | null } | null> | null } | null> | null } | { __typename: 'SettingsNavigationLeftSimpleMenu', title?: string | null, items?: Array<{ __typename: 'SettingsNavigationLeftSimpleMenuItems', icon?: string | null, type?: string | null, title?: string | null, link?: string | null } | null> | null } | null> | null, right?: Array<{ __typename: 'SettingsNavigationRightLinkItem', label?: string | null, link?: string | null, ariaLabel?: string | null } | { __typename: 'SettingsNavigationRightDropdownItem', label?: string | null, items?: Array<{ __typename: 'SettingsNavigationRightDropdownItemItems', label?: string | null, link?: string | null, ariaLabel?: string | null } | null> | null } | { __typename: 'SettingsNavigationRightButtonItem', label?: string | null, link?: string | null, ariaLabel?: string | null } | null> | null } | { __typename: 'SettingsFooter', id: string, title: string, address?: string | null, disclaimer?: any | null, _sys: { __typename?: 'SystemInfo', filename: string, basename: string, breadcrumbs: Array<string>, path: string, relativePath: string, extension: string }, columns?: Array<{ __typename: 'SettingsFooterColumns', title?: string | null, image?: { __typename: 'SettingsFooterColumnsImage', src?: string | null, width?: number | null, height?: number | null, aspectRatio?: number | null, format?: string | null, alt?: string | null } | null, links?: Array<{ __typename: 'SettingsFooterColumnsLinks', label?: string | null, link?: string | null, ariaLabel?: string | null } | null> | null } | null> | null, extras?: Array<{ __typename: 'SettingsFooterExtras', title?: string | null, links?: Array<{ __typename: 'SettingsFooterExtrasLinks', label?: string | null, link?: string | null, ariaLabel?: string | null } | null> | null } | null> | null, contacts?: Array<{ __typename: 'SettingsFooterContacts', icon?: string | null, label?: string | null, link?: string | null, ariaLabel?: string | null } | null> | null, bottom?: { __typename: 'SettingsFooterBottom', copyright?: string | null, social?: Array<{ __typename: 'SettingsFooterBottomSocial', icon?: string | null, label?: string | null, link?: string | null, ariaLabel?: string | null } | null> | null, navigation?: Array<{ __typename: 'SettingsFooterBottomNavigation', label?: string | null, link?: string | null, ariaLabel?: string | null, newWindow?: boolean | null } | null> | null } | null } | { __typename: 'SettingsSite', id: string, title: string, name: string, legalName: string, baseUrl: string, description: string, phone: string, email: string, foundingDate?: number | null, socialLinks?: Array<string | null> | null, gtmId?: string | null, fbAppId?: string | null, twitterAuthor?: string | null, _sys: { __typename?: 'SystemInfo', filename: string, basename: string, breadcrumbs: Array<string>, path: string, relativePath: string, extension: string }, logo?: { __typename: 'SettingsSiteLogo', src?: string | null, width?: number | null, height?: number | null, aspectRatio?: number | null, format?: string | null, alt?: string | null } | null, founders?: Array<{ __typename: 'SettingsSiteFounders', name?: string | null, occupation?: string | null, socialLink?: string | null } | null> | null, businessAddress: { __typename: 'SettingsSiteBusinessAddress', street: string, city: string, state: string, zip: string }, rating: { __typename: 'SettingsSiteRating', value: number, outOf: number, reviews: number } } | { __typename: 'SettingsRedirects', id: string, title: string, _sys: { __typename?: 'SystemInfo', filename: string, basename: string, breadcrumbs: Array<string>, path: string, relativePath: string, extension: string }, redirect_groups?: Array<{ __typename: 'SettingsRedirectsRedirect_groups', name?: string | null, redirects?: Array<{ __typename: 'SettingsRedirectsRedirect_groupsRedirects', from_url?: string | null, to_url?: string | null } | null> | null } | null> | null } | { __typename: 'SettingsSecurity', id: string, title: string, _sys: { __typename?: 'SystemInfo', filename: string, basename: string, breadcrumbs: Array<string>, path: string, relativePath: string, extension: string }, csp?: Array<{ __typename: 'SettingsSecurityCsp', directive?: string | null, hosts?: Array<string | null> | null } | null> | null, blocked_ips?: Array<{ __typename: 'SettingsSecurityBlocked_ips', ip_address?: string | null, subnet_mask?: string | null, date_added?: string | null, note?: string | null } | null> | null } | { __typename: 'SettingsThreeStarOccList', id: string, title: string, occupations?: Array<string | null> | null, _sys: { __typename?: 'SystemInfo', filename: string, basename: string, breadcrumbs: Array<string>, path: string, relativePath: string, extension: string } } | { __typename: 'SettingsStatesListTemplate', id: string, title: string, states?: Array<string | null> | null, _sys: { __typename?: 'SystemInfo', filename: string, basename: string, breadcrumbs: Array<string>, path: string, relativePath: string, extension: string } } | { __typename: 'SettingsGroupDICompanyRateTypes', id: string, title: string, _sys: { __typename?: 'SystemInfo', filename: string, basename: string, breadcrumbs: Array<string>, path: string, relativePath: string, extension: string }, rates?: Array<{ __typename: 'SettingsGroupDICompanyRateTypesRates', name?: string | null, id?: string | null, rate?: number | null } | null> | null, companies?: Array<{ __typename: 'SettingsGroupDICompanyRateTypesCompanies', name?: string | null, id?: string | null, rateType?: string | null, hero?: string | null } | null> | null } | { __typename: 'SettingsNotFoundPage', id: string, title: string, subtitle?: string | null, headingText?: string | null, text?: string | null, _sys: { __typename?: 'SystemInfo', filename: string, basename: string, breadcrumbs: Array<string>, path: string, relativePath: string, extension: string }, seo?: { __typename: 'SettingsNotFoundPageSeo', title?: string | null, description?: string | null } | null, image?: { __typename: 'SettingsNotFoundPageImage', src?: string | null, width?: number | null, height?: number | null, aspectRatio?: number | null, format?: string | null, alt?: string | null } | null, cta?: { __typename: 'SettingsNotFoundPageCta', label?: string | null, link?: string | null, ariaLabel?: string | null } | null } | { __typename: 'SettingsAIRatesTable', id: string, title: string, _sys: { __typename?: 'SystemInfo', filename: string, basename: string, breadcrumbs: Array<string>, path: string, relativePath: string, extension: string }, table?: Array<{ __typename: 'SettingsAIRatesTableTable', states?: Array<string | null> | null, rates_by_age?: Array<{ __typename: 'SettingsAIRatesTableTableRates_by_age', age_range?: Array<string | null> | null, rates?: Array<string | null> | null } | null> | null } | null> | null } | null } | null> | null } };

export type FormQueryVariables = Exact<{
  relativePath: Scalars['String']['input'];
}>;


export type FormQuery = { __typename?: 'Query', form: { __typename: 'FormLTDIManualForm', id: string, dataType?: string | null, title: string, incomeLimit?: number | null, bmiLimit?: number | null, flow?: string | null, calendarURL?: string | null, physician?: boolean | null, buttonLabel?: string | null, healthIssues?: Array<string | null> | null, disclaimer?: any | null, _sys: { __typename?: 'SystemInfo', filename: string, basename: string, breadcrumbs: Array<string>, path: string, relativePath: string, extension: string }, experts?: Array<{ __typename: 'FormLTDIManualFormExperts', imageSrc?: string | null, name?: string | null, title?: string | null } | null> | null, maternity?: { __typename: 'FormLTDIManualFormMaternity', income?: number | null, minHoursWorked?: number | null, excludedStates?: Array<string | null> | null, calendarURL?: string | null } | null, altProduct?: { __typename: 'FormLTDIManualFormAltProduct', imageSrc?: string | null, headingRich?: any | null, subHeadingRich?: any | null, textRich?: any | null, cta?: { __typename: 'FormLTDIManualFormAltProductCta', label?: string | null, link?: string | null } | null } | null, whitelist?: { __typename: 'FormLTDIManualFormWhitelist', occ?: { __typename: 'FormLTDIManualFormWhitelistOcc', list?: Array<string | null> | null } | null, hoursWorkedLimitOccs?: { __typename: 'FormLTDIManualFormWhitelistHoursWorkedLimitOccs', list?: Array<string | null> | null } | null, ratingOcc?: { __typename: 'FormLTDIManualFormWhitelistRatingOcc', min?: number | null, list?: Array<string | null> | null } | null } | null, digital?: { __typename: 'FormLTDIManualFormDigital', occ?: { __typename: 'FormLTDIManualFormDigitalOcc', list?: Array<string | null> | null } | null, healthIssues?: { __typename: 'FormLTDIManualFormDigitalHealthIssues', list?: Array<string | null> | null } | null } | null, ineligible?: { __typename: 'FormLTDIManualFormIneligible', income?: { __typename: 'FormLTDIManualFormIneligibleIncome', min?: number | null } | null, occ?: { __typename: 'FormLTDIManualFormIneligibleOcc', list?: Array<string | null> | null } | null, healthIssues?: { __typename: 'FormLTDIManualFormIneligibleHealthIssues', list?: Array<string | null> | null } | null, hoursWorked?: { __typename: 'FormLTDIManualFormIneligibleHoursWorked', min?: number | null } | null } | null, decline?: { __typename: 'FormLTDIManualFormDecline', headingText?: string | null, dob?: { __typename: 'FormLTDIManualFormDeclineDob', min?: number | null, minErrorText?: string | null, max?: number | null, maxErrorText?: string | null, message?: string | null } | null, income?: { __typename: 'FormLTDIManualFormDeclineIncome', min?: number | null, message?: string | null } | null, state?: { __typename: 'FormLTDIManualFormDeclineState', message?: string | null, states?: Array<string | null> | null } | null, hoursWorked?: { __typename: 'FormLTDIManualFormDeclineHoursWorked', min?: number | null } | null, familyLeave?: { __typename: 'FormLTDIManualFormDeclineFamilyLeave', message?: string | null } | null } | null, generic?: { __typename: 'FormLTDIManualFormGeneric', headingText?: string | null, message?: string | null } | null } | { __typename: 'FormSTDIDigitalForm', id: string, dataType?: string | null, title: string, bmiLimit?: number | null, buttonLabel?: string | null, disclaimer?: any | null, _sys: { __typename?: 'SystemInfo', filename: string, basename: string, breadcrumbs: Array<string>, path: string, relativePath: string, extension: string }, ineligible?: { __typename: 'FormSTDIDigitalFormIneligible', headingText?: string | null, dob?: { __typename: 'FormSTDIDigitalFormIneligibleDob', min?: number | null, minErrorText?: string | null, max?: number | null, maxErrorText?: string | null, message?: string | null } | null, occ?: { __typename: 'FormSTDIDigitalFormIneligibleOcc', message?: string | null } | null, income?: { __typename: 'FormSTDIDigitalFormIneligibleIncome', min?: number | null, message?: string | null } | null, hoursWorked?: { __typename: 'FormSTDIDigitalFormIneligibleHoursWorked', message?: string | null, min?: number | null } | null, unemployed?: { __typename: 'FormSTDIDigitalFormIneligibleUnemployed', message?: string | null } | null, citizenOrResident?: { __typename: 'FormSTDIDigitalFormIneligibleCitizenOrResident', message?: string | null } | null, disabled?: { __typename: 'FormSTDIDigitalFormIneligibleDisabled', message?: string | null } | null, licenseRevoked?: { __typename: 'FormSTDIDigitalFormIneligibleLicenseRevoked', message?: string | null } | null, state?: { __typename: 'FormSTDIDigitalFormIneligibleState', message?: string | null, states?: Array<string | null> | null } | null } | null, generic?: { __typename: 'FormSTDIDigitalFormGeneric', headingText?: string | null, message?: string | null } | null, familyCare?: { __typename: 'FormSTDIDigitalFormFamilyCare', label?: string | null, content?: any | null } | null } | { __typename: 'FormLTCManualForm', id: string, dataType?: string | null, title: string, incomeLimit?: number | null, calendarURL?: string | null, buttonLabel?: string | null, disclaimer?: any | null, _sys: { __typename?: 'SystemInfo', filename: string, basename: string, breadcrumbs: Array<string>, path: string, relativePath: string, extension: string }, ineligible?: { __typename: 'FormLTCManualFormIneligible', headingText?: string | null, dob?: { __typename: 'FormLTCManualFormIneligibleDob', min?: number | null, minErrorText?: string | null, max?: number | null, maxErrorText?: string | null, message?: string | null } | null, occ?: { __typename: 'FormLTCManualFormIneligibleOcc', message?: string | null } | null, income?: { __typename: 'FormLTCManualFormIneligibleIncome', min?: number | null, message?: string | null } | null, state?: { __typename: 'FormLTCManualFormIneligibleState', message?: string | null, states?: Array<string | null> | null } | null } | null, generic?: { __typename: 'FormLTCManualFormGeneric', headingText?: string | null, message?: string | null } | null } | { __typename: 'FormCIForm', id: string, dataType?: string | null, title: string, flow?: string | null, buttonLabel?: string | null, enableContacts?: boolean | null, disclaimer?: any | null, _sys: { __typename?: 'SystemInfo', filename: string, basename: string, breadcrumbs: Array<string>, path: string, relativePath: string, extension: string }, ineligible?: { __typename: 'FormCIFormIneligible', headingText?: string | null, dob?: { __typename: 'FormCIFormIneligibleDob', min?: number | null, minErrorText?: string | null, max?: number | null, maxErrorText?: string | null, message?: string | null } | null, state?: { __typename: 'FormCIFormIneligibleState', message?: string | null, states?: Array<string | null> | null } | null, replacing?: { __typename: 'FormCIFormIneligibleReplacing', message?: string | null } | null, hadCancer?: { __typename: 'FormCIFormIneligibleHadCancer', message?: string | null } | null } | null, generic?: { __typename: 'FormCIFormGeneric', headingText?: string | null, message?: string | null } | null } | { __typename: 'FormAEIForm', id: string, dataType?: string | null, title: string, flow?: string | null, buttonLabel?: string | null, disclaimer?: any | null, _sys: { __typename?: 'SystemInfo', filename: string, basename: string, breadcrumbs: Array<string>, path: string, relativePath: string, extension: string }, popup?: Array<{ __typename: 'FormAEIFormPopup', icon?: string | null, title?: string | null, text?: string | null, label?: string | null, link?: string | null, hint?: string | null } | null> | null, ineligible?: { __typename: 'FormAEIFormIneligible', headingText?: string | null, age?: { __typename: 'FormAEIFormIneligibleAge', min?: number | null, minErrorText?: string | null, max?: number | null, maxErrorText?: string | null, message?: string | null } | null, state?: { __typename: 'FormAEIFormIneligibleState', message?: string | null, states?: Array<string | null> | null } | null } | null, generic?: { __typename: 'FormAEIFormGeneric', headingText?: string | null, message?: string | null } | null } | { __typename: 'FormGroupDIForm', id: string, dataType?: string | null, title: string, calendarURL?: string | null, buttonLabel?: string | null, isInternal?: boolean | null, internalCalendarURL?: string | null, disclaimer?: any | null, _sys: { __typename?: 'SystemInfo', filename: string, basename: string, breadcrumbs: Array<string>, path: string, relativePath: string, extension: string }, ineligible?: { __typename: 'FormGroupDIFormIneligible', minEmployees?: { __typename: 'FormGroupDIFormIneligibleMinEmployees', min?: number | null, headingText?: string | null, message?: string | null, buttonLabel?: string | null, buttonLink?: string | null } | null } | null, generic?: { __typename: 'FormGroupDIFormGeneric', headingText?: string | null, message?: string | null } | null } | { __typename: 'FormLTDIDropticketForm', id: string, dataType?: string | null, title: string, calendarURL?: string | null, buttonLabel?: string | null, disclaimer?: any | null, _sys: { __typename?: 'SystemInfo', filename: string, basename: string, breadcrumbs: Array<string>, path: string, relativePath: string, extension: string }, thankyou?: { __typename: 'FormLTDIDropticketFormThankyou', headingText?: string | null, text?: string | null } | null, ineligible?: { __typename: 'FormLTDIDropticketFormIneligible', headingText?: string | null, dob?: { __typename: 'FormLTDIDropticketFormIneligibleDob', min?: number | null, minErrorText?: string | null, max?: number | null, maxErrorText?: string | null, message?: string | null } | null, occ?: { __typename: 'FormLTDIDropticketFormIneligibleOcc', message?: string | null } | null, income?: { __typename: 'FormLTDIDropticketFormIneligibleIncome', min?: number | null, message?: string | null } | null, state?: { __typename: 'FormLTDIDropticketFormIneligibleState', message?: string | null, states?: Array<string | null> | null } | null } | null, generic?: { __typename: 'FormLTDIDropticketFormGeneric', headingText?: string | null, message?: string | null } | null } | { __typename: 'FormLTCDropticketForm', id: string, dataType?: string | null, title: string, calendarURL?: string | null, buttonLabel?: string | null, disclaimer?: any | null, _sys: { __typename?: 'SystemInfo', filename: string, basename: string, breadcrumbs: Array<string>, path: string, relativePath: string, extension: string }, thankyou?: { __typename: 'FormLTCDropticketFormThankyou', headingText?: string | null, text?: string | null } | null, ineligible?: { __typename: 'FormLTCDropticketFormIneligible', headingText?: string | null, dob?: { __typename: 'FormLTCDropticketFormIneligibleDob', min?: number | null, minErrorText?: string | null, max?: number | null, maxErrorText?: string | null, message?: string | null } | null, income?: { __typename: 'FormLTCDropticketFormIneligibleIncome', min?: number | null, message?: string | null } | null, state?: { __typename: 'FormLTCDropticketFormIneligibleState', message?: string | null, states?: Array<string | null> | null } | null } | null, generic?: { __typename: 'FormLTCDropticketFormGeneric', headingText?: string | null, message?: string | null } | null } | { __typename: 'FormGroupDICalculatorForm', id: string, dataType?: string | null, title: string, detailsRich?: any | null, _sys: { __typename?: 'SystemInfo', filename: string, basename: string, breadcrumbs: Array<string>, path: string, relativePath: string, extension: string }, headings?: { __typename: 'FormGroupDICalculatorFormHeadings', mainRich?: any | null, contributionRich?: any | null } | null, defaults?: { __typename: 'FormGroupDICalculatorFormDefaults', numberOfEmployees?: number | null, contributionPercent?: number | null, companyType?: string | null } | null } | { __typename: 'FormAgentSignupForm', id: string, dataType?: string | null, title: string, heading?: string | null, buttonLabel?: string | null, textRich?: any | null, _sys: { __typename?: 'SystemInfo', filename: string, basename: string, breadcrumbs: Array<string>, path: string, relativePath: string, extension: string }, thankyou?: { __typename: 'FormAgentSignupFormThankyou', headingText?: string | null, text?: string | null } | null, ineligible?: { __typename: 'FormAgentSignupFormIneligible', headingText?: string | null, state?: { __typename: 'FormAgentSignupFormIneligibleState', message?: string | null, states?: Array<string | null> | null } | null } | null, generic?: { __typename: 'FormAgentSignupFormGeneric', headingText?: string | null, message?: string | null } | null } | { __typename: 'FormAgentSimpleForm', id: string, dataType?: string | null, title: string, buttonLabel?: string | null, intent?: string | null, _sys: { __typename?: 'SystemInfo', filename: string, basename: string, breadcrumbs: Array<string>, path: string, relativePath: string, extension: string }, thankyou?: { __typename: 'FormAgentSimpleFormThankyou', headingText?: string | null, text?: string | null } | null, generic?: { __typename: 'FormAgentSimpleFormGeneric', headingText?: string | null, message?: string | null } | null } };

export type FormConnectionQueryVariables = Exact<{
  before?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Float']['input']>;
  last?: InputMaybe<Scalars['Float']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FormFilter>;
}>;


export type FormConnectionQuery = { __typename?: 'Query', formConnection: { __typename?: 'FormConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', hasPreviousPage: boolean, hasNextPage: boolean, startCursor: string, endCursor: string }, edges?: Array<{ __typename?: 'FormConnectionEdges', cursor: string, node?: { __typename: 'FormLTDIManualForm', id: string, dataType?: string | null, title: string, incomeLimit?: number | null, bmiLimit?: number | null, flow?: string | null, calendarURL?: string | null, physician?: boolean | null, buttonLabel?: string | null, healthIssues?: Array<string | null> | null, disclaimer?: any | null, _sys: { __typename?: 'SystemInfo', filename: string, basename: string, breadcrumbs: Array<string>, path: string, relativePath: string, extension: string }, experts?: Array<{ __typename: 'FormLTDIManualFormExperts', imageSrc?: string | null, name?: string | null, title?: string | null } | null> | null, maternity?: { __typename: 'FormLTDIManualFormMaternity', income?: number | null, minHoursWorked?: number | null, excludedStates?: Array<string | null> | null, calendarURL?: string | null } | null, altProduct?: { __typename: 'FormLTDIManualFormAltProduct', imageSrc?: string | null, headingRich?: any | null, subHeadingRich?: any | null, textRich?: any | null, cta?: { __typename: 'FormLTDIManualFormAltProductCta', label?: string | null, link?: string | null } | null } | null, whitelist?: { __typename: 'FormLTDIManualFormWhitelist', occ?: { __typename: 'FormLTDIManualFormWhitelistOcc', list?: Array<string | null> | null } | null, hoursWorkedLimitOccs?: { __typename: 'FormLTDIManualFormWhitelistHoursWorkedLimitOccs', list?: Array<string | null> | null } | null, ratingOcc?: { __typename: 'FormLTDIManualFormWhitelistRatingOcc', min?: number | null, list?: Array<string | null> | null } | null } | null, digital?: { __typename: 'FormLTDIManualFormDigital', occ?: { __typename: 'FormLTDIManualFormDigitalOcc', list?: Array<string | null> | null } | null, healthIssues?: { __typename: 'FormLTDIManualFormDigitalHealthIssues', list?: Array<string | null> | null } | null } | null, ineligible?: { __typename: 'FormLTDIManualFormIneligible', income?: { __typename: 'FormLTDIManualFormIneligibleIncome', min?: number | null } | null, occ?: { __typename: 'FormLTDIManualFormIneligibleOcc', list?: Array<string | null> | null } | null, healthIssues?: { __typename: 'FormLTDIManualFormIneligibleHealthIssues', list?: Array<string | null> | null } | null, hoursWorked?: { __typename: 'FormLTDIManualFormIneligibleHoursWorked', min?: number | null } | null } | null, decline?: { __typename: 'FormLTDIManualFormDecline', headingText?: string | null, dob?: { __typename: 'FormLTDIManualFormDeclineDob', min?: number | null, minErrorText?: string | null, max?: number | null, maxErrorText?: string | null, message?: string | null } | null, income?: { __typename: 'FormLTDIManualFormDeclineIncome', min?: number | null, message?: string | null } | null, state?: { __typename: 'FormLTDIManualFormDeclineState', message?: string | null, states?: Array<string | null> | null } | null, hoursWorked?: { __typename: 'FormLTDIManualFormDeclineHoursWorked', min?: number | null } | null, familyLeave?: { __typename: 'FormLTDIManualFormDeclineFamilyLeave', message?: string | null } | null } | null, generic?: { __typename: 'FormLTDIManualFormGeneric', headingText?: string | null, message?: string | null } | null } | { __typename: 'FormSTDIDigitalForm', id: string, dataType?: string | null, title: string, bmiLimit?: number | null, buttonLabel?: string | null, disclaimer?: any | null, _sys: { __typename?: 'SystemInfo', filename: string, basename: string, breadcrumbs: Array<string>, path: string, relativePath: string, extension: string }, ineligible?: { __typename: 'FormSTDIDigitalFormIneligible', headingText?: string | null, dob?: { __typename: 'FormSTDIDigitalFormIneligibleDob', min?: number | null, minErrorText?: string | null, max?: number | null, maxErrorText?: string | null, message?: string | null } | null, occ?: { __typename: 'FormSTDIDigitalFormIneligibleOcc', message?: string | null } | null, income?: { __typename: 'FormSTDIDigitalFormIneligibleIncome', min?: number | null, message?: string | null } | null, hoursWorked?: { __typename: 'FormSTDIDigitalFormIneligibleHoursWorked', message?: string | null, min?: number | null } | null, unemployed?: { __typename: 'FormSTDIDigitalFormIneligibleUnemployed', message?: string | null } | null, citizenOrResident?: { __typename: 'FormSTDIDigitalFormIneligibleCitizenOrResident', message?: string | null } | null, disabled?: { __typename: 'FormSTDIDigitalFormIneligibleDisabled', message?: string | null } | null, licenseRevoked?: { __typename: 'FormSTDIDigitalFormIneligibleLicenseRevoked', message?: string | null } | null, state?: { __typename: 'FormSTDIDigitalFormIneligibleState', message?: string | null, states?: Array<string | null> | null } | null } | null, generic?: { __typename: 'FormSTDIDigitalFormGeneric', headingText?: string | null, message?: string | null } | null, familyCare?: { __typename: 'FormSTDIDigitalFormFamilyCare', label?: string | null, content?: any | null } | null } | { __typename: 'FormLTCManualForm', id: string, dataType?: string | null, title: string, incomeLimit?: number | null, calendarURL?: string | null, buttonLabel?: string | null, disclaimer?: any | null, _sys: { __typename?: 'SystemInfo', filename: string, basename: string, breadcrumbs: Array<string>, path: string, relativePath: string, extension: string }, ineligible?: { __typename: 'FormLTCManualFormIneligible', headingText?: string | null, dob?: { __typename: 'FormLTCManualFormIneligibleDob', min?: number | null, minErrorText?: string | null, max?: number | null, maxErrorText?: string | null, message?: string | null } | null, occ?: { __typename: 'FormLTCManualFormIneligibleOcc', message?: string | null } | null, income?: { __typename: 'FormLTCManualFormIneligibleIncome', min?: number | null, message?: string | null } | null, state?: { __typename: 'FormLTCManualFormIneligibleState', message?: string | null, states?: Array<string | null> | null } | null } | null, generic?: { __typename: 'FormLTCManualFormGeneric', headingText?: string | null, message?: string | null } | null } | { __typename: 'FormCIForm', id: string, dataType?: string | null, title: string, flow?: string | null, buttonLabel?: string | null, enableContacts?: boolean | null, disclaimer?: any | null, _sys: { __typename?: 'SystemInfo', filename: string, basename: string, breadcrumbs: Array<string>, path: string, relativePath: string, extension: string }, ineligible?: { __typename: 'FormCIFormIneligible', headingText?: string | null, dob?: { __typename: 'FormCIFormIneligibleDob', min?: number | null, minErrorText?: string | null, max?: number | null, maxErrorText?: string | null, message?: string | null } | null, state?: { __typename: 'FormCIFormIneligibleState', message?: string | null, states?: Array<string | null> | null } | null, replacing?: { __typename: 'FormCIFormIneligibleReplacing', message?: string | null } | null, hadCancer?: { __typename: 'FormCIFormIneligibleHadCancer', message?: string | null } | null } | null, generic?: { __typename: 'FormCIFormGeneric', headingText?: string | null, message?: string | null } | null } | { __typename: 'FormAEIForm', id: string, dataType?: string | null, title: string, flow?: string | null, buttonLabel?: string | null, disclaimer?: any | null, _sys: { __typename?: 'SystemInfo', filename: string, basename: string, breadcrumbs: Array<string>, path: string, relativePath: string, extension: string }, popup?: Array<{ __typename: 'FormAEIFormPopup', icon?: string | null, title?: string | null, text?: string | null, label?: string | null, link?: string | null, hint?: string | null } | null> | null, ineligible?: { __typename: 'FormAEIFormIneligible', headingText?: string | null, age?: { __typename: 'FormAEIFormIneligibleAge', min?: number | null, minErrorText?: string | null, max?: number | null, maxErrorText?: string | null, message?: string | null } | null, state?: { __typename: 'FormAEIFormIneligibleState', message?: string | null, states?: Array<string | null> | null } | null } | null, generic?: { __typename: 'FormAEIFormGeneric', headingText?: string | null, message?: string | null } | null } | { __typename: 'FormGroupDIForm', id: string, dataType?: string | null, title: string, calendarURL?: string | null, buttonLabel?: string | null, isInternal?: boolean | null, internalCalendarURL?: string | null, disclaimer?: any | null, _sys: { __typename?: 'SystemInfo', filename: string, basename: string, breadcrumbs: Array<string>, path: string, relativePath: string, extension: string }, ineligible?: { __typename: 'FormGroupDIFormIneligible', minEmployees?: { __typename: 'FormGroupDIFormIneligibleMinEmployees', min?: number | null, headingText?: string | null, message?: string | null, buttonLabel?: string | null, buttonLink?: string | null } | null } | null, generic?: { __typename: 'FormGroupDIFormGeneric', headingText?: string | null, message?: string | null } | null } | { __typename: 'FormLTDIDropticketForm', id: string, dataType?: string | null, title: string, calendarURL?: string | null, buttonLabel?: string | null, disclaimer?: any | null, _sys: { __typename?: 'SystemInfo', filename: string, basename: string, breadcrumbs: Array<string>, path: string, relativePath: string, extension: string }, thankyou?: { __typename: 'FormLTDIDropticketFormThankyou', headingText?: string | null, text?: string | null } | null, ineligible?: { __typename: 'FormLTDIDropticketFormIneligible', headingText?: string | null, dob?: { __typename: 'FormLTDIDropticketFormIneligibleDob', min?: number | null, minErrorText?: string | null, max?: number | null, maxErrorText?: string | null, message?: string | null } | null, occ?: { __typename: 'FormLTDIDropticketFormIneligibleOcc', message?: string | null } | null, income?: { __typename: 'FormLTDIDropticketFormIneligibleIncome', min?: number | null, message?: string | null } | null, state?: { __typename: 'FormLTDIDropticketFormIneligibleState', message?: string | null, states?: Array<string | null> | null } | null } | null, generic?: { __typename: 'FormLTDIDropticketFormGeneric', headingText?: string | null, message?: string | null } | null } | { __typename: 'FormLTCDropticketForm', id: string, dataType?: string | null, title: string, calendarURL?: string | null, buttonLabel?: string | null, disclaimer?: any | null, _sys: { __typename?: 'SystemInfo', filename: string, basename: string, breadcrumbs: Array<string>, path: string, relativePath: string, extension: string }, thankyou?: { __typename: 'FormLTCDropticketFormThankyou', headingText?: string | null, text?: string | null } | null, ineligible?: { __typename: 'FormLTCDropticketFormIneligible', headingText?: string | null, dob?: { __typename: 'FormLTCDropticketFormIneligibleDob', min?: number | null, minErrorText?: string | null, max?: number | null, maxErrorText?: string | null, message?: string | null } | null, income?: { __typename: 'FormLTCDropticketFormIneligibleIncome', min?: number | null, message?: string | null } | null, state?: { __typename: 'FormLTCDropticketFormIneligibleState', message?: string | null, states?: Array<string | null> | null } | null } | null, generic?: { __typename: 'FormLTCDropticketFormGeneric', headingText?: string | null, message?: string | null } | null } | { __typename: 'FormGroupDICalculatorForm', id: string, dataType?: string | null, title: string, detailsRich?: any | null, _sys: { __typename?: 'SystemInfo', filename: string, basename: string, breadcrumbs: Array<string>, path: string, relativePath: string, extension: string }, headings?: { __typename: 'FormGroupDICalculatorFormHeadings', mainRich?: any | null, contributionRich?: any | null } | null, defaults?: { __typename: 'FormGroupDICalculatorFormDefaults', numberOfEmployees?: number | null, contributionPercent?: number | null, companyType?: string | null } | null } | { __typename: 'FormAgentSignupForm', id: string, dataType?: string | null, title: string, heading?: string | null, buttonLabel?: string | null, textRich?: any | null, _sys: { __typename?: 'SystemInfo', filename: string, basename: string, breadcrumbs: Array<string>, path: string, relativePath: string, extension: string }, thankyou?: { __typename: 'FormAgentSignupFormThankyou', headingText?: string | null, text?: string | null } | null, ineligible?: { __typename: 'FormAgentSignupFormIneligible', headingText?: string | null, state?: { __typename: 'FormAgentSignupFormIneligibleState', message?: string | null, states?: Array<string | null> | null } | null } | null, generic?: { __typename: 'FormAgentSignupFormGeneric', headingText?: string | null, message?: string | null } | null } | { __typename: 'FormAgentSimpleForm', id: string, dataType?: string | null, title: string, buttonLabel?: string | null, intent?: string | null, _sys: { __typename?: 'SystemInfo', filename: string, basename: string, breadcrumbs: Array<string>, path: string, relativePath: string, extension: string }, thankyou?: { __typename: 'FormAgentSimpleFormThankyou', headingText?: string | null, text?: string | null } | null, generic?: { __typename: 'FormAgentSimpleFormGeneric', headingText?: string | null, message?: string | null } | null } | null } | null> | null } };

export type ManagerQueryVariables = Exact<{
  relativePath: Scalars['String']['input'];
}>;


export type ManagerQuery = { __typename?: 'Query', manager: { __typename: 'Manager', id: string, title: string, slackMentionId?: string | null, referralName?: string | null, salesPersonId?: string | null, phone?: string | null, isFallback?: boolean | null, imageSrc?: string | null, _sys: { __typename?: 'SystemInfo', filename: string, basename: string, breadcrumbs: Array<string>, path: string, relativePath: string, extension: string }, managedProducts?: Array<{ __typename: 'ManagerManagedProducts', product?: string | null, calendlyUrl?: string | null, ycbmUrl?: string | null, states?: Array<string | null> | null, contents?: Array<{ __typename: 'ManagerManagedProductsContents', type?: string | null, heading?: string | null, subHeading?: string | null, text?: string | null } | null> | null, rating?: { __typename: 'ManagerManagedProductsRating', min?: number | null, max?: number | null } | null } | null> | null } };

export type ManagerConnectionQueryVariables = Exact<{
  before?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Float']['input']>;
  last?: InputMaybe<Scalars['Float']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ManagerFilter>;
}>;


export type ManagerConnectionQuery = { __typename?: 'Query', managerConnection: { __typename?: 'ManagerConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', hasPreviousPage: boolean, hasNextPage: boolean, startCursor: string, endCursor: string }, edges?: Array<{ __typename?: 'ManagerConnectionEdges', cursor: string, node?: { __typename: 'Manager', id: string, title: string, slackMentionId?: string | null, referralName?: string | null, salesPersonId?: string | null, phone?: string | null, isFallback?: boolean | null, imageSrc?: string | null, _sys: { __typename?: 'SystemInfo', filename: string, basename: string, breadcrumbs: Array<string>, path: string, relativePath: string, extension: string }, managedProducts?: Array<{ __typename: 'ManagerManagedProducts', product?: string | null, calendlyUrl?: string | null, ycbmUrl?: string | null, states?: Array<string | null> | null, contents?: Array<{ __typename: 'ManagerManagedProductsContents', type?: string | null, heading?: string | null, subHeading?: string | null, text?: string | null } | null> | null, rating?: { __typename: 'ManagerManagedProductsRating', min?: number | null, max?: number | null } | null } | null> | null } | null } | null> | null } };

export type SpecialPageQueryVariables = Exact<{
  relativePath: Scalars['String']['input'];
}>;


export type SpecialPageQuery = { __typename?: 'Query', specialPage: { __typename: 'SpecialPageProposalSpecialPage', id: string, previewURL?: string | null, title: string, disclaimer?: any | null, _sys: { __typename?: 'SystemInfo', filename: string, basename: string, breadcrumbs: Array<string>, path: string, relativePath: string, extension: string }, seo?: { __typename: 'SpecialPageProposalSpecialPageSeo', title?: string | null } | null, content?: Array<{ __typename: 'SpecialPageProposalSpecialPageContentSectionHeroProposal', title?: string | null, headingSize?: string | null, headingRich?: any | null, subheadingRich?: any | null, textRich?: any | null, lists?: Array<{ __typename: 'SpecialPageProposalSpecialPageContentSectionHeroProposalLists', title?: string | null, items?: Array<string | null> | null } | null> | null, logos?: { __typename: 'SpecialPageProposalSpecialPageContentSectionHeroProposalLogos', highlightImgSrc?: string | null, highlightText?: string | null, logosText?: string | null, logosList?: Array<string | null> | null } | null, image?: { __typename: 'SpecialPageProposalSpecialPageContentSectionHeroProposalImage', src?: string | null, width?: number | null, height?: number | null, aspectRatio?: number | null, format?: string | null, alt?: string | null, scale?: number | null } | null, buttons?: Array<{ __typename: 'SpecialPageProposalSpecialPageContentSectionHeroProposalButtons', label?: string | null, link?: string | null, ariaLabel?: string | null } | null> | null, floatingItems?: Array<{ __typename: 'SpecialPageProposalSpecialPageContentSectionHeroProposalFloatingItemsSingleIconLinkItem', icon?: string | null, title?: string | null, text?: string | null, link?: string | null } | { __typename: 'SpecialPageProposalSpecialPageContentSectionHeroProposalFloatingItemsSingleIconTextItem', icon?: string | null, text?: string | null } | { __typename: 'SpecialPageProposalSpecialPageContentSectionHeroProposalFloatingItemsGroupedIconTextItem', items?: Array<{ __typename: 'SpecialPageProposalSpecialPageContentSectionHeroProposalFloatingItemsGroupedIconTextItemItems', icon?: string | null, text?: string | null } | null> | null } | { __typename: 'SpecialPageProposalSpecialPageContentSectionHeroProposalFloatingItemsSingleImageTextItem', image?: string | null, text?: string | null } | { __typename: 'SpecialPageProposalSpecialPageContentSectionHeroProposalFloatingItemsGroupedImageTextItem', items?: Array<{ __typename: 'SpecialPageProposalSpecialPageContentSectionHeroProposalFloatingItemsGroupedImageTextItemItems', image?: string | null, text?: string | null } | null> | null } | { __typename: 'SpecialPageProposalSpecialPageContentSectionHeroProposalFloatingItemsSingleImageItem', image?: string | null } | null> | null } | { __typename: 'SpecialPageProposalSpecialPageContentSectionLogos', headingText?: string | null, images?: Array<{ __typename: 'SpecialPageProposalSpecialPageContentSectionLogosImages', image?: string | null, title?: string | null } | null> | null } | { __typename: 'SpecialPageProposalSpecialPageContentSectionImage', scrollable?: boolean | null, spacing?: number | null, maxWidth?: string | null, align?: string | null, brzImage?: { __typename: 'SpecialPageProposalSpecialPageContentSectionImageBrzImage', title?: string | null, src?: string | null, width?: number | null, height?: number | null, aspectRatio?: number | null, format?: string | null, alt?: string | null, radius?: number | null } | null } | { __typename: 'SpecialPageProposalSpecialPageContentSectionHeading', align?: string | null, title?: string | null, headingLevel?: string | null, headingText?: string | null, text?: string | null, marginBottom?: string | null } | { __typename: 'SpecialPageProposalSpecialPageContentSectionSideStats', headingText?: string | null, textRich?: any | null, items?: Array<{ __typename: 'SpecialPageProposalSpecialPageContentSectionSideStatsItems', icon?: string | null, text?: string | null } | null> | null } | null> | null, quote?: { __typename: 'SpecialPageProposalSpecialPageQuote', headingText?: string | null, subheadingRich?: any | null, addonsHeadingText?: string | null, helpTip?: { __typename: 'SpecialPageProposalSpecialPageQuoteHelpTip', headingText?: string | null, contentRich?: any | null } | null, notFoundError?: { __typename: 'SpecialPageProposalSpecialPageQuoteNotFoundError', headingText?: string | null, textRich?: any | null } | null, genericError?: { __typename: 'SpecialPageProposalSpecialPageQuoteGenericError', headingText?: string | null, textRich?: any | null } | null, annuity?: { __typename: 'SpecialPageProposalSpecialPageQuoteAnnuity', headingText?: string | null, text?: string | null, productName?: string | null, incomeLabel?: string | null, columns?: Array<{ __typename: 'SpecialPageProposalSpecialPageQuoteAnnuityColumns', label?: string | null, value?: string | null } | null> | null } | null } | null } | { __typename: 'SpecialPageIneligibleSpecialPage', id: string, previewURL?: string | null, title: string, _sys: { __typename?: 'SystemInfo', filename: string, basename: string, breadcrumbs: Array<string>, path: string, relativePath: string, extension: string }, seo?: { __typename: 'SpecialPageIneligibleSpecialPageSeo', title?: string | null } | null, accident?: { __typename: 'SpecialPageIneligibleSpecialPageAccident', imgSrc?: string | null, headingRich?: any | null, subheadingRich?: any | null, textRich?: any | null, ctaLabel?: string | null } | null, ineligible?: { __typename: 'SpecialPageIneligibleSpecialPageIneligible', headingRich?: any | null, subheadingRich?: any | null, textRich?: any | null, products?: Array<{ __typename: 'SpecialPageIneligibleSpecialPageIneligibleProducts', title?: string | null } | null> | null } | null } };

export type SpecialPageConnectionQueryVariables = Exact<{
  before?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Float']['input']>;
  last?: InputMaybe<Scalars['Float']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<SpecialPageFilter>;
}>;


export type SpecialPageConnectionQuery = { __typename?: 'Query', specialPageConnection: { __typename?: 'SpecialPageConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', hasPreviousPage: boolean, hasNextPage: boolean, startCursor: string, endCursor: string }, edges?: Array<{ __typename?: 'SpecialPageConnectionEdges', cursor: string, node?: { __typename: 'SpecialPageProposalSpecialPage', id: string, previewURL?: string | null, title: string, disclaimer?: any | null, _sys: { __typename?: 'SystemInfo', filename: string, basename: string, breadcrumbs: Array<string>, path: string, relativePath: string, extension: string }, seo?: { __typename: 'SpecialPageProposalSpecialPageSeo', title?: string | null } | null, content?: Array<{ __typename: 'SpecialPageProposalSpecialPageContentSectionHeroProposal', title?: string | null, headingSize?: string | null, headingRich?: any | null, subheadingRich?: any | null, textRich?: any | null, lists?: Array<{ __typename: 'SpecialPageProposalSpecialPageContentSectionHeroProposalLists', title?: string | null, items?: Array<string | null> | null } | null> | null, logos?: { __typename: 'SpecialPageProposalSpecialPageContentSectionHeroProposalLogos', highlightImgSrc?: string | null, highlightText?: string | null, logosText?: string | null, logosList?: Array<string | null> | null } | null, image?: { __typename: 'SpecialPageProposalSpecialPageContentSectionHeroProposalImage', src?: string | null, width?: number | null, height?: number | null, aspectRatio?: number | null, format?: string | null, alt?: string | null, scale?: number | null } | null, buttons?: Array<{ __typename: 'SpecialPageProposalSpecialPageContentSectionHeroProposalButtons', label?: string | null, link?: string | null, ariaLabel?: string | null } | null> | null, floatingItems?: Array<{ __typename: 'SpecialPageProposalSpecialPageContentSectionHeroProposalFloatingItemsSingleIconLinkItem', icon?: string | null, title?: string | null, text?: string | null, link?: string | null } | { __typename: 'SpecialPageProposalSpecialPageContentSectionHeroProposalFloatingItemsSingleIconTextItem', icon?: string | null, text?: string | null } | { __typename: 'SpecialPageProposalSpecialPageContentSectionHeroProposalFloatingItemsGroupedIconTextItem', items?: Array<{ __typename: 'SpecialPageProposalSpecialPageContentSectionHeroProposalFloatingItemsGroupedIconTextItemItems', icon?: string | null, text?: string | null } | null> | null } | { __typename: 'SpecialPageProposalSpecialPageContentSectionHeroProposalFloatingItemsSingleImageTextItem', image?: string | null, text?: string | null } | { __typename: 'SpecialPageProposalSpecialPageContentSectionHeroProposalFloatingItemsGroupedImageTextItem', items?: Array<{ __typename: 'SpecialPageProposalSpecialPageContentSectionHeroProposalFloatingItemsGroupedImageTextItemItems', image?: string | null, text?: string | null } | null> | null } | { __typename: 'SpecialPageProposalSpecialPageContentSectionHeroProposalFloatingItemsSingleImageItem', image?: string | null } | null> | null } | { __typename: 'SpecialPageProposalSpecialPageContentSectionLogos', headingText?: string | null, images?: Array<{ __typename: 'SpecialPageProposalSpecialPageContentSectionLogosImages', image?: string | null, title?: string | null } | null> | null } | { __typename: 'SpecialPageProposalSpecialPageContentSectionImage', scrollable?: boolean | null, spacing?: number | null, maxWidth?: string | null, align?: string | null, brzImage?: { __typename: 'SpecialPageProposalSpecialPageContentSectionImageBrzImage', title?: string | null, src?: string | null, width?: number | null, height?: number | null, aspectRatio?: number | null, format?: string | null, alt?: string | null, radius?: number | null } | null } | { __typename: 'SpecialPageProposalSpecialPageContentSectionHeading', align?: string | null, title?: string | null, headingLevel?: string | null, headingText?: string | null, text?: string | null, marginBottom?: string | null } | { __typename: 'SpecialPageProposalSpecialPageContentSectionSideStats', headingText?: string | null, textRich?: any | null, items?: Array<{ __typename: 'SpecialPageProposalSpecialPageContentSectionSideStatsItems', icon?: string | null, text?: string | null } | null> | null } | null> | null, quote?: { __typename: 'SpecialPageProposalSpecialPageQuote', headingText?: string | null, subheadingRich?: any | null, addonsHeadingText?: string | null, helpTip?: { __typename: 'SpecialPageProposalSpecialPageQuoteHelpTip', headingText?: string | null, contentRich?: any | null } | null, notFoundError?: { __typename: 'SpecialPageProposalSpecialPageQuoteNotFoundError', headingText?: string | null, textRich?: any | null } | null, genericError?: { __typename: 'SpecialPageProposalSpecialPageQuoteGenericError', headingText?: string | null, textRich?: any | null } | null, annuity?: { __typename: 'SpecialPageProposalSpecialPageQuoteAnnuity', headingText?: string | null, text?: string | null, productName?: string | null, incomeLabel?: string | null, columns?: Array<{ __typename: 'SpecialPageProposalSpecialPageQuoteAnnuityColumns', label?: string | null, value?: string | null } | null> | null } | null } | null } | { __typename: 'SpecialPageIneligibleSpecialPage', id: string, previewURL?: string | null, title: string, _sys: { __typename?: 'SystemInfo', filename: string, basename: string, breadcrumbs: Array<string>, path: string, relativePath: string, extension: string }, seo?: { __typename: 'SpecialPageIneligibleSpecialPageSeo', title?: string | null } | null, accident?: { __typename: 'SpecialPageIneligibleSpecialPageAccident', imgSrc?: string | null, headingRich?: any | null, subheadingRich?: any | null, textRich?: any | null, ctaLabel?: string | null } | null, ineligible?: { __typename: 'SpecialPageIneligibleSpecialPageIneligible', headingRich?: any | null, subheadingRich?: any | null, textRich?: any | null, products?: Array<{ __typename: 'SpecialPageIneligibleSpecialPageIneligibleProducts', title?: string | null } | null> | null } | null } | null } | null> | null } };

export const PagePartsFragmentDoc = gql`
    fragment PageParts on Page {
  __typename
  ... on PageGeneric {
    component
    updatedDate
    publishedDate
    title
    settings {
      __typename
      publish {
        __typename
        published
        publishedDate
      }
      seo {
        __typename
        title
        url
        description
        image {
          __typename
          src
          width
          height
          aspectRatio
          format
          alt
        }
        org {
          __typename
          disable
        }
        faq {
          __typename
          disable
          name
          items {
            __typename
            q
            a
          }
        }
        howTo {
          __typename
          disable
          name
          description
          image {
            __typename
            src
            width
            height
            aspectRatio
            format
            alt
          }
          steps {
            __typename
            name
            url
            text
          }
        }
      }
      sitemap {
        __typename
        exclude
        breadcrumb
        changefreq
        priority
      }
      navigation {
        __typename
        disableLogo
        disableLeft
        disableRight
        disableButtons
        rightSideButtonOverride {
          __typename
          label
          link
          ariaLabel
        }
      }
      footer {
        __typename
        disableLinks
        disableBottom
      }
      disclaimer {
        __typename
        disable
        content
      }
      partner {
        __typename
      }
      client {
        __typename
        enabled
      }
    }
    content {
      __typename
      ... on PageGenericContentSectionHeroGeneric {
        title
        headingSize
        headingRich
        subheadingRich
        textRich
        lists {
          __typename
          title
          items
        }
        image {
          __typename
          src
          width
          height
          aspectRatio
          format
          alt
          scale
        }
        buttons {
          __typename
          label
          link
          ariaLabel
        }
        floatingItems {
          __typename
          ... on PageGenericContentSectionHeroGenericFloatingItemsSingleIconLinkItem {
            icon
            title
            text
            link
          }
          ... on PageGenericContentSectionHeroGenericFloatingItemsSingleIconTextItem {
            icon
            text
          }
          ... on PageGenericContentSectionHeroGenericFloatingItemsGroupedIconTextItem {
            items {
              __typename
              icon
              text
            }
          }
          ... on PageGenericContentSectionHeroGenericFloatingItemsSingleImageTextItem {
            image
            text
          }
          ... on PageGenericContentSectionHeroGenericFloatingItemsGroupedImageTextItem {
            items {
              __typename
              image
              text
            }
          }
          ... on PageGenericContentSectionHeroGenericFloatingItemsSingleImageItem {
            image
          }
        }
      }
      ... on PageGenericContentSectionHeroAgent {
        headingRich
        fallbackHeadingRich
        textRich
        image {
          __typename
          src
          width
          height
          aspectRatio
          format
          alt
        }
        defaultProducts {
          __typename
        }
        display {
          __typename
          icon
          graphic
          actionLabel
          descriptionText
          descriptionItems
          disclaimer
          buttons
        }
      }
      ... on PageGenericContentSectionLogos {
        headingText
        images {
          __typename
          image
          title
        }
      }
      ... on PageGenericContentSectionBadges {
        title
        badges {
          __typename
          image
          text
        }
      }
      ... on PageGenericContentSectionTestimonialSlider {
        title
        headingRich
        highlight
        textRich
        items {
          __typename
        }
      }
      ... on PageGenericContentSectionTestimonialGrid {
        headingText
        items {
          __typename
        }
      }
      ... on PageGenericContentSectionFloatingCta {
        headingText
        text
        buttons {
          __typename
          label
          link
          ariaLabel
        }
      }
      ... on PageGenericContentSectionImageCta {
        headingText
        text
        buttons {
          __typename
          label
          link
          ariaLabel
        }
        imageSrc
      }
      ... on PageGenericContentSectionProducts {
        headingRich
        text
        title
        items {
          __typename
        }
        display {
          __typename
          icon
          graphic
          actionLabel
          descriptionText
          descriptionItems
          disclaimer
          buttons
        }
      }
      ... on PageGenericContentSectionProductsSimple {
        items {
          __typename
        }
        display {
          __typename
          actionLabel
          descriptionText
          descriptionItems
          disclaimer
          buttons
        }
      }
      ... on PageGenericContentSectionHowItWorks {
        title
        headingText
        active
        items {
          __typename
          image
          headingText
          subheadingText
          text
          button {
            __typename
            label
            link
            ariaLabel
          }
        }
        display {
          __typename
          number
        }
      }
      ... on PageGenericContentSectionIconColumns {
        title
        headingText
        subheadingText
        colNum
        colSpacing
        bgColor
        cols {
          __typename
          imageSrc
          disableIconBg
          size
          title
          titleSize
          text
        }
      }
      ... on PageGenericContentSectionBlogPosts {
        title
        headingText
        posts {
          __typename
        }
      }
      ... on PageGenericContentSectionArticles {
        title
        headingText
        posts {
          __typename
        }
      }
      ... on PageGenericContentSectionCtaArticles {
        posts {
          __typename
          tag
          headingText
          imageSrc
          cta {
            __typename
            label
            link
          }
        }
      }
      ... on PageGenericContentSectionHelpfulArticles {
        cta {
          __typename
          headingText
          imageSrc
          button {
            __typename
            label
            link
          }
        }
        title
        posts {
          __typename
        }
      }
      ... on PageGenericContentSectionStats {
        title
        headingText
        items {
          __typename
          number
          unit
          text
        }
        secondaryHeading
        text
        button {
          __typename
          label
          link
          ariaLabel
        }
        imageSrc
        quote {
          __typename
          text
          author
          title
        }
      }
      ... on PageGenericContentSectionResources {
        title
        headingText
        imageSrc
        groups {
          __typename
          title
          items {
            __typename
            label
            link
            ariaLabel
          }
        }
      }
      ... on PageGenericContentSectionResourceHub {
        title
        headingText
        imageSrc
        groups {
          __typename
          title
          tocTitle
          articles {
            __typename
            title
            textRich
            link {
              __typename
              label
              link
              ariaLabel
            }
          }
        }
      }
      ... on PageGenericContentSectionFileResources {
        filterSettings {
          __typename
          title
          resetLabel
          noItemsMessage
          filters {
            __typename
            label
            items {
              __typename
              label
              tag
            }
          }
        }
        resources {
          __typename
          title
          type
          tooltip
          link
          tags
        }
      }
      ... on PageGenericContentSectionOurStory {
        headingText
        subheadingText
        textRich
      }
      ... on PageGenericContentSectionTeam {
        headingText
        items {
          __typename
          image
          name
          title
          about
        }
      }
      ... on PageGenericContentSectionValues {
        headingText
        items {
          __typename
          icon
          title
          text
        }
      }
      ... on PageGenericContentSectionImage {
        brzImage {
          __typename
          title
          src
          width
          height
          aspectRatio
          format
          alt
          radius
        }
        scrollable
        spacing
        maxWidth
        align
      }
      ... on PageGenericContentSectionButtons {
        align
        buttons {
          __typename
          label
          link
          ariaLabel
          variant
          color
          size
        }
        spacing
      }
      ... on PageGenericContentSectionPress {
        headingText
        textRich
        items {
          __typename
          headingText
          link
        }
      }
      ... on PageGenericContentSectionTwoColumnText {
        title
        headingText
        imageSrc
        textRich
      }
      ... on PageGenericContentSectionThreeColumnText {
        headingText
        cols {
          __typename
          title
          textRich
        }
      }
      ... on PageGenericContentSectionVibe {
        title
        headingText
        text
        button {
          __typename
          label
          link
          ariaLabel
        }
        imageSrc
        items {
          __typename
          icon
          title
          text
        }
      }
      ... on PageGenericContentSectionSellingPoints {
        imageSrc
        headingText
        text
        items {
          __typename
          icon
          title
          text
        }
      }
      ... on PageGenericContentSectionOpenings {
        sectionId
        headingText
        textRich
        title
        items {
          __typename
          title
          location
          link
        }
      }
      ... on PageGenericContentSectionStoryCards {
        title
        items {
          __typename
          ... on PageGenericContentSectionStoryCardsItemsEmployeeStory {
            textRich
            author
            authorTitle
            authorImage
          }
          ... on PageGenericContentSectionStoryCardsItemsAchievement {
            title
            textRich
            brzImage {
              __typename
              src
              width
              height
              aspectRatio
              format
              alt
            }
            badgeImage
          }
          ... on PageGenericContentSectionStoryCardsItemsAnnouncement {
            headingText
            subheadingText
            textRich
            images {
              __typename
              imageSrc
              alt
            }
          }
        }
      }
      ... on PageGenericContentSectionOtherOffers {
        headingText
        items {
          __typename
          headingText
          text
          imageSrc
        }
      }
      ... on PageGenericContentSectionAccordion {
        title
        sectionId
        items {
          __typename
          title
          textRich
        }
      }
      ... on PageGenericContentSectionQuoteProposal {
        headingText
        subheadingRich
        imageSrc
        helpTip {
          __typename
          headingText
          contentRich
        }
        addonsHeadingText
        notFoundError {
          __typename
          headingText
          textRich
        }
        genericError {
          __typename
          headingText
          textRich
        }
      }
      ... on PageGenericContentSectionTable {
        title
        headingText
        rows {
          __typename
          columns
        }
      }
      ... on PageGenericContentSectionHeading {
        align
        title
        headingLevel
        headingText
        text
        marginBottom
      }
      ... on PageGenericContentSectionContent {
        align
        maxWidth
        contentRich
      }
      ... on PageGenericContentSectionSidebarContent {
        sidebarRich
        rows {
          __typename
          cols {
            __typename
            contentRich
          }
        }
      }
      ... on PageGenericContentSectionHTML {
        contentText
      }
    }
  }
  ... on PageBlog {
    component
    updatedDate
    publishedDate
    title
    settings {
      __typename
      publish {
        __typename
        published
        publishedDate
      }
      seo {
        __typename
        title
        url
        description
        image {
          __typename
          src
          width
          height
          aspectRatio
          format
          alt
        }
        org {
          __typename
          disable
        }
        faq {
          __typename
          disable
          name
          items {
            __typename
            q
            a
          }
        }
        howTo {
          __typename
          disable
          name
          description
          image {
            __typename
            src
            width
            height
            aspectRatio
            format
            alt
          }
          steps {
            __typename
            name
            url
            text
          }
        }
      }
      sitemap {
        __typename
        exclude
        breadcrumb
        changefreq
        priority
      }
      navigation {
        __typename
        disableLogo
        disableLeft
        disableRight
        disableButtons
        rightSideButtonOverride {
          __typename
          label
          link
          ariaLabel
        }
      }
      footer {
        __typename
        disableLinks
        disableBottom
      }
      disclaimer {
        __typename
        disable
        content
      }
      partner {
        __typename
      }
      client {
        __typename
        enabled
      }
    }
    heading
    categories {
      __typename
    }
    popular {
      __typename
    }
    cta {
      __typename
      headingText
      text
      buttons {
        __typename
        label
        link
        ariaLabel
      }
    }
  }
  ... on PageForm {
    component
    updatedDate
    publishedDate
    title
    settings {
      __typename
      publish {
        __typename
        published
        publishedDate
      }
      seo {
        __typename
        title
        url
        description
        image {
          __typename
          src
          width
          height
          aspectRatio
          format
          alt
        }
        org {
          __typename
          disable
        }
        faq {
          __typename
          disable
          name
          items {
            __typename
            q
            a
          }
        }
        howTo {
          __typename
          disable
          name
          description
          image {
            __typename
            src
            width
            height
            aspectRatio
            format
            alt
          }
          steps {
            __typename
            name
            url
            text
          }
        }
      }
      sitemap {
        __typename
        exclude
        breadcrumb
        changefreq
        priority
      }
      navigation {
        __typename
        disableLogo
        disableLeft
        disableRight
        disableButtons
        rightSideButtonOverride {
          __typename
          label
          link
          ariaLabel
        }
      }
      footer {
        __typename
        disableLinks
        disableBottom
      }
      disclaimer {
        __typename
        disable
        content
      }
      partner {
        __typename
      }
      client {
        __typename
        enabled
      }
    }
    carrier {
      __typename
      logo
      headingText
      text
      button {
        __typename
        label
        link
        ariaLabel
        hint
      }
    }
    form {
      __typename
      title
      headingText
      subheadingText
      images {
        __typename
        image
        title
      }
    }
    calendar {
      __typename
      headingText
      subheadingText
    }
    sidebar {
      __typename
      help {
        __typename
        title
        links {
          __typename
          label
          link
          ariaLabel
        }
      }
      headingText
      subheadingText
      items {
        __typename
        title
        text
      }
      contacts {
        __typename
        title
        items {
          __typename
          textRich
          sub
        }
      }
      image
    }
  }
}
    `;
export const ArticlePartsFragmentDoc = gql`
    fragment ArticleParts on Article {
  __typename
  component
  updatedDate
  publishedDate
  title
  settings {
    __typename
    publish {
      __typename
      published
      publishedDate
    }
    seo {
      __typename
      title
      url
      description
      image {
        __typename
        src
        width
        height
        aspectRatio
        format
        alt
      }
      org {
        __typename
        disable
      }
      faq {
        __typename
        disable
        name
        items {
          __typename
          q
          a
        }
      }
      howTo {
        __typename
        disable
        name
        description
        image {
          __typename
          src
          width
          height
          aspectRatio
          format
          alt
        }
        steps {
          __typename
          name
          url
          text
        }
      }
    }
    sitemap {
      __typename
      exclude
      breadcrumb
      changefreq
      priority
    }
    navigation {
      __typename
      disableLogo
      disableLeft
      disableRight
      disableButtons
      rightSideButtonOverride {
        __typename
        label
        link
        ariaLabel
      }
    }
    footer {
      __typename
      disableLinks
      disableBottom
    }
    disclaimer {
      __typename
      disable
      content
    }
    partner {
      __typename
    }
    client {
      __typename
      enabled
    }
  }
  readtime {
    __typename
    text
    minutes
    time
    words
  }
  cover
  thumbnail
  headingRich
  subtitleRich
  excerptText
  widgets {
    __typename
    image
    heading
    text
    label
    link
  }
  cta {
    __typename
    headingText
    text
    buttons {
      __typename
      label
      link
      ariaLabel
    }
  }
  related {
    __typename
  }
  body
}
    `;
export const PostPartsFragmentDoc = gql`
    fragment PostParts on Post {
  __typename
  component
  updatedDate
  publishedDate
  title
  settings {
    __typename
    publish {
      __typename
      published
      publishedDate
    }
    seo {
      __typename
      title
      url
      description
      image {
        __typename
        src
        width
        height
        aspectRatio
        format
        alt
      }
      org {
        __typename
        disable
      }
      faq {
        __typename
        disable
        name
        items {
          __typename
          q
          a
        }
      }
      howTo {
        __typename
        disable
        name
        description
        image {
          __typename
          src
          width
          height
          aspectRatio
          format
          alt
        }
        steps {
          __typename
          name
          url
          text
        }
      }
    }
    sitemap {
      __typename
      exclude
      breadcrumb
      changefreq
      priority
    }
    navigation {
      __typename
      disableLogo
      disableLeft
      disableRight
      disableButtons
      rightSideButtonOverride {
        __typename
        label
        link
        ariaLabel
      }
    }
    footer {
      __typename
      disableLinks
      disableBottom
    }
    disclaimer {
      __typename
      disable
      content
    }
    partner {
      __typename
    }
    client {
      __typename
      enabled
    }
  }
  readtime {
    __typename
    text
    minutes
    time
    words
  }
  cover
  thumbnail
  headingRich
  excerptText
  widgets {
    __typename
    image
    heading
    text
    label
    link
  }
  cta {
    __typename
    headingText
    text
    buttons {
      __typename
      label
      link
      ariaLabel
    }
  }
  related {
    __typename
  }
  body
}
    `;
export const CategoryPartsFragmentDoc = gql`
    fragment CategoryParts on Category {
  __typename
  component
  updatedDate
  publishedDate
  title
  settings {
    __typename
    publish {
      __typename
      published
      publishedDate
    }
    seo {
      __typename
      title
      url
      description
      image {
        __typename
        src
        width
        height
        aspectRatio
        format
        alt
      }
      org {
        __typename
        disable
      }
      faq {
        __typename
        disable
        name
        items {
          __typename
          q
          a
        }
      }
      howTo {
        __typename
        disable
        name
        description
        image {
          __typename
          src
          width
          height
          aspectRatio
          format
          alt
        }
        steps {
          __typename
          name
          url
          text
        }
      }
    }
    sitemap {
      __typename
      exclude
      breadcrumb
      changefreq
      priority
    }
    navigation {
      __typename
      disableLogo
      disableLeft
      disableRight
      disableButtons
      rightSideButtonOverride {
        __typename
        label
        link
        ariaLabel
      }
    }
    footer {
      __typename
      disableLinks
      disableBottom
    }
    disclaimer {
      __typename
      disable
      content
    }
    partner {
      __typename
    }
    client {
      __typename
      enabled
    }
  }
  name
}
    `;
export const AuthorPartsFragmentDoc = gql`
    fragment AuthorParts on Author {
  __typename
  component
  updatedDate
  publishedDate
  title
  settings {
    __typename
    publish {
      __typename
      published
      publishedDate
    }
    seo {
      __typename
      title
      url
      description
      image {
        __typename
        src
        width
        height
        aspectRatio
        format
        alt
      }
      org {
        __typename
        disable
      }
      faq {
        __typename
        disable
        name
        items {
          __typename
          q
          a
        }
      }
      howTo {
        __typename
        disable
        name
        description
        image {
          __typename
          src
          width
          height
          aspectRatio
          format
          alt
        }
        steps {
          __typename
          name
          url
          text
        }
      }
    }
    sitemap {
      __typename
      exclude
      breadcrumb
      changefreq
      priority
    }
    navigation {
      __typename
      disableLogo
      disableLeft
      disableRight
      disableButtons
      rightSideButtonOverride {
        __typename
        label
        link
        ariaLabel
      }
    }
    footer {
      __typename
      disableLinks
      disableBottom
    }
    disclaimer {
      __typename
      disable
      content
    }
    partner {
      __typename
    }
    client {
      __typename
      enabled
    }
  }
  name
  jobTitle
  avatar
  email
  bio
}
    `;
export const ProductPartsFragmentDoc = gql`
    fragment ProductParts on Product {
  __typename
  dataType
  title
  productGroup
  shortName
  icon
  graphic
  actionLabel
  descriptionText
  descriptionItems
  disclaimer
  buttons {
    __typename
    label
    link
    ariaLabel
    agentLink
  }
}
    `;
export const TestimonialPartsFragmentDoc = gql`
    fragment TestimonialParts on Testimonial {
  __typename
  dataType
  title
  stars
  author
  authorTitle
  link
  body
}
    `;
export const PartnerPartsFragmentDoc = gql`
    fragment PartnerParts on Partner {
  __typename
  dataType
  title
  pid
  enabled
  logo {
    __typename
    src
  }
  displayName
  ctaLink
  products
  disclaimer
}
    `;
export const CobrandPartsFragmentDoc = gql`
    fragment CobrandParts on Cobrand {
  __typename
  dataType
  title
  logoSrc
  displayName
}
    `;
export const BgaPartsFragmentDoc = gql`
    fragment BgaParts on Bga {
  __typename
  dataType
  title
  urlSlug
  logoSrc
  mobileLogoSrc
  websiteDisplayName
  ctaLink
  productsRefs {
    __typename
  }
}
    `;
export const NotificationPartsFragmentDoc = gql`
    fragment NotificationParts on Notification {
  __typename
  title
  color
  body
}
    `;
export const SettingsPartsFragmentDoc = gql`
    fragment SettingsParts on Settings {
  __typename
  ... on SettingsNavigation {
    title
    left {
      __typename
      ... on SettingsNavigationLeftMegaMenu {
        title
        heading
        items {
          __typename
          title
          description
          icon
          image {
            __typename
            src
            width
            height
            aspectRatio
            format
            alt
          }
          buttons {
            __typename
            label
            link
            ariaLabel
          }
          columns {
            __typename
            title
            links {
              __typename
              label
              link
              ariaLabel
            }
          }
        }
      }
      ... on SettingsNavigationLeftSimpleMenu {
        title
        items {
          __typename
          icon
          type
          title
          link
        }
      }
    }
    right {
      __typename
      ... on SettingsNavigationRightLinkItem {
        label
        link
        ariaLabel
      }
      ... on SettingsNavigationRightDropdownItem {
        label
        items {
          __typename
          label
          link
          ariaLabel
        }
      }
      ... on SettingsNavigationRightButtonItem {
        label
        link
        ariaLabel
      }
    }
  }
  ... on SettingsFooter {
    title
    columns {
      __typename
      title
      image {
        __typename
        src
        width
        height
        aspectRatio
        format
        alt
      }
      links {
        __typename
        label
        link
        ariaLabel
      }
    }
    extras {
      __typename
      title
      links {
        __typename
        label
        link
        ariaLabel
      }
    }
    address
    contacts {
      __typename
      icon
      label
      link
      ariaLabel
    }
    bottom {
      __typename
      copyright
      social {
        __typename
        icon
        label
        link
        ariaLabel
      }
      navigation {
        __typename
        label
        link
        ariaLabel
        newWindow
      }
    }
    disclaimer
  }
  ... on SettingsSite {
    title
    name
    legalName
    baseUrl
    logo {
      __typename
      src
      width
      height
      aspectRatio
      format
      alt
    }
    description
    phone
    email
    foundingDate
    founders {
      __typename
      name
      occupation
      socialLink
    }
    businessAddress {
      __typename
      street
      city
      state
      zip
    }
    rating {
      __typename
      value
      outOf
      reviews
    }
    socialLinks
    gtmId
    fbAppId
    twitterAuthor
  }
  ... on SettingsRedirects {
    title
    redirect_groups {
      __typename
      name
      redirects {
        __typename
        from_url
        to_url
      }
    }
  }
  ... on SettingsSecurity {
    title
    csp {
      __typename
      directive
      hosts
    }
    blocked_ips {
      __typename
      ip_address
      subnet_mask
      date_added
      note
    }
  }
  ... on SettingsThreeStarOccList {
    title
    occupations
  }
  ... on SettingsStatesListTemplate {
    title
    states
  }
  ... on SettingsGroupDICompanyRateTypes {
    title
    rates {
      __typename
      name
      id
      rate
    }
    companies {
      __typename
      name
      id
      rateType
      hero
    }
  }
  ... on SettingsNotFoundPage {
    title
    seo {
      __typename
      title
      description
    }
    subtitle
    headingText
    text
    image {
      __typename
      src
      width
      height
      aspectRatio
      format
      alt
    }
    cta {
      __typename
      label
      link
      ariaLabel
    }
  }
  ... on SettingsAIRatesTable {
    title
    table {
      __typename
      states
      rates_by_age {
        __typename
        age_range
        rates
      }
    }
  }
}
    `;
export const FormPartsFragmentDoc = gql`
    fragment FormParts on Form {
  __typename
  ... on FormLTDIManualForm {
    dataType
    title
    incomeLimit
    bmiLimit
    flow
    calendarURL
    physician
    buttonLabel
    experts {
      __typename
      imageSrc
      name
      title
    }
    maternity {
      __typename
      income
      minHoursWorked
      excludedStates
      calendarURL
    }
    altProduct {
      __typename
      imageSrc
      headingRich
      subHeadingRich
      textRich
      cta {
        __typename
        label
        link
      }
    }
    whitelist {
      __typename
      occ {
        __typename
        list
      }
      hoursWorkedLimitOccs {
        __typename
        list
      }
      ratingOcc {
        __typename
        min
        list
      }
    }
    digital {
      __typename
      occ {
        __typename
        list
      }
      healthIssues {
        __typename
        list
      }
    }
    ineligible {
      __typename
      income {
        __typename
        min
      }
      occ {
        __typename
        list
      }
      healthIssues {
        __typename
        list
      }
      hoursWorked {
        __typename
        min
      }
    }
    decline {
      __typename
      headingText
      dob {
        __typename
        min
        minErrorText
        max
        maxErrorText
        message
      }
      income {
        __typename
        min
        message
      }
      state {
        __typename
        message
        states
      }
      hoursWorked {
        __typename
        min
      }
      familyLeave {
        __typename
        message
      }
    }
    generic {
      __typename
      headingText
      message
    }
    healthIssues
    disclaimer
  }
  ... on FormSTDIDigitalForm {
    dataType
    title
    bmiLimit
    buttonLabel
    ineligible {
      __typename
      headingText
      dob {
        __typename
        min
        minErrorText
        max
        maxErrorText
        message
      }
      occ {
        __typename
        message
      }
      income {
        __typename
        min
        message
      }
      hoursWorked {
        __typename
        message
        min
      }
      unemployed {
        __typename
        message
      }
      citizenOrResident {
        __typename
        message
      }
      disabled {
        __typename
        message
      }
      licenseRevoked {
        __typename
        message
      }
      state {
        __typename
        message
        states
      }
    }
    generic {
      __typename
      headingText
      message
    }
    familyCare {
      __typename
      label
      content
    }
    disclaimer
  }
  ... on FormLTCManualForm {
    dataType
    title
    incomeLimit
    calendarURL
    buttonLabel
    ineligible {
      __typename
      headingText
      dob {
        __typename
        min
        minErrorText
        max
        maxErrorText
        message
      }
      occ {
        __typename
        message
      }
      income {
        __typename
        min
        message
      }
      state {
        __typename
        message
        states
      }
    }
    generic {
      __typename
      headingText
      message
    }
    disclaimer
  }
  ... on FormCIForm {
    dataType
    title
    flow
    buttonLabel
    enableContacts
    ineligible {
      __typename
      headingText
      dob {
        __typename
        min
        minErrorText
        max
        maxErrorText
        message
      }
      state {
        __typename
        message
        states
      }
      replacing {
        __typename
        message
      }
      hadCancer {
        __typename
        message
      }
    }
    generic {
      __typename
      headingText
      message
    }
    disclaimer
  }
  ... on FormAEIForm {
    dataType
    title
    flow
    buttonLabel
    popup {
      __typename
      icon
      title
      text
      label
      link
      hint
    }
    ineligible {
      __typename
      headingText
      age {
        __typename
        min
        minErrorText
        max
        maxErrorText
        message
      }
      state {
        __typename
        message
        states
      }
    }
    generic {
      __typename
      headingText
      message
    }
    disclaimer
  }
  ... on FormGroupDIForm {
    dataType
    title
    calendarURL
    buttonLabel
    isInternal
    internalCalendarURL
    ineligible {
      __typename
      minEmployees {
        __typename
        min
        headingText
        message
        buttonLabel
        buttonLink
      }
    }
    generic {
      __typename
      headingText
      message
    }
    disclaimer
  }
  ... on FormLTDIDropticketForm {
    dataType
    title
    calendarURL
    buttonLabel
    thankyou {
      __typename
      headingText
      text
    }
    ineligible {
      __typename
      headingText
      dob {
        __typename
        min
        minErrorText
        max
        maxErrorText
        message
      }
      occ {
        __typename
        message
      }
      income {
        __typename
        min
        message
      }
      state {
        __typename
        message
        states
      }
    }
    generic {
      __typename
      headingText
      message
    }
    disclaimer
  }
  ... on FormLTCDropticketForm {
    dataType
    title
    calendarURL
    buttonLabel
    thankyou {
      __typename
      headingText
      text
    }
    ineligible {
      __typename
      headingText
      dob {
        __typename
        min
        minErrorText
        max
        maxErrorText
        message
      }
      income {
        __typename
        min
        message
      }
      state {
        __typename
        message
        states
      }
    }
    generic {
      __typename
      headingText
      message
    }
    disclaimer
  }
  ... on FormGroupDICalculatorForm {
    dataType
    title
    headings {
      __typename
      mainRich
      contributionRich
    }
    defaults {
      __typename
      numberOfEmployees
      contributionPercent
      companyType
    }
    detailsRich
  }
  ... on FormAgentSignupForm {
    dataType
    title
    heading
    buttonLabel
    textRich
    thankyou {
      __typename
      headingText
      text
    }
    ineligible {
      __typename
      headingText
      state {
        __typename
        message
        states
      }
    }
    generic {
      __typename
      headingText
      message
    }
  }
  ... on FormAgentSimpleForm {
    dataType
    title
    buttonLabel
    intent
    thankyou {
      __typename
      headingText
      text
    }
    generic {
      __typename
      headingText
      message
    }
  }
}
    `;
export const ManagerPartsFragmentDoc = gql`
    fragment ManagerParts on Manager {
  __typename
  title
  slackMentionId
  referralName
  salesPersonId
  phone
  isFallback
  imageSrc
  managedProducts {
    __typename
    product
    calendlyUrl
    ycbmUrl
    contents {
      __typename
      type
      heading
      subHeading
      text
    }
    rating {
      __typename
      min
      max
    }
    states
  }
}
    `;
export const SpecialPagePartsFragmentDoc = gql`
    fragment SpecialPageParts on SpecialPage {
  __typename
  ... on SpecialPageProposalSpecialPage {
    previewURL
    title
    seo {
      __typename
      title
    }
    content {
      __typename
      ... on SpecialPageProposalSpecialPageContentSectionHeroProposal {
        title
        headingSize
        headingRich
        subheadingRich
        textRich
        lists {
          __typename
          title
          items
        }
        logos {
          __typename
          highlightImgSrc
          highlightText
          logosText
          logosList
        }
        image {
          __typename
          src
          width
          height
          aspectRatio
          format
          alt
          scale
        }
        buttons {
          __typename
          label
          link
          ariaLabel
        }
        floatingItems {
          __typename
          ... on SpecialPageProposalSpecialPageContentSectionHeroProposalFloatingItemsSingleIconLinkItem {
            icon
            title
            text
            link
          }
          ... on SpecialPageProposalSpecialPageContentSectionHeroProposalFloatingItemsSingleIconTextItem {
            icon
            text
          }
          ... on SpecialPageProposalSpecialPageContentSectionHeroProposalFloatingItemsGroupedIconTextItem {
            items {
              __typename
              icon
              text
            }
          }
          ... on SpecialPageProposalSpecialPageContentSectionHeroProposalFloatingItemsSingleImageTextItem {
            image
            text
          }
          ... on SpecialPageProposalSpecialPageContentSectionHeroProposalFloatingItemsGroupedImageTextItem {
            items {
              __typename
              image
              text
            }
          }
          ... on SpecialPageProposalSpecialPageContentSectionHeroProposalFloatingItemsSingleImageItem {
            image
          }
        }
      }
      ... on SpecialPageProposalSpecialPageContentSectionLogos {
        headingText
        images {
          __typename
          image
          title
        }
      }
      ... on SpecialPageProposalSpecialPageContentSectionImage {
        brzImage {
          __typename
          title
          src
          width
          height
          aspectRatio
          format
          alt
          radius
        }
        scrollable
        spacing
        maxWidth
        align
      }
      ... on SpecialPageProposalSpecialPageContentSectionHeading {
        align
        title
        headingLevel
        headingText
        text
        marginBottom
      }
      ... on SpecialPageProposalSpecialPageContentSectionSideStats {
        headingText
        textRich
        items {
          __typename
          icon
          text
        }
      }
    }
    quote {
      __typename
      headingText
      subheadingRich
      helpTip {
        __typename
        headingText
        contentRich
      }
      addonsHeadingText
      notFoundError {
        __typename
        headingText
        textRich
      }
      genericError {
        __typename
        headingText
        textRich
      }
      annuity {
        __typename
        headingText
        text
        productName
        columns {
          __typename
          label
          value
        }
        incomeLabel
      }
    }
    disclaimer
  }
  ... on SpecialPageIneligibleSpecialPage {
    previewURL
    title
    seo {
      __typename
      title
    }
    accident {
      __typename
      imgSrc
      headingRich
      subheadingRich
      textRich
      ctaLabel
    }
    ineligible {
      __typename
      headingRich
      subheadingRich
      textRich
      products {
        __typename
        title
      }
    }
  }
}
    `;
export const PageDocument = gql`
    query page($relativePath: String!) {
  page(relativePath: $relativePath) {
    ... on Document {
      _sys {
        filename
        basename
        breadcrumbs
        path
        relativePath
        extension
      }
      id
    }
    ...PageParts
  }
}
    ${PagePartsFragmentDoc}`;
export const PageConnectionDocument = gql`
    query pageConnection($before: String, $after: String, $first: Float, $last: Float, $sort: String, $filter: PageFilter) {
  pageConnection(
    before: $before
    after: $after
    first: $first
    last: $last
    sort: $sort
    filter: $filter
  ) {
    pageInfo {
      hasPreviousPage
      hasNextPage
      startCursor
      endCursor
    }
    totalCount
    edges {
      cursor
      node {
        ... on Document {
          _sys {
            filename
            basename
            breadcrumbs
            path
            relativePath
            extension
          }
          id
        }
        ...PageParts
      }
    }
  }
}
    ${PagePartsFragmentDoc}`;
export const ArticleDocument = gql`
    query article($relativePath: String!) {
  article(relativePath: $relativePath) {
    ... on Document {
      _sys {
        filename
        basename
        breadcrumbs
        path
        relativePath
        extension
      }
      id
    }
    ...ArticleParts
  }
}
    ${ArticlePartsFragmentDoc}`;
export const ArticleConnectionDocument = gql`
    query articleConnection($before: String, $after: String, $first: Float, $last: Float, $sort: String, $filter: ArticleFilter) {
  articleConnection(
    before: $before
    after: $after
    first: $first
    last: $last
    sort: $sort
    filter: $filter
  ) {
    pageInfo {
      hasPreviousPage
      hasNextPage
      startCursor
      endCursor
    }
    totalCount
    edges {
      cursor
      node {
        ... on Document {
          _sys {
            filename
            basename
            breadcrumbs
            path
            relativePath
            extension
          }
          id
        }
        ...ArticleParts
      }
    }
  }
}
    ${ArticlePartsFragmentDoc}`;
export const PostDocument = gql`
    query post($relativePath: String!) {
  post(relativePath: $relativePath) {
    ... on Document {
      _sys {
        filename
        basename
        breadcrumbs
        path
        relativePath
        extension
      }
      id
    }
    ...PostParts
  }
}
    ${PostPartsFragmentDoc}`;
export const PostConnectionDocument = gql`
    query postConnection($before: String, $after: String, $first: Float, $last: Float, $sort: String, $filter: PostFilter) {
  postConnection(
    before: $before
    after: $after
    first: $first
    last: $last
    sort: $sort
    filter: $filter
  ) {
    pageInfo {
      hasPreviousPage
      hasNextPage
      startCursor
      endCursor
    }
    totalCount
    edges {
      cursor
      node {
        ... on Document {
          _sys {
            filename
            basename
            breadcrumbs
            path
            relativePath
            extension
          }
          id
        }
        ...PostParts
      }
    }
  }
}
    ${PostPartsFragmentDoc}`;
export const CategoryDocument = gql`
    query category($relativePath: String!) {
  category(relativePath: $relativePath) {
    ... on Document {
      _sys {
        filename
        basename
        breadcrumbs
        path
        relativePath
        extension
      }
      id
    }
    ...CategoryParts
  }
}
    ${CategoryPartsFragmentDoc}`;
export const CategoryConnectionDocument = gql`
    query categoryConnection($before: String, $after: String, $first: Float, $last: Float, $sort: String, $filter: CategoryFilter) {
  categoryConnection(
    before: $before
    after: $after
    first: $first
    last: $last
    sort: $sort
    filter: $filter
  ) {
    pageInfo {
      hasPreviousPage
      hasNextPage
      startCursor
      endCursor
    }
    totalCount
    edges {
      cursor
      node {
        ... on Document {
          _sys {
            filename
            basename
            breadcrumbs
            path
            relativePath
            extension
          }
          id
        }
        ...CategoryParts
      }
    }
  }
}
    ${CategoryPartsFragmentDoc}`;
export const AuthorDocument = gql`
    query author($relativePath: String!) {
  author(relativePath: $relativePath) {
    ... on Document {
      _sys {
        filename
        basename
        breadcrumbs
        path
        relativePath
        extension
      }
      id
    }
    ...AuthorParts
  }
}
    ${AuthorPartsFragmentDoc}`;
export const AuthorConnectionDocument = gql`
    query authorConnection($before: String, $after: String, $first: Float, $last: Float, $sort: String, $filter: AuthorFilter) {
  authorConnection(
    before: $before
    after: $after
    first: $first
    last: $last
    sort: $sort
    filter: $filter
  ) {
    pageInfo {
      hasPreviousPage
      hasNextPage
      startCursor
      endCursor
    }
    totalCount
    edges {
      cursor
      node {
        ... on Document {
          _sys {
            filename
            basename
            breadcrumbs
            path
            relativePath
            extension
          }
          id
        }
        ...AuthorParts
      }
    }
  }
}
    ${AuthorPartsFragmentDoc}`;
export const ProductDocument = gql`
    query product($relativePath: String!) {
  product(relativePath: $relativePath) {
    ... on Document {
      _sys {
        filename
        basename
        breadcrumbs
        path
        relativePath
        extension
      }
      id
    }
    ...ProductParts
  }
}
    ${ProductPartsFragmentDoc}`;
export const ProductConnectionDocument = gql`
    query productConnection($before: String, $after: String, $first: Float, $last: Float, $sort: String, $filter: ProductFilter) {
  productConnection(
    before: $before
    after: $after
    first: $first
    last: $last
    sort: $sort
    filter: $filter
  ) {
    pageInfo {
      hasPreviousPage
      hasNextPage
      startCursor
      endCursor
    }
    totalCount
    edges {
      cursor
      node {
        ... on Document {
          _sys {
            filename
            basename
            breadcrumbs
            path
            relativePath
            extension
          }
          id
        }
        ...ProductParts
      }
    }
  }
}
    ${ProductPartsFragmentDoc}`;
export const TestimonialDocument = gql`
    query testimonial($relativePath: String!) {
  testimonial(relativePath: $relativePath) {
    ... on Document {
      _sys {
        filename
        basename
        breadcrumbs
        path
        relativePath
        extension
      }
      id
    }
    ...TestimonialParts
  }
}
    ${TestimonialPartsFragmentDoc}`;
export const TestimonialConnectionDocument = gql`
    query testimonialConnection($before: String, $after: String, $first: Float, $last: Float, $sort: String, $filter: TestimonialFilter) {
  testimonialConnection(
    before: $before
    after: $after
    first: $first
    last: $last
    sort: $sort
    filter: $filter
  ) {
    pageInfo {
      hasPreviousPage
      hasNextPage
      startCursor
      endCursor
    }
    totalCount
    edges {
      cursor
      node {
        ... on Document {
          _sys {
            filename
            basename
            breadcrumbs
            path
            relativePath
            extension
          }
          id
        }
        ...TestimonialParts
      }
    }
  }
}
    ${TestimonialPartsFragmentDoc}`;
export const PartnerDocument = gql`
    query partner($relativePath: String!) {
  partner(relativePath: $relativePath) {
    ... on Document {
      _sys {
        filename
        basename
        breadcrumbs
        path
        relativePath
        extension
      }
      id
    }
    ...PartnerParts
  }
}
    ${PartnerPartsFragmentDoc}`;
export const PartnerConnectionDocument = gql`
    query partnerConnection($before: String, $after: String, $first: Float, $last: Float, $sort: String, $filter: PartnerFilter) {
  partnerConnection(
    before: $before
    after: $after
    first: $first
    last: $last
    sort: $sort
    filter: $filter
  ) {
    pageInfo {
      hasPreviousPage
      hasNextPage
      startCursor
      endCursor
    }
    totalCount
    edges {
      cursor
      node {
        ... on Document {
          _sys {
            filename
            basename
            breadcrumbs
            path
            relativePath
            extension
          }
          id
        }
        ...PartnerParts
      }
    }
  }
}
    ${PartnerPartsFragmentDoc}`;
export const CobrandDocument = gql`
    query cobrand($relativePath: String!) {
  cobrand(relativePath: $relativePath) {
    ... on Document {
      _sys {
        filename
        basename
        breadcrumbs
        path
        relativePath
        extension
      }
      id
    }
    ...CobrandParts
  }
}
    ${CobrandPartsFragmentDoc}`;
export const CobrandConnectionDocument = gql`
    query cobrandConnection($before: String, $after: String, $first: Float, $last: Float, $sort: String, $filter: CobrandFilter) {
  cobrandConnection(
    before: $before
    after: $after
    first: $first
    last: $last
    sort: $sort
    filter: $filter
  ) {
    pageInfo {
      hasPreviousPage
      hasNextPage
      startCursor
      endCursor
    }
    totalCount
    edges {
      cursor
      node {
        ... on Document {
          _sys {
            filename
            basename
            breadcrumbs
            path
            relativePath
            extension
          }
          id
        }
        ...CobrandParts
      }
    }
  }
}
    ${CobrandPartsFragmentDoc}`;
export const BgaDocument = gql`
    query bga($relativePath: String!) {
  bga(relativePath: $relativePath) {
    ... on Document {
      _sys {
        filename
        basename
        breadcrumbs
        path
        relativePath
        extension
      }
      id
    }
    ...BgaParts
  }
}
    ${BgaPartsFragmentDoc}`;
export const BgaConnectionDocument = gql`
    query bgaConnection($before: String, $after: String, $first: Float, $last: Float, $sort: String, $filter: BgaFilter) {
  bgaConnection(
    before: $before
    after: $after
    first: $first
    last: $last
    sort: $sort
    filter: $filter
  ) {
    pageInfo {
      hasPreviousPage
      hasNextPage
      startCursor
      endCursor
    }
    totalCount
    edges {
      cursor
      node {
        ... on Document {
          _sys {
            filename
            basename
            breadcrumbs
            path
            relativePath
            extension
          }
          id
        }
        ...BgaParts
      }
    }
  }
}
    ${BgaPartsFragmentDoc}`;
export const NotificationDocument = gql`
    query notification($relativePath: String!) {
  notification(relativePath: $relativePath) {
    ... on Document {
      _sys {
        filename
        basename
        breadcrumbs
        path
        relativePath
        extension
      }
      id
    }
    ...NotificationParts
  }
}
    ${NotificationPartsFragmentDoc}`;
export const NotificationConnectionDocument = gql`
    query notificationConnection($before: String, $after: String, $first: Float, $last: Float, $sort: String, $filter: NotificationFilter) {
  notificationConnection(
    before: $before
    after: $after
    first: $first
    last: $last
    sort: $sort
    filter: $filter
  ) {
    pageInfo {
      hasPreviousPage
      hasNextPage
      startCursor
      endCursor
    }
    totalCount
    edges {
      cursor
      node {
        ... on Document {
          _sys {
            filename
            basename
            breadcrumbs
            path
            relativePath
            extension
          }
          id
        }
        ...NotificationParts
      }
    }
  }
}
    ${NotificationPartsFragmentDoc}`;
export const SettingsDocument = gql`
    query settings($relativePath: String!) {
  settings(relativePath: $relativePath) {
    ... on Document {
      _sys {
        filename
        basename
        breadcrumbs
        path
        relativePath
        extension
      }
      id
    }
    ...SettingsParts
  }
}
    ${SettingsPartsFragmentDoc}`;
export const SettingsConnectionDocument = gql`
    query settingsConnection($before: String, $after: String, $first: Float, $last: Float, $sort: String, $filter: SettingsFilter) {
  settingsConnection(
    before: $before
    after: $after
    first: $first
    last: $last
    sort: $sort
    filter: $filter
  ) {
    pageInfo {
      hasPreviousPage
      hasNextPage
      startCursor
      endCursor
    }
    totalCount
    edges {
      cursor
      node {
        ... on Document {
          _sys {
            filename
            basename
            breadcrumbs
            path
            relativePath
            extension
          }
          id
        }
        ...SettingsParts
      }
    }
  }
}
    ${SettingsPartsFragmentDoc}`;
export const FormDocument = gql`
    query form($relativePath: String!) {
  form(relativePath: $relativePath) {
    ... on Document {
      _sys {
        filename
        basename
        breadcrumbs
        path
        relativePath
        extension
      }
      id
    }
    ...FormParts
  }
}
    ${FormPartsFragmentDoc}`;
export const FormConnectionDocument = gql`
    query formConnection($before: String, $after: String, $first: Float, $last: Float, $sort: String, $filter: FormFilter) {
  formConnection(
    before: $before
    after: $after
    first: $first
    last: $last
    sort: $sort
    filter: $filter
  ) {
    pageInfo {
      hasPreviousPage
      hasNextPage
      startCursor
      endCursor
    }
    totalCount
    edges {
      cursor
      node {
        ... on Document {
          _sys {
            filename
            basename
            breadcrumbs
            path
            relativePath
            extension
          }
          id
        }
        ...FormParts
      }
    }
  }
}
    ${FormPartsFragmentDoc}`;
export const ManagerDocument = gql`
    query manager($relativePath: String!) {
  manager(relativePath: $relativePath) {
    ... on Document {
      _sys {
        filename
        basename
        breadcrumbs
        path
        relativePath
        extension
      }
      id
    }
    ...ManagerParts
  }
}
    ${ManagerPartsFragmentDoc}`;
export const ManagerConnectionDocument = gql`
    query managerConnection($before: String, $after: String, $first: Float, $last: Float, $sort: String, $filter: ManagerFilter) {
  managerConnection(
    before: $before
    after: $after
    first: $first
    last: $last
    sort: $sort
    filter: $filter
  ) {
    pageInfo {
      hasPreviousPage
      hasNextPage
      startCursor
      endCursor
    }
    totalCount
    edges {
      cursor
      node {
        ... on Document {
          _sys {
            filename
            basename
            breadcrumbs
            path
            relativePath
            extension
          }
          id
        }
        ...ManagerParts
      }
    }
  }
}
    ${ManagerPartsFragmentDoc}`;
export const SpecialPageDocument = gql`
    query specialPage($relativePath: String!) {
  specialPage(relativePath: $relativePath) {
    ... on Document {
      _sys {
        filename
        basename
        breadcrumbs
        path
        relativePath
        extension
      }
      id
    }
    ...SpecialPageParts
  }
}
    ${SpecialPagePartsFragmentDoc}`;
export const SpecialPageConnectionDocument = gql`
    query specialPageConnection($before: String, $after: String, $first: Float, $last: Float, $sort: String, $filter: SpecialPageFilter) {
  specialPageConnection(
    before: $before
    after: $after
    first: $first
    last: $last
    sort: $sort
    filter: $filter
  ) {
    pageInfo {
      hasPreviousPage
      hasNextPage
      startCursor
      endCursor
    }
    totalCount
    edges {
      cursor
      node {
        ... on Document {
          _sys {
            filename
            basename
            breadcrumbs
            path
            relativePath
            extension
          }
          id
        }
        ...SpecialPageParts
      }
    }
  }
}
    ${SpecialPagePartsFragmentDoc}`;
export type Requester<C= {}> = <R, V>(doc: DocumentNode, vars?: V, options?: C) => Promise<R>
  export function getSdk<C>(requester: Requester<C>) {
    return {
      page(variables: PageQueryVariables, options?: C): Promise<{data: PageQuery, errors?: { message: string, locations: { line: number, column: number }[], path: string[] }[], variables: PageQueryVariables, query: string}> {
        return requester<{data: PageQuery, errors?: { message: string, locations: { line: number, column: number }[], path: string[] }[], variables: PageQueryVariables, query: string}, PageQueryVariables>(PageDocument, variables, options);
      },
    pageConnection(variables?: PageConnectionQueryVariables, options?: C): Promise<{data: PageConnectionQuery, errors?: { message: string, locations: { line: number, column: number }[], path: string[] }[], variables: PageConnectionQueryVariables, query: string}> {
        return requester<{data: PageConnectionQuery, errors?: { message: string, locations: { line: number, column: number }[], path: string[] }[], variables: PageConnectionQueryVariables, query: string}, PageConnectionQueryVariables>(PageConnectionDocument, variables, options);
      },
    article(variables: ArticleQueryVariables, options?: C): Promise<{data: ArticleQuery, errors?: { message: string, locations: { line: number, column: number }[], path: string[] }[], variables: ArticleQueryVariables, query: string}> {
        return requester<{data: ArticleQuery, errors?: { message: string, locations: { line: number, column: number }[], path: string[] }[], variables: ArticleQueryVariables, query: string}, ArticleQueryVariables>(ArticleDocument, variables, options);
      },
    articleConnection(variables?: ArticleConnectionQueryVariables, options?: C): Promise<{data: ArticleConnectionQuery, errors?: { message: string, locations: { line: number, column: number }[], path: string[] }[], variables: ArticleConnectionQueryVariables, query: string}> {
        return requester<{data: ArticleConnectionQuery, errors?: { message: string, locations: { line: number, column: number }[], path: string[] }[], variables: ArticleConnectionQueryVariables, query: string}, ArticleConnectionQueryVariables>(ArticleConnectionDocument, variables, options);
      },
    post(variables: PostQueryVariables, options?: C): Promise<{data: PostQuery, errors?: { message: string, locations: { line: number, column: number }[], path: string[] }[], variables: PostQueryVariables, query: string}> {
        return requester<{data: PostQuery, errors?: { message: string, locations: { line: number, column: number }[], path: string[] }[], variables: PostQueryVariables, query: string}, PostQueryVariables>(PostDocument, variables, options);
      },
    postConnection(variables?: PostConnectionQueryVariables, options?: C): Promise<{data: PostConnectionQuery, errors?: { message: string, locations: { line: number, column: number }[], path: string[] }[], variables: PostConnectionQueryVariables, query: string}> {
        return requester<{data: PostConnectionQuery, errors?: { message: string, locations: { line: number, column: number }[], path: string[] }[], variables: PostConnectionQueryVariables, query: string}, PostConnectionQueryVariables>(PostConnectionDocument, variables, options);
      },
    category(variables: CategoryQueryVariables, options?: C): Promise<{data: CategoryQuery, errors?: { message: string, locations: { line: number, column: number }[], path: string[] }[], variables: CategoryQueryVariables, query: string}> {
        return requester<{data: CategoryQuery, errors?: { message: string, locations: { line: number, column: number }[], path: string[] }[], variables: CategoryQueryVariables, query: string}, CategoryQueryVariables>(CategoryDocument, variables, options);
      },
    categoryConnection(variables?: CategoryConnectionQueryVariables, options?: C): Promise<{data: CategoryConnectionQuery, errors?: { message: string, locations: { line: number, column: number }[], path: string[] }[], variables: CategoryConnectionQueryVariables, query: string}> {
        return requester<{data: CategoryConnectionQuery, errors?: { message: string, locations: { line: number, column: number }[], path: string[] }[], variables: CategoryConnectionQueryVariables, query: string}, CategoryConnectionQueryVariables>(CategoryConnectionDocument, variables, options);
      },
    author(variables: AuthorQueryVariables, options?: C): Promise<{data: AuthorQuery, errors?: { message: string, locations: { line: number, column: number }[], path: string[] }[], variables: AuthorQueryVariables, query: string}> {
        return requester<{data: AuthorQuery, errors?: { message: string, locations: { line: number, column: number }[], path: string[] }[], variables: AuthorQueryVariables, query: string}, AuthorQueryVariables>(AuthorDocument, variables, options);
      },
    authorConnection(variables?: AuthorConnectionQueryVariables, options?: C): Promise<{data: AuthorConnectionQuery, errors?: { message: string, locations: { line: number, column: number }[], path: string[] }[], variables: AuthorConnectionQueryVariables, query: string}> {
        return requester<{data: AuthorConnectionQuery, errors?: { message: string, locations: { line: number, column: number }[], path: string[] }[], variables: AuthorConnectionQueryVariables, query: string}, AuthorConnectionQueryVariables>(AuthorConnectionDocument, variables, options);
      },
    product(variables: ProductQueryVariables, options?: C): Promise<{data: ProductQuery, errors?: { message: string, locations: { line: number, column: number }[], path: string[] }[], variables: ProductQueryVariables, query: string}> {
        return requester<{data: ProductQuery, errors?: { message: string, locations: { line: number, column: number }[], path: string[] }[], variables: ProductQueryVariables, query: string}, ProductQueryVariables>(ProductDocument, variables, options);
      },
    productConnection(variables?: ProductConnectionQueryVariables, options?: C): Promise<{data: ProductConnectionQuery, errors?: { message: string, locations: { line: number, column: number }[], path: string[] }[], variables: ProductConnectionQueryVariables, query: string}> {
        return requester<{data: ProductConnectionQuery, errors?: { message: string, locations: { line: number, column: number }[], path: string[] }[], variables: ProductConnectionQueryVariables, query: string}, ProductConnectionQueryVariables>(ProductConnectionDocument, variables, options);
      },
    testimonial(variables: TestimonialQueryVariables, options?: C): Promise<{data: TestimonialQuery, errors?: { message: string, locations: { line: number, column: number }[], path: string[] }[], variables: TestimonialQueryVariables, query: string}> {
        return requester<{data: TestimonialQuery, errors?: { message: string, locations: { line: number, column: number }[], path: string[] }[], variables: TestimonialQueryVariables, query: string}, TestimonialQueryVariables>(TestimonialDocument, variables, options);
      },
    testimonialConnection(variables?: TestimonialConnectionQueryVariables, options?: C): Promise<{data: TestimonialConnectionQuery, errors?: { message: string, locations: { line: number, column: number }[], path: string[] }[], variables: TestimonialConnectionQueryVariables, query: string}> {
        return requester<{data: TestimonialConnectionQuery, errors?: { message: string, locations: { line: number, column: number }[], path: string[] }[], variables: TestimonialConnectionQueryVariables, query: string}, TestimonialConnectionQueryVariables>(TestimonialConnectionDocument, variables, options);
      },
    partner(variables: PartnerQueryVariables, options?: C): Promise<{data: PartnerQuery, errors?: { message: string, locations: { line: number, column: number }[], path: string[] }[], variables: PartnerQueryVariables, query: string}> {
        return requester<{data: PartnerQuery, errors?: { message: string, locations: { line: number, column: number }[], path: string[] }[], variables: PartnerQueryVariables, query: string}, PartnerQueryVariables>(PartnerDocument, variables, options);
      },
    partnerConnection(variables?: PartnerConnectionQueryVariables, options?: C): Promise<{data: PartnerConnectionQuery, errors?: { message: string, locations: { line: number, column: number }[], path: string[] }[], variables: PartnerConnectionQueryVariables, query: string}> {
        return requester<{data: PartnerConnectionQuery, errors?: { message: string, locations: { line: number, column: number }[], path: string[] }[], variables: PartnerConnectionQueryVariables, query: string}, PartnerConnectionQueryVariables>(PartnerConnectionDocument, variables, options);
      },
    cobrand(variables: CobrandQueryVariables, options?: C): Promise<{data: CobrandQuery, errors?: { message: string, locations: { line: number, column: number }[], path: string[] }[], variables: CobrandQueryVariables, query: string}> {
        return requester<{data: CobrandQuery, errors?: { message: string, locations: { line: number, column: number }[], path: string[] }[], variables: CobrandQueryVariables, query: string}, CobrandQueryVariables>(CobrandDocument, variables, options);
      },
    cobrandConnection(variables?: CobrandConnectionQueryVariables, options?: C): Promise<{data: CobrandConnectionQuery, errors?: { message: string, locations: { line: number, column: number }[], path: string[] }[], variables: CobrandConnectionQueryVariables, query: string}> {
        return requester<{data: CobrandConnectionQuery, errors?: { message: string, locations: { line: number, column: number }[], path: string[] }[], variables: CobrandConnectionQueryVariables, query: string}, CobrandConnectionQueryVariables>(CobrandConnectionDocument, variables, options);
      },
    bga(variables: BgaQueryVariables, options?: C): Promise<{data: BgaQuery, errors?: { message: string, locations: { line: number, column: number }[], path: string[] }[], variables: BgaQueryVariables, query: string}> {
        return requester<{data: BgaQuery, errors?: { message: string, locations: { line: number, column: number }[], path: string[] }[], variables: BgaQueryVariables, query: string}, BgaQueryVariables>(BgaDocument, variables, options);
      },
    bgaConnection(variables?: BgaConnectionQueryVariables, options?: C): Promise<{data: BgaConnectionQuery, errors?: { message: string, locations: { line: number, column: number }[], path: string[] }[], variables: BgaConnectionQueryVariables, query: string}> {
        return requester<{data: BgaConnectionQuery, errors?: { message: string, locations: { line: number, column: number }[], path: string[] }[], variables: BgaConnectionQueryVariables, query: string}, BgaConnectionQueryVariables>(BgaConnectionDocument, variables, options);
      },
    notification(variables: NotificationQueryVariables, options?: C): Promise<{data: NotificationQuery, errors?: { message: string, locations: { line: number, column: number }[], path: string[] }[], variables: NotificationQueryVariables, query: string}> {
        return requester<{data: NotificationQuery, errors?: { message: string, locations: { line: number, column: number }[], path: string[] }[], variables: NotificationQueryVariables, query: string}, NotificationQueryVariables>(NotificationDocument, variables, options);
      },
    notificationConnection(variables?: NotificationConnectionQueryVariables, options?: C): Promise<{data: NotificationConnectionQuery, errors?: { message: string, locations: { line: number, column: number }[], path: string[] }[], variables: NotificationConnectionQueryVariables, query: string}> {
        return requester<{data: NotificationConnectionQuery, errors?: { message: string, locations: { line: number, column: number }[], path: string[] }[], variables: NotificationConnectionQueryVariables, query: string}, NotificationConnectionQueryVariables>(NotificationConnectionDocument, variables, options);
      },
    settings(variables: SettingsQueryVariables, options?: C): Promise<{data: SettingsQuery, errors?: { message: string, locations: { line: number, column: number }[], path: string[] }[], variables: SettingsQueryVariables, query: string}> {
        return requester<{data: SettingsQuery, errors?: { message: string, locations: { line: number, column: number }[], path: string[] }[], variables: SettingsQueryVariables, query: string}, SettingsQueryVariables>(SettingsDocument, variables, options);
      },
    settingsConnection(variables?: SettingsConnectionQueryVariables, options?: C): Promise<{data: SettingsConnectionQuery, errors?: { message: string, locations: { line: number, column: number }[], path: string[] }[], variables: SettingsConnectionQueryVariables, query: string}> {
        return requester<{data: SettingsConnectionQuery, errors?: { message: string, locations: { line: number, column: number }[], path: string[] }[], variables: SettingsConnectionQueryVariables, query: string}, SettingsConnectionQueryVariables>(SettingsConnectionDocument, variables, options);
      },
    form(variables: FormQueryVariables, options?: C): Promise<{data: FormQuery, errors?: { message: string, locations: { line: number, column: number }[], path: string[] }[], variables: FormQueryVariables, query: string}> {
        return requester<{data: FormQuery, errors?: { message: string, locations: { line: number, column: number }[], path: string[] }[], variables: FormQueryVariables, query: string}, FormQueryVariables>(FormDocument, variables, options);
      },
    formConnection(variables?: FormConnectionQueryVariables, options?: C): Promise<{data: FormConnectionQuery, errors?: { message: string, locations: { line: number, column: number }[], path: string[] }[], variables: FormConnectionQueryVariables, query: string}> {
        return requester<{data: FormConnectionQuery, errors?: { message: string, locations: { line: number, column: number }[], path: string[] }[], variables: FormConnectionQueryVariables, query: string}, FormConnectionQueryVariables>(FormConnectionDocument, variables, options);
      },
    manager(variables: ManagerQueryVariables, options?: C): Promise<{data: ManagerQuery, errors?: { message: string, locations: { line: number, column: number }[], path: string[] }[], variables: ManagerQueryVariables, query: string}> {
        return requester<{data: ManagerQuery, errors?: { message: string, locations: { line: number, column: number }[], path: string[] }[], variables: ManagerQueryVariables, query: string}, ManagerQueryVariables>(ManagerDocument, variables, options);
      },
    managerConnection(variables?: ManagerConnectionQueryVariables, options?: C): Promise<{data: ManagerConnectionQuery, errors?: { message: string, locations: { line: number, column: number }[], path: string[] }[], variables: ManagerConnectionQueryVariables, query: string}> {
        return requester<{data: ManagerConnectionQuery, errors?: { message: string, locations: { line: number, column: number }[], path: string[] }[], variables: ManagerConnectionQueryVariables, query: string}, ManagerConnectionQueryVariables>(ManagerConnectionDocument, variables, options);
      },
    specialPage(variables: SpecialPageQueryVariables, options?: C): Promise<{data: SpecialPageQuery, errors?: { message: string, locations: { line: number, column: number }[], path: string[] }[], variables: SpecialPageQueryVariables, query: string}> {
        return requester<{data: SpecialPageQuery, errors?: { message: string, locations: { line: number, column: number }[], path: string[] }[], variables: SpecialPageQueryVariables, query: string}, SpecialPageQueryVariables>(SpecialPageDocument, variables, options);
      },
    specialPageConnection(variables?: SpecialPageConnectionQueryVariables, options?: C): Promise<{data: SpecialPageConnectionQuery, errors?: { message: string, locations: { line: number, column: number }[], path: string[] }[], variables: SpecialPageConnectionQueryVariables, query: string}> {
        return requester<{data: SpecialPageConnectionQuery, errors?: { message: string, locations: { line: number, column: number }[], path: string[] }[], variables: SpecialPageConnectionQueryVariables, query: string}, SpecialPageConnectionQueryVariables>(SpecialPageConnectionDocument, variables, options);
      }
    };
  }
  export type Sdk = ReturnType<typeof getSdk>;

// TinaSDK generated code
import { createClient, TinaClient } from "tinacms/dist/client";

const generateRequester = (
  client: TinaClient,
) => {
  const requester: (
    doc: any,
    vars?: any,
    options?: {
      branch?: string,
      /**
       * Aside from `method` and `body`, all fetch options are passed
       * through to underlying fetch request
       */
      fetchOptions?: Omit<Parameters<typeof fetch>[1], 'body' | 'method'>,
    },
    client
  ) => Promise<any> = async (doc, vars, options) => {
    let url = client.apiUrl
    if (options?.branch) {
      const index = client.apiUrl.lastIndexOf('/')
      url = client.apiUrl.substring(0, index + 1) + options.branch
    }
    const data = await client.request({
      query: doc,
      variables: vars,
      url,
    }, options)

    return { data: data?.data, errors: data?.errors, query: doc, variables: vars || {} }
  }

  return requester
}

/**
 * @experimental this class can be used but may change in the future
 **/
export const ExperimentalGetTinaClient = () =>
  getSdk(
    generateRequester(
      createClient({
        url: "https://content.tinajs.io/1.4/content/4d440eb3-2c21-4393-86b4-98fe62ba3470/github/master",
        queries,
      })
    )
  )

export const queries = (
  client: TinaClient,
) => {
  const requester = generateRequester(client)
  return getSdk(requester)
}

  